/* tslint:disable */
/* eslint-disable */
/**
 * matchbox
 * ## CP2連携項目について  マイナビで利用してるブレインラボ提供のCP2(http://203.138.99.35/ ) におけるmatchboxユーザーのステータスを取得しています。（取得方法は現在調整中）  管理画面から見られる以下の求職者情報はCP2からCP2側で設定した文字列が設定されるのでそれを表示するものとする  - 登録ステータス : cp2_registration_status - 面談ステータス : cp2_consultation_status - 担当者 : cp2_charge_name  またCP2との連携判断はCP2からmatchbox APIを叩かれることで判定、CP2側からどのタイミングで実行されるかは現時点では不明  ## 選択項目のある値について  マスタまたは以下スプレットシートを参照  https://docs.google.com/spreadsheets/d/1v_ih6lS23AkzfN1L64PzTAprSADogw_GLajva46LsyQ/edit#gid=2058907492  実装時は以下のファイルに定義、定義は求職者サイドと基本共有する  https://github.com/prtytokyo/matchbox-2021-web-frontend/blob/develop/src/definition/FORM_OPTIONS.ts  ## 広告ID(user_entry_id)について  広告測定で利用するユーザーに採番した広告IDは以下の実装で割り付け  https://github.com/prtytokyo/matchbox-2021-web-frontend/blob/develop/src/pages/Account/Register.tsx#L91-L103  ## パスワード仕様について  - パスワードはアルファベットの大文字、小文字、数字、ドット（ . ）、ハイフン（ - ）、アンダーバー（ _ ）から3種類以上を組み合わせて8文字以上で入力。 - ログインIDと同じ文字列を含む値は禁止する。 - 次の文字列の使用を禁止する。password、passwd、test、admin、administrator、sysadmin  ## Enumの指定についての注意  プロパティにEnumを指定すると型はEnum型で生成されますがEnumはスキーマーごとに生成されるます、例えばDirectSearchConditionResponseとDirectSearchConditionRequestという別のスキーマーを作成しその中にrateというEnumなプロパティがあった場合、それぞれ以下のEnum型が生成時に作成されます  DirectSearchConditionResponseRateEnum / DirectSearchConditionRequestRateEnum  そのためレスポンスモデルをそのままリクエストとして投げたい場合型が一致せずにエラーが発生します。  回避方法としてはリクエスト時にasで以下のようにキャストするかEnumを仕様書側で使用しないなどしてください。  ``` // 何かしらで取ってきたレスポンスデータにリクエスト用のプロパティを追加してデータをつくるなどした場合Enum型が違うとエラーになってしまうのでasでキャストして回避 } const query = {   request_value: \'test\',   ...responseData } as DirectSearchConditionRequest  save(query); ```  もしくはUnion型で生成されるようにしればいいはずなんですが今のところその方法がわからない  ## PDF生成APIのレスポンスヘッダーについて  PDF生成中にローダーを表示するためレスポンスヘッダーにSet-Cookieを含める  - name : downloadStarted - value : 1 - Expires : 現在時刻から5分  ## ユーザー情報のIDの扱いについて  ユーザー情報には `user_id` と `matchbox_id` があるが用途は以下の通り  ### user_id  v1でユーザーID（ニックネーム）として入力していた情報でv1では主に公開URLに利用していたがv2からはユーザーIDの任意入力が廃止になったため本来は不要になったものだったが `matchbox_id` を公開URLに使用するとDirectユーザーが `matchbox_id` を利用して求職者の個人情報を推測される可能性があるため公開URL用途で `matchbox_id` とは別のIDを付与してそれを公開URLとして使用  ### matchbox_id  連番のIDの場合他のユーザーIDを推測されやすいため C+数字8桁乱数として生成。通常のID用途は基本的にこちらを利用する。  ## 範囲指定の検索ロジックについて  検索条件設定の「選考ステータス最終更新日」「オファー数」など範囲指定要素の場合下限・上限どちらかの一方しか指定がない場合は  - 下限のみ : 下限以上の値全て - 上限のみ : 上限までの値全て   を検索するものとする。
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 企業情報  # block_company_id について - MBの企業情報と国税庁の企業情報は別々に持つ - 国税庁の方の企業情報はブロック企業追加時のみに使う（企業名、ふりがな、裏側で国税庁番号 - ユーザーに見せる情報はMB側で登録された情報 - MBの企業情報には、ブロック対象として複数の国税庁番号（企業情報）を登録/編集することができるようにする（例：A+B=Cのような合併が発生し、Aのアカウントを使い続けたい場合、AもBもCの企業でもブロックさせたい可能性があるため）
 * @export
 * @interface AdminCompany
 */
export interface AdminCompany {
    /**
     * 内部的に採番している Direct用の企業ID 
     * @type {number}
     * @memberof AdminCompany
     */
    'id': number;
    /**
     * 企業名
     * @type {string}
     * @memberof AdminCompany
     */
    'name': string;
    /**
     * 企業名 かな
     * @type {string}
     * @memberof AdminCompany
     */
    'kana': string;
    /**
     * 業種  選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof AdminCompany
     */
    'business_type'?: number;
    /**
     * 都道府県 選択項目は実装側定義参照
     * @type {number}
     * @memberof AdminCompany
     */
    'prefecture'?: number;
    /**
     * 所在地
     * @type {string}
     * @memberof AdminCompany
     */
    'address'?: string;
    /**
     * 社員数 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof AdminCompany
     */
    'employee_amount'?: number;
    /**
     * 事業内容
     * @type {string}
     * @memberof AdminCompany
     */
    'description'?: string;
    /**
     * WebサイトURL
     * @type {string}
     * @memberof AdminCompany
     */
    'url'?: string;
    /**
     * クリエイターへのひとこと
     * @type {string}
     * @memberof AdminCompany
     */
    'message'?: string;
    /**
     * 企業ロゴ : POST / PATCH のリクエスト時はData URI形式`data:image/png;base64,iV...`で送信。レスポンスの際はS3に保存したURIを返却。
     * @type {string}
     * @memberof AdminCompany
     */
    'icon'?: string;
    /**
     * 最終ログイン日
     * @type {string}
     * @memberof AdminCompany
     */
    'last_login'?: string;
    /**
     * アカウント開設日
     * @type {string}
     * @memberof AdminCompany
     */
    'registration_date'?: string;
    /**
     * 企業DBとの紐付け
     * @type {Array<BlockCompany>}
     * @memberof AdminCompany
     */
    'block_company_id'?: Array<BlockCompany>;
    /**
     * 電話番号
     * @type {string}
     * @memberof AdminCompany
     */
    'tel'?: string;
    /**
     * MW担当者
     * @type {number}
     * @memberof AdminCompany
     */
    'mw_user_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminCompany
     */
    'status'?: AdminCompanyStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum AdminCompanyStatusEnum {
    Active = 'active',
    Inactive = 'inactive',
    BeforeDelete = 'before_delete'
}

/**
 * 
 * @export
 * @interface AdminCompanyAllOf
 */
export interface AdminCompanyAllOf {
    /**
     * 企業DBとの紐付け
     * @type {Array<BlockCompany>}
     * @memberof AdminCompanyAllOf
     */
    'block_company_id'?: Array<BlockCompany>;
    /**
     * 電話番号
     * @type {string}
     * @memberof AdminCompanyAllOf
     */
    'tel'?: string;
    /**
     * MW担当者
     * @type {number}
     * @memberof AdminCompanyAllOf
     */
    'mw_user_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminCompanyAllOf
     */
    'status'?: AdminCompanyAllOfStatusEnum;
    /**
     * 最終ログイン日
     * @type {string}
     * @memberof AdminCompanyAllOf
     */
    'last_login'?: string;
    /**
     * アカウント開設日
     * @type {string}
     * @memberof AdminCompanyAllOf
     */
    'registration_date'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum AdminCompanyAllOfStatusEnum {
    Active = 'active',
    Inactive = 'inactive',
    BeforeDelete = 'before_delete'
}

/**
 * 
 * @export
 * @interface AdminCompanyPostParam
 */
export interface AdminCompanyPostParam {
    /**
     * 企業名
     * @type {string}
     * @memberof AdminCompanyPostParam
     */
    'name': string;
    /**
     * 企業名 かな
     * @type {string}
     * @memberof AdminCompanyPostParam
     */
    'kana': string;
    /**
     * 電話番号
     * @type {string}
     * @memberof AdminCompanyPostParam
     */
    'tel'?: string;
    /**
     * 企業DBとの紐付け
     * @type {Array<BlockCompany>}
     * @memberof AdminCompanyPostParam
     */
    'block_company_id'?: Array<BlockCompany>;
    /**
     * 
     * @type {string}
     * @memberof AdminCompanyPostParam
     */
    'company_user_name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCompanyPostParam
     */
    'company_user_furigana': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCompanyPostParam
     */
    'company_user_section': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCompanyPostParam
     */
    'company_user_post'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCompanyPostParam
     */
    'company_user_email': string;
    /**
     * MW担当者
     * @type {number}
     * @memberof AdminCompanyPostParam
     */
    'mw_user_id'?: number;
}
/**
 * 
 * @export
 * @interface AdminCompanyPostParamAllOf
 */
export interface AdminCompanyPostParamAllOf {
    /**
     * 企業名
     * @type {string}
     * @memberof AdminCompanyPostParamAllOf
     */
    'name': string;
    /**
     * 企業名 かな
     * @type {string}
     * @memberof AdminCompanyPostParamAllOf
     */
    'kana': string;
    /**
     * 電話番号
     * @type {string}
     * @memberof AdminCompanyPostParamAllOf
     */
    'tel'?: string;
    /**
     * 企業DBとの紐付け
     * @type {Array<BlockCompany>}
     * @memberof AdminCompanyPostParamAllOf
     */
    'block_company_id'?: Array<BlockCompany>;
    /**
     * 
     * @type {string}
     * @memberof AdminCompanyPostParamAllOf
     */
    'company_user_name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCompanyPostParamAllOf
     */
    'company_user_furigana': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCompanyPostParamAllOf
     */
    'company_user_section': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCompanyPostParamAllOf
     */
    'company_user_post'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCompanyPostParamAllOf
     */
    'company_user_email': string;
    /**
     * MW担当者
     * @type {number}
     * @memberof AdminCompanyPostParamAllOf
     */
    'mw_user_id'?: number;
}
/**
 * 管理者 Direct企業検索条件モデル
 * @export
 * @interface AdminDirectCompanySearchConditionModel
 */
export interface AdminDirectCompanySearchConditionModel {
    /**
     * フリーワード 複数設定可能  以下検索対象  - 企業名 - 企業名かな
     * @type {Array<string>}
     * @memberof AdminDirectCompanySearchConditionModel
     */
    'keyword'?: Array<string>;
    /**
     * 内部的に採番している Direct用の企業ID 
     * @type {number}
     * @memberof AdminDirectCompanySearchConditionModel
     */
    'directompany_id'?: number;
    /**
     * 紐づける 国税庁番号 法人番号の採番ルールは（CHAR(13)
     * @type {string}
     * @memberof AdminDirectCompanySearchConditionModel
     */
    'block_company_id'?: string;
    /**
     * 企業名
     * @type {string}
     * @memberof AdminDirectCompanySearchConditionModel
     */
    'name'?: string;
    /**
     * 企業名 かな
     * @type {string}
     * @memberof AdminDirectCompanySearchConditionModel
     */
    'kana'?: string;
    /**
     * 最終ログイン 期間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminDirectCompanySearchConditionModel
     */
    'last_login'?: Array<string>;
    /**
     * 登録日（サーバー側で付与） 期間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminDirectCompanySearchConditionModel
     */
    'registration_date'?: Array<string>;
    /**
     * 都道府県 選択項目は実装側定義参照
     * @type {number}
     * @memberof AdminDirectCompanySearchConditionModel
     */
    'prefecture'?: number;
    /**
     * 所在地
     * @type {string}
     * @memberof AdminDirectCompanySearchConditionModel
     */
    'address'?: string;
    /**
     * 業種 複数選択可能 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminDirectCompanySearchConditionModel
     */
    'business_type'?: Array<number>;
    /**
     * 社員数 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof AdminDirectCompanySearchConditionModel
     */
    'employee_amount'?: number;
    /**
     * 事業内容 複数設定可能
     * @type {Array<string>}
     * @memberof AdminDirectCompanySearchConditionModel
     */
    'description'?: Array<string>;
    /**
     * 企業担当者ID 採番ルール要確認
     * @type {string}
     * @memberof AdminDirectCompanySearchConditionModel
     */
    'direct_company_user_id'?: string;
    /**
     * 企業担当者のログインID（メールアドレス）
     * @type {string}
     * @memberof AdminDirectCompanySearchConditionModel
     */
    'direct_company_user_email'?: string;
    /**
     * 企業担当者の名前
     * @type {string}
     * @memberof AdminDirectCompanySearchConditionModel
     */
    'direct_company_user_name'?: string;
    /**
     * マイナビワークス担当者 選択項目はマスタまたは実装側定義参照 もしくはCP2？ 要確認
     * @type {string}
     * @memberof AdminDirectCompanySearchConditionModel
     */
    'mw_user'?: string;
}
/**
 * Admin 企業向けの検索条件レスポンス
 * @export
 * @interface AdminDirectSearchConditionResponse
 */
export interface AdminDirectSearchConditionResponse {
    /**
     * 検索条件ID
     * @type {number}
     * @memberof AdminDirectSearchConditionResponse
     */
    'id': number;
    /**
     * メール配信設定 true する false しない
     * @type {boolean}
     * @memberof AdminDirectSearchConditionResponse
     */
    'direct_mail'?: boolean;
    /**
     * メール設定を紐付けた企業情報
     * @type {Array<DirectCompanySummaryModel>}
     * @memberof AdminDirectSearchConditionResponse
     */
    'shared_companies'?: Array<DirectCompanySummaryModel>;
    /**
     * 検索条件名
     * @type {string}
     * @memberof AdminDirectSearchConditionResponse
     */
    'search_condition_name': string;
    /**
     * フリーワード 複数設定可能  毎日夜中にバッチで以下の情報をまとめたテキストをユーザー毎に更新しそのテキストが検索対象  - ユーザー情報 : 経歴 - ポートフォリオ :ページタイトル / イントロダクション / タイトル - ポートフォリオアイテム : description - 履歴書 : 志望動機 / 趣味特技 /本人希望 - 職務経歴 : 社名 / 業務内容 / 職務内容 / 最終ポジション / 退職理由 - 学歴 : 学校名 / 学部学科名 - 資格 : 資格タイプ / 資格名
     * @type {Array<string>}
     * @memberof AdminDirectSearchConditionResponse
     */
    'keyword'?: Array<string>;
    /**
     * オファー 選考ステータス 複数選択可能 選択項目はマスタまたは実装側定義参照  検索は全ての進捗（企業-求職者のやりとり）を対象とし、その進捗に関係のある求職者を出す
     * @type {Array<number>}
     * @memberof AdminDirectSearchConditionResponse
     */
    'offer_status'?: Array<number>;
    /**
     * オファー マッチ度 複数選択可能 選択項目はマスタまたは実装側定義参照  検索は全ての進捗（企業-求職者のやりとり）を対象とし、その進捗に関係のある求職者を出す  1: 底 | 2: 中 | 3: 高
     * @type {Array<number>}
     * @memberof AdminDirectSearchConditionResponse
     */
    'rate'?: Array<number>;
    /**
     * オファー 選考ステータス最終更新日 期間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminDirectSearchConditionResponse
     */
    'offer_update_at'?: Array<string>;
    /**
     * 一般ユーザーID C+数字乱数8桁（Ex. C12183640）
     * @type {string}
     * @memberof AdminDirectSearchConditionResponse
     */
    'matchbox_id'?: string;
    /**
     * 男女 (0:未設定(default), 1:女子, 2:男子)
     * @type {number}
     * @memberof AdminDirectSearchConditionResponse
     */
    'gender'?: number;
    /**
     * 年齢 [form, to] 配列で指
     * @type {Array<number>}
     * @memberof AdminDirectSearchConditionResponse
     */
    'age'?: Array<number>;
    /**
     * 職種と経験年数。複数の場合 OR検索
     * @type {Array<CommonSCMcExperiencedJobObjectModel>}
     * @memberof AdminDirectSearchConditionResponse
     */
    'mc_experienced_job'?: Array<CommonSCMcExperiencedJobObjectModel>;
    /**
     * 転職希望時期 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminDirectSearchConditionResponse
     */
    'mc_preferred_change_date'?: Array<number>;
    /**
     * 都道府県 選択項目は実装側定義参照
     * @type {number}
     * @memberof AdminDirectSearchConditionResponse
     */
    'prefecture'?: number;
    /**
     * 就業状況 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof AdminDirectSearchConditionResponse
     */
    'mc_situation'?: number;
    /**
     * 現在の在籍企業
     * @type {string}
     * @memberof AdminDirectSearchConditionResponse
     */
    'career_history_current_companies'?: string;
    /**
     * 現在の年収 選択項目は希望年収と同様マスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminDirectSearchConditionResponse
     */
    'mc_yearly_income'?: Array<number>;
    /**
     * 現在の在籍部署名
     * @type {string}
     * @memberof AdminDirectSearchConditionResponse
     */
    'career_history_current_section'?: string;
    /**
     * 現在の役職名
     * @type {string}
     * @memberof AdminDirectSearchConditionResponse
     */
    'career_history_current_post'?: string;
    /**
     * ポートフォリオの作品数 範囲を[form, to] 配列で指定
     * @type {Array<number>}
     * @memberof AdminDirectSearchConditionResponse
     */
    'portfolio_item_count'?: Array<number>;
    /**
     * 経験社数 範囲を[form, to] 配列で指定
     * @type {Array<number>}
     * @memberof AdminDirectSearchConditionResponse
     */
    'career_history_amount'?: Array<number>;
    /**
     * これまでの在籍企業 複数設定可能
     * @type {Array<string>}
     * @memberof AdminDirectSearchConditionResponse
     */
    'career_history_companies'?: Array<string>;
    /**
     * これまでの部署名 複数設定可能
     * @type {Array<string>}
     * @memberof AdminDirectSearchConditionResponse
     */
    'career_history_section'?: Array<string>;
    /**
     * これまでの役職名 複数設定可能
     * @type {Array<string>}
     * @memberof AdminDirectSearchConditionResponse
     */
    'career_history_post'?: Array<string>;
    /**
     * 担当内容 複数設定可能  各ポートフォリオ作品内の「担当内容」を参照
     * @type {Array<string>}
     * @memberof AdminDirectSearchConditionResponse
     */
    'qa_answer'?: Array<string>;
    /**
     * 経験 複数設定可能 ポートフォリオ作品の経験の項目を検索
     * @type {Array<string>}
     * @memberof AdminDirectSearchConditionResponse
     */
    'career_history_experiences'?: Array<string>;
    /**
     * 使用言語・ツール 複数設定可能
     * @type {Array<string>}
     * @memberof AdminDirectSearchConditionResponse
     */
    'career_history_tools'?: Array<string>;
    /**
     * 最大マネジメント人数 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminDirectSearchConditionResponse
     */
    'mc_maximum_management_count'?: Array<number>;
    /**
     * 資格・免許 複数設定可能
     * @type {Array<string>}
     * @memberof AdminDirectSearchConditionResponse
     */
    'q_title'?: Array<string>;
    /**
     * TOEIC点数
     * @type {number}
     * @memberof AdminDirectSearchConditionResponse
     */
    'q_toeic_score'?: number;
    /**
     * TOEFL点数
     * @type {number}
     * @memberof AdminDirectSearchConditionResponse
     */
    'q_toefl_score'?: number;
    /**
     * 英語力 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof AdminDirectSearchConditionResponse
     */
    'mc_english_skills'?: number;
    /**
     * 学校名 複数設定可能
     * @type {Array<string>}
     * @memberof AdminDirectSearchConditionResponse
     */
    'e_school_name'?: Array<string>;
    /**
     * 最終学歴 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminDirectSearchConditionResponse
     */
    'final_education'?: Array<number>;
    /**
     * 希望職種 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminDirectSearchConditionResponse
     */
    'mc_preferred_job_type'?: Array<number>;
    /**
     * 希望業種 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminDirectSearchConditionResponse
     */
    'mc_preferred_business_type'?: Array<number>;
    /**
     * 希望勤務地 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminDirectSearchConditionResponse
     */
    'mc_preferred_prefecture'?: Array<number>;
    /**
     * 希望年収 選択項目は現在の年収と同様マスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminDirectSearchConditionResponse
     */
    'mc_preferred_yearly_income'?: Array<number>;
    /**
     * 希望雇用形態 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminDirectSearchConditionResponse
     */
    'mc_preferred_employment_status'?: Array<number>;
    /**
     * こだわりの条件 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminDirectSearchConditionResponse
     */
    'mc_conditions'?: Array<number>;
    /**
     * 自作ポートフォリオの登録の有無(1:あり/0:なし)
     * @type {number}
     * @memberof AdminDirectSearchConditionResponse
     */
    'has_own_portfolio'?: number;
    /**
     * 入力代行ステータス - 0: 申し込み無し - 1: 求職者依頼中 - 2: 管理者見送り - 3: 管理者入力完了 - 4: 求職者入力内容反映済 
     * @type {number}
     * @memberof AdminDirectSearchConditionResponse
     */
    'input_agency'?: number;
    /**
     * ポートフォリオ更新日 期間選択 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof AdminDirectSearchConditionResponse
     */
    'last_update_portfolio'?: number;
    /**
     * ⾃作ポートフォリオの最終更新日 期間選択 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof AdminDirectSearchConditionResponse
     */
    'last_update_own_portfolio'?: number;
    /**
     * 職務経歴書の最終更新日 期間選択 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof AdminDirectSearchConditionResponse
     */
    'last_update_career_history'?: number;
    /**
     * 登録日（サーバー側で付与） 期間選択 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof AdminDirectSearchConditionResponse
     */
    'registration_date'?: number;
    /**
     * 最終ログイン 期間選択 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof AdminDirectSearchConditionResponse
     */
    'last_login'?: number;
}
/**
 * 
 * @export
 * @interface AdminDirectSearchConditionResponseAllOf
 */
export interface AdminDirectSearchConditionResponseAllOf {
    /**
     * 検索条件ID
     * @type {number}
     * @memberof AdminDirectSearchConditionResponseAllOf
     */
    'id': number;
    /**
     * メール配信設定 true する false しない
     * @type {boolean}
     * @memberof AdminDirectSearchConditionResponseAllOf
     */
    'direct_mail'?: boolean;
    /**
     * メール設定を紐付けた企業情報
     * @type {Array<DirectCompanySummaryModel>}
     * @memberof AdminDirectSearchConditionResponseAllOf
     */
    'shared_companies'?: Array<DirectCompanySummaryModel>;
}
/**
 * Admin 企業向けの保存した検索一覧レスポンス
 * @export
 * @interface AdminDirectSearchConditionsResponse
 */
export interface AdminDirectSearchConditionsResponse {
    /**
     * 保存検索一覧
     * @type {Array<AdminDirectSearchConditionResponse>}
     * @memberof AdminDirectSearchConditionsResponse
     */
    'conditions': Array<AdminDirectSearchConditionResponse>;
    /**
     * success のみ
     * @type {string}
     * @memberof AdminDirectSearchConditionsResponse
     */
    'result': string;
}
/**
 * 
 * @export
 * @interface AdminDirectSearchConditionsResponseAllOf
 */
export interface AdminDirectSearchConditionsResponseAllOf {
    /**
     * 保存検索一覧
     * @type {Array<AdminDirectSearchConditionResponse>}
     * @memberof AdminDirectSearchConditionsResponseAllOf
     */
    'conditions': Array<AdminDirectSearchConditionResponse>;
}
/**
 * Admin Direct 管理画面で取得できるユーザー情報のベースモデル Admin Directではuser_infoがそれぞれ違う  matchbox_id は user_info にあるからいらないかも？  ---  * ユーザーの状態を新しく追加しなくてはいけないかもしれない  ## user_statusについて - active / アクティブ（現状のすべてのユーザー） - inactive / 非アクティブ、サイトからは表示されず、/admin/ 系のAPIしか動かない - before_delete / この状態になってから３ヶ月で削除される - deleted / 削除された（そもそもこの状態はDBにデータが無いので現れることはない） - ユーザーが削除されるまでのパラメータも必要？
 * @export
 * @interface AdminDirectUserSearchModel
 */
export interface AdminDirectUserSearchModel {
    /**
     * 一般ユーザーID C+数字乱数8桁（Ex. C12183640）
     * @type {string}
     * @memberof AdminDirectUserSearchModel
     */
    'matchbox_id': string;
    /**
     * アカウント開設日 YYY-MM-DD
     * @type {string}
     * @memberof AdminDirectUserSearchModel
     */
    'registration_date'?: string;
    /**
     * ポートフォリオ更新日 YYY-MM-DD hh:mm:ss
     * @type {string}
     * @memberof AdminDirectUserSearchModel
     */
    'last_update_portfolio'?: string;
    /**
     * 自作ポートフォリオ更新日 YYY-MM-DD hh:mm:ss
     * @type {string}
     * @memberof AdminDirectUserSearchModel
     */
    'last_update_own_portfolio'?: string;
    /**
     * ポートフォリオ更新日 YYY-MM-DD hh:mm:ss
     * @type {string}
     * @memberof AdminDirectUserSearchModel
     */
    'last_update_public_portfolio'?: string;
    /**
     * 履歴書更新日更新日 YYY-MM-DD hh:mm:ss
     * @type {string}
     * @memberof AdminDirectUserSearchModel
     */
    'last_update_resume'?: string;
    /**
     * 
     * @type {Portfolio}
     * @memberof AdminDirectUserSearchModel
     */
    'portfolio'?: Portfolio;
    /**
     * 
     * @type {OwnPortfolio}
     * @memberof AdminDirectUserSearchModel
     */
    'own_portfolio'?: OwnPortfolio;
    /**
     * 職務経歴書更新日 YYY-MM-DD hh:mm:ss
     * @type {string}
     * @memberof AdminDirectUserSearchModel
     */
    'last_update_career_history'?: string;
    /**
     * ユーザー状態 active | inactive | before_delete | deleted
     * @type {string}
     * @memberof AdminDirectUserSearchModel
     */
    'user_status': string;
    /**
     * 
     * @type {CareerHistory}
     * @memberof AdminDirectUserSearchModel
     */
    'career_history'?: CareerHistory;
    /**
     * 最終ログイン日
     * @type {Set<LastLogin>}
     * @memberof AdminDirectUserSearchModel
     */
    'last_login': Set<LastLogin>;
    /**
     * 広告効果測定用エントリーID 15桁の数値の文字列で生成 詳細は仕様書の説明項目を参照
     * @type {string}
     * @memberof AdminDirectUserSearchModel
     */
    'user_entry_id': string;
    /**
     * 
     * @type {MyNavi}
     * @memberof AdminDirectUserSearchModel
     */
    'mc'?: MyNavi;
    /**
     * 管理タグ（旧確認ステータス）
     * @type {string}
     * @memberof AdminDirectUserSearchModel
     */
    'user_admin_tags'?: string;
    /**
     * 
     * @type {Array<Offer>}
     * @memberof AdminDirectUserSearchModel
     */
    'offers'?: Array<Offer>;
    /**
     * 検索結果に表示された求職者情報が、Direct/Adminユーザーにクリックされているか。求職者が自身の情報を更新した際に、すべてのDirect/Adminユーザーに対しての、is_readがfalseにリセットされる
     * @type {boolean}
     * @memberof AdminDirectUserSearchModel
     */
    'is_read'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminDirectUserSearchModel
     */
    'portfolio_item_count'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminDirectUserSearchModel
     */
    'portfolio_password'?: string;
    /**
     * 
     * @type {AdminUserInfoModel}
     * @memberof AdminDirectUserSearchModel
     */
    'user_info'?: AdminUserInfoModel;
    /**
     * 
     * @type {string}
     * @memberof AdminDirectUserSearchModel
     */
    'status'?: string;
    /**
     * 非表示作品含んだ数
     * @type {string}
     * @memberof AdminDirectUserSearchModel
     */
    'portfolio_item_count_contained_invisible'?: string;
    /**
     * 企業向けポートフォリオの作品数
     * @type {number}
     * @memberof AdminDirectUserSearchModel
     */
    'direct_portfolio_item_count'?: number;
    /**
     * 企業向け求職者コメント
     * @type {string}
     * @memberof AdminDirectUserSearchModel
     */
    'comment'?: string;
    /**
     * 最終オファー登録日 YYY-MM-DD
     * @type {string}
     * @memberof AdminDirectUserSearchModel
     */
    'last_update_use_direct'?: string;
}
/**
 * 管理画面用マスタ Cp2連携モデル
 * @export
 * @interface AdminMasterCp2Model
 */
export interface AdminMasterCp2Model {
    /**
     * 
     * @type {Array<CommonMasterOptionModel>}
     * @memberof AdminMasterCp2Model
     */
    'cp2_registration_status': Array<CommonMasterOptionModel>;
    /**
     * 
     * @type {Array<CommonMasterOptionModel>}
     * @memberof AdminMasterCp2Model
     */
    'cp2_consultation_status': Array<CommonMasterOptionModel>;
    /**
     * 
     * @type {Array<CommonMasterOptionModel>}
     * @memberof AdminMasterCp2Model
     */
    'cp2_charge_name': Array<CommonMasterOptionModel>;
}
/**
 * 管理画面 求職者情報 Cp2連携モデル
 * @export
 * @interface AdminMatchboxUserCp2Model
 */
export interface AdminMatchboxUserCp2Model {
    /**
     * CP2 登録ステータス CP2連携項目についてはAPI Overview項目参照 valueが返ってくるので表示名に関しては[マスタ](#operation/get-admin-master-cp2)から取得
     * @type {string}
     * @memberof AdminMatchboxUserCp2Model
     */
    'cp2_registration_status'?: string;
    /**
     * CP2 面談ステータス CP2連携項目についてはAPI Overview項目参照 valueが返ってくるので表示名に関しては[マスタ](#operation/get-admin-master-cp2)から取得
     * @type {string}
     * @memberof AdminMatchboxUserCp2Model
     */
    'cp2_consultation_status'?: string;
    /**
     * CP2 担当者名 CP2連携項目についてはAPI Overview項目参照 valueが返ってくるので表示名に関しては[マスタ](#operation/get-admin-master-cp2)から取得
     * @type {string}
     * @memberof AdminMatchboxUserCp2Model
     */
    'cp2_charge_name'?: string;
}
/**
 * 管理画面 求職者情報 リクエスト
 * @export
 * @interface AdminMatchboxUserRequest
 */
export interface AdminMatchboxUserRequest {
    /**
     * ポートフォリオ公開状態（プライバシー設定）  - public : パスワードなし - password : パスワードつき - closed : 非公開
     * @type {string}
     * @memberof AdminMatchboxUserRequest
     */
    'portfolio_status'?: string;
    /**
     * 求職者ユーザーのパスワード portfolio_status をパスワード付きで公開する場合  パスワードの仕様は冒頭説明項目参照
     * @type {string}
     * @memberof AdminMatchboxUserRequest
     */
    'portfolio_password'?: string;
    /**
     * ユーザー状態 active | inactive | before_delete | deleted
     * @type {string}
     * @memberof AdminMatchboxUserRequest
     */
    'user_status'?: string;
    /**
     * 管理タグ（旧確認ステータス）
     * @type {string}
     * @memberof AdminMatchboxUserRequest
     */
    'user_admin_tags'?: string;
    /**
     * 企業向け求職者コメント
     * @type {string}
     * @memberof AdminMatchboxUserRequest
     */
    'comment'?: string;
}
/**
 * 管理画面 求職者情報 レスポンス
 * @export
 * @interface AdminMatchboxUserResponse
 */
export interface AdminMatchboxUserResponse {
    /**
     * 一般ユーザーID C+数字乱数8桁（Ex. C12183640）
     * @type {string}
     * @memberof AdminMatchboxUserResponse
     */
    'matchbox_id': string;
    /**
     * アカウント開設日 YYY-MM-DD
     * @type {string}
     * @memberof AdminMatchboxUserResponse
     */
    'registration_date'?: string;
    /**
     * ポートフォリオ更新日 YYY-MM-DD hh:mm:ss
     * @type {string}
     * @memberof AdminMatchboxUserResponse
     */
    'last_update_portfolio'?: string;
    /**
     * 自作ポートフォリオ更新日 YYY-MM-DD hh:mm:ss
     * @type {string}
     * @memberof AdminMatchboxUserResponse
     */
    'last_update_own_portfolio'?: string;
    /**
     * ポートフォリオ更新日 YYY-MM-DD hh:mm:ss
     * @type {string}
     * @memberof AdminMatchboxUserResponse
     */
    'last_update_public_portfolio'?: string;
    /**
     * 履歴書更新日更新日 YYY-MM-DD hh:mm:ss
     * @type {string}
     * @memberof AdminMatchboxUserResponse
     */
    'last_update_resume'?: string;
    /**
     * 
     * @type {Portfolio}
     * @memberof AdminMatchboxUserResponse
     */
    'portfolio'?: Portfolio;
    /**
     * 
     * @type {OwnPortfolio}
     * @memberof AdminMatchboxUserResponse
     */
    'own_portfolio'?: OwnPortfolio;
    /**
     * 職務経歴書更新日 YYY-MM-DD hh:mm:ss
     * @type {string}
     * @memberof AdminMatchboxUserResponse
     */
    'last_update_career_history'?: string;
    /**
     * ユーザー状態 active | inactive | before_delete | deleted
     * @type {string}
     * @memberof AdminMatchboxUserResponse
     */
    'user_status': string;
    /**
     * 
     * @type {CareerHistory}
     * @memberof AdminMatchboxUserResponse
     */
    'career_history'?: CareerHistory;
    /**
     * 最終ログイン日
     * @type {Set<LastLogin>}
     * @memberof AdminMatchboxUserResponse
     */
    'last_login': Set<LastLogin>;
    /**
     * 広告効果測定用エントリーID 15桁の数値の文字列で生成 詳細は仕様書の説明項目を参照
     * @type {string}
     * @memberof AdminMatchboxUserResponse
     */
    'user_entry_id': string;
    /**
     * 
     * @type {MyNavi}
     * @memberof AdminMatchboxUserResponse
     */
    'mc'?: MyNavi;
    /**
     * 管理タグ（旧確認ステータス）
     * @type {string}
     * @memberof AdminMatchboxUserResponse
     */
    'user_admin_tags'?: string;
    /**
     * 
     * @type {Array<Offer>}
     * @memberof AdminMatchboxUserResponse
     */
    'offers'?: Array<Offer>;
    /**
     * 検索結果に表示された求職者情報が、Direct/Adminユーザーにクリックされているか。求職者が自身の情報を更新した際に、すべてのDirect/Adminユーザーに対しての、is_readがfalseにリセットされる
     * @type {boolean}
     * @memberof AdminMatchboxUserResponse
     */
    'is_read'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminMatchboxUserResponse
     */
    'portfolio_item_count'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminMatchboxUserResponse
     */
    'portfolio_password'?: string;
    /**
     * 
     * @type {AdminUserInfoModel}
     * @memberof AdminMatchboxUserResponse
     */
    'user_info': AdminUserInfoModel;
    /**
     * 
     * @type {string}
     * @memberof AdminMatchboxUserResponse
     */
    'status'?: string;
    /**
     * 非表示作品含んだ数
     * @type {string}
     * @memberof AdminMatchboxUserResponse
     */
    'portfolio_item_count_contained_invisible'?: string;
    /**
     * 企業向けポートフォリオの作品数
     * @type {number}
     * @memberof AdminMatchboxUserResponse
     */
    'direct_portfolio_item_count'?: number;
    /**
     * 企業向け求職者コメント
     * @type {string}
     * @memberof AdminMatchboxUserResponse
     */
    'comment'?: string;
    /**
     * 最終オファー登録日 YYY-MM-DD
     * @type {string}
     * @memberof AdminMatchboxUserResponse
     */
    'last_update_use_direct'?: string;
    /**
     * success のみ
     * @type {string}
     * @memberof AdminMatchboxUserResponse
     */
    'result': string;
}
/**
 * 管理者 社内メモ モデル
 * @export
 * @interface AdminNoteModel
 */
export interface AdminNoteModel {
    /**
     * メモデータのID
     * @type {number}
     * @memberof AdminNoteModel
     */
    'id'?: number;
    /**
     * 一般ユーザーID C+数字乱数8桁（Ex. C12183640）
     * @type {string}
     * @memberof AdminNoteModel
     */
    'matchbox_id'?: string;
    /**
     * メモ内容
     * @type {string}
     * @memberof AdminNoteModel
     */
    'content'?: string;
    /**
     * 
     * @type {AdminUserModel}
     * @memberof AdminNoteModel
     */
    'user'?: AdminUserModel;
    /**
     * 既読。エンドユーザーと、Direct管理者がそれぞれ個別のステータスを持つ
     * @type {boolean}
     * @memberof AdminNoteModel
     */
    'is_read'?: boolean;
    /**
     * メモ作成日 YYYY-MM-DD hh:mm:ss
     * @type {string}
     * @memberof AdminNoteModel
     */
    'created_at'?: string;
}
/**
 * メモを既読にする
 * @export
 * @interface AdminNotePatchParam
 */
export interface AdminNotePatchParam {
    /**
     * 
     * @type {boolean}
     * @memberof AdminNotePatchParam
     */
    'is_read'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminNotePatchParam
     */
    'id'?: number;
}
/**
 * matchbox_idは送るユーザーを指定、company_idは送る企業を指定
 * @export
 * @interface AdminNotePostParam
 */
export interface AdminNotePostParam {
    /**
     * 
     * @type {string}
     * @memberof AdminNotePostParam
     */
    'content'?: string;
    /**
     * 一般ユーザーID C+数字乱数8桁（Ex. C12183640）
     * @type {string}
     * @memberof AdminNotePostParam
     */
    'matchbox_id'?: string;
    /**
     * 内部的に採番している Direct用の企業ID 
     * @type {number}
     * @memberof AdminNotePostParam
     */
    'company_id'?: number;
}
/**
 * 管理者 メモ一覧 レスポンス
 * @export
 * @interface AdminNotesResponse
 */
export interface AdminNotesResponse {
    /**
     * 
     * @type {Array<AdminNoteModel>}
     * @memberof AdminNotesResponse
     */
    'notes'?: Array<AdminNoteModel>;
    /**
     * success のみ
     * @type {string}
     * @memberof AdminNotesResponse
     */
    'result': string;
}
/**
 * 
 * @export
 * @interface AdminNotesResponseAllOf
 */
export interface AdminNotesResponseAllOf {
    /**
     * 
     * @type {Array<AdminNoteModel>}
     * @memberof AdminNotesResponseAllOf
     */
    'notes'?: Array<AdminNoteModel>;
}
/**
 * 管理者 Direct検索条件リクエスト
 * @export
 * @interface AdminSearchCompaniesRequest
 */
export interface AdminSearchCompaniesRequest {
    /**
     * 取得件数 指定がない場合は20
     * @type {number}
     * @memberof AdminSearchCompaniesRequest
     */
    'limit'?: number;
    /**
     * 次のページ番号 指定がない場合は0
     * @type {number}
     * @memberof AdminSearchCompaniesRequest
     */
    'offset'?: number;
    /**
     * 検索項目 項目はdescription参照
     * @type {string}
     * @memberof AdminSearchCompaniesRequest
     */
    'sort_by'?: string;
    /**
     * 検索順序 asc | desc
     * @type {string}
     * @memberof AdminSearchCompaniesRequest
     */
    'sort_order'?: string;
    /**
     * 
     * @type {AdminDirectCompanySearchConditionModel}
     * @memberof AdminSearchCompaniesRequest
     */
    'conditions'?: AdminDirectCompanySearchConditionModel;
}
/**
 * 
 * @export
 * @interface AdminSearchCompaniesRequestAllOf
 */
export interface AdminSearchCompaniesRequestAllOf {
    /**
     * 
     * @type {AdminDirectCompanySearchConditionModel}
     * @memberof AdminSearchCompaniesRequestAllOf
     */
    'conditions'?: AdminDirectCompanySearchConditionModel;
}
/**
 * 管理画面用 Direct企業検索レスポンス
 * @export
 * @interface AdminSearchCompaniesResponse
 */
export interface AdminSearchCompaniesResponse {
    /**
     * 
     * @type {Array<AdminCompany>}
     * @memberof AdminSearchCompaniesResponse
     */
    'companies'?: Array<AdminCompany>;
    /**
     * ページネーションの次のoffset or null
     * @type {number}
     * @memberof AdminSearchCompaniesResponse
     */
    'offset'?: number | null;
    /**
     * 現在の条件でのレコード総数
     * @type {number}
     * @memberof AdminSearchCompaniesResponse
     */
    'total'?: number;
    /**
     * success のみ
     * @type {string}
     * @memberof AdminSearchCompaniesResponse
     */
    'result': string;
}
/**
 * 
 * @export
 * @interface AdminSearchCompaniesResponseAllOf
 */
export interface AdminSearchCompaniesResponseAllOf {
    /**
     * 
     * @type {Array<AdminCompany>}
     * @memberof AdminSearchCompaniesResponseAllOf
     */
    'companies'?: Array<AdminCompany>;
}
/**
 * Admin検索条件モデル Admin側のみで使用するモデルピックアップ
 * @export
 * @interface AdminSearchConditionDifferenceModel
 */
export interface AdminSearchConditionDifferenceModel {
    /**
     * 広告効果測定用エントリーID 15桁の数値の文字列で生成 詳細は仕様書の説明項目を参照
     * @type {string}
     * @memberof AdminSearchConditionDifferenceModel
     */
    'user_entry_id'?: string;
    /**
     * ユーザーID、ニックネーム URL などにも使用。ユニークなもの
     * @type {string}
     * @memberof AdminSearchConditionDifferenceModel
     */
    'user_id'?: string;
    /**
     * ユーザー名
     * @type {string}
     * @memberof AdminSearchConditionDifferenceModel
     */
    'name'?: string;
    /**
     * ユーザー名 ふりがな
     * @type {string}
     * @memberof AdminSearchConditionDifferenceModel
     */
    'furigana'?: string;
    /**
     * Eメールアドレス
     * @type {string}
     * @memberof AdminSearchConditionDifferenceModel
     */
    'email'?: string;
    /**
     * ポートフォリオURL
     * @type {string}
     * @memberof AdminSearchConditionDifferenceModel
     */
    'portfolio_url'?: string;
    /**
     * 電話番号(ハイフン省略可)
     * @type {string}
     * @memberof AdminSearchConditionDifferenceModel
     */
    'tel'?: string;
    /**
     * 住所 検索対象はユーザー情報のaddress1, address2, address3
     * @type {string}
     * @memberof AdminSearchConditionDifferenceModel
     */
    'address'?: string;
    /**
     * 誕生日 期間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminSearchConditionDifferenceModel
     */
    'birth_date'?: Array<string>;
    /**
     * 最終ログイン 期間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminSearchConditionDifferenceModel
     */
    'last_login'?: Array<string>;
    /**
     * 登録日（サーバー側で付与） 期間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminSearchConditionDifferenceModel
     */
    'registration_date'?: Array<string>;
    /**
     * ポートフォリオの最終更新日 期間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminSearchConditionDifferenceModel
     */
    'last_update_portfolio'?: Array<string>;
    /**
     * ⾃作ポートフォリオの最終更新日間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminSearchConditionDifferenceModel
     */
    'last_update_own_portfolio'?: Array<string>;
    /**
     * 履歴書の最終更新日 期間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminSearchConditionDifferenceModel
     */
    'last_update_resume'?: Array<string>;
    /**
     * 履歴職務経歴書の最終更新日間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminSearchConditionDifferenceModel
     */
    'last_update_career_history'?: Array<string>;
    /**
     * ポートフォリオ公開状態（プライバシー設定）  - public : パスワードなし - password : パスワードつき - closed : 非公開
     * @type {string}
     * @memberof AdminSearchConditionDifferenceModel
     */
    'portfolio_state'?: string;
    /**
     * ダイレクトへの登録 - 0 未登録 - 1 登録済み
     * @type {number}
     * @memberof AdminSearchConditionDifferenceModel
     */
    'connected_to_mbdirect'?: number;
    /**
     * オファー 対応状況 1: 未完了 | 2: 保留 | 3: 完了
     * @type {number}
     * @memberof AdminSearchConditionDifferenceModel
     */
    'mw_status'?: number;
    /**
     * オファー数 範囲を[form, to] 配列で指定
     * @type {Array<number>}
     * @memberof AdminSearchConditionDifferenceModel
     */
    'offer_amount'?: Array<number>;
    /**
     * ピックアップ数 範囲を[form, to] 配列で指定
     * @type {Array<number>}
     * @memberof AdminSearchConditionDifferenceModel
     */
    'offer_pickup_amount'?: Array<number>;
    /**
     * 管理タグ（旧確認ステータス） 複数選択可能 選択項目はマスタまたは実装側定義参照
     * @type {Array<string>}
     * @memberof AdminSearchConditionDifferenceModel
     */
    'user_admin_tags'?: Array<string>;
    /**
     * ポートフォリオの公開作品数 範囲を[form, to] 配列で指定
     * @type {Array<number>}
     * @memberof AdminSearchConditionDifferenceModel
     */
    'published_portfolio_item_count'?: Array<number>;
    /**
     * ポートフォリオの公開作品数 範囲を[form, to] 配列で指定
     * @type {Array<number>}
     * @memberof AdminSearchConditionDifferenceModel
     */
    'direct_portfolio_item_count'?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof AdminSearchConditionDifferenceModel
     */
    'portfolio_item_count_contained_invisible'?: number;
    /**
     * タグ検索
     * @type {Array<string>}
     * @memberof AdminSearchConditionDifferenceModel
     */
    'user_tags'?: Array<string>;
    /**
     * 最終オファー登録日 期間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminSearchConditionDifferenceModel
     */
    'last_update_use_direct'?: Array<string>;
}
/**
 * Admin検索条件モデル Directのモデルの拡張版
 * @export
 * @interface AdminSearchConditionModel
 */
export interface AdminSearchConditionModel {
    /**
     * フリーワード 複数設定可能  毎日夜中にバッチで以下の情報をまとめたテキストをユーザー毎に更新しそのテキストが検索対象  - ユーザー情報 : 経歴 - ポートフォリオ :ページタイトル / イントロダクション / タイトル - ポートフォリオアイテム : description - 履歴書 : 志望動機 / 趣味特技 /本人希望 - 職務経歴 : 社名 / 業務内容 / 職務内容 / 最終ポジション / 退職理由 - 学歴 : 学校名 / 学部学科名 - 資格 : 資格タイプ / 資格名
     * @type {Array<string>}
     * @memberof AdminSearchConditionModel
     */
    'keyword'?: Array<string>;
    /**
     * オファー 選考ステータス 複数選択可能 選択項目はマスタまたは実装側定義参照  検索は全ての進捗（企業-求職者のやりとり）を対象とし、その進捗に関係のある求職者を出す
     * @type {Array<number>}
     * @memberof AdminSearchConditionModel
     */
    'offer_status'?: Array<number>;
    /**
     * オファー マッチ度 複数選択可能 選択項目はマスタまたは実装側定義参照  検索は全ての進捗（企業-求職者のやりとり）を対象とし、その進捗に関係のある求職者を出す  1: 底 | 2: 中 | 3: 高
     * @type {Array<number>}
     * @memberof AdminSearchConditionModel
     */
    'rate'?: Array<number>;
    /**
     * オファー 選考ステータス最終更新日 期間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminSearchConditionModel
     */
    'offer_update_at'?: Array<string>;
    /**
     * 一般ユーザーID C+数字乱数8桁（Ex. C12183640）
     * @type {string}
     * @memberof AdminSearchConditionModel
     */
    'matchbox_id'?: string;
    /**
     * 男女 (0:未設定(default), 1:女子, 2:男子)
     * @type {number}
     * @memberof AdminSearchConditionModel
     */
    'gender'?: number;
    /**
     * 年齢 [form, to] 配列で指
     * @type {Array<number>}
     * @memberof AdminSearchConditionModel
     */
    'age'?: Array<number>;
    /**
     * 職種と経験年数。複数の場合 OR検索
     * @type {Array<CommonSCMcExperiencedJobObjectModel>}
     * @memberof AdminSearchConditionModel
     */
    'mc_experienced_job'?: Array<CommonSCMcExperiencedJobObjectModel>;
    /**
     * 転職希望時期 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminSearchConditionModel
     */
    'mc_preferred_change_date'?: Array<number>;
    /**
     * 都道府県 選択項目は実装側定義参照
     * @type {number}
     * @memberof AdminSearchConditionModel
     */
    'prefecture'?: number;
    /**
     * 就業状況 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof AdminSearchConditionModel
     */
    'mc_situation'?: number;
    /**
     * 現在の在籍企業
     * @type {string}
     * @memberof AdminSearchConditionModel
     */
    'career_history_current_companies'?: string;
    /**
     * 現在の年収 選択項目は希望年収と同様マスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminSearchConditionModel
     */
    'mc_yearly_income'?: Array<number>;
    /**
     * 現在の在籍部署名
     * @type {string}
     * @memberof AdminSearchConditionModel
     */
    'career_history_current_section'?: string;
    /**
     * 現在の役職名
     * @type {string}
     * @memberof AdminSearchConditionModel
     */
    'career_history_current_post'?: string;
    /**
     * ポートフォリオの作品数 範囲を[form, to] 配列で指定
     * @type {Array<number>}
     * @memberof AdminSearchConditionModel
     */
    'portfolio_item_count'?: Array<number>;
    /**
     * 経験社数 範囲を[form, to] 配列で指定
     * @type {Array<number>}
     * @memberof AdminSearchConditionModel
     */
    'career_history_amount'?: Array<number>;
    /**
     * これまでの在籍企業 複数設定可能
     * @type {Array<string>}
     * @memberof AdminSearchConditionModel
     */
    'career_history_companies'?: Array<string>;
    /**
     * これまでの部署名 複数設定可能
     * @type {Array<string>}
     * @memberof AdminSearchConditionModel
     */
    'career_history_section'?: Array<string>;
    /**
     * これまでの役職名 複数設定可能
     * @type {Array<string>}
     * @memberof AdminSearchConditionModel
     */
    'career_history_post'?: Array<string>;
    /**
     * 担当内容 複数設定可能  各ポートフォリオ作品内の「担当内容」を参照
     * @type {Array<string>}
     * @memberof AdminSearchConditionModel
     */
    'qa_answer'?: Array<string>;
    /**
     * 経験 複数設定可能 ポートフォリオ作品の経験の項目を検索
     * @type {Array<string>}
     * @memberof AdminSearchConditionModel
     */
    'career_history_experiences'?: Array<string>;
    /**
     * 使用言語・ツール 複数設定可能
     * @type {Array<string>}
     * @memberof AdminSearchConditionModel
     */
    'career_history_tools'?: Array<string>;
    /**
     * 最大マネジメント人数 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminSearchConditionModel
     */
    'mc_maximum_management_count'?: Array<number>;
    /**
     * 資格・免許 複数設定可能
     * @type {Array<string>}
     * @memberof AdminSearchConditionModel
     */
    'q_title'?: Array<string>;
    /**
     * TOEIC点数
     * @type {number}
     * @memberof AdminSearchConditionModel
     */
    'q_toeic_score'?: number;
    /**
     * TOEFL点数
     * @type {number}
     * @memberof AdminSearchConditionModel
     */
    'q_toefl_score'?: number;
    /**
     * 英語力 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof AdminSearchConditionModel
     */
    'mc_english_skills'?: number;
    /**
     * 学校名 複数設定可能
     * @type {Array<string>}
     * @memberof AdminSearchConditionModel
     */
    'e_school_name'?: Array<string>;
    /**
     * 最終学歴 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminSearchConditionModel
     */
    'final_education'?: Array<number>;
    /**
     * 希望職種 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminSearchConditionModel
     */
    'mc_preferred_job_type'?: Array<number>;
    /**
     * 希望業種 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminSearchConditionModel
     */
    'mc_preferred_business_type'?: Array<number>;
    /**
     * 希望勤務地 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminSearchConditionModel
     */
    'mc_preferred_prefecture'?: Array<number>;
    /**
     * 希望年収 選択項目は現在の年収と同様マスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminSearchConditionModel
     */
    'mc_preferred_yearly_income'?: Array<number>;
    /**
     * 希望雇用形態 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminSearchConditionModel
     */
    'mc_preferred_employment_status'?: Array<number>;
    /**
     * こだわりの条件 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminSearchConditionModel
     */
    'mc_conditions'?: Array<number>;
    /**
     * 自作ポートフォリオの登録の有無(1:あり/0:なし)
     * @type {number}
     * @memberof AdminSearchConditionModel
     */
    'has_own_portfolio'?: number;
    /**
     * 入力代行ステータス - 0: 申し込み無し - 1: 求職者依頼中 - 2: 管理者見送り - 3: 管理者入力完了 - 4: 求職者入力内容反映済 
     * @type {number}
     * @memberof AdminSearchConditionModel
     */
    'input_agency'?: number;
    /**
     * 広告効果測定用エントリーID 15桁の数値の文字列で生成 詳細は仕様書の説明項目を参照
     * @type {string}
     * @memberof AdminSearchConditionModel
     */
    'user_entry_id'?: string;
    /**
     * ユーザーID、ニックネーム URL などにも使用。ユニークなもの
     * @type {string}
     * @memberof AdminSearchConditionModel
     */
    'user_id'?: string;
    /**
     * ユーザー名
     * @type {string}
     * @memberof AdminSearchConditionModel
     */
    'name'?: string;
    /**
     * ユーザー名 ふりがな
     * @type {string}
     * @memberof AdminSearchConditionModel
     */
    'furigana'?: string;
    /**
     * Eメールアドレス
     * @type {string}
     * @memberof AdminSearchConditionModel
     */
    'email'?: string;
    /**
     * ポートフォリオURL
     * @type {string}
     * @memberof AdminSearchConditionModel
     */
    'portfolio_url'?: string;
    /**
     * 電話番号(ハイフン省略可)
     * @type {string}
     * @memberof AdminSearchConditionModel
     */
    'tel'?: string;
    /**
     * 住所 検索対象はユーザー情報のaddress1, address2, address3
     * @type {string}
     * @memberof AdminSearchConditionModel
     */
    'address'?: string;
    /**
     * 誕生日 期間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminSearchConditionModel
     */
    'birth_date'?: Array<string>;
    /**
     * 最終ログイン 期間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminSearchConditionModel
     */
    'last_login'?: Array<string>;
    /**
     * 登録日（サーバー側で付与） 期間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminSearchConditionModel
     */
    'registration_date'?: Array<string>;
    /**
     * ポートフォリオの最終更新日 期間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminSearchConditionModel
     */
    'last_update_portfolio'?: Array<string>;
    /**
     * ⾃作ポートフォリオの最終更新日間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminSearchConditionModel
     */
    'last_update_own_portfolio'?: Array<string>;
    /**
     * 履歴書の最終更新日 期間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminSearchConditionModel
     */
    'last_update_resume'?: Array<string>;
    /**
     * 履歴職務経歴書の最終更新日間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminSearchConditionModel
     */
    'last_update_career_history'?: Array<string>;
    /**
     * ポートフォリオ公開状態（プライバシー設定）  - public : パスワードなし - password : パスワードつき - closed : 非公開
     * @type {string}
     * @memberof AdminSearchConditionModel
     */
    'portfolio_state'?: string;
    /**
     * ダイレクトへの登録 - 0 未登録 - 1 登録済み
     * @type {number}
     * @memberof AdminSearchConditionModel
     */
    'connected_to_mbdirect'?: number;
    /**
     * オファー 対応状況 1: 未完了 | 2: 保留 | 3: 完了
     * @type {number}
     * @memberof AdminSearchConditionModel
     */
    'mw_status'?: number;
    /**
     * オファー数 範囲を[form, to] 配列で指定
     * @type {Array<number>}
     * @memberof AdminSearchConditionModel
     */
    'offer_amount'?: Array<number>;
    /**
     * ピックアップ数 範囲を[form, to] 配列で指定
     * @type {Array<number>}
     * @memberof AdminSearchConditionModel
     */
    'offer_pickup_amount'?: Array<number>;
    /**
     * 管理タグ（旧確認ステータス） 複数選択可能 選択項目はマスタまたは実装側定義参照
     * @type {Array<string>}
     * @memberof AdminSearchConditionModel
     */
    'user_admin_tags'?: Array<string>;
    /**
     * ポートフォリオの公開作品数 範囲を[form, to] 配列で指定
     * @type {Array<number>}
     * @memberof AdminSearchConditionModel
     */
    'published_portfolio_item_count'?: Array<number>;
    /**
     * ポートフォリオの公開作品数 範囲を[form, to] 配列で指定
     * @type {Array<number>}
     * @memberof AdminSearchConditionModel
     */
    'direct_portfolio_item_count'?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof AdminSearchConditionModel
     */
    'portfolio_item_count_contained_invisible'?: number;
    /**
     * タグ検索
     * @type {Array<string>}
     * @memberof AdminSearchConditionModel
     */
    'user_tags'?: Array<string>;
    /**
     * 最終オファー登録日 期間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminSearchConditionModel
     */
    'last_update_use_direct'?: Array<string>;
}
/**
 * Adminの検索条件保存リクエスト
 * @export
 * @interface AdminSearchConditionRequest
 */
export interface AdminSearchConditionRequest {
    /**
     * 検索条件名
     * @type {string}
     * @memberof AdminSearchConditionRequest
     */
    'search_condition_name': string;
    /**
     * フリーワード 複数設定可能  毎日夜中にバッチで以下の情報をまとめたテキストをユーザー毎に更新しそのテキストが検索対象  - ユーザー情報 : 経歴 - ポートフォリオ :ページタイトル / イントロダクション / タイトル - ポートフォリオアイテム : description - 履歴書 : 志望動機 / 趣味特技 /本人希望 - 職務経歴 : 社名 / 業務内容 / 職務内容 / 最終ポジション / 退職理由 - 学歴 : 学校名 / 学部学科名 - 資格 : 資格タイプ / 資格名
     * @type {Array<string>}
     * @memberof AdminSearchConditionRequest
     */
    'keyword'?: Array<string>;
    /**
     * オファー 選考ステータス 複数選択可能 選択項目はマスタまたは実装側定義参照  検索は全ての進捗（企業-求職者のやりとり）を対象とし、その進捗に関係のある求職者を出す
     * @type {Array<number>}
     * @memberof AdminSearchConditionRequest
     */
    'offer_status'?: Array<number>;
    /**
     * オファー マッチ度 複数選択可能 選択項目はマスタまたは実装側定義参照  検索は全ての進捗（企業-求職者のやりとり）を対象とし、その進捗に関係のある求職者を出す  1: 底 | 2: 中 | 3: 高
     * @type {Array<number>}
     * @memberof AdminSearchConditionRequest
     */
    'rate'?: Array<number>;
    /**
     * オファー 選考ステータス最終更新日 期間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminSearchConditionRequest
     */
    'offer_update_at'?: Array<string>;
    /**
     * 一般ユーザーID C+数字乱数8桁（Ex. C12183640）
     * @type {string}
     * @memberof AdminSearchConditionRequest
     */
    'matchbox_id'?: string;
    /**
     * 男女 (0:未設定(default), 1:女子, 2:男子)
     * @type {number}
     * @memberof AdminSearchConditionRequest
     */
    'gender'?: number;
    /**
     * 年齢 [form, to] 配列で指
     * @type {Array<number>}
     * @memberof AdminSearchConditionRequest
     */
    'age'?: Array<number>;
    /**
     * 職種と経験年数。複数の場合 OR検索
     * @type {Array<CommonSCMcExperiencedJobObjectModel>}
     * @memberof AdminSearchConditionRequest
     */
    'mc_experienced_job'?: Array<CommonSCMcExperiencedJobObjectModel>;
    /**
     * 転職希望時期 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminSearchConditionRequest
     */
    'mc_preferred_change_date'?: Array<number>;
    /**
     * 都道府県 選択項目は実装側定義参照
     * @type {number}
     * @memberof AdminSearchConditionRequest
     */
    'prefecture'?: number;
    /**
     * 就業状況 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof AdminSearchConditionRequest
     */
    'mc_situation'?: number;
    /**
     * 現在の在籍企業
     * @type {string}
     * @memberof AdminSearchConditionRequest
     */
    'career_history_current_companies'?: string;
    /**
     * 現在の年収 選択項目は希望年収と同様マスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminSearchConditionRequest
     */
    'mc_yearly_income'?: Array<number>;
    /**
     * 現在の在籍部署名
     * @type {string}
     * @memberof AdminSearchConditionRequest
     */
    'career_history_current_section'?: string;
    /**
     * 現在の役職名
     * @type {string}
     * @memberof AdminSearchConditionRequest
     */
    'career_history_current_post'?: string;
    /**
     * ポートフォリオの作品数 範囲を[form, to] 配列で指定
     * @type {Array<number>}
     * @memberof AdminSearchConditionRequest
     */
    'portfolio_item_count'?: Array<number>;
    /**
     * 経験社数 範囲を[form, to] 配列で指定
     * @type {Array<number>}
     * @memberof AdminSearchConditionRequest
     */
    'career_history_amount'?: Array<number>;
    /**
     * これまでの在籍企業 複数設定可能
     * @type {Array<string>}
     * @memberof AdminSearchConditionRequest
     */
    'career_history_companies'?: Array<string>;
    /**
     * これまでの部署名 複数設定可能
     * @type {Array<string>}
     * @memberof AdminSearchConditionRequest
     */
    'career_history_section'?: Array<string>;
    /**
     * これまでの役職名 複数設定可能
     * @type {Array<string>}
     * @memberof AdminSearchConditionRequest
     */
    'career_history_post'?: Array<string>;
    /**
     * 担当内容 複数設定可能  各ポートフォリオ作品内の「担当内容」を参照
     * @type {Array<string>}
     * @memberof AdminSearchConditionRequest
     */
    'qa_answer'?: Array<string>;
    /**
     * 経験 複数設定可能 ポートフォリオ作品の経験の項目を検索
     * @type {Array<string>}
     * @memberof AdminSearchConditionRequest
     */
    'career_history_experiences'?: Array<string>;
    /**
     * 使用言語・ツール 複数設定可能
     * @type {Array<string>}
     * @memberof AdminSearchConditionRequest
     */
    'career_history_tools'?: Array<string>;
    /**
     * 最大マネジメント人数 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminSearchConditionRequest
     */
    'mc_maximum_management_count'?: Array<number>;
    /**
     * 資格・免許 複数設定可能
     * @type {Array<string>}
     * @memberof AdminSearchConditionRequest
     */
    'q_title'?: Array<string>;
    /**
     * TOEIC点数
     * @type {number}
     * @memberof AdminSearchConditionRequest
     */
    'q_toeic_score'?: number;
    /**
     * TOEFL点数
     * @type {number}
     * @memberof AdminSearchConditionRequest
     */
    'q_toefl_score'?: number;
    /**
     * 英語力 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof AdminSearchConditionRequest
     */
    'mc_english_skills'?: number;
    /**
     * 学校名 複数設定可能
     * @type {Array<string>}
     * @memberof AdminSearchConditionRequest
     */
    'e_school_name'?: Array<string>;
    /**
     * 最終学歴 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminSearchConditionRequest
     */
    'final_education'?: Array<number>;
    /**
     * 希望職種 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminSearchConditionRequest
     */
    'mc_preferred_job_type'?: Array<number>;
    /**
     * 希望業種 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminSearchConditionRequest
     */
    'mc_preferred_business_type'?: Array<number>;
    /**
     * 希望勤務地 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminSearchConditionRequest
     */
    'mc_preferred_prefecture'?: Array<number>;
    /**
     * 希望年収 選択項目は現在の年収と同様マスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminSearchConditionRequest
     */
    'mc_preferred_yearly_income'?: Array<number>;
    /**
     * 希望雇用形態 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminSearchConditionRequest
     */
    'mc_preferred_employment_status'?: Array<number>;
    /**
     * こだわりの条件 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminSearchConditionRequest
     */
    'mc_conditions'?: Array<number>;
    /**
     * 自作ポートフォリオの登録の有無(1:あり/0:なし)
     * @type {number}
     * @memberof AdminSearchConditionRequest
     */
    'has_own_portfolio'?: number;
    /**
     * 入力代行ステータス - 0: 申し込み無し - 1: 求職者依頼中 - 2: 管理者見送り - 3: 管理者入力完了 - 4: 求職者入力内容反映済 
     * @type {number}
     * @memberof AdminSearchConditionRequest
     */
    'input_agency'?: number;
    /**
     * 広告効果測定用エントリーID 15桁の数値の文字列で生成 詳細は仕様書の説明項目を参照
     * @type {string}
     * @memberof AdminSearchConditionRequest
     */
    'user_entry_id'?: string;
    /**
     * ユーザーID、ニックネーム URL などにも使用。ユニークなもの
     * @type {string}
     * @memberof AdminSearchConditionRequest
     */
    'user_id'?: string;
    /**
     * ユーザー名
     * @type {string}
     * @memberof AdminSearchConditionRequest
     */
    'name'?: string;
    /**
     * ユーザー名 ふりがな
     * @type {string}
     * @memberof AdminSearchConditionRequest
     */
    'furigana'?: string;
    /**
     * Eメールアドレス
     * @type {string}
     * @memberof AdminSearchConditionRequest
     */
    'email'?: string;
    /**
     * ポートフォリオURL
     * @type {string}
     * @memberof AdminSearchConditionRequest
     */
    'portfolio_url'?: string;
    /**
     * 電話番号(ハイフン省略可)
     * @type {string}
     * @memberof AdminSearchConditionRequest
     */
    'tel'?: string;
    /**
     * 住所 検索対象はユーザー情報のaddress1, address2, address3
     * @type {string}
     * @memberof AdminSearchConditionRequest
     */
    'address'?: string;
    /**
     * 誕生日 期間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminSearchConditionRequest
     */
    'birth_date'?: Array<string>;
    /**
     * 最終ログイン 期間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminSearchConditionRequest
     */
    'last_login'?: Array<string>;
    /**
     * 登録日（サーバー側で付与） 期間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminSearchConditionRequest
     */
    'registration_date'?: Array<string>;
    /**
     * ポートフォリオの最終更新日 期間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminSearchConditionRequest
     */
    'last_update_portfolio'?: Array<string>;
    /**
     * ⾃作ポートフォリオの最終更新日間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminSearchConditionRequest
     */
    'last_update_own_portfolio'?: Array<string>;
    /**
     * 履歴書の最終更新日 期間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminSearchConditionRequest
     */
    'last_update_resume'?: Array<string>;
    /**
     * 履歴職務経歴書の最終更新日間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminSearchConditionRequest
     */
    'last_update_career_history'?: Array<string>;
    /**
     * ポートフォリオ公開状態（プライバシー設定）  - public : パスワードなし - password : パスワードつき - closed : 非公開
     * @type {string}
     * @memberof AdminSearchConditionRequest
     */
    'portfolio_state'?: string;
    /**
     * ダイレクトへの登録 - 0 未登録 - 1 登録済み
     * @type {number}
     * @memberof AdminSearchConditionRequest
     */
    'connected_to_mbdirect'?: number;
    /**
     * オファー 対応状況 1: 未完了 | 2: 保留 | 3: 完了
     * @type {number}
     * @memberof AdminSearchConditionRequest
     */
    'mw_status'?: number;
    /**
     * オファー数 範囲を[form, to] 配列で指定
     * @type {Array<number>}
     * @memberof AdminSearchConditionRequest
     */
    'offer_amount'?: Array<number>;
    /**
     * ピックアップ数 範囲を[form, to] 配列で指定
     * @type {Array<number>}
     * @memberof AdminSearchConditionRequest
     */
    'offer_pickup_amount'?: Array<number>;
    /**
     * 管理タグ（旧確認ステータス） 複数選択可能 選択項目はマスタまたは実装側定義参照
     * @type {Array<string>}
     * @memberof AdminSearchConditionRequest
     */
    'user_admin_tags'?: Array<string>;
    /**
     * ポートフォリオの公開作品数 範囲を[form, to] 配列で指定
     * @type {Array<number>}
     * @memberof AdminSearchConditionRequest
     */
    'published_portfolio_item_count'?: Array<number>;
    /**
     * ポートフォリオの公開作品数 範囲を[form, to] 配列で指定
     * @type {Array<number>}
     * @memberof AdminSearchConditionRequest
     */
    'direct_portfolio_item_count'?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof AdminSearchConditionRequest
     */
    'portfolio_item_count_contained_invisible'?: number;
    /**
     * タグ検索
     * @type {Array<string>}
     * @memberof AdminSearchConditionRequest
     */
    'user_tags'?: Array<string>;
    /**
     * 最終オファー登録日 期間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminSearchConditionRequest
     */
    'last_update_use_direct'?: Array<string>;
}
/**
 * Adminの検索条件レスポンス
 * @export
 * @interface AdminSearchConditionResponse
 */
export interface AdminSearchConditionResponse {
    /**
     * 検索条件ID
     * @type {number}
     * @memberof AdminSearchConditionResponse
     */
    'id': number;
    /**
     * メール配信設定 true する false しない
     * @type {boolean}
     * @memberof AdminSearchConditionResponse
     */
    'direct_mail'?: boolean;
    /**
     * 検索条件名
     * @type {string}
     * @memberof AdminSearchConditionResponse
     */
    'search_condition_name': string;
    /**
     * フリーワード 複数設定可能  毎日夜中にバッチで以下の情報をまとめたテキストをユーザー毎に更新しそのテキストが検索対象  - ユーザー情報 : 経歴 - ポートフォリオ :ページタイトル / イントロダクション / タイトル - ポートフォリオアイテム : description - 履歴書 : 志望動機 / 趣味特技 /本人希望 - 職務経歴 : 社名 / 業務内容 / 職務内容 / 最終ポジション / 退職理由 - 学歴 : 学校名 / 学部学科名 - 資格 : 資格タイプ / 資格名
     * @type {Array<string>}
     * @memberof AdminSearchConditionResponse
     */
    'keyword'?: Array<string>;
    /**
     * オファー 選考ステータス 複数選択可能 選択項目はマスタまたは実装側定義参照  検索は全ての進捗（企業-求職者のやりとり）を対象とし、その進捗に関係のある求職者を出す
     * @type {Array<number>}
     * @memberof AdminSearchConditionResponse
     */
    'offer_status'?: Array<number>;
    /**
     * オファー マッチ度 複数選択可能 選択項目はマスタまたは実装側定義参照  検索は全ての進捗（企業-求職者のやりとり）を対象とし、その進捗に関係のある求職者を出す  1: 底 | 2: 中 | 3: 高
     * @type {Array<number>}
     * @memberof AdminSearchConditionResponse
     */
    'rate'?: Array<number>;
    /**
     * オファー 選考ステータス最終更新日 期間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminSearchConditionResponse
     */
    'offer_update_at'?: Array<string>;
    /**
     * 一般ユーザーID C+数字乱数8桁（Ex. C12183640）
     * @type {string}
     * @memberof AdminSearchConditionResponse
     */
    'matchbox_id'?: string;
    /**
     * 男女 (0:未設定(default), 1:女子, 2:男子)
     * @type {number}
     * @memberof AdminSearchConditionResponse
     */
    'gender'?: number;
    /**
     * 年齢 [form, to] 配列で指
     * @type {Array<number>}
     * @memberof AdminSearchConditionResponse
     */
    'age'?: Array<number>;
    /**
     * 職種と経験年数。複数の場合 OR検索
     * @type {Array<CommonSCMcExperiencedJobObjectModel>}
     * @memberof AdminSearchConditionResponse
     */
    'mc_experienced_job'?: Array<CommonSCMcExperiencedJobObjectModel>;
    /**
     * 転職希望時期 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminSearchConditionResponse
     */
    'mc_preferred_change_date'?: Array<number>;
    /**
     * 都道府県 選択項目は実装側定義参照
     * @type {number}
     * @memberof AdminSearchConditionResponse
     */
    'prefecture'?: number;
    /**
     * 就業状況 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof AdminSearchConditionResponse
     */
    'mc_situation'?: number;
    /**
     * 現在の在籍企業
     * @type {string}
     * @memberof AdminSearchConditionResponse
     */
    'career_history_current_companies'?: string;
    /**
     * 現在の年収 選択項目は希望年収と同様マスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminSearchConditionResponse
     */
    'mc_yearly_income'?: Array<number>;
    /**
     * 現在の在籍部署名
     * @type {string}
     * @memberof AdminSearchConditionResponse
     */
    'career_history_current_section'?: string;
    /**
     * 現在の役職名
     * @type {string}
     * @memberof AdminSearchConditionResponse
     */
    'career_history_current_post'?: string;
    /**
     * ポートフォリオの作品数 範囲を[form, to] 配列で指定
     * @type {Array<number>}
     * @memberof AdminSearchConditionResponse
     */
    'portfolio_item_count'?: Array<number>;
    /**
     * 経験社数 範囲を[form, to] 配列で指定
     * @type {Array<number>}
     * @memberof AdminSearchConditionResponse
     */
    'career_history_amount'?: Array<number>;
    /**
     * これまでの在籍企業 複数設定可能
     * @type {Array<string>}
     * @memberof AdminSearchConditionResponse
     */
    'career_history_companies'?: Array<string>;
    /**
     * これまでの部署名 複数設定可能
     * @type {Array<string>}
     * @memberof AdminSearchConditionResponse
     */
    'career_history_section'?: Array<string>;
    /**
     * これまでの役職名 複数設定可能
     * @type {Array<string>}
     * @memberof AdminSearchConditionResponse
     */
    'career_history_post'?: Array<string>;
    /**
     * 担当内容 複数設定可能  各ポートフォリオ作品内の「担当内容」を参照
     * @type {Array<string>}
     * @memberof AdminSearchConditionResponse
     */
    'qa_answer'?: Array<string>;
    /**
     * 経験 複数設定可能 ポートフォリオ作品の経験の項目を検索
     * @type {Array<string>}
     * @memberof AdminSearchConditionResponse
     */
    'career_history_experiences'?: Array<string>;
    /**
     * 使用言語・ツール 複数設定可能
     * @type {Array<string>}
     * @memberof AdminSearchConditionResponse
     */
    'career_history_tools'?: Array<string>;
    /**
     * 最大マネジメント人数 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminSearchConditionResponse
     */
    'mc_maximum_management_count'?: Array<number>;
    /**
     * 資格・免許 複数設定可能
     * @type {Array<string>}
     * @memberof AdminSearchConditionResponse
     */
    'q_title'?: Array<string>;
    /**
     * TOEIC点数
     * @type {number}
     * @memberof AdminSearchConditionResponse
     */
    'q_toeic_score'?: number;
    /**
     * TOEFL点数
     * @type {number}
     * @memberof AdminSearchConditionResponse
     */
    'q_toefl_score'?: number;
    /**
     * 英語力 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof AdminSearchConditionResponse
     */
    'mc_english_skills'?: number;
    /**
     * 学校名 複数設定可能
     * @type {Array<string>}
     * @memberof AdminSearchConditionResponse
     */
    'e_school_name'?: Array<string>;
    /**
     * 最終学歴 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminSearchConditionResponse
     */
    'final_education'?: Array<number>;
    /**
     * 希望職種 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminSearchConditionResponse
     */
    'mc_preferred_job_type'?: Array<number>;
    /**
     * 希望業種 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminSearchConditionResponse
     */
    'mc_preferred_business_type'?: Array<number>;
    /**
     * 希望勤務地 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminSearchConditionResponse
     */
    'mc_preferred_prefecture'?: Array<number>;
    /**
     * 希望年収 選択項目は現在の年収と同様マスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminSearchConditionResponse
     */
    'mc_preferred_yearly_income'?: Array<number>;
    /**
     * 希望雇用形態 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminSearchConditionResponse
     */
    'mc_preferred_employment_status'?: Array<number>;
    /**
     * こだわりの条件 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof AdminSearchConditionResponse
     */
    'mc_conditions'?: Array<number>;
    /**
     * 自作ポートフォリオの登録の有無(1:あり/0:なし)
     * @type {number}
     * @memberof AdminSearchConditionResponse
     */
    'has_own_portfolio'?: number;
    /**
     * 入力代行ステータス - 0: 申し込み無し - 1: 求職者依頼中 - 2: 管理者見送り - 3: 管理者入力完了 - 4: 求職者入力内容反映済 
     * @type {number}
     * @memberof AdminSearchConditionResponse
     */
    'input_agency'?: number;
    /**
     * 広告効果測定用エントリーID 15桁の数値の文字列で生成 詳細は仕様書の説明項目を参照
     * @type {string}
     * @memberof AdminSearchConditionResponse
     */
    'user_entry_id'?: string;
    /**
     * ユーザーID、ニックネーム URL などにも使用。ユニークなもの
     * @type {string}
     * @memberof AdminSearchConditionResponse
     */
    'user_id'?: string;
    /**
     * ユーザー名
     * @type {string}
     * @memberof AdminSearchConditionResponse
     */
    'name'?: string;
    /**
     * ユーザー名 ふりがな
     * @type {string}
     * @memberof AdminSearchConditionResponse
     */
    'furigana'?: string;
    /**
     * Eメールアドレス
     * @type {string}
     * @memberof AdminSearchConditionResponse
     */
    'email'?: string;
    /**
     * ポートフォリオURL
     * @type {string}
     * @memberof AdminSearchConditionResponse
     */
    'portfolio_url'?: string;
    /**
     * 電話番号(ハイフン省略可)
     * @type {string}
     * @memberof AdminSearchConditionResponse
     */
    'tel'?: string;
    /**
     * 住所 検索対象はユーザー情報のaddress1, address2, address3
     * @type {string}
     * @memberof AdminSearchConditionResponse
     */
    'address'?: string;
    /**
     * 誕生日 期間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminSearchConditionResponse
     */
    'birth_date'?: Array<string>;
    /**
     * 最終ログイン 期間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminSearchConditionResponse
     */
    'last_login'?: Array<string>;
    /**
     * 登録日（サーバー側で付与） 期間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminSearchConditionResponse
     */
    'registration_date'?: Array<string>;
    /**
     * ポートフォリオの最終更新日 期間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminSearchConditionResponse
     */
    'last_update_portfolio'?: Array<string>;
    /**
     * ⾃作ポートフォリオの最終更新日間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminSearchConditionResponse
     */
    'last_update_own_portfolio'?: Array<string>;
    /**
     * 履歴書の最終更新日 期間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminSearchConditionResponse
     */
    'last_update_resume'?: Array<string>;
    /**
     * 履歴職務経歴書の最終更新日間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminSearchConditionResponse
     */
    'last_update_career_history'?: Array<string>;
    /**
     * ポートフォリオ公開状態（プライバシー設定）  - public : パスワードなし - password : パスワードつき - closed : 非公開
     * @type {string}
     * @memberof AdminSearchConditionResponse
     */
    'portfolio_state'?: string;
    /**
     * ダイレクトへの登録 - 0 未登録 - 1 登録済み
     * @type {number}
     * @memberof AdminSearchConditionResponse
     */
    'connected_to_mbdirect'?: number;
    /**
     * オファー 対応状況 1: 未完了 | 2: 保留 | 3: 完了
     * @type {number}
     * @memberof AdminSearchConditionResponse
     */
    'mw_status'?: number;
    /**
     * オファー数 範囲を[form, to] 配列で指定
     * @type {Array<number>}
     * @memberof AdminSearchConditionResponse
     */
    'offer_amount'?: Array<number>;
    /**
     * ピックアップ数 範囲を[form, to] 配列で指定
     * @type {Array<number>}
     * @memberof AdminSearchConditionResponse
     */
    'offer_pickup_amount'?: Array<number>;
    /**
     * 管理タグ（旧確認ステータス） 複数選択可能 選択項目はマスタまたは実装側定義参照
     * @type {Array<string>}
     * @memberof AdminSearchConditionResponse
     */
    'user_admin_tags'?: Array<string>;
    /**
     * ポートフォリオの公開作品数 範囲を[form, to] 配列で指定
     * @type {Array<number>}
     * @memberof AdminSearchConditionResponse
     */
    'published_portfolio_item_count'?: Array<number>;
    /**
     * ポートフォリオの公開作品数 範囲を[form, to] 配列で指定
     * @type {Array<number>}
     * @memberof AdminSearchConditionResponse
     */
    'direct_portfolio_item_count'?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof AdminSearchConditionResponse
     */
    'portfolio_item_count_contained_invisible'?: number;
    /**
     * タグ検索
     * @type {Array<string>}
     * @memberof AdminSearchConditionResponse
     */
    'user_tags'?: Array<string>;
    /**
     * 最終オファー登録日 期間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof AdminSearchConditionResponse
     */
    'last_update_use_direct'?: Array<string>;
}
/**
 * Adminの保存した検索一覧レスポンス
 * @export
 * @interface AdminSearchConditionsResponse
 */
export interface AdminSearchConditionsResponse {
    /**
     * 保存検索一覧
     * @type {Array<AdminSearchConditionResponse>}
     * @memberof AdminSearchConditionsResponse
     */
    'conditions': Array<AdminSearchConditionResponse>;
    /**
     * success のみ
     * @type {string}
     * @memberof AdminSearchConditionsResponse
     */
    'result': string;
}
/**
 * 
 * @export
 * @interface AdminSearchConditionsResponseAllOf
 */
export interface AdminSearchConditionsResponseAllOf {
    /**
     * 保存検索一覧
     * @type {Array<AdminSearchConditionResponse>}
     * @memberof AdminSearchConditionsResponseAllOf
     */
    'conditions': Array<AdminSearchConditionResponse>;
}
/**
 * Admin ユーザー検索リクエスト
 * @export
 * @interface AdminSearchUserRequest
 */
export interface AdminSearchUserRequest {
    /**
     * 取得件数 指定がない場合は20
     * @type {number}
     * @memberof AdminSearchUserRequest
     */
    'limit'?: number;
    /**
     * 次のページ番号 指定がない場合は0
     * @type {number}
     * @memberof AdminSearchUserRequest
     */
    'offset'?: number;
    /**
     * 検索項目 項目はdescription参照
     * @type {string}
     * @memberof AdminSearchUserRequest
     */
    'sort_by'?: string;
    /**
     * 検索順序 asc | desc
     * @type {string}
     * @memberof AdminSearchUserRequest
     */
    'sort_order'?: string;
    /**
     * 
     * @type {AdminSearchConditionModel}
     * @memberof AdminSearchUserRequest
     */
    'conditions'?: AdminSearchConditionModel;
}
/**
 * 
 * @export
 * @interface AdminSearchUserRequestAllOf
 */
export interface AdminSearchUserRequestAllOf {
    /**
     * 
     * @type {AdminSearchConditionModel}
     * @memberof AdminSearchUserRequestAllOf
     */
    'conditions'?: AdminSearchConditionModel;
}
/**
 * Adminのユーザー情報検索レスポンス
 * @export
 * @interface AdminSearchUsersResponse
 */
export interface AdminSearchUsersResponse {
    /**
     * 
     * @type {Array<AdminUserSearchModel>}
     * @memberof AdminSearchUsersResponse
     */
    'users': Array<AdminUserSearchModel>;
    /**
     * ページネーションの次のoffset or null
     * @type {number}
     * @memberof AdminSearchUsersResponse
     */
    'offset'?: number | null;
    /**
     * 現在の条件でのレコード総数
     * @type {number}
     * @memberof AdminSearchUsersResponse
     */
    'total'?: number;
    /**
     * success のみ
     * @type {string}
     * @memberof AdminSearchUsersResponse
     */
    'result': string;
}
/**
 * 
 * @export
 * @interface AdminSearchUsersResponseAllOf
 */
export interface AdminSearchUsersResponseAllOf {
    /**
     * 
     * @type {Array<AdminUserSearchModel>}
     * @memberof AdminSearchUsersResponseAllOf
     */
    'users': Array<AdminUserSearchModel>;
}
/**
 * Admin用のユーザー情報
 * @export
 * @interface AdminUserInfoModel
 */
export interface AdminUserInfoModel {
    /**
     * CP2 登録ステータス CP2連携項目についてはAPI Overview項目参照 valueが返ってくるので表示名に関しては[マスタ](#operation/get-admin-master-cp2)から取得
     * @type {string}
     * @memberof AdminUserInfoModel
     */
    'cp2_registration_status'?: string;
    /**
     * CP2 面談ステータス CP2連携項目についてはAPI Overview項目参照 valueが返ってくるので表示名に関しては[マスタ](#operation/get-admin-master-cp2)から取得
     * @type {string}
     * @memberof AdminUserInfoModel
     */
    'cp2_consultation_status'?: string;
    /**
     * CP2 担当者名 CP2連携項目についてはAPI Overview項目参照 valueが返ってくるので表示名に関しては[マスタ](#operation/get-admin-master-cp2)から取得
     * @type {string}
     * @memberof AdminUserInfoModel
     */
    'cp2_charge_name'?: string;
    /**
     * 電話番号(ハイフン省略可)
     * @type {string}
     * @memberof AdminUserInfoModel
     */
    'tel'?: string;
    /**
     * 郵便番号  バリデーション - 半角数字 - ハイフンなしの7桁数値相当の文字列  仕様 - フロント側では `3桁 - 4桁` の表記に変換
     * @type {string}
     * @memberof AdminUserInfoModel
     */
    'postal_code'?: string;
    /**
     * v1の仕様を引き継いだAddress群 1,2,3がある  address1 の場合は「ふりがな」用途で利用しているため以下のバリデーションを設定する  バリデーション - 平仮名 + 空白スペース
     * @type {string}
     * @memberof AdminUserInfoModel
     */
    'address1'?: string;
    /**
     * 住所 検索対象はユーザー情報のaddress1, address2, address3
     * @type {string}
     * @memberof AdminUserInfoModel
     */
    'address2'?: string;
    /**
     * 住所 検索対象はユーザー情報のaddress1, address2, address3
     * @type {string}
     * @memberof AdminUserInfoModel
     */
    'address3'?: string;
    /**
     * 男女 (0:未設定(default), 1:女子, 2:男子)
     * @type {number}
     * @memberof AdminUserInfoModel
     */
    'gender'?: number;
    /**
     * 
     * @type {ImagePhoto}
     * @memberof AdminUserInfoModel
     */
    'photo'?: ImagePhoto;
    /**
     * ユーザー名
     * @type {string}
     * @memberof AdminUserInfoModel
     */
    'name'?: string;
    /**
     * ユーザー名 ふりがな
     * @type {string}
     * @memberof AdminUserInfoModel
     */
    'furigana'?: string;
    /**
     * Eメールアドレス
     * @type {string}
     * @memberof AdminUserInfoModel
     */
    'email'?: string;
    /**
     * 都道府県 選択項目は実装側定義参照
     * @type {number}
     * @memberof AdminUserInfoModel
     */
    'prefecture'?: number;
    /**
     * 流入経路 使ってない？？
     * @type {string}
     * @memberof AdminUserInfoModel
     */
    'come_from'?: string;
    /**
     * CP2に連携しているかのフラグ  0 : 未連携 1 : 連携済  連携判断については[CP2連携項目について](/#section/CP2)を参照
     * @type {number}
     * @memberof AdminUserInfoModel
     */
    'cp2_status'?: number;
    /**
     * matchbox を使うかどうか
     * @type {boolean}
     * @memberof AdminUserInfoModel
     */
    'use_matchbox'?: boolean;
    /**
     * 職業 記入した職業の文字列が返ってくる
     * @type {string}
     * @memberof AdminUserInfoModel
     */
    'job'?: string;
    /**
     * 一般ユーザーID C+数字乱数8桁（Ex. C12183640）
     * @type {string}
     * @memberof AdminUserInfoModel
     */
    'matchbox_id': string;
    /**
     * P+数字乱数8桁 主にポートフォリオの公開URLで使用
     * @type {string}
     * @memberof AdminUserInfoModel
     */
    'user_id': string;
    /**
     * 誕生年  バリデーション - 半角数字 - 1900 - 2021（または現在年） まで
     * @type {number}
     * @memberof AdminUserInfoModel
     */
    'birth_year'?: number;
    /**
     * 誕生月  バリデーション - 半角数字 - 1 - 12 まで
     * @type {number}
     * @memberof AdminUserInfoModel
     */
    'birth_month'?: number;
    /**
     * 誕生日  バリデーション - 半角数字 - 1 - 31 まで
     * @type {number}
     * @memberof AdminUserInfoModel
     */
    'birth_day'?: number;
    /**
     * 今までのご経験（300字以内）mynavi-creatorで使用
     * @type {string}
     * @memberof AdminUserInfoModel
     */
    'description'?: string;
    /**
     * ユーザーアイコン : POST / PATCH のリクエスト時はData URI形式`data:image/png;base64,iV...`で送信。レスポンスの際はS3に保存したURIを返却。
     * @type {string}
     * @memberof AdminUserInfoModel
     */
    'icon'?: string;
    /**
     * Direct利用状況
     * @type {boolean}
     * @memberof AdminUserInfoModel
     */
    'use_direct'?: boolean;
}
/**
 * 
 * @export
 * @interface AdminUserInfoModelAllOf
 */
export interface AdminUserInfoModelAllOf {
    /**
     * 電話番号(ハイフン省略可)
     * @type {string}
     * @memberof AdminUserInfoModelAllOf
     */
    'tel'?: string;
    /**
     * 郵便番号  バリデーション - 半角数字 - ハイフンなしの7桁数値相当の文字列  仕様 - フロント側では `3桁 - 4桁` の表記に変換
     * @type {string}
     * @memberof AdminUserInfoModelAllOf
     */
    'postal_code'?: string;
    /**
     * v1の仕様を引き継いだAddress群 1,2,3がある  address1 の場合は「ふりがな」用途で利用しているため以下のバリデーションを設定する  バリデーション - 平仮名 + 空白スペース
     * @type {string}
     * @memberof AdminUserInfoModelAllOf
     */
    'address1'?: string;
    /**
     * 住所 検索対象はユーザー情報のaddress1, address2, address3
     * @type {string}
     * @memberof AdminUserInfoModelAllOf
     */
    'address2'?: string;
    /**
     * 住所 検索対象はユーザー情報のaddress1, address2, address3
     * @type {string}
     * @memberof AdminUserInfoModelAllOf
     */
    'address3'?: string;
    /**
     * 男女 (0:未設定(default), 1:女子, 2:男子)
     * @type {number}
     * @memberof AdminUserInfoModelAllOf
     */
    'gender'?: number;
    /**
     * 
     * @type {ImagePhoto}
     * @memberof AdminUserInfoModelAllOf
     */
    'photo'?: ImagePhoto;
    /**
     * ユーザー名
     * @type {string}
     * @memberof AdminUserInfoModelAllOf
     */
    'name'?: string;
    /**
     * ユーザー名 ふりがな
     * @type {string}
     * @memberof AdminUserInfoModelAllOf
     */
    'furigana'?: string;
    /**
     * Eメールアドレス
     * @type {string}
     * @memberof AdminUserInfoModelAllOf
     */
    'email'?: string;
    /**
     * 都道府県 選択項目は実装側定義参照
     * @type {number}
     * @memberof AdminUserInfoModelAllOf
     */
    'prefecture'?: number;
    /**
     * 流入経路 使ってない？？
     * @type {string}
     * @memberof AdminUserInfoModelAllOf
     */
    'come_from'?: string;
    /**
     * CP2に連携しているかのフラグ  0 : 未連携 1 : 連携済  連携判断については[CP2連携項目について](/#section/CP2)を参照
     * @type {number}
     * @memberof AdminUserInfoModelAllOf
     */
    'cp2_status'?: number;
    /**
     * matchbox を使うかどうか
     * @type {boolean}
     * @memberof AdminUserInfoModelAllOf
     */
    'use_matchbox'?: boolean;
    /**
     * 職業 記入した職業の文字列が返ってくる
     * @type {string}
     * @memberof AdminUserInfoModelAllOf
     */
    'job'?: string;
    /**
     * 一般ユーザーID C+数字乱数8桁（Ex. C12183640）
     * @type {string}
     * @memberof AdminUserInfoModelAllOf
     */
    'matchbox_id': string;
    /**
     * P+数字乱数8桁 主にポートフォリオの公開URLで使用
     * @type {string}
     * @memberof AdminUserInfoModelAllOf
     */
    'user_id': string;
    /**
     * 誕生年  バリデーション - 半角数字 - 1900 - 2021（または現在年） まで
     * @type {number}
     * @memberof AdminUserInfoModelAllOf
     */
    'birth_year'?: number;
    /**
     * 誕生月  バリデーション - 半角数字 - 1 - 12 まで
     * @type {number}
     * @memberof AdminUserInfoModelAllOf
     */
    'birth_month'?: number;
    /**
     * 誕生日  バリデーション - 半角数字 - 1 - 31 まで
     * @type {number}
     * @memberof AdminUserInfoModelAllOf
     */
    'birth_day'?: number;
    /**
     * 今までのご経験（300字以内）mynavi-creatorで使用
     * @type {string}
     * @memberof AdminUserInfoModelAllOf
     */
    'description'?: string;
    /**
     * ユーザーアイコン : POST / PATCH のリクエスト時はData URI形式`data:image/png;base64,iV...`で送信。レスポンスの際はS3に保存したURIを返却。
     * @type {string}
     * @memberof AdminUserInfoModelAllOf
     */
    'icon'?: string;
    /**
     * Direct利用状況
     * @type {boolean}
     * @memberof AdminUserInfoModelAllOf
     */
    'use_direct'?: boolean;
}
/**
 * 管理者アカウント情報
 * @export
 * @interface AdminUserModel
 */
export interface AdminUserModel {
    /**
     * 管理者名
     * @type {string}
     * @memberof AdminUserModel
     */
    'name'?: string;
    /**
     * メールアドレス
     * @type {string}
     * @memberof AdminUserModel
     */
    'email'?: string;
    /**
     * 部署 
     * @type {string}
     * @memberof AdminUserModel
     */
    'section'?: string;
    /**
     * 役職 
     * @type {string}
     * @memberof AdminUserModel
     */
    'post'?: string;
    /**
     * ユーザーのタイプ 管理者のみ
     * @type {string}
     * @memberof AdminUserModel
     */
    'user_type': AdminUserModelUserTypeEnum;
    /**
     * 管理者ID
     * @type {string}
     * @memberof AdminUserModel
     */
    'admin_id': string;
    /**
     * ユーザーアイコン : POST / PATCH のリクエスト時はData URI形式`data:image/png;base64,iV...`で送信。レスポンスの際はS3に保存したURIを返却。
     * @type {string}
     * @memberof AdminUserModel
     */
    'icon'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum AdminUserModelUserTypeEnum {
    Admin = 'admin'
}

/**
 * 管理者アカウント情報  一般ユーザー情報をもとに必要なものだけピックアップ
 * @export
 * @interface AdminUserResponse
 */
export interface AdminUserResponse {
    /**
     * 
     * @type {AdminUserModel}
     * @memberof AdminUserResponse
     */
    'user_info'?: AdminUserModel;
    /**
     * success のみ
     * @type {string}
     * @memberof AdminUserResponse
     */
    'result': string;
}
/**
 * 
 * @export
 * @interface AdminUserResponseAllOf
 */
export interface AdminUserResponseAllOf {
    /**
     * 
     * @type {AdminUserModel}
     * @memberof AdminUserResponseAllOf
     */
    'user_info'?: AdminUserModel;
}
/**
 * Admin用ユーザー情報モデル
 * @export
 * @interface AdminUserSearchModel
 */
export interface AdminUserSearchModel {
    /**
     * 一般ユーザーID C+数字乱数8桁（Ex. C12183640）
     * @type {string}
     * @memberof AdminUserSearchModel
     */
    'matchbox_id': string;
    /**
     * アカウント開設日 YYY-MM-DD
     * @type {string}
     * @memberof AdminUserSearchModel
     */
    'registration_date'?: string;
    /**
     * ポートフォリオ更新日 YYY-MM-DD hh:mm:ss
     * @type {string}
     * @memberof AdminUserSearchModel
     */
    'last_update_portfolio'?: string;
    /**
     * 自作ポートフォリオ更新日 YYY-MM-DD hh:mm:ss
     * @type {string}
     * @memberof AdminUserSearchModel
     */
    'last_update_own_portfolio'?: string;
    /**
     * ポートフォリオ更新日 YYY-MM-DD hh:mm:ss
     * @type {string}
     * @memberof AdminUserSearchModel
     */
    'last_update_public_portfolio'?: string;
    /**
     * 履歴書更新日更新日 YYY-MM-DD hh:mm:ss
     * @type {string}
     * @memberof AdminUserSearchModel
     */
    'last_update_resume'?: string;
    /**
     * 
     * @type {Portfolio}
     * @memberof AdminUserSearchModel
     */
    'portfolio'?: Portfolio;
    /**
     * 
     * @type {OwnPortfolio}
     * @memberof AdminUserSearchModel
     */
    'own_portfolio'?: OwnPortfolio;
    /**
     * 職務経歴書更新日 YYY-MM-DD hh:mm:ss
     * @type {string}
     * @memberof AdminUserSearchModel
     */
    'last_update_career_history'?: string;
    /**
     * ユーザー状態 active | inactive | before_delete | deleted
     * @type {string}
     * @memberof AdminUserSearchModel
     */
    'user_status': string;
    /**
     * 
     * @type {CareerHistory}
     * @memberof AdminUserSearchModel
     */
    'career_history'?: CareerHistory;
    /**
     * 最終ログイン日
     * @type {Set<LastLogin>}
     * @memberof AdminUserSearchModel
     */
    'last_login': Set<LastLogin>;
    /**
     * 広告効果測定用エントリーID 15桁の数値の文字列で生成 詳細は仕様書の説明項目を参照
     * @type {string}
     * @memberof AdminUserSearchModel
     */
    'user_entry_id': string;
    /**
     * 
     * @type {MyNavi}
     * @memberof AdminUserSearchModel
     */
    'mc'?: MyNavi;
    /**
     * 管理タグ（旧確認ステータス）
     * @type {string}
     * @memberof AdminUserSearchModel
     */
    'user_admin_tags'?: string;
    /**
     * 
     * @type {Array<Offer>}
     * @memberof AdminUserSearchModel
     */
    'offers'?: Array<Offer>;
    /**
     * 検索結果に表示された求職者情報が、Direct/Adminユーザーにクリックされているか。求職者が自身の情報を更新した際に、すべてのDirect/Adminユーザーに対しての、is_readがfalseにリセットされる
     * @type {boolean}
     * @memberof AdminUserSearchModel
     */
    'is_read'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminUserSearchModel
     */
    'portfolio_item_count'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminUserSearchModel
     */
    'portfolio_password'?: string;
    /**
     * 
     * @type {AdminUserInfoModel}
     * @memberof AdminUserSearchModel
     */
    'user_info': AdminUserInfoModel;
    /**
     * 
     * @type {string}
     * @memberof AdminUserSearchModel
     */
    'status'?: string;
    /**
     * 非表示作品含んだ数
     * @type {string}
     * @memberof AdminUserSearchModel
     */
    'portfolio_item_count_contained_invisible'?: string;
    /**
     * 企業向けポートフォリオの作品数
     * @type {number}
     * @memberof AdminUserSearchModel
     */
    'direct_portfolio_item_count'?: number;
    /**
     * 企業向け求職者コメント
     * @type {string}
     * @memberof AdminUserSearchModel
     */
    'comment'?: string;
    /**
     * 最終オファー登録日 YYY-MM-DD
     * @type {string}
     * @memberof AdminUserSearchModel
     */
    'last_update_use_direct'?: string;
}
/**
 * 
 * @export
 * @interface AdminUserSearchModelAllOf
 */
export interface AdminUserSearchModelAllOf {
    /**
     * 
     * @type {AdminUserInfoModel}
     * @memberof AdminUserSearchModelAllOf
     */
    'user_info': AdminUserInfoModel;
}
/**
 * 
 * @export
 * @interface AdminUserTagResponse
 */
export interface AdminUserTagResponse {
    /**
     * 
     * @type {UserTag}
     * @memberof AdminUserTagResponse
     */
    'data'?: UserTag;
    /**
     * success のみ
     * @type {string}
     * @memberof AdminUserTagResponse
     */
    'result': string;
}
/**
 * 
 * @export
 * @interface AdminUserTagResponseAllOf
 */
export interface AdminUserTagResponseAllOf {
    /**
     * 
     * @type {UserTag}
     * @memberof AdminUserTagResponseAllOf
     */
    'data'?: UserTag;
}
/**
 * 
 * @export
 * @interface AdminUserTagsMatchboxIdResponse
 */
export interface AdminUserTagsMatchboxIdResponse {
    /**
     * 
     * @type {Array<UserTagMatchboxId>}
     * @memberof AdminUserTagsMatchboxIdResponse
     */
    'items'?: Array<UserTagMatchboxId>;
    /**
     * success のみ
     * @type {string}
     * @memberof AdminUserTagsMatchboxIdResponse
     */
    'result': string;
}
/**
 * 
 * @export
 * @interface AdminUserTagsMatchboxIdResponseAllOf
 */
export interface AdminUserTagsMatchboxIdResponseAllOf {
    /**
     * 
     * @type {Array<UserTagMatchboxId>}
     * @memberof AdminUserTagsMatchboxIdResponseAllOf
     */
    'items'?: Array<UserTagMatchboxId>;
}
/**
 * 
 * @export
 * @interface AdminUserTagsResponse
 */
export interface AdminUserTagsResponse {
    /**
     * 
     * @type {Array<UserTag>}
     * @memberof AdminUserTagsResponse
     */
    'items'?: Array<UserTag>;
    /**
     * success のみ
     * @type {string}
     * @memberof AdminUserTagsResponse
     */
    'result': string;
}
/**
 * 
 * @export
 * @interface AdminUserTagsResponseAllOf
 */
export interface AdminUserTagsResponseAllOf {
    /**
     * 
     * @type {Array<UserTag>}
     * @memberof AdminUserTagsResponseAllOf
     */
    'items'?: Array<UserTag>;
}
/**
 * 同意チェック
 * @export
 * @interface Agreed
 */
export interface Agreed {
    /**
     * 同意しているかどうか
     * @type {boolean}
     * @memberof Agreed
     */
    'agreed'?: boolean;
}
/**
 * 
 * @export
 * @interface Analysis
 */
export interface Analysis {
    /**
     * 
     * @type {string}
     * @memberof Analysis
     */
    'title': string;
    /**
     * 
     * @type {number}
     * @memberof Analysis
     */
    'user': number;
    /**
     * 
     * @type {number}
     * @memberof Analysis
     */
    'male': number;
    /**
     * 
     * @type {number}
     * @memberof Analysis
     */
    'female': number;
    /**
     * 
     * @type {number}
     * @memberof Analysis
     */
    'mc_connected': number;
    /**
     * 
     * @type {number}
     * @memberof Analysis
     */
    'portfolio_created': number;
    /**
     * 
     * @type {number}
     * @memberof Analysis
     */
    'portfolio_over_3items': number;
    /**
     * 
     * @type {number}
     * @memberof Analysis
     */
    'portfolio_0_40': number;
    /**
     * 
     * @type {number}
     * @memberof Analysis
     */
    'portfolio_41_70': number;
    /**
     * 
     * @type {number}
     * @memberof Analysis
     */
    'portfolio_71_100': number;
    /**
     * 
     * @type {number}
     * @memberof Analysis
     */
    'resume_created': number;
    /**
     * 
     * @type {number}
     * @memberof Analysis
     */
    'resume_0_40': number;
    /**
     * 
     * @type {number}
     * @memberof Analysis
     */
    'resume_41_70': number;
    /**
     * 
     * @type {number}
     * @memberof Analysis
     */
    'resume_71_100': number;
}
/**
 * 
 * @export
 * @interface AnalysisResponse
 */
export interface AnalysisResponse {
    /**
     * 
     * @type {Array<Analysis>}
     * @memberof AnalysisResponse
     */
    'analysis': Array<Analysis>;
    /**
     * 
     * @type {string}
     * @memberof AnalysisResponse
     */
    'result': AnalysisResponseResultEnum;
    /**
     * 
     * @type {string}
     * @memberof AnalysisResponse
     */
    'error_message'?: string;
    /**
     * 
     * @type {number}
     * @memberof AnalysisResponse
     */
    'error_code'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum AnalysisResponseResultEnum {
    Success = 'success',
    Fail = 'fail'
}

/**
 * 
 * @export
 * @interface AnalysisResponseAllOf
 */
export interface AnalysisResponseAllOf {
    /**
     * 
     * @type {Array<Analysis>}
     * @memberof AnalysisResponseAllOf
     */
    'analysis': Array<Analysis>;
}
/**
 * 緊急連絡先
 * @export
 * @interface AnotherContact
 */
export interface AnotherContact {
    /**
     * 
     * @type {string}
     * @memberof AnotherContact
     */
    'a_name': string;
    /**
     * 
     * @type {string}
     * @memberof AnotherContact
     */
    'a_furigana': string;
    /**
     * 
     * @type {string}
     * @memberof AnotherContact
     */
    'a_email': string;
    /**
     * 
     * @type {string}
     * @memberof AnotherContact
     */
    'a_postal': string;
    /**
     * 
     * @type {string}
     * @memberof AnotherContact
     */
    'a_address': string;
    /**
     * 
     * @type {string}
     * @memberof AnotherContact
     */
    'a_address_furigana': string;
    /**
     * 
     * @type {string}
     * @memberof AnotherContact
     */
    'a_tel': string;
}
/**
 * 
 * @export
 * @interface BlockCompaniesPatchParam
 */
export interface BlockCompaniesPatchParam {
    /**
     * 
     * @type {Array<string>}
     * @memberof BlockCompaniesPatchParam
     */
    'ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface BlockCompaniesResponse
 */
export interface BlockCompaniesResponse {
    /**
     * 
     * @type {Array<BlockCompany>}
     * @memberof BlockCompaniesResponse
     */
    'companies'?: Array<BlockCompany>;
    /**
     * 
     * @type {string}
     * @memberof BlockCompaniesResponse
     */
    'result': BlockCompaniesResponseResultEnum;
    /**
     * 
     * @type {string}
     * @memberof BlockCompaniesResponse
     */
    'error_message'?: string;
    /**
     * 
     * @type {number}
     * @memberof BlockCompaniesResponse
     */
    'error_code'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum BlockCompaniesResponseResultEnum {
    Success = 'success',
    Fail = 'fail'
}

/**
 * 
 * @export
 * @interface BlockCompaniesResponseAllOf
 */
export interface BlockCompaniesResponseAllOf {
    /**
     * 
     * @type {Array<BlockCompany>}
     * @memberof BlockCompaniesResponseAllOf
     */
    'companies'?: Array<BlockCompany>;
}
/**
 * 
 * @export
 * @interface BlockCompany
 */
export interface BlockCompany {
    /**
     * 紐づける 国税庁番号 法人番号の採番ルールは（CHAR(13)
     * @type {string}
     * @memberof BlockCompany
     */
    'id': string;
    /**
     * 企業名
     * @type {string}
     * @memberof BlockCompany
     */
    'name': string;
    /**
     * 企業名（ふりがな）
     * @type {string}
     * @memberof BlockCompany
     */
    'kana': string;
    /**
     * 住所
     * @type {string}
     * @memberof BlockCompany
     */
    'address': string;
}
/**
 * 
 * @export
 * @interface BlockCompanyPostParam
 */
export interface BlockCompanyPostParam {
    /**
     * 取得件数 指定がない場合は20
     * @type {number}
     * @memberof BlockCompanyPostParam
     */
    'limit'?: number;
    /**
     * 次のページ番号 指定がない場合は0
     * @type {number}
     * @memberof BlockCompanyPostParam
     */
    'offset'?: number;
    /**
     * 検索項目 項目はdescription参照
     * @type {string}
     * @memberof BlockCompanyPostParam
     */
    'sort_by'?: string;
    /**
     * 検索順序 asc | desc
     * @type {string}
     * @memberof BlockCompanyPostParam
     */
    'sort_order'?: string;
    /**
     * 
     * @type {string}
     * @memberof BlockCompanyPostParam
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface BlockCompanyPostParamAllOf
 */
export interface BlockCompanyPostParamAllOf {
    /**
     * 
     * @type {string}
     * @memberof BlockCompanyPostParamAllOf
     */
    'name': string;
}
/**
 * 職務経歴
 * @export
 * @interface Career
 */
export interface Career {
    /**
     * 職務経歴id
     * @type {string}
     * @memberof Career
     */
    'c_id': string;
    /**
     * 社名
     * @type {string}
     * @memberof Career
     */
    'c_company_name': string;
    /**
     * 入社年月
     * @type {string}
     * @memberof Career
     */
    'c_join_date': string;
    /**
     * 退職年月
     * @type {string}
     * @memberof Career
     */
    'c_leave_date'?: string;
    /**
     * 雇用形態 選択式（マスタから選択）
     * @type {number}
     * @memberof Career
     */
    'c_employment_status': number;
    /**
     * 事業内容
     * @type {string}
     * @memberof Career
     */
    'c_detail'?: string;
    /**
     * 転職・退職理由
     * @type {string}
     * @memberof Career
     */
    'c_leave_reason'?: string;
    /**
     * 退職しているかどうかのフラグ。true が退職している。
     * @type {boolean}
     * @memberof Career
     */
    'c_leave_flag'?: boolean;
    /**
     * 
     * @type {Array<Project>}
     * @memberof Career
     */
    'c_projects'?: Array<Project>;
    /**
     * 役職
     * @type {string}
     * @memberof Career
     */
    'c_post'?: string;
    /**
     * 部署
     * @type {string}
     * @memberof Career
     */
    'c_section'?: string;
    /**
     * 従業員数
     * @type {number}
     * @memberof Career
     */
    'c_employee_count'?: number;
    /**
     * 資本金 単位:万
     * @type {number}
     * @memberof Career
     */
    'c_capital'?: number;
    /**
     * 履歴書にて、職務経歴を表示するかどうか
     * @type {boolean}
     * @memberof Career
     */
    'c_visible'?: boolean;
}
/**
 * 職務経歴
 * @export
 * @interface CareerHistory
 */
export interface CareerHistory {
    /**
     * 肩書き
     * @type {string}
     * @memberof CareerHistory
     */
    'job'?: string;
    /**
     * 概要
     * @type {string}
     * @memberof CareerHistory
     */
    'description'?: string;
    /**
     * 活かせる経験・スキル・得意分野
     * @type {string}
     * @memberof CareerHistory
     */
    'advantage'?: string;
    /**
     * 職務経歴書の更新日
     * @type {string}
     * @memberof CareerHistory
     */
    'latest_update'?: string;
    /**
     * 自己PR
     * @type {string}
     * @memberof CareerHistory
     */
    'pr'?: string;
    /**
     * テクニカルスキル
     * @type {Array<CareerHistorySkills>}
     * @memberof CareerHistory
     */
    'skills'?: Array<CareerHistorySkills>;
    /**
     * 職歴
     * @type {Array<Career>}
     * @memberof CareerHistory
     */
    'careers'?: Array<Career>;
    /**
     * 資格・免許
     * @type {Array<Qualification>}
     * @memberof CareerHistory
     */
    'qualifications'?: Array<Qualification>;
}
/**
 * 
 * @export
 * @interface CareerHistorySkill
 */
export interface CareerHistorySkill {
    /**
     * 
     * @type {number}
     * @memberof CareerHistorySkill
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CareerHistorySkill
     */
    'name'?: string;
    /**
     * 経験年数  0 : 1年未満 1 : 1年 2 : 2年 3: 3年以上
     * @type {number}
     * @memberof CareerHistorySkill
     */
    'experience'?: number;
    /**
     * 
     * @type {number}
     * @memberof CareerHistorySkill
     */
    'level'?: number;
}
/**
 * 
 * @export
 * @interface CareerHistorySkills
 */
export interface CareerHistorySkills {
    /**
     * 
     * @type {number}
     * @memberof CareerHistorySkills
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CareerHistorySkills
     */
    'name'?: string;
    /**
     * 経験年数  0 : 1年未満 1 : 1年 2 : 2年 3: 3年以上
     * @type {number}
     * @memberof CareerHistorySkills
     */
    'experience'?: number;
    /**
     * 
     * @type {number}
     * @memberof CareerHistorySkills
     */
    'level'?: number;
}
/**
 * 職務経歴 サマリー
 * @export
 * @interface CareerSummaryModel
 */
export interface CareerSummaryModel {
    /**
     * 職務経歴id
     * @type {string}
     * @memberof CareerSummaryModel
     */
    'c_id': string;
    /**
     * 社名
     * @type {string}
     * @memberof CareerSummaryModel
     */
    'c_company_name': string;
    /**
     * 入社年月
     * @type {string}
     * @memberof CareerSummaryModel
     */
    'c_join_date': string;
    /**
     * 退職年月
     * @type {string}
     * @memberof CareerSummaryModel
     */
    'c_leave_date': string;
    /**
     * 退職しているかどうかのフラグ。true が退職している。
     * @type {boolean}
     * @memberof CareerSummaryModel
     */
    'c_leave_flag'?: boolean;
    /**
     * 履歴書にて、職務経歴を表示するかどうか
     * @type {boolean}
     * @memberof CareerSummaryModel
     */
    'c_visible': boolean;
}
/**
 * 管理画面用マスタ 選択要素のオプション要素になるベースモデル プロパティ名はフロント側で加工しやすいようにこの名称とする、またvalue値がstringなのはHTMLのselect要素はvalueにstringしか受け取らないため数値相当の値も全てstringとして受けるものとする。
 * @export
 * @interface CommonMasterOptionModel
 */
export interface CommonMasterOptionModel {
    /**
     * オプション用のvalue値
     * @type {string}
     * @memberof CommonMasterOptionModel
     */
    'value': string;
    /**
     * オプション表示名
     * @type {string}
     * @memberof CommonMasterOptionModel
     */
    'children': string;
}
/**
 * 
 * @export
 * @interface CommonSCMcExperiencedJobObjectModel
 */
export interface CommonSCMcExperiencedJobObjectModel {
    /**
     * 職種 選択項目はマスタまたは実装側定義参
     * @type {number}
     * @memberof CommonSCMcExperiencedJobObjectModel
     */
    'job'?: number;
    /**
     * 経験年数 選択項目はマスタまたは実装側定義参
     * @type {Array<number>}
     * @memberof CommonSCMcExperiencedJobObjectModel
     */
    'job_year'?: Array<number>;
}
/**
 * 
 * @export
 * @interface CompanyGroup
 */
export interface CompanyGroup {
    /**
     * グループ名
     * @type {string}
     * @memberof CompanyGroup
     */
    'name': string;
    /**
     * 企業グループID
     * @type {string}
     * @memberof CompanyGroup
     */
    'id': string;
    /**
     * 
     * @type {Array<CompanyUser>}
     * @memberof CompanyGroup
     */
    'users': Array<CompanyUser>;
}
/**
 * 
 * @export
 * @interface CompanyGroupAllOf
 */
export interface CompanyGroupAllOf {
    /**
     * 
     * @type {Array<CompanyUser>}
     * @memberof CompanyGroupAllOf
     */
    'users': Array<CompanyUser>;
}
/**
 * 
 * @export
 * @interface CompanyGroupParam
 */
export interface CompanyGroupParam {
    /**
     * 
     * @type {string}
     * @memberof CompanyGroupParam
     */
    'name': string;
}
/**
 * 企業用グループ 概要
 * @export
 * @interface CompanyGroupSummary
 */
export interface CompanyGroupSummary {
    /**
     * グループ名
     * @type {string}
     * @memberof CompanyGroupSummary
     */
    'name': string;
    /**
     * 企業グループID
     * @type {string}
     * @memberof CompanyGroupSummary
     */
    'id': string;
}
/**
 * 企業用ユーザー
 * @export
 * @interface CompanyUser
 */
export interface CompanyUser {
    /**
     * 名
     * @type {string}
     * @memberof CompanyUser
     */
    'name'?: string;
    /**
     * ユーザーアイコン : POST / PATCH のリクエスト時はData URI形式`data:image/png;base64,iV...`で送信。レスポンスの際はS3に保存したURIを返却。
     * @type {string}
     * @memberof CompanyUser
     */
    'photo'?: string;
    /**
     * Eメールアドレス
     * @type {string}
     * @memberof CompanyUser
     */
    'email'?: string;
    /**
     * 
     * @type {DirectUserTypeModel}
     * @memberof CompanyUser
     */
    'user_type'?: DirectUserTypeModel;
    /**
     * 部署 
     * @type {string}
     * @memberof CompanyUser
     */
    'section'?: string;
    /**
     * 役職 
     * @type {string}
     * @memberof CompanyUser
     */
    'post'?: string;
    /**
     * 採用時に見るポイント 選択項目はマスタまたは実装側定義参照 
     * @type {number}
     * @memberof CompanyUser
     */
    'point'?: number;
    /**
     * 企業ユーザーID B+数字乱数8桁（Ex. B12183640）
     * @type {string}
     * @memberof CompanyUser
     */
    'matchbox_id'?: string;
    /**
     * 最終ログイン日
     * @type {string}
     * @memberof CompanyUser
     */
    'last_login'?: string;
    /**
     * アカウント開設日
     * @type {string}
     * @memberof CompanyUser
     */
    'registration_date'?: string;
    /**
     * 所属グループ
     * @type {Array<string>}
     * @memberof CompanyUser
     */
    'groups'?: Array<string>;
}
/**
 * Direct Admin 両方で利用する検索条件項目
 * @export
 * @interface DirectAdminSearchConditionModel
 */
export interface DirectAdminSearchConditionModel {
    /**
     * フリーワード 複数設定可能  毎日夜中にバッチで以下の情報をまとめたテキストをユーザー毎に更新しそのテキストが検索対象  - ユーザー情報 : 経歴 - ポートフォリオ :ページタイトル / イントロダクション / タイトル - ポートフォリオアイテム : description - 履歴書 : 志望動機 / 趣味特技 /本人希望 - 職務経歴 : 社名 / 業務内容 / 職務内容 / 最終ポジション / 退職理由 - 学歴 : 学校名 / 学部学科名 - 資格 : 資格タイプ / 資格名
     * @type {Array<string>}
     * @memberof DirectAdminSearchConditionModel
     */
    'keyword'?: Array<string>;
    /**
     * オファー 選考ステータス 複数選択可能 選択項目はマスタまたは実装側定義参照  検索は全ての進捗（企業-求職者のやりとり）を対象とし、その進捗に関係のある求職者を出す
     * @type {Array<number>}
     * @memberof DirectAdminSearchConditionModel
     */
    'offer_status'?: Array<number>;
    /**
     * オファー マッチ度 複数選択可能 選択項目はマスタまたは実装側定義参照  検索は全ての進捗（企業-求職者のやりとり）を対象とし、その進捗に関係のある求職者を出す  1: 底 | 2: 中 | 3: 高
     * @type {Array<number>}
     * @memberof DirectAdminSearchConditionModel
     */
    'rate'?: Array<number>;
    /**
     * オファー 選考ステータス最終更新日 期間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof DirectAdminSearchConditionModel
     */
    'offer_update_at'?: Array<string>;
    /**
     * 一般ユーザーID C+数字乱数8桁（Ex. C12183640）
     * @type {string}
     * @memberof DirectAdminSearchConditionModel
     */
    'matchbox_id'?: string;
    /**
     * 男女 (0:未設定(default), 1:女子, 2:男子)
     * @type {number}
     * @memberof DirectAdminSearchConditionModel
     */
    'gender'?: number;
    /**
     * 年齢 [form, to] 配列で指
     * @type {Array<number>}
     * @memberof DirectAdminSearchConditionModel
     */
    'age'?: Array<number>;
    /**
     * 職種と経験年数。複数の場合 OR検索
     * @type {Array<CommonSCMcExperiencedJobObjectModel>}
     * @memberof DirectAdminSearchConditionModel
     */
    'mc_experienced_job'?: Array<CommonSCMcExperiencedJobObjectModel>;
    /**
     * 転職希望時期 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectAdminSearchConditionModel
     */
    'mc_preferred_change_date'?: Array<number>;
    /**
     * 都道府県 選択項目は実装側定義参照
     * @type {number}
     * @memberof DirectAdminSearchConditionModel
     */
    'prefecture'?: number;
    /**
     * 就業状況 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof DirectAdminSearchConditionModel
     */
    'mc_situation'?: number;
    /**
     * 現在の在籍企業
     * @type {string}
     * @memberof DirectAdminSearchConditionModel
     */
    'career_history_current_companies'?: string;
    /**
     * 現在の年収 選択項目は希望年収と同様マスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectAdminSearchConditionModel
     */
    'mc_yearly_income'?: Array<number>;
    /**
     * 現在の在籍部署名
     * @type {string}
     * @memberof DirectAdminSearchConditionModel
     */
    'career_history_current_section'?: string;
    /**
     * 現在の役職名
     * @type {string}
     * @memberof DirectAdminSearchConditionModel
     */
    'career_history_current_post'?: string;
    /**
     * ポートフォリオの作品数 範囲を[form, to] 配列で指定
     * @type {Array<number>}
     * @memberof DirectAdminSearchConditionModel
     */
    'portfolio_item_count'?: Array<number>;
    /**
     * 経験社数 範囲を[form, to] 配列で指定
     * @type {Array<number>}
     * @memberof DirectAdminSearchConditionModel
     */
    'career_history_amount'?: Array<number>;
    /**
     * これまでの在籍企業 複数設定可能
     * @type {Array<string>}
     * @memberof DirectAdminSearchConditionModel
     */
    'career_history_companies'?: Array<string>;
    /**
     * これまでの部署名 複数設定可能
     * @type {Array<string>}
     * @memberof DirectAdminSearchConditionModel
     */
    'career_history_section'?: Array<string>;
    /**
     * これまでの役職名 複数設定可能
     * @type {Array<string>}
     * @memberof DirectAdminSearchConditionModel
     */
    'career_history_post'?: Array<string>;
    /**
     * 担当内容 複数設定可能  各ポートフォリオ作品内の「担当内容」を参照
     * @type {Array<string>}
     * @memberof DirectAdminSearchConditionModel
     */
    'qa_answer'?: Array<string>;
    /**
     * 経験 複数設定可能 ポートフォリオ作品の経験の項目を検索
     * @type {Array<string>}
     * @memberof DirectAdminSearchConditionModel
     */
    'career_history_experiences'?: Array<string>;
    /**
     * 使用言語・ツール 複数設定可能
     * @type {Array<string>}
     * @memberof DirectAdminSearchConditionModel
     */
    'career_history_tools'?: Array<string>;
    /**
     * 最大マネジメント人数 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectAdminSearchConditionModel
     */
    'mc_maximum_management_count'?: Array<number>;
    /**
     * 資格・免許 複数設定可能
     * @type {Array<string>}
     * @memberof DirectAdminSearchConditionModel
     */
    'q_title'?: Array<string>;
    /**
     * TOEIC点数
     * @type {number}
     * @memberof DirectAdminSearchConditionModel
     */
    'q_toeic_score'?: number;
    /**
     * TOEFL点数
     * @type {number}
     * @memberof DirectAdminSearchConditionModel
     */
    'q_toefl_score'?: number;
    /**
     * 英語力 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof DirectAdminSearchConditionModel
     */
    'mc_english_skills'?: number;
    /**
     * 学校名 複数設定可能
     * @type {Array<string>}
     * @memberof DirectAdminSearchConditionModel
     */
    'e_school_name'?: Array<string>;
    /**
     * 最終学歴 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectAdminSearchConditionModel
     */
    'final_education'?: Array<number>;
    /**
     * 希望職種 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectAdminSearchConditionModel
     */
    'mc_preferred_job_type'?: Array<number>;
    /**
     * 希望業種 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectAdminSearchConditionModel
     */
    'mc_preferred_business_type'?: Array<number>;
    /**
     * 希望勤務地 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectAdminSearchConditionModel
     */
    'mc_preferred_prefecture'?: Array<number>;
    /**
     * 希望年収 選択項目は現在の年収と同様マスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectAdminSearchConditionModel
     */
    'mc_preferred_yearly_income'?: Array<number>;
    /**
     * 希望雇用形態 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectAdminSearchConditionModel
     */
    'mc_preferred_employment_status'?: Array<number>;
    /**
     * こだわりの条件 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectAdminSearchConditionModel
     */
    'mc_conditions'?: Array<number>;
    /**
     * 自作ポートフォリオの登録の有無(1:あり/0:なし)
     * @type {number}
     * @memberof DirectAdminSearchConditionModel
     */
    'has_own_portfolio'?: number;
    /**
     * 入力代行ステータス - 0: 申し込み無し - 1: 求職者依頼中 - 2: 管理者見送り - 3: 管理者入力完了 - 4: 求職者入力内容反映済 
     * @type {number}
     * @memberof DirectAdminSearchConditionModel
     */
    'input_agency'?: number;
}
/**
 * 
 * @export
 * @interface DirectCompanyGroupResponse
 */
export interface DirectCompanyGroupResponse {
    /**
     * グループ名
     * @type {string}
     * @memberof DirectCompanyGroupResponse
     */
    'name': string;
    /**
     * 企業グループID
     * @type {string}
     * @memberof DirectCompanyGroupResponse
     */
    'id': string;
    /**
     * 
     * @type {Array<CompanyUser>}
     * @memberof DirectCompanyGroupResponse
     */
    'users': Array<CompanyUser>;
    /**
     * success のみ
     * @type {string}
     * @memberof DirectCompanyGroupResponse
     */
    'result': string;
}
/**
 * 
 * @export
 * @interface DirectCompanyGroupsResponse
 */
export interface DirectCompanyGroupsResponse {
    /**
     * 
     * @type {Array<CompanyGroupSummary>}
     * @memberof DirectCompanyGroupsResponse
     */
    'groups'?: Array<CompanyGroupSummary>;
    /**
     * success のみ
     * @type {string}
     * @memberof DirectCompanyGroupsResponse
     */
    'result': string;
}
/**
 * 
 * @export
 * @interface DirectCompanyGroupsResponseAllOf
 */
export interface DirectCompanyGroupsResponseAllOf {
    /**
     * 
     * @type {Array<CompanyGroupSummary>}
     * @memberof DirectCompanyGroupsResponseAllOf
     */
    'groups'?: Array<CompanyGroupSummary>;
}
/**
 * 自社情報モデル
 * @export
 * @interface DirectCompanyModel
 */
export interface DirectCompanyModel {
    /**
     * 内部的に採番している Direct用の企業ID 
     * @type {number}
     * @memberof DirectCompanyModel
     */
    'id': number;
    /**
     * 企業名
     * @type {string}
     * @memberof DirectCompanyModel
     */
    'name': string;
    /**
     * 企業名 かな
     * @type {string}
     * @memberof DirectCompanyModel
     */
    'kana': string;
    /**
     * 業種  選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof DirectCompanyModel
     */
    'business_type'?: number;
    /**
     * 都道府県 選択項目は実装側定義参照
     * @type {number}
     * @memberof DirectCompanyModel
     */
    'prefecture'?: number;
    /**
     * 所在地
     * @type {string}
     * @memberof DirectCompanyModel
     */
    'address'?: string;
    /**
     * 社員数 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof DirectCompanyModel
     */
    'employee_amount'?: number;
    /**
     * 事業内容
     * @type {string}
     * @memberof DirectCompanyModel
     */
    'description'?: string;
    /**
     * WebサイトURL
     * @type {string}
     * @memberof DirectCompanyModel
     */
    'url'?: string;
    /**
     * クリエイターへのひとこと
     * @type {string}
     * @memberof DirectCompanyModel
     */
    'message'?: string;
    /**
     * 企業ロゴ : POST / PATCH のリクエスト時はData URI形式`data:image/png;base64,iV...`で送信。レスポンスの際はS3に保存したURIを返却。
     * @type {string}
     * @memberof DirectCompanyModel
     */
    'icon'?: string;
    /**
     * 
     * @type {string}
     * @memberof DirectCompanyModel
     */
    'last_login'?: string;
    /**
     * 
     * @type {string}
     * @memberof DirectCompanyModel
     */
    'registration_date'?: string;
}
/**
 * 自社情報 レスポンス
 * @export
 * @interface DirectCompanyResponse
 */
export interface DirectCompanyResponse {
    /**
     * success のみ
     * @type {string}
     * @memberof DirectCompanyResponse
     */
    'result': string;
    /**
     * 
     * @type {Array<CompanyUser>}
     * @memberof DirectCompanyResponse
     */
    'users'?: Array<CompanyUser>;
    /**
     * 
     * @type {DirectCompanyModel}
     * @memberof DirectCompanyResponse
     */
    'company'?: DirectCompanyModel;
}
/**
 * 
 * @export
 * @interface DirectCompanyResponseAllOf
 */
export interface DirectCompanyResponseAllOf {
    /**
     * 
     * @type {Array<CompanyUser>}
     * @memberof DirectCompanyResponseAllOf
     */
    'users'?: Array<CompanyUser>;
    /**
     * 
     * @type {DirectCompanyModel}
     * @memberof DirectCompanyResponseAllOf
     */
    'company'?: DirectCompanyModel;
}
/**
 * 自社情報概要
 * @export
 * @interface DirectCompanySummary
 */
export interface DirectCompanySummary {
    /**
     * 企業ID
     * @type {number}
     * @memberof DirectCompanySummary
     */
    'id': number;
    /**
     * 企業名
     * @type {string}
     * @memberof DirectCompanySummary
     */
    'name': string;
    /**
     * 企業名（ふりがな）
     * @type {string}
     * @memberof DirectCompanySummary
     */
    'kana': string;
    /**
     * 企業ロゴ : POST / PATCH のリクエスト時はData URI形式`data:image/png;base64,iV...`で送信。レスポンスの際はS3に保存したURIを返却。
     * @type {string}
     * @memberof DirectCompanySummary
     */
    'icon'?: string;
}
/**
 * Direct企業サマリー モデル
 * @export
 * @interface DirectCompanySummaryModel
 */
export interface DirectCompanySummaryModel {
    /**
     * 内部的に採番している Direct用の企業ID 
     * @type {number}
     * @memberof DirectCompanySummaryModel
     */
    'id': number;
    /**
     * 企業名
     * @type {string}
     * @memberof DirectCompanySummaryModel
     */
    'name': string;
    /**
     * 企業名 かな
     * @type {string}
     * @memberof DirectCompanySummaryModel
     */
    'kana': string;
}
/**
 * 企業用ユーザー 変更リクエスト
 * @export
 * @interface DirectCompanyUserParam
 */
export interface DirectCompanyUserParam {
    /**
     * 
     * @type {DirectUserTypeModel}
     * @memberof DirectCompanyUserParam
     */
    'user_type'?: DirectUserTypeModel;
    /**
     * 保持するgroup idの配列を全て投げる
     * @type {Array<string>}
     * @memberof DirectCompanyUserParam
     */
    'groups'?: Array<string>;
}
/**
 * 企業用ユーザー一覧 レスポンス
 * @export
 * @interface DirectCompanyUsersResponse
 */
export interface DirectCompanyUsersResponse {
    /**
     * 
     * @type {Array<CompanyUser>}
     * @memberof DirectCompanyUsersResponse
     */
    'users'?: Array<CompanyUser>;
    /**
     * ページネーションの次のoffset or null
     * @type {number}
     * @memberof DirectCompanyUsersResponse
     */
    'offset'?: number | null;
    /**
     * 現在の条件でのレコード総数
     * @type {number}
     * @memberof DirectCompanyUsersResponse
     */
    'total'?: number;
    /**
     * success のみ
     * @type {string}
     * @memberof DirectCompanyUsersResponse
     */
    'result': string;
}
/**
 * 
 * @export
 * @interface DirectCompanyUsersResponseAllOf
 */
export interface DirectCompanyUsersResponseAllOf {
    /**
     * 
     * @type {Array<CompanyUser>}
     * @memberof DirectCompanyUsersResponseAllOf
     */
    'users'?: Array<CompanyUser>;
}
/**
 * Direct ログイン情報
 * @export
 * @interface DirectIsLoginResponse
 */
export interface DirectIsLoginResponse {
    /**
     * 
     * @type {DirectIsLoginResponseAllOfCompanyUser}
     * @memberof DirectIsLoginResponse
     */
    'company_user'?: DirectIsLoginResponseAllOfCompanyUser;
    /**
     * 
     * @type {boolean}
     * @memberof DirectIsLoginResponse
     */
    'is_login': boolean;
    /**
     * success のみ
     * @type {string}
     * @memberof DirectIsLoginResponse
     */
    'result': string;
}
/**
 * 
 * @export
 * @interface DirectIsLoginResponseAllOf
 */
export interface DirectIsLoginResponseAllOf {
    /**
     * 
     * @type {DirectIsLoginResponseAllOfCompanyUser}
     * @memberof DirectIsLoginResponseAllOf
     */
    'company_user'?: DirectIsLoginResponseAllOfCompanyUser;
    /**
     * 
     * @type {boolean}
     * @memberof DirectIsLoginResponseAllOf
     */
    'is_login': boolean;
}
/**
 * 
 * @export
 * @interface DirectIsLoginResponseAllOfCompanyUser
 */
export interface DirectIsLoginResponseAllOfCompanyUser {
    /**
     * 企業ユーザーID B+数字乱数8桁（Ex. B12183640）
     * @type {string}
     * @memberof DirectIsLoginResponseAllOfCompanyUser
     */
    'matchbox_id': string;
    /**
     * ユーザー名
     * @type {string}
     * @memberof DirectIsLoginResponseAllOfCompanyUser
     */
    'name': string;
    /**
     * 権限 user_typeと同様 1 : user 2 : maneger 3 : hr
     * @type {number}
     * @memberof DirectIsLoginResponseAllOfCompanyUser
     */
    'privilege': number;
    /**
     * 
     * @type {DirectUserTypeModel}
     * @memberof DirectIsLoginResponseAllOfCompanyUser
     */
    'user_type': DirectUserTypeModel;
    /**
     * 内部的に採番している Direct用の企業ID 
     * @type {number}
     * @memberof DirectIsLoginResponseAllOfCompanyUser
     */
    'company_id': number;
}
/**
 * * ピックアップを既読にする。 * direct_adminがピックアップのステータスを変更する。 * mwが対応状況を変更する
 * @export
 * @interface DirectOfferPatchParam
 */
export interface DirectOfferPatchParam {
    /**
     * OfferデータID
     * @type {string}
     * @memberof DirectOfferPatchParam
     */
    'id': string;
    /**
     * 企業・求職者アカウントのステータス状態  - 2 : 企業 マイナビワークスに相談する - 3 : 企業 一次面接にオファーする - 4 : 企業 見送る - 5 : 求職者 一次面接オファーを見送る - 6 : 求職者 一次面接オファーに応諾する - 7 : 求職者 マイナビワークスに一次面接オファーを相談する - 8 : 企業 カジュアル面談にオファーする - 9 : 求職者 カジュアル面談オファーに応諾する - 10 : 求職者 カジュアル面談オファーを見送る - 11 : 求職者 マイナビワークスにカジュアル面談オファーを相談する
     * @type {number}
     * @memberof DirectOfferPatchParam
     */
    'status'?: number;
    /**
     * 既読。エンドユーザーと、Direct管理者がそれぞれ個別のステータスを持つ
     * @type {boolean}
     * @memberof DirectOfferPatchParam
     */
    'is_read'?: boolean;
    /**
     * オファー 対応状況 1: 未完了 | 2: 保留 | 3: 完了
     * @type {number}
     * @memberof DirectOfferPatchParam
     */
    'mw_status'?: number;
    /**
     * マイナビワークスに相談・オファー時のコメント
     * @type {string}
     * @memberof DirectOfferPatchParam
     */
    'comment'?: string;
    /**
     * オファー時のポジション指定 ポジションのID
     * @type {number}
     * @memberof DirectOfferPatchParam
     */
    'offer_position'?: number | null;
}
/**
 * ポジション 設定
 * @export
 * @interface DirectOfferPositionParam
 */
export interface DirectOfferPositionParam {
    /**
     * 
     * @type {string}
     * @memberof DirectOfferPositionParam
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DirectOfferPositionParam
     */
    'body'?: string;
    /**
     * 表示
     * @type {boolean}
     * @memberof DirectOfferPositionParam
     */
    'active'?: boolean;
}
/**
 * Direct検索条件モデル Direct側のみで使用するモデルピックアップ
 * @export
 * @interface DirectSearchConditionDifferenceModel
 */
export interface DirectSearchConditionDifferenceModel {
    /**
     * ポートフォリオ更新日 期間選択 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof DirectSearchConditionDifferenceModel
     */
    'last_update_portfolio'?: number;
    /**
     * ⾃作ポートフォリオの最終更新日 期間選択 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof DirectSearchConditionDifferenceModel
     */
    'last_update_own_portfolio'?: number;
    /**
     * 職務経歴書の最終更新日 期間選択 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof DirectSearchConditionDifferenceModel
     */
    'last_update_career_history'?: number;
    /**
     * 登録日（サーバー側で付与） 期間選択 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof DirectSearchConditionDifferenceModel
     */
    'registration_date'?: number;
    /**
     * 最終ログイン 期間選択 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof DirectSearchConditionDifferenceModel
     */
    'last_login'?: number;
}
/**
 * Directの検索条件
 * @export
 * @interface DirectSearchConditionModel
 */
export interface DirectSearchConditionModel {
    /**
     * フリーワード 複数設定可能  毎日夜中にバッチで以下の情報をまとめたテキストをユーザー毎に更新しそのテキストが検索対象  - ユーザー情報 : 経歴 - ポートフォリオ :ページタイトル / イントロダクション / タイトル - ポートフォリオアイテム : description - 履歴書 : 志望動機 / 趣味特技 /本人希望 - 職務経歴 : 社名 / 業務内容 / 職務内容 / 最終ポジション / 退職理由 - 学歴 : 学校名 / 学部学科名 - 資格 : 資格タイプ / 資格名
     * @type {Array<string>}
     * @memberof DirectSearchConditionModel
     */
    'keyword'?: Array<string>;
    /**
     * オファー 選考ステータス 複数選択可能 選択項目はマスタまたは実装側定義参照  検索は全ての進捗（企業-求職者のやりとり）を対象とし、その進捗に関係のある求職者を出す
     * @type {Array<number>}
     * @memberof DirectSearchConditionModel
     */
    'offer_status'?: Array<number>;
    /**
     * オファー マッチ度 複数選択可能 選択項目はマスタまたは実装側定義参照  検索は全ての進捗（企業-求職者のやりとり）を対象とし、その進捗に関係のある求職者を出す  1: 底 | 2: 中 | 3: 高
     * @type {Array<number>}
     * @memberof DirectSearchConditionModel
     */
    'rate'?: Array<number>;
    /**
     * オファー 選考ステータス最終更新日 期間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof DirectSearchConditionModel
     */
    'offer_update_at'?: Array<string>;
    /**
     * 一般ユーザーID C+数字乱数8桁（Ex. C12183640）
     * @type {string}
     * @memberof DirectSearchConditionModel
     */
    'matchbox_id'?: string;
    /**
     * 男女 (0:未設定(default), 1:女子, 2:男子)
     * @type {number}
     * @memberof DirectSearchConditionModel
     */
    'gender'?: number;
    /**
     * 年齢 [form, to] 配列で指
     * @type {Array<number>}
     * @memberof DirectSearchConditionModel
     */
    'age'?: Array<number>;
    /**
     * 職種と経験年数。複数の場合 OR検索
     * @type {Array<CommonSCMcExperiencedJobObjectModel>}
     * @memberof DirectSearchConditionModel
     */
    'mc_experienced_job'?: Array<CommonSCMcExperiencedJobObjectModel>;
    /**
     * 転職希望時期 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectSearchConditionModel
     */
    'mc_preferred_change_date'?: Array<number>;
    /**
     * 都道府県 選択項目は実装側定義参照
     * @type {number}
     * @memberof DirectSearchConditionModel
     */
    'prefecture'?: number;
    /**
     * 就業状況 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof DirectSearchConditionModel
     */
    'mc_situation'?: number;
    /**
     * 現在の在籍企業
     * @type {string}
     * @memberof DirectSearchConditionModel
     */
    'career_history_current_companies'?: string;
    /**
     * 現在の年収 選択項目は希望年収と同様マスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectSearchConditionModel
     */
    'mc_yearly_income'?: Array<number>;
    /**
     * 現在の在籍部署名
     * @type {string}
     * @memberof DirectSearchConditionModel
     */
    'career_history_current_section'?: string;
    /**
     * 現在の役職名
     * @type {string}
     * @memberof DirectSearchConditionModel
     */
    'career_history_current_post'?: string;
    /**
     * ポートフォリオの作品数 範囲を[form, to] 配列で指定
     * @type {Array<number>}
     * @memberof DirectSearchConditionModel
     */
    'portfolio_item_count'?: Array<number>;
    /**
     * 経験社数 範囲を[form, to] 配列で指定
     * @type {Array<number>}
     * @memberof DirectSearchConditionModel
     */
    'career_history_amount'?: Array<number>;
    /**
     * これまでの在籍企業 複数設定可能
     * @type {Array<string>}
     * @memberof DirectSearchConditionModel
     */
    'career_history_companies'?: Array<string>;
    /**
     * これまでの部署名 複数設定可能
     * @type {Array<string>}
     * @memberof DirectSearchConditionModel
     */
    'career_history_section'?: Array<string>;
    /**
     * これまでの役職名 複数設定可能
     * @type {Array<string>}
     * @memberof DirectSearchConditionModel
     */
    'career_history_post'?: Array<string>;
    /**
     * 担当内容 複数設定可能  各ポートフォリオ作品内の「担当内容」を参照
     * @type {Array<string>}
     * @memberof DirectSearchConditionModel
     */
    'qa_answer'?: Array<string>;
    /**
     * 経験 複数設定可能 ポートフォリオ作品の経験の項目を検索
     * @type {Array<string>}
     * @memberof DirectSearchConditionModel
     */
    'career_history_experiences'?: Array<string>;
    /**
     * 使用言語・ツール 複数設定可能
     * @type {Array<string>}
     * @memberof DirectSearchConditionModel
     */
    'career_history_tools'?: Array<string>;
    /**
     * 最大マネジメント人数 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectSearchConditionModel
     */
    'mc_maximum_management_count'?: Array<number>;
    /**
     * 資格・免許 複数設定可能
     * @type {Array<string>}
     * @memberof DirectSearchConditionModel
     */
    'q_title'?: Array<string>;
    /**
     * TOEIC点数
     * @type {number}
     * @memberof DirectSearchConditionModel
     */
    'q_toeic_score'?: number;
    /**
     * TOEFL点数
     * @type {number}
     * @memberof DirectSearchConditionModel
     */
    'q_toefl_score'?: number;
    /**
     * 英語力 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof DirectSearchConditionModel
     */
    'mc_english_skills'?: number;
    /**
     * 学校名 複数設定可能
     * @type {Array<string>}
     * @memberof DirectSearchConditionModel
     */
    'e_school_name'?: Array<string>;
    /**
     * 最終学歴 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectSearchConditionModel
     */
    'final_education'?: Array<number>;
    /**
     * 希望職種 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectSearchConditionModel
     */
    'mc_preferred_job_type'?: Array<number>;
    /**
     * 希望業種 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectSearchConditionModel
     */
    'mc_preferred_business_type'?: Array<number>;
    /**
     * 希望勤務地 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectSearchConditionModel
     */
    'mc_preferred_prefecture'?: Array<number>;
    /**
     * 希望年収 選択項目は現在の年収と同様マスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectSearchConditionModel
     */
    'mc_preferred_yearly_income'?: Array<number>;
    /**
     * 希望雇用形態 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectSearchConditionModel
     */
    'mc_preferred_employment_status'?: Array<number>;
    /**
     * こだわりの条件 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectSearchConditionModel
     */
    'mc_conditions'?: Array<number>;
    /**
     * 自作ポートフォリオの登録の有無(1:あり/0:なし)
     * @type {number}
     * @memberof DirectSearchConditionModel
     */
    'has_own_portfolio'?: number;
    /**
     * 入力代行ステータス - 0: 申し込み無し - 1: 求職者依頼中 - 2: 管理者見送り - 3: 管理者入力完了 - 4: 求職者入力内容反映済 
     * @type {number}
     * @memberof DirectSearchConditionModel
     */
    'input_agency'?: number;
    /**
     * ポートフォリオ更新日 期間選択 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof DirectSearchConditionModel
     */
    'last_update_portfolio'?: number;
    /**
     * ⾃作ポートフォリオの最終更新日 期間選択 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof DirectSearchConditionModel
     */
    'last_update_own_portfolio'?: number;
    /**
     * 職務経歴書の最終更新日 期間選択 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof DirectSearchConditionModel
     */
    'last_update_career_history'?: number;
    /**
     * 登録日（サーバー側で付与） 期間選択 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof DirectSearchConditionModel
     */
    'registration_date'?: number;
    /**
     * 最終ログイン 期間選択 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof DirectSearchConditionModel
     */
    'last_login'?: number;
}
/**
 * Directの検索条件保存リクエスト
 * @export
 * @interface DirectSearchConditionRequest
 */
export interface DirectSearchConditionRequest {
    /**
     * 検索条件名
     * @type {string}
     * @memberof DirectSearchConditionRequest
     */
    'search_condition_name': string;
    /**
     * フリーワード 複数設定可能  毎日夜中にバッチで以下の情報をまとめたテキストをユーザー毎に更新しそのテキストが検索対象  - ユーザー情報 : 経歴 - ポートフォリオ :ページタイトル / イントロダクション / タイトル - ポートフォリオアイテム : description - 履歴書 : 志望動機 / 趣味特技 /本人希望 - 職務経歴 : 社名 / 業務内容 / 職務内容 / 最終ポジション / 退職理由 - 学歴 : 学校名 / 学部学科名 - 資格 : 資格タイプ / 資格名
     * @type {Array<string>}
     * @memberof DirectSearchConditionRequest
     */
    'keyword'?: Array<string>;
    /**
     * オファー 選考ステータス 複数選択可能 選択項目はマスタまたは実装側定義参照  検索は全ての進捗（企業-求職者のやりとり）を対象とし、その進捗に関係のある求職者を出す
     * @type {Array<number>}
     * @memberof DirectSearchConditionRequest
     */
    'offer_status'?: Array<number>;
    /**
     * オファー マッチ度 複数選択可能 選択項目はマスタまたは実装側定義参照  検索は全ての進捗（企業-求職者のやりとり）を対象とし、その進捗に関係のある求職者を出す  1: 底 | 2: 中 | 3: 高
     * @type {Array<number>}
     * @memberof DirectSearchConditionRequest
     */
    'rate'?: Array<number>;
    /**
     * オファー 選考ステータス最終更新日 期間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof DirectSearchConditionRequest
     */
    'offer_update_at'?: Array<string>;
    /**
     * 一般ユーザーID C+数字乱数8桁（Ex. C12183640）
     * @type {string}
     * @memberof DirectSearchConditionRequest
     */
    'matchbox_id'?: string;
    /**
     * 男女 (0:未設定(default), 1:女子, 2:男子)
     * @type {number}
     * @memberof DirectSearchConditionRequest
     */
    'gender'?: number;
    /**
     * 年齢 [form, to] 配列で指
     * @type {Array<number>}
     * @memberof DirectSearchConditionRequest
     */
    'age'?: Array<number>;
    /**
     * 職種と経験年数。複数の場合 OR検索
     * @type {Array<CommonSCMcExperiencedJobObjectModel>}
     * @memberof DirectSearchConditionRequest
     */
    'mc_experienced_job'?: Array<CommonSCMcExperiencedJobObjectModel>;
    /**
     * 転職希望時期 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectSearchConditionRequest
     */
    'mc_preferred_change_date'?: Array<number>;
    /**
     * 都道府県 選択項目は実装側定義参照
     * @type {number}
     * @memberof DirectSearchConditionRequest
     */
    'prefecture'?: number;
    /**
     * 就業状況 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof DirectSearchConditionRequest
     */
    'mc_situation'?: number;
    /**
     * 現在の在籍企業
     * @type {string}
     * @memberof DirectSearchConditionRequest
     */
    'career_history_current_companies'?: string;
    /**
     * 現在の年収 選択項目は希望年収と同様マスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectSearchConditionRequest
     */
    'mc_yearly_income'?: Array<number>;
    /**
     * 現在の在籍部署名
     * @type {string}
     * @memberof DirectSearchConditionRequest
     */
    'career_history_current_section'?: string;
    /**
     * 現在の役職名
     * @type {string}
     * @memberof DirectSearchConditionRequest
     */
    'career_history_current_post'?: string;
    /**
     * ポートフォリオの作品数 範囲を[form, to] 配列で指定
     * @type {Array<number>}
     * @memberof DirectSearchConditionRequest
     */
    'portfolio_item_count'?: Array<number>;
    /**
     * 経験社数 範囲を[form, to] 配列で指定
     * @type {Array<number>}
     * @memberof DirectSearchConditionRequest
     */
    'career_history_amount'?: Array<number>;
    /**
     * これまでの在籍企業 複数設定可能
     * @type {Array<string>}
     * @memberof DirectSearchConditionRequest
     */
    'career_history_companies'?: Array<string>;
    /**
     * これまでの部署名 複数設定可能
     * @type {Array<string>}
     * @memberof DirectSearchConditionRequest
     */
    'career_history_section'?: Array<string>;
    /**
     * これまでの役職名 複数設定可能
     * @type {Array<string>}
     * @memberof DirectSearchConditionRequest
     */
    'career_history_post'?: Array<string>;
    /**
     * 担当内容 複数設定可能  各ポートフォリオ作品内の「担当内容」を参照
     * @type {Array<string>}
     * @memberof DirectSearchConditionRequest
     */
    'qa_answer'?: Array<string>;
    /**
     * 経験 複数設定可能 ポートフォリオ作品の経験の項目を検索
     * @type {Array<string>}
     * @memberof DirectSearchConditionRequest
     */
    'career_history_experiences'?: Array<string>;
    /**
     * 使用言語・ツール 複数設定可能
     * @type {Array<string>}
     * @memberof DirectSearchConditionRequest
     */
    'career_history_tools'?: Array<string>;
    /**
     * 最大マネジメント人数 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectSearchConditionRequest
     */
    'mc_maximum_management_count'?: Array<number>;
    /**
     * 資格・免許 複数設定可能
     * @type {Array<string>}
     * @memberof DirectSearchConditionRequest
     */
    'q_title'?: Array<string>;
    /**
     * TOEIC点数
     * @type {number}
     * @memberof DirectSearchConditionRequest
     */
    'q_toeic_score'?: number;
    /**
     * TOEFL点数
     * @type {number}
     * @memberof DirectSearchConditionRequest
     */
    'q_toefl_score'?: number;
    /**
     * 英語力 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof DirectSearchConditionRequest
     */
    'mc_english_skills'?: number;
    /**
     * 学校名 複数設定可能
     * @type {Array<string>}
     * @memberof DirectSearchConditionRequest
     */
    'e_school_name'?: Array<string>;
    /**
     * 最終学歴 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectSearchConditionRequest
     */
    'final_education'?: Array<number>;
    /**
     * 希望職種 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectSearchConditionRequest
     */
    'mc_preferred_job_type'?: Array<number>;
    /**
     * 希望業種 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectSearchConditionRequest
     */
    'mc_preferred_business_type'?: Array<number>;
    /**
     * 希望勤務地 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectSearchConditionRequest
     */
    'mc_preferred_prefecture'?: Array<number>;
    /**
     * 希望年収 選択項目は現在の年収と同様マスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectSearchConditionRequest
     */
    'mc_preferred_yearly_income'?: Array<number>;
    /**
     * 希望雇用形態 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectSearchConditionRequest
     */
    'mc_preferred_employment_status'?: Array<number>;
    /**
     * こだわりの条件 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectSearchConditionRequest
     */
    'mc_conditions'?: Array<number>;
    /**
     * 自作ポートフォリオの登録の有無(1:あり/0:なし)
     * @type {number}
     * @memberof DirectSearchConditionRequest
     */
    'has_own_portfolio'?: number;
    /**
     * 入力代行ステータス - 0: 申し込み無し - 1: 求職者依頼中 - 2: 管理者見送り - 3: 管理者入力完了 - 4: 求職者入力内容反映済 
     * @type {number}
     * @memberof DirectSearchConditionRequest
     */
    'input_agency'?: number;
    /**
     * ポートフォリオ更新日 期間選択 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof DirectSearchConditionRequest
     */
    'last_update_portfolio'?: number;
    /**
     * ⾃作ポートフォリオの最終更新日 期間選択 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof DirectSearchConditionRequest
     */
    'last_update_own_portfolio'?: number;
    /**
     * 職務経歴書の最終更新日 期間選択 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof DirectSearchConditionRequest
     */
    'last_update_career_history'?: number;
    /**
     * 登録日（サーバー側で付与） 期間選択 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof DirectSearchConditionRequest
     */
    'registration_date'?: number;
    /**
     * 最終ログイン 期間選択 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof DirectSearchConditionRequest
     */
    'last_login'?: number;
}
/**
 * 
 * @export
 * @interface DirectSearchConditionRequestAllOf
 */
export interface DirectSearchConditionRequestAllOf {
    /**
     * 検索条件名
     * @type {string}
     * @memberof DirectSearchConditionRequestAllOf
     */
    'search_condition_name': string;
}
/**
 * Directの検索条件レスポンス
 * @export
 * @interface DirectSearchConditionResponse
 */
export interface DirectSearchConditionResponse {
    /**
     * 検索条件ID
     * @type {number}
     * @memberof DirectSearchConditionResponse
     */
    'id': number;
    /**
     * メール配信設定 true する false しない
     * @type {boolean}
     * @memberof DirectSearchConditionResponse
     */
    'direct_mail'?: boolean;
    /**
     * 検索条件名
     * @type {string}
     * @memberof DirectSearchConditionResponse
     */
    'search_condition_name': string;
    /**
     * フリーワード 複数設定可能  毎日夜中にバッチで以下の情報をまとめたテキストをユーザー毎に更新しそのテキストが検索対象  - ユーザー情報 : 経歴 - ポートフォリオ :ページタイトル / イントロダクション / タイトル - ポートフォリオアイテム : description - 履歴書 : 志望動機 / 趣味特技 /本人希望 - 職務経歴 : 社名 / 業務内容 / 職務内容 / 最終ポジション / 退職理由 - 学歴 : 学校名 / 学部学科名 - 資格 : 資格タイプ / 資格名
     * @type {Array<string>}
     * @memberof DirectSearchConditionResponse
     */
    'keyword'?: Array<string>;
    /**
     * オファー 選考ステータス 複数選択可能 選択項目はマスタまたは実装側定義参照  検索は全ての進捗（企業-求職者のやりとり）を対象とし、その進捗に関係のある求職者を出す
     * @type {Array<number>}
     * @memberof DirectSearchConditionResponse
     */
    'offer_status'?: Array<number>;
    /**
     * オファー マッチ度 複数選択可能 選択項目はマスタまたは実装側定義参照  検索は全ての進捗（企業-求職者のやりとり）を対象とし、その進捗に関係のある求職者を出す  1: 底 | 2: 中 | 3: 高
     * @type {Array<number>}
     * @memberof DirectSearchConditionResponse
     */
    'rate'?: Array<number>;
    /**
     * オファー 選考ステータス最終更新日 期間を [form, to] 配列で指定
     * @type {Array<string>}
     * @memberof DirectSearchConditionResponse
     */
    'offer_update_at'?: Array<string>;
    /**
     * 一般ユーザーID C+数字乱数8桁（Ex. C12183640）
     * @type {string}
     * @memberof DirectSearchConditionResponse
     */
    'matchbox_id'?: string;
    /**
     * 男女 (0:未設定(default), 1:女子, 2:男子)
     * @type {number}
     * @memberof DirectSearchConditionResponse
     */
    'gender'?: number;
    /**
     * 年齢 [form, to] 配列で指
     * @type {Array<number>}
     * @memberof DirectSearchConditionResponse
     */
    'age'?: Array<number>;
    /**
     * 職種と経験年数。複数の場合 OR検索
     * @type {Array<CommonSCMcExperiencedJobObjectModel>}
     * @memberof DirectSearchConditionResponse
     */
    'mc_experienced_job'?: Array<CommonSCMcExperiencedJobObjectModel>;
    /**
     * 転職希望時期 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectSearchConditionResponse
     */
    'mc_preferred_change_date'?: Array<number>;
    /**
     * 都道府県 選択項目は実装側定義参照
     * @type {number}
     * @memberof DirectSearchConditionResponse
     */
    'prefecture'?: number;
    /**
     * 就業状況 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof DirectSearchConditionResponse
     */
    'mc_situation'?: number;
    /**
     * 現在の在籍企業
     * @type {string}
     * @memberof DirectSearchConditionResponse
     */
    'career_history_current_companies'?: string;
    /**
     * 現在の年収 選択項目は希望年収と同様マスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectSearchConditionResponse
     */
    'mc_yearly_income'?: Array<number>;
    /**
     * 現在の在籍部署名
     * @type {string}
     * @memberof DirectSearchConditionResponse
     */
    'career_history_current_section'?: string;
    /**
     * 現在の役職名
     * @type {string}
     * @memberof DirectSearchConditionResponse
     */
    'career_history_current_post'?: string;
    /**
     * ポートフォリオの作品数 範囲を[form, to] 配列で指定
     * @type {Array<number>}
     * @memberof DirectSearchConditionResponse
     */
    'portfolio_item_count'?: Array<number>;
    /**
     * 経験社数 範囲を[form, to] 配列で指定
     * @type {Array<number>}
     * @memberof DirectSearchConditionResponse
     */
    'career_history_amount'?: Array<number>;
    /**
     * これまでの在籍企業 複数設定可能
     * @type {Array<string>}
     * @memberof DirectSearchConditionResponse
     */
    'career_history_companies'?: Array<string>;
    /**
     * これまでの部署名 複数設定可能
     * @type {Array<string>}
     * @memberof DirectSearchConditionResponse
     */
    'career_history_section'?: Array<string>;
    /**
     * これまでの役職名 複数設定可能
     * @type {Array<string>}
     * @memberof DirectSearchConditionResponse
     */
    'career_history_post'?: Array<string>;
    /**
     * 担当内容 複数設定可能  各ポートフォリオ作品内の「担当内容」を参照
     * @type {Array<string>}
     * @memberof DirectSearchConditionResponse
     */
    'qa_answer'?: Array<string>;
    /**
     * 経験 複数設定可能 ポートフォリオ作品の経験の項目を検索
     * @type {Array<string>}
     * @memberof DirectSearchConditionResponse
     */
    'career_history_experiences'?: Array<string>;
    /**
     * 使用言語・ツール 複数設定可能
     * @type {Array<string>}
     * @memberof DirectSearchConditionResponse
     */
    'career_history_tools'?: Array<string>;
    /**
     * 最大マネジメント人数 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectSearchConditionResponse
     */
    'mc_maximum_management_count'?: Array<number>;
    /**
     * 資格・免許 複数設定可能
     * @type {Array<string>}
     * @memberof DirectSearchConditionResponse
     */
    'q_title'?: Array<string>;
    /**
     * TOEIC点数
     * @type {number}
     * @memberof DirectSearchConditionResponse
     */
    'q_toeic_score'?: number;
    /**
     * TOEFL点数
     * @type {number}
     * @memberof DirectSearchConditionResponse
     */
    'q_toefl_score'?: number;
    /**
     * 英語力 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof DirectSearchConditionResponse
     */
    'mc_english_skills'?: number;
    /**
     * 学校名 複数設定可能
     * @type {Array<string>}
     * @memberof DirectSearchConditionResponse
     */
    'e_school_name'?: Array<string>;
    /**
     * 最終学歴 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectSearchConditionResponse
     */
    'final_education'?: Array<number>;
    /**
     * 希望職種 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectSearchConditionResponse
     */
    'mc_preferred_job_type'?: Array<number>;
    /**
     * 希望業種 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectSearchConditionResponse
     */
    'mc_preferred_business_type'?: Array<number>;
    /**
     * 希望勤務地 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectSearchConditionResponse
     */
    'mc_preferred_prefecture'?: Array<number>;
    /**
     * 希望年収 選択項目は現在の年収と同様マスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectSearchConditionResponse
     */
    'mc_preferred_yearly_income'?: Array<number>;
    /**
     * 希望雇用形態 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectSearchConditionResponse
     */
    'mc_preferred_employment_status'?: Array<number>;
    /**
     * こだわりの条件 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectSearchConditionResponse
     */
    'mc_conditions'?: Array<number>;
    /**
     * 自作ポートフォリオの登録の有無(1:あり/0:なし)
     * @type {number}
     * @memberof DirectSearchConditionResponse
     */
    'has_own_portfolio'?: number;
    /**
     * 入力代行ステータス - 0: 申し込み無し - 1: 求職者依頼中 - 2: 管理者見送り - 3: 管理者入力完了 - 4: 求職者入力内容反映済 
     * @type {number}
     * @memberof DirectSearchConditionResponse
     */
    'input_agency'?: number;
    /**
     * ポートフォリオ更新日 期間選択 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof DirectSearchConditionResponse
     */
    'last_update_portfolio'?: number;
    /**
     * ⾃作ポートフォリオの最終更新日 期間選択 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof DirectSearchConditionResponse
     */
    'last_update_own_portfolio'?: number;
    /**
     * 職務経歴書の最終更新日 期間選択 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof DirectSearchConditionResponse
     */
    'last_update_career_history'?: number;
    /**
     * 登録日（サーバー側で付与） 期間選択 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof DirectSearchConditionResponse
     */
    'registration_date'?: number;
    /**
     * 最終ログイン 期間選択 選択項目はマスタまたは実装側定義参照
     * @type {number}
     * @memberof DirectSearchConditionResponse
     */
    'last_login'?: number;
}
/**
 * 
 * @export
 * @interface DirectSearchConditionResponseAllOf
 */
export interface DirectSearchConditionResponseAllOf {
    /**
     * 検索条件ID
     * @type {number}
     * @memberof DirectSearchConditionResponseAllOf
     */
    'id': number;
    /**
     * メール配信設定 true する false しない
     * @type {boolean}
     * @memberof DirectSearchConditionResponseAllOf
     */
    'direct_mail'?: boolean;
}
/**
 * Directの保存した検索一覧レスポンス
 * @export
 * @interface DirectSearchConditionsResponse
 */
export interface DirectSearchConditionsResponse {
    /**
     * 保存検索一覧
     * @type {Array<DirectSearchConditionResponse>}
     * @memberof DirectSearchConditionsResponse
     */
    'conditions': Array<DirectSearchConditionResponse>;
    /**
     * success のみ
     * @type {string}
     * @memberof DirectSearchConditionsResponse
     */
    'result': string;
}
/**
 * 
 * @export
 * @interface DirectSearchConditionsResponseAllOf
 */
export interface DirectSearchConditionsResponseAllOf {
    /**
     * 保存検索一覧
     * @type {Array<DirectSearchConditionResponse>}
     * @memberof DirectSearchConditionsResponseAllOf
     */
    'conditions': Array<DirectSearchConditionResponse>;
}
/**
 * Direct ユーザー検索リクエスト
 * @export
 * @interface DirectSearchUserRequest
 */
export interface DirectSearchUserRequest {
    /**
     * 取得件数 指定がない場合は20
     * @type {number}
     * @memberof DirectSearchUserRequest
     */
    'limit'?: number;
    /**
     * 次のページ番号 指定がない場合は0
     * @type {number}
     * @memberof DirectSearchUserRequest
     */
    'offset'?: number;
    /**
     * 検索項目 項目はdescription参照
     * @type {string}
     * @memberof DirectSearchUserRequest
     */
    'sort_by'?: string;
    /**
     * 検索順序 asc | desc
     * @type {string}
     * @memberof DirectSearchUserRequest
     */
    'sort_order'?: string;
    /**
     * 
     * @type {DirectSearchConditionModel}
     * @memberof DirectSearchUserRequest
     */
    'conditions'?: DirectSearchConditionModel;
}
/**
 * 
 * @export
 * @interface DirectSearchUserRequestAllOf
 */
export interface DirectSearchUserRequestAllOf {
    /**
     * 
     * @type {DirectSearchConditionModel}
     * @memberof DirectSearchUserRequestAllOf
     */
    'conditions'?: DirectSearchConditionModel;
}
/**
 * Directのユーザー情報検索レスポンス
 * @export
 * @interface DirectSearchUsersResponse
 */
export interface DirectSearchUsersResponse {
    /**
     * 
     * @type {Array<DirectUserSearchModel>}
     * @memberof DirectSearchUsersResponse
     */
    'users': Array<DirectUserSearchModel>;
    /**
     * ページネーションの次のoffset or null
     * @type {number}
     * @memberof DirectSearchUsersResponse
     */
    'offset'?: number | null;
    /**
     * 現在の条件でのレコード総数
     * @type {number}
     * @memberof DirectSearchUsersResponse
     */
    'total'?: number;
    /**
     * success のみ
     * @type {string}
     * @memberof DirectSearchUsersResponse
     */
    'result': string;
}
/**
 * 
 * @export
 * @interface DirectSearchUsersResponseAllOf
 */
export interface DirectSearchUsersResponseAllOf {
    /**
     * 
     * @type {Array<DirectUserSearchModel>}
     * @memberof DirectSearchUsersResponseAllOf
     */
    'users': Array<DirectUserSearchModel>;
}
/**
 * Direct用のユーザー情報
 * @export
 * @interface DirectUserInfoModel
 */
export interface DirectUserInfoModel {
    /**
     * 男女 (0:未設定(default), 1:女子, 2:男子)
     * @type {number}
     * @memberof DirectUserInfoModel
     */
    'gender'?: number;
    /**
     * 希望職種 選択項目はマスタまたは実装側定義参照
     * @type {Array<number>}
     * @memberof DirectUserInfoModel
     */
    'job'?: Array<number>;
    /**
     * 誕生年  バリデーション - 半角数字 - 1900 - 2021（または現在年） まで
     * @type {number}
     * @memberof DirectUserInfoModel
     */
    'birth_year'?: number;
    /**
     * 誕生月  バリデーション - 半角数字 - 1 - 12 まで
     * @type {number}
     * @memberof DirectUserInfoModel
     */
    'birth_month'?: number;
    /**
     * 一般ユーザーID C+数字乱数8桁（Ex. C12183640）
     * @type {string}
     * @memberof DirectUserInfoModel
     */
    'matchbox_id'?: string;
    /**
     * 都道府県 選択項目は実装側定義参照
     * @type {number}
     * @memberof DirectUserInfoModel
     */
    'prefecture'?: number;
}
/**
 * プロフィール 変更リクエスト
 * @export
 * @interface DirectUserParam
 */
export interface DirectUserParam {
    /**
     * ユーザー名
     * @type {string}
     * @memberof DirectUserParam
     */
    'name'?: string;
    /**
     * 部署 
     * @type {string}
     * @memberof DirectUserParam
     */
    'section'?: string;
    /**
     * 役職 
     * @type {string}
     * @memberof DirectUserParam
     */
    'post'?: string;
    /**
     * 採用時に見るポイント 選択項目はマスタまたは実装側定義参照 
     * @type {number}
     * @memberof DirectUserParam
     */
    'point'?: number;
    /**
     * ユーザーアイコン : POST / PATCH のリクエスト時はData URI形式`data:image/png;base64,iV...`で送信。レスポンスの際はS3に保存したURIを返却。
     * @type {string}
     * @memberof DirectUserParam
     */
    'photo'?: string;
    /**
     * 企業ユーザーID B+数字乱数8桁（Ex. B12183640）
     * @type {string}
     * @memberof DirectUserParam
     */
    'matchbox_id': string;
}
/**
 * 企業用ユーザー レスポンス
 * @export
 * @interface DirectUserResponse
 */
export interface DirectUserResponse {
    /**
     * 
     * @type {CompanyUser}
     * @memberof DirectUserResponse
     */
    'user_info': CompanyUser;
    /**
     * 
     * @type {DirectCompanySummary}
     * @memberof DirectUserResponse
     */
    'company'?: DirectCompanySummary;
    /**
     * success のみ
     * @type {string}
     * @memberof DirectUserResponse
     */
    'result': string;
}
/**
 * 
 * @export
 * @interface DirectUserResponseAllOf
 */
export interface DirectUserResponseAllOf {
    /**
     * 
     * @type {CompanyUser}
     * @memberof DirectUserResponseAllOf
     */
    'user_info': CompanyUser;
    /**
     * 
     * @type {DirectCompanySummary}
     * @memberof DirectUserResponseAllOf
     */
    'company'?: DirectCompanySummary;
}
/**
 * Direct用ユーザー情報モデル
 * @export
 * @interface DirectUserSearchModel
 */
export interface DirectUserSearchModel {
    /**
     * 一般ユーザーID C+数字乱数8桁（Ex. C12183640）
     * @type {string}
     * @memberof DirectUserSearchModel
     */
    'matchbox_id': string;
    /**
     * アカウント開設日 YYY-MM-DD
     * @type {string}
     * @memberof DirectUserSearchModel
     */
    'registration_date'?: string;
    /**
     * ポートフォリオ更新日 YYY-MM-DD hh:mm:ss
     * @type {string}
     * @memberof DirectUserSearchModel
     */
    'last_update_portfolio'?: string;
    /**
     * 自作ポートフォリオ更新日 YYY-MM-DD hh:mm:ss
     * @type {string}
     * @memberof DirectUserSearchModel
     */
    'last_update_own_portfolio'?: string;
    /**
     * ポートフォリオ更新日 YYY-MM-DD hh:mm:ss
     * @type {string}
     * @memberof DirectUserSearchModel
     */
    'last_update_public_portfolio'?: string;
    /**
     * 履歴書更新日更新日 YYY-MM-DD hh:mm:ss
     * @type {string}
     * @memberof DirectUserSearchModel
     */
    'last_update_resume'?: string;
    /**
     * 
     * @type {Portfolio}
     * @memberof DirectUserSearchModel
     */
    'portfolio'?: Portfolio;
    /**
     * 
     * @type {OwnPortfolio}
     * @memberof DirectUserSearchModel
     */
    'own_portfolio'?: OwnPortfolio;
    /**
     * 職務経歴書更新日 YYY-MM-DD hh:mm:ss
     * @type {string}
     * @memberof DirectUserSearchModel
     */
    'last_update_career_history'?: string;
    /**
     * ユーザー状態 active | inactive | before_delete | deleted
     * @type {string}
     * @memberof DirectUserSearchModel
     */
    'user_status': string;
    /**
     * 
     * @type {CareerHistory}
     * @memberof DirectUserSearchModel
     */
    'career_history'?: CareerHistory;
    /**
     * 最終ログイン日
     * @type {Set<LastLogin>}
     * @memberof DirectUserSearchModel
     */
    'last_login': Set<LastLogin>;
    /**
     * 広告効果測定用エントリーID 15桁の数値の文字列で生成 詳細は仕様書の説明項目を参照
     * @type {string}
     * @memberof DirectUserSearchModel
     */
    'user_entry_id': string;
    /**
     * 
     * @type {MyNavi}
     * @memberof DirectUserSearchModel
     */
    'mc'?: MyNavi;
    /**
     * 管理タグ（旧確認ステータス）
     * @type {string}
     * @memberof DirectUserSearchModel
     */
    'user_admin_tags'?: string;
    /**
     * 
     * @type {Array<Offer>}
     * @memberof DirectUserSearchModel
     */
    'offers'?: Array<Offer>;
    /**
     * 検索結果に表示された求職者情報が、Direct/Adminユーザーにクリックされているか。求職者が自身の情報を更新した際に、すべてのDirect/Adminユーザーに対しての、is_readがfalseにリセットされる
     * @type {boolean}
     * @memberof DirectUserSearchModel
     */
    'is_read'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DirectUserSearchModel
     */
    'portfolio_item_count'?: number;
    /**
     * 
     * @type {string}
     * @memberof DirectUserSearchModel
     */
    'portfolio_password'?: string;
    /**
     * 
     * @type {DirectUserInfoModel}
     * @memberof DirectUserSearchModel
     */
    'user_info'?: DirectUserInfoModel;
    /**
     * 
     * @type {string}
     * @memberof DirectUserSearchModel
     */
    'status'?: string;
    /**
     * 非表示作品含んだ数
     * @type {string}
     * @memberof DirectUserSearchModel
     */
    'portfolio_item_count_contained_invisible'?: string;
    /**
     * 企業向けポートフォリオの作品数
     * @type {number}
     * @memberof DirectUserSearchModel
     */
    'direct_portfolio_item_count'?: number;
    /**
     * 企業向け求職者コメント
     * @type {string}
     * @memberof DirectUserSearchModel
     */
    'comment'?: string;
    /**
     * 最終オファー登録日 YYY-MM-DD
     * @type {string}
     * @memberof DirectUserSearchModel
     */
    'last_update_use_direct'?: string;
}
/**
 * 
 * @export
 * @interface DirectUserSearchModelAllOf
 */
export interface DirectUserSearchModelAllOf {
    /**
     * 
     * @type {DirectUserInfoModel}
     * @memberof DirectUserSearchModelAllOf
     */
    'user_info'?: DirectUserInfoModel;
}
/**
 * 
 * @export
 * @interface DirectUserTagResponse
 */
export interface DirectUserTagResponse {
    /**
     * 
     * @type {UserTagDirect}
     * @memberof DirectUserTagResponse
     */
    'data'?: UserTagDirect;
    /**
     * success のみ
     * @type {string}
     * @memberof DirectUserTagResponse
     */
    'result': string;
}
/**
 * 
 * @export
 * @interface DirectUserTagResponseAllOf
 */
export interface DirectUserTagResponseAllOf {
    /**
     * 
     * @type {UserTagDirect}
     * @memberof DirectUserTagResponseAllOf
     */
    'data'?: UserTagDirect;
}
/**
 * direct_user: 企業管理画面一般ユーザー direct_manager : 利用責任者 direct_hr : 採用担当者
 * @export
 * @enum {string}
 */

export enum DirectUserTypeModel {
    Manager = 'direct_manager',
    User = 'direct_user',
    Hr = 'direct_hr'
}

/**
 * 学歴 レスポンス
 * @export
 * @interface EducationData
 */
export interface EducationData {
    /**
     * 学歴id 
     * @type {string}
     * @memberof EducationData
     */
    'e_id': string;
    /**
     * 学校名 
     * @type {string}
     * @memberof EducationData
     */
    'e_school_name'?: string;
    /**
     * 学部学科名 
     * @type {string}
     * @memberof EducationData
     */
    'e_department'?: string;
    /**
     * 入学年月 YYYY-MM の書式
     * @type {string}
     * @memberof EducationData
     */
    'e_admission_date'?: string;
    /**
     * 卒業しているかどうかのフラグ。trueが卒業している。 
     * @type {boolean}
     * @memberof EducationData
     */
    'e_graduate_flag'?: boolean;
    /**
     * 卒業年月 YYYY-MM の書式
     * @type {string}
     * @memberof EducationData
     */
    'e_graduate_date'?: string;
    /**
     * 卒業区分 選択式（マスタから選択） 
     * @type {number}
     * @memberof EducationData
     */
    'e_graduate_category'?: number;
}
/**
 * 学歴 編集
 * @export
 * @interface EducationPatchRequest
 */
export interface EducationPatchRequest {
    /**
     * 学歴id 
     * @type {string}
     * @memberof EducationPatchRequest
     */
    'e_id': string;
    /**
     * 学校名 
     * @type {string}
     * @memberof EducationPatchRequest
     */
    'e_school_name'?: string | null;
    /**
     * 卒業年月 YYYY-MM の書式
     * @type {string}
     * @memberof EducationPatchRequest
     */
    'e_graduate_date'?: string | null;
}
/**
 * 学歴 新規作成
 * @export
 * @interface EducationPostRequest
 */
export interface EducationPostRequest {
    /**
     * 空文字列
     * @type {string}
     * @memberof EducationPostRequest
     */
    'e_id': string;
    /**
     * 学校名 
     * @type {string}
     * @memberof EducationPostRequest
     */
    'e_school_name'?: string | null;
    /**
     * 卒業年月 YYYY-MM の書式
     * @type {string}
     * @memberof EducationPostRequest
     */
    'e_graduate_date'?: string | null;
}
/**
 * 学歴 レスポンス  配列は変更後のデータ全てを返す
 * @export
 * @interface EducationResponse
 */
export interface EducationResponse {
    /**
     * 
     * @type {Array<EducationData>}
     * @memberof EducationResponse
     */
    'educations': Array<EducationData>;
    /**
     * 
     * @type {string}
     * @memberof EducationResponse
     */
    'result': EducationResponseResultEnum;
    /**
     * 
     * @type {string}
     * @memberof EducationResponse
     */
    'error_message'?: string;
    /**
     * 
     * @type {number}
     * @memberof EducationResponse
     */
    'error_code'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum EducationResponseResultEnum {
    Success = 'success',
    Fail = 'fail'
}

/**
 * 
 * @export
 * @interface EducationResponseAllOf
 */
export interface EducationResponseAllOf {
    /**
     * 
     * @type {Array<EducationData>}
     * @memberof EducationResponseAllOf
     */
    'educations': Array<EducationData>;
}
/**
 * 
 * @export
 * @interface Embed
 */
export interface Embed {
    /**
     * 
     * @type {string}
     * @memberof Embed
     */
    'embed'?: string;
    /**
     * 
     * @type {Image}
     * @memberof Embed
     */
    'image'?: Image;
    /**
     * 
     * @type {string}
     * @memberof Embed
     */
    'caption'?: string;
}
/**
 * 
 * @export
 * @interface FileResponse
 */
export interface FileResponse {
    /**
     * 
     * @type {string}
     * @memberof FileResponse
     */
    'f_id': string;
    /**
     * 
     * @type {string}
     * @memberof FileResponse
     */
    'f_url': string;
    /**
     * 
     * @type {string}
     * @memberof FileResponse
     */
    'f_thumbnail': string;
    /**
     * 
     * @type {string}
     * @memberof FileResponse
     */
    'result': FileResponseResultEnum;
    /**
     * 
     * @type {string}
     * @memberof FileResponse
     */
    'error_message'?: string;
    /**
     * 
     * @type {number}
     * @memberof FileResponse
     */
    'error_code'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum FileResponseResultEnum {
    Success = 'success',
    Fail = 'fail'
}

/**
 * 汎用イメージ
 * @export
 * @interface Image
 */
export interface Image {
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'f_id': string;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'f_url': string;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'f_thumbnail': string;
}
/**
 * 履歴書 証明写真
 * @export
 * @interface ImagePhoto
 */
export interface ImagePhoto {
    /**
     * 
     * @type {string}
     * @memberof ImagePhoto
     */
    'f_id': string;
    /**
     * 
     * @type {string}
     * @memberof ImagePhoto
     */
    'f_url': string;
    /**
     * 
     * @type {string}
     * @memberof ImagePhoto
     */
    'f_thumbnail': string;
}
/**
 * 
 * @export
 * @interface InlineObject
 */
export interface InlineObject {
    /**
     * 
     * @type {string}
     * @memberof InlineObject
     */
    'password_new': string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject
     */
    'password_new_re': string;
}
/**
 * true 配信する false 配信しない
 * @export
 * @interface InlineObject1
 */
export interface InlineObject1 {
    /**
     * メール配信設定 true する false しない
     * @type {boolean}
     * @memberof InlineObject1
     */
    'direct_mail': boolean;
}
/**
 * 
 * @export
 * @interface InlineObject10
 */
export interface InlineObject10 {
    /**
     * 
     * @type {Array<string>}
     * @memberof InlineObject10
     */
    'users': Array<string>;
}
/**
 * 
 * @export
 * @interface InlineObject11
 */
export interface InlineObject11 {
    /**
     * CompanyGroupIdを指定
     * @type {Array<string>}
     * @memberof InlineObject11
     */
    'groups'?: Array<string>;
}
/**
 * 
 * @export
 * @interface InlineObject12
 */
export interface InlineObject12 {
    /**
     * 招待するユーザーのemailアドレス
     * @type {Array<string>}
     * @memberof InlineObject12
     */
    'users'?: Array<string>;
}
/**
 * 
 * @export
 * @interface InlineObject14
 */
export interface InlineObject14 {
    /**
     * 検索条件id
     * @type {Array<number>}
     * @memberof InlineObject14
     */
    'ids'?: Array<number>;
}
/**
 * true 配信する false 配信しない
 * @export
 * @interface InlineObject15
 */
export interface InlineObject15 {
    /**
     * メール配信設定 true する false しない
     * @type {boolean}
     * @memberof InlineObject15
     */
    'direct_mail': boolean;
}
/**
 * 
 * @export
 * @interface InlineObject16
 */
export interface InlineObject16 {
    /**
     * 一般ユーザーID C+数字乱数8桁（Ex. C12183640）
     * @type {string}
     * @memberof InlineObject16
     */
    'matchbox_id': string;
}
/**
 * 
 * @export
 * @interface InlineObject19
 */
export interface InlineObject19 {
    /**
     * offer position の id　の配列
     * @type {Array<number>}
     * @memberof InlineObject19
     */
    'positions': Array<number>;
}
/**
 * 
 * @export
 * @interface InlineObject20
 */
export interface InlineObject20 {
    /**
     * 入力代行ステータス - 0: 申し込み無し - 1: 求職者依頼中 - 2: 管理者見送り - 3: 管理者入力完了 - 4: 求職者入力内容反映済 
     * @type {number}
     * @memberof InlineObject20
     */
    'status': number;
}
/**
 * 
 * @export
 * @interface InlineObject3
 */
export interface InlineObject3 {
    /**
     * 検索条件id
     * @type {Array<number>}
     * @memberof InlineObject3
     */
    'ids'?: Array<number>;
}
/**
 * 
 * @export
 * @interface InlineObject4
 */
export interface InlineObject4 {
    /**
     * 一般ユーザーID C+数字乱数8桁（Ex. C12183640）
     * @type {string}
     * @memberof InlineObject4
     */
    'matchbox_id': string;
}
/**
 * 
 * @export
 * @interface InlineObject5
 */
export interface InlineObject5 {
    /**
     * 検索条件id
     * @type {Array<number>}
     * @memberof InlineObject5
     */
    'ids'?: Array<number>;
}
/**
 * 
 * @export
 * @interface InlineObject6
 */
export interface InlineObject6 {
    /**
     * 企業向け検索条件のid
     * @type {Array<number>}
     * @memberof InlineObject6
     */
    'search_condition_id'?: Array<number>;
    /**
     * Direct 企業ID
     * @type {Array<number>}
     * @memberof InlineObject6
     */
    'company_ids'?: Array<number>;
}
/**
 * 
 * @export
 * @interface InlineObject7
 */
export interface InlineObject7 {
    /**
     * 新しいパスワード
     * @type {string}
     * @memberof InlineObject7
     */
    'password_new': string;
    /**
     * 新しいパスワード(もう一度)
     * @type {string}
     * @memberof InlineObject7
     */
    'password_new_re': string;
}
/**
 * 
 * @export
 * @interface InlineObject8
 */
export interface InlineObject8 {
    /**
     * 入力代行ステータス - 0: 申し込み無し - 1: 求職者依頼中 - 2: 管理者見送り - 3: 管理者入力完了 - 4: 求職者入力内容反映済 
     * @type {number}
     * @memberof InlineObject8
     */
    'status'?: number;
    /**
     * 管理者が入力代行完了・見送り時に求職者へ通知するコメント
     * @type {string}
     * @memberof InlineObject8
     */
    'comment'?: string;
}
/**
 * 入力代行情報レスポンス
 * @export
 * @interface InputAgencyResponse
 */
export interface InputAgencyResponse {
    /**
     * 入力代行ステータス - 0: 申し込み無し - 1: 求職者依頼中 - 2: 管理者見送り - 3: 管理者入力完了 - 4: 求職者入力内容反映済 
     * @type {number}
     * @memberof InputAgencyResponse
     */
    'status'?: number;
    /**
     * 
     * @type {string}
     * @memberof InputAgencyResponse
     */
    'result': InputAgencyResponseResultEnum;
    /**
     * 
     * @type {string}
     * @memberof InputAgencyResponse
     */
    'error_message'?: string;
    /**
     * 
     * @type {number}
     * @memberof InputAgencyResponse
     */
    'error_code'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum InputAgencyResponseResultEnum {
    Success = 'success',
    Fail = 'fail'
}

/**
 * 
 * @export
 * @interface InputAgencyResponseAllOf
 */
export interface InputAgencyResponseAllOf {
    /**
     * 入力代行ステータス - 0: 申し込み無し - 1: 求職者依頼中 - 2: 管理者見送り - 3: 管理者入力完了 - 4: 求職者入力内容反映済 
     * @type {number}
     * @memberof InputAgencyResponseAllOf
     */
    'status'?: number;
}
/**
 * 
 * @export
 * @interface LastLogin
 */
export interface LastLogin {
    /**
     * 最終ログイン日
     * @type {string}
     * @memberof LastLogin
     */
    'login_date': string;
    /**
     * IP アドレス 現在は利用してない？？
     * @type {string}
     * @memberof LastLogin
     */
    'ip_address'?: string;
    /**
     * デバイス 現在は利用してない？？
     * @type {string}
     * @memberof LastLogin
     */
    'device'?: string;
}
/**
 * 求職者 履歴書レスポンス
 * @export
 * @interface MBResumeResponse
 */
export interface MBResumeResponse {
    /**
     * 
     * @type {ResumeUser}
     * @memberof MBResumeResponse
     */
    'user'?: ResumeUser;
    /**
     * 
     * @type {AnotherContact}
     * @memberof MBResumeResponse
     */
    'another_contact'?: AnotherContact;
    /**
     * 
     * @type {ResumeSummary}
     * @memberof MBResumeResponse
     */
    'resume'?: ResumeSummary;
    /**
     * 
     * @type {Set<Qualification>}
     * @memberof MBResumeResponse
     */
    'qualifications'?: Set<Qualification>;
    /**
     * 
     * @type {Set<EducationData>}
     * @memberof MBResumeResponse
     */
    'educations'?: Set<EducationData>;
    /**
     * 
     * @type {Set<CareerSummaryModel>}
     * @memberof MBResumeResponse
     */
    'careers'?: Set<CareerSummaryModel>;
    /**
     * 
     * @type {number}
     * @memberof MBResumeResponse
     */
    'first_visit'?: number;
    /**
     * success のみ
     * @type {string}
     * @memberof MBResumeResponse
     */
    'result': string;
}
/**
 * 書類データモデル
 * @export
 * @interface MatchboxUserDocumentModel
 */
export interface MatchboxUserDocumentModel {
    /**
     * ファイル名
     * @type {string}
     * @memberof MatchboxUserDocumentModel
     */
    'name': string;
    /**
     * ファイルURL
     * @type {string}
     * @memberof MatchboxUserDocumentModel
     */
    'url': string;
    /**
     * データ保存日
     * @type {string}
     * @memberof MatchboxUserDocumentModel
     */
    'date': string;
    /**
     * ドキュメントのid
     * @type {string}
     * @memberof MatchboxUserDocumentModel
     */
    'f_id': string;
    /**
     * ファイルサイズ （単位はKB)
     * @type {string}
     * @memberof MatchboxUserDocumentModel
     */
    'size': string;
}
/**
 * - resume : 履歴書アップロードファイル - career_history : 職務経歴書アップロードファイル
 * @export
 * @interface MatchboxUserResponse
 */
export interface MatchboxUserResponse {
    /**
     * 
     * @type {UserInfo}
     * @memberof MatchboxUserResponse
     */
    'user_info'?: UserInfo;
    /**
     * 
     * @type {Set<LastLogin>}
     * @memberof MatchboxUserResponse
     */
    'last_login'?: Set<LastLogin>;
    /**
     * 
     * @type {string}
     * @memberof MatchboxUserResponse
     */
    'registration_date'?: string;
    /**
     * 
     * @type {number}
     * @memberof MatchboxUserResponse
     */
    'view_count_portfolio'?: number;
    /**
     * 
     * @type {string}
     * @memberof MatchboxUserResponse
     */
    'last_update_portfolio'?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchboxUserResponse
     */
    'last_update_resume'?: string;
    /**
     * 
     * @type {MatchboxUserDocumentModel}
     * @memberof MatchboxUserResponse
     */
    'resume'?: MatchboxUserDocumentModel;
    /**
     * 
     * @type {MatchboxUserDocumentModel}
     * @memberof MatchboxUserResponse
     */
    'career_history'?: MatchboxUserDocumentModel;
    /**
     * success のみ
     * @type {string}
     * @memberof MatchboxUserResponse
     */
    'result': string;
}
/**
 * 
 * @export
 * @interface MatchboxUserResponseAllOf
 */
export interface MatchboxUserResponseAllOf {
    /**
     * 
     * @type {UserInfo}
     * @memberof MatchboxUserResponseAllOf
     */
    'user_info'?: UserInfo;
    /**
     * 
     * @type {Set<LastLogin>}
     * @memberof MatchboxUserResponseAllOf
     */
    'last_login'?: Set<LastLogin>;
    /**
     * 
     * @type {string}
     * @memberof MatchboxUserResponseAllOf
     */
    'registration_date'?: string;
    /**
     * 
     * @type {number}
     * @memberof MatchboxUserResponseAllOf
     */
    'view_count_portfolio'?: number;
    /**
     * 
     * @type {string}
     * @memberof MatchboxUserResponseAllOf
     */
    'last_update_portfolio'?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchboxUserResponseAllOf
     */
    'last_update_resume'?: string;
    /**
     * 
     * @type {MatchboxUserDocumentModel}
     * @memberof MatchboxUserResponseAllOf
     */
    'resume'?: MatchboxUserDocumentModel;
    /**
     * 
     * @type {MatchboxUserDocumentModel}
     * @memberof MatchboxUserResponseAllOf
     */
    'career_history'?: MatchboxUserDocumentModel;
}
/**
 * 画像ページにて利用するモックアップ画像
 * @export
 * @interface Mockup
 */
export interface Mockup {
    /**
     * 
     * @type {string}
     * @memberof Mockup
     */
    'm_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Mockup
     */
    'm_type'?: MockupMTypeEnum;
    /**
     * 
     * @type {Array<Image>}
     * @memberof Mockup
     */
    'm_contents'?: Array<Image>;
    /**
     * 説明文
     * @type {string}
     * @memberof Mockup
     */
    'm_description'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum MockupMTypeEnum {
    Sp = 'sp',
    All = 'all'
}

/**
 * マイナビクリエイター連携項目
 * @export
 * @interface MyNavi
 */
export interface MyNavi {
    /**
     * マイナビクリエイターに連携しているかどうか
     * @type {boolean}
     * @memberof MyNavi
     */
    'mc_connected': boolean;
    /**
     * 経験職種
     * @type {number}
     * @memberof MyNavi
     */
    'mc_experienced_job': number;
    /**
     * 経験年数
     * @type {number}
     * @memberof MyNavi
     */
    'mc_experienced_year': number;
    /**
     * 経験社数 選択式
     * @type {number}
     * @memberof MyNavi
     */
    'mc_companies_count': number;
    /**
     * 現在の年収 選択式
     * @type {number}
     * @memberof MyNavi
     */
    'mc_yearly_income': number;
    /**
     * 就業状況 選択式
     * @type {number}
     * @memberof MyNavi
     */
    'mc_situation': number;
    /**
     * 希望職種 選択式（マスタから選択） これは登録時のものと一緒
     * @type {Array<number>}
     * @memberof MyNavi
     */
    'mc_preferred_job_type': Array<number>;
    /**
     * 希望業種 選択式
     * @type {number}
     * @memberof MyNavi
     */
    'mc_preferred_business_type': number;
    /**
     * 希望年収 選択式
     * @type {number}
     * @memberof MyNavi
     */
    'mc_preferred_yearly_income': number;
    /**
     * 希望勤務地 都道府県 選択式（マスタ /master/prefecture）
     * @type {Array<number>}
     * @memberof MyNavi
     */
    'mc_preferred_prefecture': Array<number>;
    /**
     * 転職希望時期 選択式（マスタから選択）
     * @type {number}
     * @memberof MyNavi
     */
    'mc_preferred_change_date': number;
    /**
     * 備考
     * @type {string}
     * @memberof MyNavi
     */
    'mc_preferred_reason': string;
    /**
     * 最大マネジメント人数
     * @type {number}
     * @memberof MyNavi
     */
    'mc_maximum_management_count'?: number;
    /**
     * 英語力  以下の値を取る  1 文書・マニュアル読解 2 e-mailでのやりとり 3 電話での会話 4 英語での会議 5 英語での商談・交渉 6 海外滞在
     * @type {number}
     * @memberof MyNavi
     */
    'mc_english_skills'?: number;
    /**
     * 最終学歴  以下の値を取る  1 高校 2 専門学校 3 高等専門学校 4 短期大学 5 大学 6 大学院（MBA含む） 7 その他
     * @type {number}
     * @memberof MyNavi
     */
    'mc_final_education'?: number;
    /**
     * 職務経歴概要
     * @type {string}
     * @memberof MyNavi
     */
    'mc_description'?: string;
    /**
     * 希望雇用形態 選択式（マスタから選択）
     * @type {Array<number>}
     * @memberof MyNavi
     */
    'mc_preferred_employment_status': Array<number>;
    /**
     * こだわりの条件 選択式（マスタから選択）
     * @type {Array<number>}
     * @memberof MyNavi
     */
    'mc_conditions'?: Array<number>;
    /**
     * その他希望条件
     * @type {string}
     * @memberof MyNavi
     */
    'mc_preferred_conditions'?: string;
}
/**
 * 
 * @export
 * @interface Mypage
 */
export interface Mypage {
    /**
     * お知らせ
     * @type {Array<News>}
     * @memberof Mypage
     */
    'news': Array<News>;
    /**
     * MatchBox Directの新着
     * @type {boolean}
     * @memberof Mypage
     */
    'new_message'?: boolean;
    /**
     * メンテナンスメッセージ
     * @type {Array<string>}
     * @memberof Mypage
     */
    'maintenance'?: Array<string>;
    /**
     * 
     * @type {MypageDocuments}
     * @memberof Mypage
     */
    'documents'?: MypageDocuments;
    /**
     * 基本情報完成度が100未満である
     * @type {boolean}
     * @memberof Mypage
     */
    'basic_information_incomplation'?: boolean;
    /**
     * 職務経歴完成度が100未満である
     * @type {boolean}
     * @memberof Mypage
     */
    'career_information_incompletion'?: boolean;
    /**
     * MATCHBOX Directへの登録
     * @type {boolean}
     * @memberof Mypage
     */
    'use_direct'?: boolean;
}
/**
 * アップロードした履歴書・職務経歴書
 * @export
 * @interface MypageDocuments
 */
export interface MypageDocuments {
    /**
     * 
     * @type {Image}
     * @memberof MypageDocuments
     */
    'resume'?: Image;
    /**
     * 
     * @type {Image}
     * @memberof MypageDocuments
     */
    'career'?: Image;
}
/**
 * 
 * @export
 * @interface News
 */
export interface News {
    /**
     * 
     * @type {string}
     * @memberof News
     */
    'id'?: string;
    /**
     * 
     * @type {Image}
     * @memberof News
     */
    'image'?: Image;
    /**
     * 
     * @type {string}
     * @memberof News
     */
    'content'?: string;
}
/**
 * ## 社内メモ
 * @export
 * @interface Note
 */
export interface Note {
    /**
     * 
     * @type {number}
     * @memberof Note
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Note
     */
    'matchbox_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Note
     */
    'content'?: string;
    /**
     * 
     * @type {CompanyUser | User}
     * @memberof Note
     */
    'user'?: CompanyUser | User;
    /**
     * 既読。エンドユーザーと、Direct管理者がそれぞれ個別のステータスを持つ
     * @type {boolean}
     * @memberof Note
     */
    'is_read'?: boolean;
    /**
     * メモ作成日 YYYY-MM-DD hh:mm:ss
     * @type {string}
     * @memberof Note
     */
    'created_at'?: string;
}
/**
 * 
 * @export
 * @interface NotesResponse
 */
export interface NotesResponse {
    /**
     * 
     * @type {Array<Note>}
     * @memberof NotesResponse
     */
    'notes'?: Array<Note>;
    /**
     * 
     * @type {string}
     * @memberof NotesResponse
     */
    'result': NotesResponseResultEnum;
    /**
     * 
     * @type {string}
     * @memberof NotesResponse
     */
    'error_message'?: string;
    /**
     * 
     * @type {number}
     * @memberof NotesResponse
     */
    'error_code'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum NotesResponseResultEnum {
    Success = 'success',
    Fail = 'fail'
}

/**
 * 
 * @export
 * @interface NotesResponseAllOf
 */
export interface NotesResponseAllOf {
    /**
     * 
     * @type {Array<Note>}
     * @memberof NotesResponseAllOf
     */
    'notes'?: Array<Note>;
}
/**
 * ### Status 0. 回答期限終了 1. 企業 ピックアップ 2. 企業 マイナビワークスに相談中 3. 企業 一次面接オファー中 4. 企業 見送り 5. 求職者 一次面接見送り（企業オファー中） 6. 求職者 一次面接オファー応諾（企業オファー中） 7. 求職者 マイナビワークスに一次面接相談中（企業オファー中） 8. 企業 カジュアル面談オファー中 9. 求職者 カジュアル面談オファー応諾（企業オファー中） 10. 求職者 カジュアル面接見送り（企業オファー中） 11. 求職者 マイナビワークスにカジュアル面談相談中（企業オファー中）  ### rate 1. 低 2. 中 3. 高  ### mw_status 1. 未完了 2. 保留 3. 完了  ### position  - position : アクション時の指定ポジション - reaction_position : ピックアップ時の指定ポジション
 * @export
 * @interface Offer
 */
export interface Offer {
    /**
     * 
     * @type {number}
     * @memberof Offer
     */
    'id'?: number;
    /**
     * 対象の求職者ID
     * @type {string}
     * @memberof Offer
     */
    'matchbox_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof Offer
     */
    'status'?: OfferStatusEnum;
    /**
     * マイナビワークスに相談・オファー時のコメント
     * @type {string}
     * @memberof Offer
     */
    'comment'?: string;
    /**
     * マッチ度
     * @type {number}
     * @memberof Offer
     */
    'rate'?: OfferRateEnum;
    /**
     * 
     * @type {AdminCompany}
     * @memberof Offer
     */
    'senter'?: AdminCompany;
    /**
     * 既読。エンドユーザーと、Directユーザーがそれぞれ個別のステータスを持つ
     * @type {boolean}
     * @memberof Offer
     */
    'is_read'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Offer
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof Offer
     */
    'updated_at'?: string;
    /**
     * マイナビ担当者対応状況
     * @type {number}
     * @memberof Offer
     */
    'mw_status'?: OfferMwStatusEnum;
    /**
     * 【管理者・企業ユーザーから閲覧時】リアクション一覧
     * @type {Array<Reaction>}
     * @memberof Offer
     */
    'reactions'?: Array<Reaction>;
    /**
     * 【管理者・企業ユーザーから閲覧時】対象ユーザーの経験職種（一覧表示用）
     * @type {number}
     * @memberof Offer
     */
    'mc_experienced_job'?: number;
    /**
     * 
     * @type {OfferPositionData}
     * @memberof Offer
     */
    'position'?: OfferPositionData;
    /**
     * 
     * @type {OfferPositionData}
     * @memberof Offer
     */
    'reaction_position'?: OfferPositionData;
    /**
     * 
     * @type {CompanyUser}
     * @memberof Offer
     */
    'user'?: CompanyUser;
    /**
     * 求職者の閲覧（Direct利用無しか、ブロック企業に設定されていれば不可）
     * @type {boolean}
     * @memberof Offer
     */
    'user_disabled'?: boolean;
    /**
     * マイナビワークスに相談・オファー時のコメント
     * @type {string}
     * @memberof Offer
     */
    'user_comment'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum OfferStatusEnum {
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3,
    NUMBER_4 = 4,
    NUMBER_5 = 5,
    NUMBER_6 = 6,
    NUMBER_7 = 7,
    NUMBER_8 = 8,
    NUMBER_9 = 9,
    NUMBER_10 = 10,
    NUMBER_11 = 11,
    NUMBER_0 = 0
}
/**
    * @export
    * @enum {string}
    */
export enum OfferRateEnum {
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3
}
/**
    * @export
    * @enum {string}
    */
export enum OfferMwStatusEnum {
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3
}

/**
 * * ピックアップを既読にする。 * direct_adminがピックアップのステータスを変更する。 * mwが対応状況を変更する
 * @export
 * @interface OfferPatchParam
 */
export interface OfferPatchParam {
    /**
     * OfferデータID
     * @type {string}
     * @memberof OfferPatchParam
     */
    'offer_id'?: string;
    /**
     * 企業・求職者アカウントのステータス状態  - 2 : 企業 マイナビワークスに相談する - 3 : 企業 一次面接にオファーする - 4 : 企業 見送る - 5 : 求職者 一次面接オファーを見送る - 6 : 求職者 一次面接オファーに応諾する - 7 : 求職者 マイナビワークスに一次面接オファーを相談する - 8 : 企業 カジュアル面談にオファーする - 9 : 求職者 カジュアル面談オファーに応諾する - 10 : 求職者 カジュアル面談オファーを見送る - 11 : 求職者 マイナビワークスにカジュアル面談オファーを相談する
     * @type {number}
     * @memberof OfferPatchParam
     */
    'status'?: number;
    /**
     * 既読。エンドユーザーと、Direct管理者がそれぞれ個別のステータスを持つ
     * @type {boolean}
     * @memberof OfferPatchParam
     */
    'is_read'?: boolean;
    /**
     * オファー 対応状況 1: 未完了 | 2: 保留 | 3: 完了
     * @type {number}
     * @memberof OfferPatchParam
     */
    'mw_status'?: number;
    /**
     * マイナビワークスに相談・オファー時のコメント
     * @type {string}
     * @memberof OfferPatchParam
     */
    'comment'?: string;
}
/**
 * オファー時のポジション指定 ポジションのID
 * @export
 * @interface OfferPositionData
 */
export interface OfferPositionData {
    /**
     * オファー時のポジション指定 ポジションのID
     * @type {number}
     * @memberof OfferPositionData
     */
    'id': number | null;
    /**
     * ポジション名
     * @type {string}
     * @memberof OfferPositionData
     */
    'name': string;
    /**
     * ポジション説明
     * @type {string}
     * @memberof OfferPositionData
     */
    'body': string;
    /**
     * 表示
     * @type {boolean}
     * @memberof OfferPositionData
     */
    'active': boolean;
}
/**
 * ポジション詳細データ
 * @export
 * @interface OfferPositionDataResponse
 */
export interface OfferPositionDataResponse {
    /**
     * 
     * @type {OfferPositionData}
     * @memberof OfferPositionDataResponse
     */
    'data': OfferPositionData;
}
/**
 * オファー時のポジション指定 ポジションのID
 * @export
 * @interface OfferPositionsData
 */
export interface OfferPositionsData {
    /**
     * 
     * @type {Array<OfferPositionData>}
     * @memberof OfferPositionsData
     */
    'positions': Array<OfferPositionData>;
}
/**
 * notify_all が true の場合は notify_member / notify_group の値は無視する  通知はメールで送信  reaction_position は ピックアップ時のポジション指定に利用する
 * @export
 * @interface OfferPostParam
 */
export interface OfferPostParam {
    /**
     * 求職者のid
     * @type {string}
     * @memberof OfferPostParam
     */
    'matchbox_id': string;
    /**
     * マッチ度
     * @type {number}
     * @memberof OfferPostParam
     */
    'rate': OfferPostParamRateEnum;
    /**
     * オファー時のポジション指定 ポジションのID
     * @type {number}
     * @memberof OfferPostParam
     */
    'offer_position'?: number | null;
    /**
     * オファー時のポジション指定 ポジションのID
     * @type {number}
     * @memberof OfferPostParam
     */
    'reaction_position'?: number | null;
}

/**
    * @export
    * @enum {string}
    */
export enum OfferPostParamRateEnum {
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3
}

/**
 * 
 * @export
 * @interface OfferResponse
 */
export interface OfferResponse {
    /**
     * 
     * @type {number}
     * @memberof OfferResponse
     */
    'id'?: number;
    /**
     * 対象の求職者ID
     * @type {string}
     * @memberof OfferResponse
     */
    'matchbox_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof OfferResponse
     */
    'status'?: OfferResponseStatusEnum;
    /**
     * マイナビワークスに相談・オファー時のコメント
     * @type {string}
     * @memberof OfferResponse
     */
    'comment'?: string;
    /**
     * マッチ度
     * @type {number}
     * @memberof OfferResponse
     */
    'rate'?: OfferResponseRateEnum;
    /**
     * 
     * @type {AdminCompany}
     * @memberof OfferResponse
     */
    'senter'?: AdminCompany;
    /**
     * 既読。エンドユーザーと、Directユーザーがそれぞれ個別のステータスを持つ
     * @type {boolean}
     * @memberof OfferResponse
     */
    'is_read'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OfferResponse
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof OfferResponse
     */
    'updated_at'?: string;
    /**
     * マイナビ担当者対応状況
     * @type {number}
     * @memberof OfferResponse
     */
    'mw_status'?: OfferResponseMwStatusEnum;
    /**
     * 【管理者・企業ユーザーから閲覧時】リアクション一覧
     * @type {Array<Reaction>}
     * @memberof OfferResponse
     */
    'reactions'?: Array<Reaction>;
    /**
     * 【管理者・企業ユーザーから閲覧時】対象ユーザーの経験職種（一覧表示用）
     * @type {number}
     * @memberof OfferResponse
     */
    'mc_experienced_job'?: number;
    /**
     * 
     * @type {OfferPositionData}
     * @memberof OfferResponse
     */
    'position'?: OfferPositionData;
    /**
     * 
     * @type {OfferPositionData}
     * @memberof OfferResponse
     */
    'reaction_position'?: OfferPositionData;
    /**
     * 
     * @type {CompanyUser}
     * @memberof OfferResponse
     */
    'user'?: CompanyUser;
    /**
     * 求職者の閲覧（Direct利用無しか、ブロック企業に設定されていれば不可）
     * @type {boolean}
     * @memberof OfferResponse
     */
    'user_disabled'?: boolean;
    /**
     * マイナビワークスに相談・オファー時のコメント
     * @type {string}
     * @memberof OfferResponse
     */
    'user_comment'?: string;
    /**
     * success のみ
     * @type {string}
     * @memberof OfferResponse
     */
    'result': string;
}

/**
    * @export
    * @enum {string}
    */
export enum OfferResponseStatusEnum {
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3,
    NUMBER_4 = 4,
    NUMBER_5 = 5,
    NUMBER_6 = 6,
    NUMBER_7 = 7,
    NUMBER_8 = 8,
    NUMBER_9 = 9,
    NUMBER_10 = 10,
    NUMBER_11 = 11,
    NUMBER_0 = 0
}
/**
    * @export
    * @enum {string}
    */
export enum OfferResponseRateEnum {
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3
}
/**
    * @export
    * @enum {string}
    */
export enum OfferResponseMwStatusEnum {
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3
}

/**
 * 個人ユーザーへのレスポンスの場合は `Offer.sender`は表示しない
 * @export
 * @interface OffersResponse
 */
export interface OffersResponse {
    /**
     * 
     * @type {Array<Offer>}
     * @memberof OffersResponse
     */
    'offers'?: Array<Offer>;
    /**
     * 
     * @type {string}
     * @memberof OffersResponse
     */
    'result': OffersResponseResultEnum;
    /**
     * エラーコード
     * @type {string}
     * @memberof OffersResponse
     */
    'error_code': string;
    /**
     * エラーメッセージ
     * @type {string}
     * @memberof OffersResponse
     */
    'error_message': string;
    /**
     * ページネーションの次のoffset or null
     * @type {number}
     * @memberof OffersResponse
     */
    'offset'?: number | null;
    /**
     * 現在の条件でのレコード総数
     * @type {number}
     * @memberof OffersResponse
     */
    'total'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum OffersResponseResultEnum {
    Fail = 'fail'
}

/**
 * 
 * @export
 * @interface OffersResponseAllOf
 */
export interface OffersResponseAllOf {
    /**
     * 
     * @type {Array<Offer>}
     * @memberof OffersResponseAllOf
     */
    'offers'?: Array<Offer>;
}
/**
 * 自作ポートフォリオ情報
 * @export
 * @interface OwnPortfolio
 */
export interface OwnPortfolio {
    /**
     * 自作ポートフォリオURL
     * @type {string}
     * @memberof OwnPortfolio
     */
    'url'?: string;
    /**
     * 補足情報
     * @type {string}
     * @memberof OwnPortfolio
     */
    'supplementary_info'?: string;
    /**
     * 自作ポートフォリオ最終更新日
     * @type {string}
     * @memberof OwnPortfolio
     */
    'updated_at'?: string;
}
/**
 * 自作ポートフォリオ登録リクエスト
 * @export
 * @interface OwnPortfolioRequest
 */
export interface OwnPortfolioRequest {
    /**
     * 自作ポートフォリオURL
     * @type {string}
     * @memberof OwnPortfolioRequest
     */
    'url'?: string;
    /**
     * 補足情報
     * @type {string}
     * @memberof OwnPortfolioRequest
     */
    'supplementary_info'?: string;
}
/**
 * 自作ポートフォリオレスポンス
 * @export
 * @interface OwnPortfolioResponse
 */
export interface OwnPortfolioResponse {
    /**
     * 
     * @type {UserOwnPortfolio}
     * @memberof OwnPortfolioResponse
     */
    'own_portfolio'?: UserOwnPortfolio;
    /**
     * 
     * @type {string}
     * @memberof OwnPortfolioResponse
     */
    'result': OwnPortfolioResponseResultEnum;
    /**
     * 
     * @type {string}
     * @memberof OwnPortfolioResponse
     */
    'error_message'?: string;
    /**
     * 
     * @type {number}
     * @memberof OwnPortfolioResponse
     */
    'error_code'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum OwnPortfolioResponseResultEnum {
    Success = 'success',
    Fail = 'fail'
}

/**
 * 
 * @export
 * @interface OwnPortfolioResponseAllOf
 */
export interface OwnPortfolioResponseAllOf {
    /**
     * 
     * @type {UserOwnPortfolio}
     * @memberof OwnPortfolioResponseAllOf
     */
    'own_portfolio'?: UserOwnPortfolio;
}
/**
 * PDF生成リクエスト時のID
 * @export
 * @interface PDFTicketId
 */
export interface PDFTicketId {
    /**
     * 
     * @type {number}
     * @memberof PDFTicketId
     */
    'ticket_id'?: number;
}
/**
 * PDF生成リクエスト時のステータス
 * @export
 * @interface PDFTicketStatus
 */
export interface PDFTicketStatus {
    /**
     * 0:PDF生成リクエスト完了 1:PDF生成中 2:PDF生成完了 3:PDFダウンロード済
     * @type {number}
     * @memberof PDFTicketStatus
     */
    'status': number;
}
/**
 * 
 * @export
 * @interface Pagination
 */
export interface Pagination {
    /**
     * 取得件数 指定がない場合は20
     * @type {number}
     * @memberof Pagination
     */
    'limit'?: number;
    /**
     * 次のページ番号 指定がない場合は0
     * @type {number}
     * @memberof Pagination
     */
    'offset'?: number;
    /**
     * 検索項目 項目はdescription参照
     * @type {string}
     * @memberof Pagination
     */
    'sort_by'?: string;
    /**
     * 検索順序 asc | desc
     * @type {string}
     * @memberof Pagination
     */
    'sort_order'?: string;
}
/**
 * 
 * @export
 * @interface PaginationOffset
 */
export interface PaginationOffset {
    /**
     * ページネーションの次のoffset or null
     * @type {number}
     * @memberof PaginationOffset
     */
    'offset'?: number | null;
    /**
     * 現在の条件でのレコード総数
     * @type {number}
     * @memberof PaginationOffset
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface PasswordChangeParam
 */
export interface PasswordChangeParam {
    /**
     * 現在のパスワード
     * @type {string}
     * @memberof PasswordChangeParam
     */
    'password_current': string;
    /**
     * 新しいパスワード
     * @type {string}
     * @memberof PasswordChangeParam
     */
    'password_new': string;
    /**
     * 新しいパスワード(もう一度)
     * @type {string}
     * @memberof PasswordChangeParam
     */
    'password_new_re': string;
}
/**
 * 
 * @export
 * @interface PasswordResetParam
 */
export interface PasswordResetParam {
    /**
     * 使用しているアカウント（メールアドレス）
     * @type {string}
     * @memberof PasswordResetParam
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface Portfolio
 */
export interface Portfolio {
    /**
     * 公開状態（プライバシー設定） 選択式
     * @type {string}
     * @memberof Portfolio
     */
    'status': PortfolioStatusEnum;
    /**
     * パスワード 見えちゃいけないので、設定文字数？
     * @type {string}
     * @memberof Portfolio
     */
    'password': string;
    /**
     * 背景色
     * @type {string}
     * @memberof Portfolio
     */
    'background_color': string;
    /**
     * フォントの種類。取り急ぎはゴシックと明朝のみ（游ゴシック、游明朝で）、パラメータ名にハイフン使えないので修正してしまった
     * @type {string}
     * @memberof Portfolio
     */
    'font': string;
    /**
     * 共通して使用するページタイトル
     * @type {string}
     * @memberof Portfolio
     */
    'page_title': string;
    /**
     * 
     * @type {Profile}
     * @memberof Portfolio
     */
    'profile'?: Profile;
    /**
     * 
     * @type {Set<PortfolioItem>}
     * @memberof Portfolio
     */
    'items'?: Set<PortfolioItem>;
    /**
     * 1 初回訪問
     * @type {number}
     * @memberof Portfolio
     */
    'first_visit': number;
    /**
     * 1 一度でも公開処理をしたかどうか
     * @type {number}
     * @memberof Portfolio
     */
    'publish': number;
    /**
     * 1 プライバシーポリシーのチェック
     * @type {number}
     * @memberof Portfolio
     */
    'privacy': number;
    /**
     * 
     * @type {Image}
     * @memberof Portfolio
     */
    'page_title_logo'?: Image;
    /**
     * 作品リストの最終更新日
     * @type {string}
     * @memberof Portfolio
     */
    'updated_at'?: string;
    /**
     * 企業向けの作品アイテム
     * @type {Array<PortfolioItem>}
     * @memberof Portfolio
     */
    'direct_items'?: Array<PortfolioItem>;
}

/**
    * @export
    * @enum {string}
    */
export enum PortfolioStatusEnum {
    Password = 'password',
    Closed = 'closed',
    Public = 'public'
}

/**
 * 旧APIの `i_year`は移行しない  ---  * 作品における i_image / i_embedlink はどちらかが必須 * i_embedlink にはいるリンクは、 youtube, vimeo, soundcloud, slideshare を予定 * i_embedlink に保存されてる URL(Embed用のコード) から id の部分だけ正規表現で抜き取って iframe のコードはこちらで調整したい感じ。下記のようなパターン。  ``` * youtube <iframe width=\"サイズ\" height=\"サイズ\" src=\"https://www.youtube-nocookie.com/embed/3rHJZwKh2qI?rel=0\" frameborder=\"0\" allowfullscreen></iframe>  * vimeo <iframe src=\"https://player.vimeo.com/video/235153416\" width=\"640\" height=\"274\" frameborder=\"0\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe> <p><a href=\"https://vimeo.com/235153416\">Antithesis | Async | Ryuichi Sakamoto</a> from <a href=\"https://vimeo.com/kachichan\">Kachi Chan</a> on <a href=\"https://vimeo.com\">Vimeo</a>.</p>  * soundcloud <iframe width=\"100%\" height=\"300\" scrolling=\"no\" frameborder=\"no\" src=\"https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/344120620&amp;color=%23ff5500&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;visual=true\"></iframe>  * slideshare <iframe src=\"//www.slideshare.net/slideshow/embed_code/key/aCPEiux3fol7ci\" width=\"595\" height=\"485\" frameborder=\"0\" marginwidth=\"0\" marginheight=\"0\" scrolling=\"no\" style=\"border:1px solid #CCC; border-width:1px; margin-bottom:5px; max-width: 100%;\" allowfullscreen> </iframe> <div style=\"margin-bottom:5px\"> <strong> <a href=\"//www.slideshare.net/sfamilian/visual-design-with-data-feb-2017\" title=\"Visual Design with Data\" target=\"_blank\">Visual Design with Data</a> </strong> from <strong><a href=\"https://www.slideshare.net/sfamilian\" target=\"_blank\">Seth Familian</a></strong> </div> ```
 * @export
 * @interface PortfolioItem
 */
export interface PortfolioItem {
    /**
     * 
     * @type {number}
     * @memberof PortfolioItem
     */
    'i_id': number;
    /**
     * 
     * @type {Image}
     * @memberof PortfolioItem
     */
    'i_image': Image;
    /**
     * 
     * @type {string}
     * @memberof PortfolioItem
     */
    'i_embedlink': string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioItem
     */
    'i_title': string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioItem
     */
    'i_url': string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioItem
     */
    'i_description': string;
    /**
     * 
     * @type {Set<PortfolioPage>}
     * @memberof PortfolioItem
     */
    'i_pages': Set<PortfolioPage>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PortfolioItem
     */
    'i_tags'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PortfolioItem
     */
    'i_start_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioItem
     */
    'i_end_date'?: string;
    /**
     * 作品の表示・非表示を切り替え
     * @type {boolean}
     * @memberof PortfolioItem
     */
    'i_visible': boolean;
}
/**
 * 
 * @export
 * @interface PortfolioItemPostParam
 */
export interface PortfolioItemPostParam {
    /**
     * 
     * @type {string}
     * @memberof PortfolioItemPostParam
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface PortfolioItemResponse
 */
export interface PortfolioItemResponse {
    /**
     * 
     * @type {number}
     * @memberof PortfolioItemResponse
     */
    'i_id': number;
    /**
     * 
     * @type {Image}
     * @memberof PortfolioItemResponse
     */
    'i_image': Image;
    /**
     * 
     * @type {string}
     * @memberof PortfolioItemResponse
     */
    'i_embedlink': string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioItemResponse
     */
    'i_title': string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioItemResponse
     */
    'i_url': string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioItemResponse
     */
    'i_description': string;
    /**
     * 
     * @type {Set<PortfolioPage>}
     * @memberof PortfolioItemResponse
     */
    'i_pages': Set<PortfolioPage>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PortfolioItemResponse
     */
    'i_tags'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PortfolioItemResponse
     */
    'i_start_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioItemResponse
     */
    'i_end_date'?: string;
    /**
     * 作品の表示・非表示を切り替え
     * @type {boolean}
     * @memberof PortfolioItemResponse
     */
    'i_visible': boolean;
    /**
     * 
     * @type {string}
     * @memberof PortfolioItemResponse
     */
    'result': PortfolioItemResponseResultEnum;
    /**
     * 
     * @type {string}
     * @memberof PortfolioItemResponse
     */
    'error_message'?: string;
    /**
     * 
     * @type {number}
     * @memberof PortfolioItemResponse
     */
    'error_code'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum PortfolioItemResponseResultEnum {
    Success = 'success',
    Fail = 'fail'
}

/**
 * 
 * @export
 * @interface PortfolioPage
 */
export interface PortfolioPage {
    /**
     * 
     * @type {number}
     * @memberof PortfolioPage
     */
    'p_id': number;
    /**
     * style-2の場合のみp_contentsでMockupを利用できる
     * @type {string}
     * @memberof PortfolioPage
     */
    'p_page_layout': PortfolioPagePPageLayoutEnum;
    /**
     * 
     * @type {Set<Question | Mockup | Embed | Image & object>}
     * @memberof PortfolioPage
     */
    'p_contents'?: Set<Question | Mockup | Embed | Image & object>;
}

/**
    * @export
    * @enum {string}
    */
export enum PortfolioPagePPageLayoutEnum {
    Questions = 'questions',
    Style2 = 'style-2',
    Style4 = 'style-4',
    Style8 = 'style-8',
    StyleV2 = 'style-v-2',
    Style1 = 'style-1'
}

/**
 * 
 * @export
 * @interface PortfolioProgressResponse
 */
export interface PortfolioProgressResponse {
    /**
     * 
     * @type {Array<number>}
     * @memberof PortfolioProgressResponse
     */
    'progress': Array<number>;
    /**
     * 
     * @type {string}
     * @memberof PortfolioProgressResponse
     */
    'result': string;
}
/**
 * ポートフォリオプロフィール
 * @export
 * @interface Profile
 */
export interface Profile {
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'user_id': string;
    /**
     * 
     * @type {Image}
     * @memberof Profile
     */
    'main_image': Image;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'icon': string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'name': string;
    /**
     * v2では未使用
     * @type {string}
     * @memberof Profile
     */
    'furigana'?: string;
    /**
     * 自己紹介
     * @type {string}
     * @memberof Profile
     */
    'introduction': string;
    /**
     * 各作品詳細の`Question.q_id==b_8`を抽出
     * @type {Array<string>}
     * @memberof Profile
     */
    'experiences': Array<string>;
    /**
     * 職務経歴書から抽出
     * @type {Array<ProfileSkills>}
     * @memberof Profile
     */
    'skills': Array<ProfileSkills>;
    /**
     * パーソナルアンケート回答
     * @type {Array<ProfileAnswers>}
     * @memberof Profile
     */
    'answers'?: Array<ProfileAnswers>;
    /**
     * 肩書き
     * @type {string}
     * @memberof Profile
     */
    'job_title'?: string;
}
/**
 * 
 * @export
 * @interface ProfileAnswers
 */
export interface ProfileAnswers {
    /**
     * 
     * @type {string}
     * @memberof ProfileAnswers
     */
    'question'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileAnswers
     */
    'answer'?: string;
}
/**
 * 
 * @export
 * @interface ProfileSkills
 */
export interface ProfileSkills {
    /**
     * 
     * @type {string}
     * @memberof ProfileSkills
     */
    'name'?: string;
    /**
     * 5段階
     * @type {number}
     * @memberof ProfileSkills
     */
    'star'?: number;
    /**
     * 0から36ヶ月まで
     * @type {number}
     * @memberof ProfileSkills
     */
    'term'?: number;
}
/**
 * 
 * @export
 * @interface Project
 */
export interface Project {
    /**
     * プロジェクト名
     * @type {string}
     * @memberof Project
     */
    'name'?: string;
    /**
     * 開始時期
     * @type {string}
     * @memberof Project
     */
    'start_date'?: string | null;
    /**
     * 終了時期
     * @type {string}
     * @memberof Project
     */
    'end_date'?: string | null;
    /**
     * 詳細
     * @type {string}
     * @memberof Project
     */
    'detail'?: string;
    /**
     * 役割・チーム体制
     * @type {string}
     * @memberof Project
     */
    'structure'?: string;
    /**
     * 使用言語・ツール
     * @type {string}
     * @memberof Project
     */
    'tools'?: string;
    /**
     * 
     * @type {number}
     * @memberof Project
     */
    'id'?: number;
}
/**
 * 資格
 * @export
 * @interface Qualification
 */
export interface Qualification {
    /**
     * 資格id 
     * @type {string}
     * @memberof Qualification
     */
    'q_id': string;
    /**
     * 
     * @type {string}
     * @memberof Qualification
     */
    'q_type': QualificationQTypeEnum;
    /**
     * 資格名 
     * @type {string}
     * @memberof Qualification
     */
    'q_title': string;
    /**
     * 取得年度 
     * @type {string}
     * @memberof Qualification
     */
    'q_date': string;
    /**
     * 点数
     * @type {string}
     * @memberof Qualification
     */
    'q_score': string;
    /**
     * 履歴書画面にて資格を表示するかどうか
     * @type {boolean}
     * @memberof Qualification
     */
    'q_visible'?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum QualificationQTypeEnum {
    Text = 'text',
    Toeic = 'toeic',
    Toefl = 'toefl'
}

/**
 * qa_idは以下ルールで固定  # qa_id: \'a_N\'  https://git.s2factory.co.jp/s2/matchbox/v1/-/blob/master/fe/src/app/Portfolio/store/state/category1.js  # qa_id: \'b_N\'  https://git.s2factory.co.jp/s2/matchbox/v1/-/blob/master/fe/src/app/Portfolio/store/state/category2.js  # qa_id: \'c_N\'  https://git.s2factory.co.jp/s2/matchbox/v1/-/blob/master/fe/src/app/Portfolio/store/state/category3.js 
 * @export
 * @interface Question
 */
export interface Question {
    /**
     * 
     * @type {string}
     * @memberof Question
     */
    'qa_id': string;
    /**
     * 
     * @type {string}
     * @memberof Question
     */
    'qa_category': string;
    /**
     * 
     * @type {string}
     * @memberof Question
     */
    'qa_question': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Question
     */
    'qa_answer': Array<string>;
}
/**
 * Offerに対する反応  ### status 2: マイナビワークスに相談したい 3: 一次面接オファーしたい 8: カジュアル面談オファーしたい 4: 見送りたい 
 * @export
 * @interface Reaction
 */
export interface Reaction {
    /**
     * 
     * @type {number}
     * @memberof Reaction
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof Reaction
     */
    'offer_id'?: number;
    /**
     * 社員id
     * @type {string}
     * @memberof Reaction
     */
    'matchbox_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof Reaction
     */
    'status'?: ReactionStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Reaction
     */
    'comment'?: string;
    /**
     * 
     * @type {string}
     * @memberof Reaction
     */
    'created_at'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ReactionStatusEnum {
    NUMBER_2 = 2,
    NUMBER_3 = 3,
    NUMBER_8 = 8,
    NUMBER_4 = 4
}

/**
 * オファーに対するコメント送信param  notify_type が offer と reaction で利用するメールテンプレを変更 reaction の場合は 責任者に通知する。  通知はメールで送信
 * @export
 * @interface ReactionPatchParam
 */
export interface ReactionPatchParam {
    /**
     * 
     * @type {number}
     * @memberof ReactionPatchParam
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ReactionPatchParam
     */
    'comment'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReactionPatchParam
     */
    'status'?: ReactionPatchParamStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ReactionPatchParam
     */
    'notify_type'?: ReactionPatchParamNotifyTypeEnum;
    /**
     * 社員全員にメールを通知
     * @type {boolean}
     * @memberof ReactionPatchParam
     */
    'notify_all'?: boolean;
    /**
     * 通知する企業ユーザーのIDを設定
     * @type {Array<string>}
     * @memberof ReactionPatchParam
     */
    'notify_member'?: Array<string>;
    /**
     * 通知するグループのIDを設定
     * @type {Array<string>}
     * @memberof ReactionPatchParam
     */
    'notify_group'?: Array<string>;
}

/**
    * @export
    * @enum {string}
    */
export enum ReactionPatchParamStatusEnum {
    NUMBER_2 = 2,
    NUMBER_3 = 3,
    NUMBER_8 = 8,
    NUMBER_4 = 4
}
/**
    * @export
    * @enum {string}
    */
export enum ReactionPatchParamNotifyTypeEnum {
    Offer = 'offer',
    Reaction = 'reaction'
}

/**
 * オファーに対するコメント送信param  notify_type が offer と reaction で利用するメールテンプレを変更 reaction の場合は 責任者に通知する。  通知はメールで送信
 * @export
 * @interface ReactionPostParam
 */
export interface ReactionPostParam {
    /**
     * 
     * @type {string}
     * @memberof ReactionPostParam
     */
    'content': string;
    /**
     * 
     * @type {string}
     * @memberof ReactionPostParam
     */
    'matchbox_id': string;
    /**
     * 
     * @type {number}
     * @memberof ReactionPostParam
     */
    'offer_id': number;
    /**
     * 
     * @type {number}
     * @memberof ReactionPostParam
     */
    'status': ReactionPostParamStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ReactionPostParam
     */
    'notify_type': ReactionPostParamNotifyTypeEnum;
    /**
     * 社員全員にメールを通知
     * @type {boolean}
     * @memberof ReactionPostParam
     */
    'notify_all'?: boolean;
    /**
     * 通知する企業ユーザーのIDを設定
     * @type {Array<string>}
     * @memberof ReactionPostParam
     */
    'notify_member'?: Array<string>;
    /**
     * 通知するグループのIDを設定
     * @type {Array<string>}
     * @memberof ReactionPostParam
     */
    'notify_group'?: Array<string>;
}

/**
    * @export
    * @enum {string}
    */
export enum ReactionPostParamStatusEnum {
    NUMBER_2 = 2,
    NUMBER_3 = 3,
    NUMBER_8 = 8,
    NUMBER_4 = 4
}
/**
    * @export
    * @enum {string}
    */
export enum ReactionPostParamNotifyTypeEnum {
    Offer = 'offer',
    Reaction = 'reaction'
}

/**
 * 
 * @export
 * @interface ReactionResponse
 */
export interface ReactionResponse {
    /**
     * 
     * @type {number}
     * @memberof ReactionResponse
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReactionResponse
     */
    'offer_id'?: number;
    /**
     * 社員id
     * @type {string}
     * @memberof ReactionResponse
     */
    'matchbox_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReactionResponse
     */
    'status'?: ReactionResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ReactionResponse
     */
    'comment'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReactionResponse
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReactionResponse
     */
    'result': ReactionResponseResultEnum;
    /**
     * 
     * @type {string}
     * @memberof ReactionResponse
     */
    'error_message'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReactionResponse
     */
    'error_code'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum ReactionResponseStatusEnum {
    NUMBER_2 = 2,
    NUMBER_3 = 3,
    NUMBER_8 = 8,
    NUMBER_4 = 4
}
/**
    * @export
    * @enum {string}
    */
export enum ReactionResponseResultEnum {
    Success = 'success',
    Fail = 'fail'
}

/**
 * position : アクション時の指定ポジション reaction_position : ピックアップ時の指定ポジション
 * @export
 * @interface ReactionsResponse
 */
export interface ReactionsResponse {
    /**
     * 
     * @type {Array<ReactionsResponseAllOfReactions>}
     * @memberof ReactionsResponse
     */
    'reactions'?: Array<ReactionsResponseAllOfReactions>;
    /**
     * 
     * @type {OfferPositionData}
     * @memberof ReactionsResponse
     */
    'position'?: OfferPositionData;
    /**
     * 
     * @type {OfferPositionData}
     * @memberof ReactionsResponse
     */
    'reaction_position'?: OfferPositionData;
    /**
     * 
     * @type {string}
     * @memberof ReactionsResponse
     */
    'result': ReactionsResponseResultEnum;
    /**
     * 
     * @type {string}
     * @memberof ReactionsResponse
     */
    'error_message'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReactionsResponse
     */
    'error_code'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum ReactionsResponseResultEnum {
    Success = 'success',
    Fail = 'fail'
}

/**
 * 
 * @export
 * @interface ReactionsResponseAllOf
 */
export interface ReactionsResponseAllOf {
    /**
     * 
     * @type {Array<ReactionsResponseAllOfReactions>}
     * @memberof ReactionsResponseAllOf
     */
    'reactions'?: Array<ReactionsResponseAllOfReactions>;
    /**
     * 
     * @type {OfferPositionData}
     * @memberof ReactionsResponseAllOf
     */
    'position'?: OfferPositionData;
    /**
     * 
     * @type {OfferPositionData}
     * @memberof ReactionsResponseAllOf
     */
    'reaction_position'?: OfferPositionData;
}
/**
 * 
 * @export
 * @interface ReactionsResponseAllOfReactions
 */
export interface ReactionsResponseAllOfReactions {
    /**
     * 
     * @type {Reaction}
     * @memberof ReactionsResponseAllOfReactions
     */
    'reaction'?: Reaction;
    /**
     * 
     * @type {CompanyUser}
     * @memberof ReactionsResponseAllOfReactions
     */
    'user'?: CompanyUser;
}
/**
 * 
 * @export
 * @interface RequestPassword
 */
export interface RequestPassword {
    /**
     * トークンの値
     * @type {string}
     * @memberof RequestPassword
     */
    'token': string;
    /**
     * パスワード文字列 仕様は未設定
     * @type {string}
     * @memberof RequestPassword
     */
    'password': string;
    /**
     * パスワード文字列 仕様は未設定
     * @type {string}
     * @memberof RequestPassword
     */
    're_password': string;
}
/**
 * 
 * @export
 * @interface RequestPasswordAllOf
 */
export interface RequestPasswordAllOf {
    /**
     * パスワード文字列 仕様は未設定
     * @type {string}
     * @memberof RequestPasswordAllOf
     */
    'password': string;
    /**
     * パスワード文字列 仕様は未設定
     * @type {string}
     * @memberof RequestPasswordAllOf
     */
    're_password': string;
}
/**
 * トークンのチェック
 * @export
 * @interface RequestTokenCheck
 */
export interface RequestTokenCheck {
    /**
     * トークンの値
     * @type {string}
     * @memberof RequestTokenCheck
     */
    'token': string;
}
/**
 * @type ResponseCommon
 * 汎用レスポンス
 * @export
 */
export type ResponseCommon = ResponseError | ResponseSuccess;

/**
 * 汎用エラーレスポンス
 * @export
 * @interface ResponseError
 */
export interface ResponseError {
    /**
     * エラーコード
     * @type {string}
     * @memberof ResponseError
     */
    'error_code': string;
    /**
     * エラーメッセージ
     * @type {string}
     * @memberof ResponseError
     */
    'error_message': string;
    /**
     * 
     * @type {string}
     * @memberof ResponseError
     */
    'result': ResponseErrorResultEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ResponseErrorResultEnum {
    Fail = 'fail'
}

/**
 * マイナビクリエーター希望職種
 * @export
 * @interface ResponseMyNav
 */
export interface ResponseMyNav {
    /**
     * 
     * @type {MyNavi}
     * @memberof ResponseMyNav
     */
    'mynavi_creator': MyNavi;
    /**
     * 
     * @type {string}
     * @memberof ResponseMyNav
     */
    'result': ResponseMyNavResultEnum;
    /**
     * 
     * @type {string}
     * @memberof ResponseMyNav
     */
    'error_message'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseMyNav
     */
    'error_code'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum ResponseMyNavResultEnum {
    Success = 'success',
    Fail = 'fail'
}

/**
 * 
 * @export
 * @interface ResponseMyNavAllOf
 */
export interface ResponseMyNavAllOf {
    /**
     * 
     * @type {MyNavi}
     * @memberof ResponseMyNavAllOf
     */
    'mynavi_creator': MyNavi;
}
/**
 * 汎用成功レスポンス
 * @export
 * @interface ResponseSuccess
 */
export interface ResponseSuccess {
    /**
     * success のみ
     * @type {string}
     * @memberof ResponseSuccess
     */
    'result': string;
}
/**
 * 履歴書
 * @export
 * @interface Resume
 */
export interface Resume {
    /**
     * 
     * @type {ResumeUser}
     * @memberof Resume
     */
    'user'?: ResumeUser;
    /**
     * 
     * @type {AnotherContact}
     * @memberof Resume
     */
    'another_contact'?: AnotherContact;
    /**
     * 
     * @type {ResumeSummary}
     * @memberof Resume
     */
    'resume'?: ResumeSummary;
    /**
     * 
     * @type {Set<Qualification>}
     * @memberof Resume
     */
    'qualifications'?: Set<Qualification>;
    /**
     * 
     * @type {Set<EducationData>}
     * @memberof Resume
     */
    'educations'?: Set<EducationData>;
    /**
     * 
     * @type {Set<CareerSummaryModel>}
     * @memberof Resume
     */
    'careers'?: Set<CareerSummaryModel>;
    /**
     * 
     * @type {number}
     * @memberof Resume
     */
    'first_visit'?: number;
}
/**
 * 
 * @export
 * @interface ResumeSummary
 */
export interface ResumeSummary {
    /**
     * 
     * @type {string}
     * @memberof ResumeSummary
     */
    'statement'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResumeSummary
     */
    'interest_things'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResumeSummary
     */
    'hope_job'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResumeSummary
     */
    'commute_time'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResumeSummary
     */
    'dependent_family'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ResumeSummary
     */
    'partner'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResumeSummary
     */
    'duty_of_support'?: boolean;
}
/**
 * 
 * @export
 * @interface ResumeUser
 */
export interface ResumeUser {
    /**
     * 
     * @type {UserResumeInfo}
     * @memberof ResumeUser
     */
    'user_info'?: UserResumeInfo;
    /**
     * ユーザーアイコン : POST / PATCH のリクエスト時はData URI形式`data:image/png;base64,iV...`で送信。レスポンスの際はS3に保存したURIを返却。
     * @type {string}
     * @memberof ResumeUser
     */
    'icon'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResumeUser
     */
    'registration_date'?: string;
    /**
     * 
     * @type {number}
     * @memberof ResumeUser
     */
    'view_count_portfolio'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResumeUser
     */
    'last_update_resume'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResumeUser
     */
    'last_update_portfolio'?: string;
    /**
     * 
     * @type {LastLogin}
     * @memberof ResumeUser
     */
    'last_login'?: LastLogin;
}
/**
 * 
 * @export
 * @interface SaveSearchConditionResponse
 */
export interface SaveSearchConditionResponse {
    /**
     * success のみ
     * @type {string}
     * @memberof SaveSearchConditionResponse
     */
    'result': string;
    /**
     * 
     * @type {number}
     * @memberof SaveSearchConditionResponse
     */
    'search_condition_id'?: number;
}
/**
 * 
 * @export
 * @interface SaveSearchConditionResponseAllOf
 */
export interface SaveSearchConditionResponseAllOf {
    /**
     * 
     * @type {number}
     * @memberof SaveSearchConditionResponseAllOf
     */
    'search_condition_id'?: number;
}
/**
 * 
 * @export
 * @interface SearchPortfolioResponse
 */
export interface SearchPortfolioResponse {
    /**
     * 
     * @type {Set<Portfolio>}
     * @memberof SearchPortfolioResponse
     */
    'portfolios': Set<Portfolio>;
    /**
     * 
     * @type {string}
     * @memberof SearchPortfolioResponse
     */
    'result': SearchPortfolioResponseResultEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchPortfolioResponse
     */
    'error_message'?: string;
    /**
     * 
     * @type {number}
     * @memberof SearchPortfolioResponse
     */
    'error_code'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum SearchPortfolioResponseResultEnum {
    Success = 'success',
    Fail = 'fail'
}

/**
 * 
 * @export
 * @interface SearchPortfolioResponseAllOf
 */
export interface SearchPortfolioResponseAllOf {
    /**
     * 
     * @type {Set<Portfolio>}
     * @memberof SearchPortfolioResponseAllOf
     */
    'portfolios': Set<Portfolio>;
}
/**
 * CA用ユーザー検索パラメータ
 * @export
 * @interface SearchUsers
 */
export interface SearchUsers {
    /**
     * どこを検索するか要相談 
     * @type {string}
     * @memberof SearchUsers
     */
    'keyword'?: string;
    /**
     * 広告効果測定用エントリーID 
     * @type {string}
     * @memberof SearchUsers
     */
    'user_entry_id'?: string;
    /**
     * ユーザーID、ニックネーム URL などにも使用。ユニークなものです。 
     * @type {string}
     * @memberof SearchUsers
     */
    'user_id'?: string;
    /**
     * 名
     * @type {string}
     * @memberof SearchUsers
     */
    'name'?: string;
    /**
     * ふりがな
     * @type {string}
     * @memberof SearchUsers
     */
    'furigana'?: string;
    /**
     * Eメールアドレス 
     * @type {string}
     * @memberof SearchUsers
     */
    'email'?: string;
    /**
     * 都道府県 選択式 
     * @type {number}
     * @memberof SearchUsers
     */
    'prefecture'?: number;
    /**
     * ポートフォリオURL
     * @type {string}
     * @memberof SearchUsers
     */
    'portfolio_url'?: string;
    /**
     * 電話番号(ハイフン省略可) 
     * @type {string}
     * @memberof SearchUsers
     */
    'tel'?: string;
    /**
     * 【注意】address1, address2, address3 から検索 
     * @type {string}
     * @memberof SearchUsers
     */
    'address'?: string;
    /**
     * 男女 (0:未設定(default), 1:女子, 2:男子) 
     * @type {number}
     * @memberof SearchUsers
     */
    'gender'?: number;
    /**
     * レンジで指定可能 年齢 
     * @type {string}
     * @memberof SearchUsers
     */
    'age'?: string;
    /**
     * 期間指定可能　誕生日 
     * @type {string}
     * @memberof SearchUsers
     */
    'birth_date'?: string;
    /**
     * 期間指定可能　最終ログイン 
     * @type {string}
     * @memberof SearchUsers
     */
    'last_login'?: string;
    /**
     * 期間指定可能　登録日（サーバー側で付与） 
     * @type {string}
     * @memberof SearchUsers
     */
    'registration_date'?: string;
    /**
     * 期間指定可能　ポートフォリオの最終更新日 
     * @type {string}
     * @memberof SearchUsers
     */
    'last_update_portfolio'?: string;
    /**
     * 期間指定可能　履歴書の最終更新日 
     * @type {string}
     * @memberof SearchUsers
     */
    'last_update_resume'?: string;
    /**
     * 期間指定可能　⾃作ポートフォリオの最終更新日
     * @type {string}
     * @memberof SearchUsers
     */
    'last_update_own_portfolio'?: string;
    /**
     * 期間指定可能　職務経歴書の最終更新日
     * @type {string}
     * @memberof SearchUsers
     */
    'last_update_career_history'?: string;
    /**
     * ポートフォリオの作品数 
     * @type {number}
     * @memberof SearchUsers
     */
    'portfolio_item_count'?: number;
    /**
     * ポートフォリオ公開状態（プライバシー設定） 
     * @type {string}
     * @memberof SearchUsers
     */
    'status'?: string;
    /**
     * 【新規追加】ユーザーの状態 
     * @type {string}
     * @memberof SearchUsers
     */
    'user_status'?: string;
    /**
     * 希望職種
     * @type {Array<number>}
     * @memberof SearchUsers
     */
    'mc_preferred_job_type'?: Array<number>;
    /**
     * 希望業種
     * @type {Array<number>}
     * @memberof SearchUsers
     */
    'mc_preferred_business_type'?: Array<number>;
    /**
     * 希望勤務地
     * @type {Array<number>}
     * @memberof SearchUsers
     */
    'mc_preferred_prefecture'?: Array<number>;
    /**
     * 希望年収
     * @type {number}
     * @memberof SearchUsers
     */
    'mc_preferred_yearly_income'?: number;
    /**
     * 英語力
     * @type {number}
     * @memberof SearchUsers
     */
    'mc_english_skills'?: number;
    /**
     * 最大マネジメント人数
     * @type {number}
     * @memberof SearchUsers
     */
    'mc_maximum_management_count'?: number;
    /**
     * 現在の年収
     * @type {number}
     * @memberof SearchUsers
     */
    'mc_yearly_income'?: number;
    /**
     * 職種と経験年数。複数の場合 OR検索
     * @type {Array<SearchUsersMcExperiencedJob>}
     * @memberof SearchUsers
     */
    'mc_experienced_job'?: Array<SearchUsersMcExperiencedJob>;
    /**
     * 経験者数
     * @type {number}
     * @memberof SearchUsers
     */
    'career_history_amount'?: number;
    /**
     * 在籍企業
     * @type {string}
     * @memberof SearchUsers
     */
    'career_history_current_companies'?: string;
    /**
     * 現在の在籍部署名
     * @type {string}
     * @memberof SearchUsers
     */
    'career_history_current_section'?: string;
    /**
     * 現在の役職名
     * @type {string}
     * @memberof SearchUsers
     */
    'career_history_current_post'?: string;
    /**
     * これまでの在籍企業
     * @type {string}
     * @memberof SearchUsers
     */
    'career_history_companies'?: string;
    /**
     * これまでの部署名
     * @type {string}
     * @memberof SearchUsers
     */
    'career_history_section'?: string;
    /**
     * これまでの役職名
     * @type {string}
     * @memberof SearchUsers
     */
    'career_history_post'?: string;
    /**
     * 使用言語・ツール
     * @type {string}
     * @memberof SearchUsers
     */
    'career_history_tools'?: string;
    /**
     * 資格・免許
     * @type {string}
     * @memberof SearchUsers
     */
    'q_title'?: string;
    /**
     * 学校名
     * @type {string}
     * @memberof SearchUsers
     */
    'e_school_name'?: string;
    /**
     * TOEIC点数
     * @type {number}
     * @memberof SearchUsers
     */
    'q_toeic_score'?: number;
    /**
     * TOEFL点数
     * @type {number}
     * @memberof SearchUsers
     */
    'q_toefl_score'?: number;
    /**
     * ダイレクトへの登録
     * @type {boolean}
     * @memberof SearchUsers
     */
    'connected_to_mbdirect'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchUsers
     */
    'matchbox_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof SearchUsers
     */
    'offer_status'?: SearchUsersOfferStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchUsers
     */
    'offer_update_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchUsers
     */
    'offer_amount'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchUsers
     */
    'offer_pickup_amount'?: string;
    /**
     * 
     * @type {number}
     * @memberof SearchUsers
     */
    'offer_mw_status'?: SearchUsersOfferMwStatusEnum;
    /**
     * 確認用タグ 
     * @type {Array<string>}
     * @memberof SearchUsers
     */
    'user_admin_tags'?: Array<string>;
    /**
     * 就業状況 選択式 
     * @type {number}
     * @memberof SearchUsers
     */
    'mc_situation'?: number;
    /**
     * 転職希望時期 選択式（マスタから選択）
     * @type {number}
     * @memberof SearchUsers
     */
    'mc_preferred_change_date'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum SearchUsersOfferStatusEnum {
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3,
    NUMBER_4 = 4,
    NUMBER_5 = 5,
    NUMBER_6 = 6,
    NUMBER_7 = 7
}
/**
    * @export
    * @enum {string}
    */
export enum SearchUsersOfferMwStatusEnum {
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3
}

/**
 * Directで利用する検索用パラメータ
 * @export
 * @interface SearchUsersByDirect
 */
export interface SearchUsersByDirect {
    /**
     * どこを検索するか要相談 
     * @type {string}
     * @memberof SearchUsersByDirect
     */
    'keyword'?: string;
    /**
     * 広告効果測定用エントリーID 
     * @type {string}
     * @memberof SearchUsersByDirect
     */
    'user_entry_id'?: string;
    /**
     * ユーザーID、ニックネーム URL などにも使用。ユニークなものです。 
     * @type {string}
     * @memberof SearchUsersByDirect
     */
    'user_id'?: string;
    /**
     * 名
     * @type {string}
     * @memberof SearchUsersByDirect
     */
    'name'?: string;
    /**
     * ふりがな
     * @type {string}
     * @memberof SearchUsersByDirect
     */
    'furigana'?: string;
    /**
     * Eメールアドレス 
     * @type {string}
     * @memberof SearchUsersByDirect
     */
    'email'?: string;
    /**
     * 都道府県 選択式 
     * @type {number}
     * @memberof SearchUsersByDirect
     */
    'prefecture'?: number;
    /**
     * ポートフォリオURL
     * @type {string}
     * @memberof SearchUsersByDirect
     */
    'portfolio_url'?: string;
    /**
     * 電話番号(ハイフン省略可) 
     * @type {string}
     * @memberof SearchUsersByDirect
     */
    'tel'?: string;
    /**
     * 【注意】address1, address2, address3 から検索 
     * @type {string}
     * @memberof SearchUsersByDirect
     */
    'address'?: string;
    /**
     * 男女 (0:未設定(default), 1:女子, 2:男子) 
     * @type {number}
     * @memberof SearchUsersByDirect
     */
    'gender'?: number;
    /**
     * レンジで指定可能 年齢 
     * @type {string}
     * @memberof SearchUsersByDirect
     */
    'age'?: string;
    /**
     * 期間指定可能　誕生日 
     * @type {string}
     * @memberof SearchUsersByDirect
     */
    'birth_date'?: string;
    /**
     * 期間指定可能　最終ログイン 
     * @type {string}
     * @memberof SearchUsersByDirect
     */
    'last_login'?: string;
    /**
     * 期間指定可能　登録日（サーバー側で付与） 
     * @type {string}
     * @memberof SearchUsersByDirect
     */
    'registration_date'?: string;
    /**
     * 期間指定可能　ポートフォリオの最終更新日 
     * @type {string}
     * @memberof SearchUsersByDirect
     */
    'last_update_portfolio'?: string;
    /**
     * 期間指定可能　履歴書の最終更新日 
     * @type {string}
     * @memberof SearchUsersByDirect
     */
    'last_update_resume'?: string;
    /**
     * 期間指定可能　⾃作ポートフォリオの最終更新日
     * @type {string}
     * @memberof SearchUsersByDirect
     */
    'last_update_own_portfolio'?: string;
    /**
     * 期間指定可能　職務経歴書の最終更新日
     * @type {string}
     * @memberof SearchUsersByDirect
     */
    'last_update_career_history'?: string;
    /**
     * ポートフォリオの作品数 
     * @type {number}
     * @memberof SearchUsersByDirect
     */
    'portfolio_item_count'?: number;
    /**
     * ポートフォリオ公開状態（プライバシー設定） 
     * @type {string}
     * @memberof SearchUsersByDirect
     */
    'status'?: string;
    /**
     * 【新規追加】ユーザーの状態 
     * @type {string}
     * @memberof SearchUsersByDirect
     */
    'user_status'?: string;
    /**
     * 希望職種
     * @type {Array<number>}
     * @memberof SearchUsersByDirect
     */
    'mc_preferred_job_type'?: Array<number>;
    /**
     * 希望業種
     * @type {Array<number>}
     * @memberof SearchUsersByDirect
     */
    'mc_preferred_business_type'?: Array<number>;
    /**
     * 希望勤務地
     * @type {Array<number>}
     * @memberof SearchUsersByDirect
     */
    'mc_preferred_prefecture'?: Array<number>;
    /**
     * 希望年収
     * @type {number}
     * @memberof SearchUsersByDirect
     */
    'mc_preferred_yearly_income'?: number;
    /**
     * 英語力
     * @type {number}
     * @memberof SearchUsersByDirect
     */
    'mc_english_skills'?: number;
    /**
     * 最大マネジメント人数
     * @type {number}
     * @memberof SearchUsersByDirect
     */
    'mc_maximum_management_count'?: number;
    /**
     * 現在の年収
     * @type {number}
     * @memberof SearchUsersByDirect
     */
    'mc_yearly_income'?: number;
    /**
     * 職種と経験年数。複数の場合 OR検索
     * @type {Array<SearchUsersMcExperiencedJob>}
     * @memberof SearchUsersByDirect
     */
    'mc_experienced_job'?: Array<SearchUsersMcExperiencedJob>;
    /**
     * 経験者数
     * @type {number}
     * @memberof SearchUsersByDirect
     */
    'career_history_amount'?: number;
    /**
     * 在籍企業
     * @type {string}
     * @memberof SearchUsersByDirect
     */
    'career_history_current_companies'?: string;
    /**
     * 現在の在籍部署名
     * @type {string}
     * @memberof SearchUsersByDirect
     */
    'career_history_current_section'?: string;
    /**
     * 現在の役職名
     * @type {string}
     * @memberof SearchUsersByDirect
     */
    'career_history_current_post'?: string;
    /**
     * これまでの在籍企業
     * @type {string}
     * @memberof SearchUsersByDirect
     */
    'career_history_companies'?: string;
    /**
     * これまでの部署名
     * @type {string}
     * @memberof SearchUsersByDirect
     */
    'career_history_section'?: string;
    /**
     * これまでの役職名
     * @type {string}
     * @memberof SearchUsersByDirect
     */
    'career_history_post'?: string;
    /**
     * 使用言語・ツール
     * @type {string}
     * @memberof SearchUsersByDirect
     */
    'career_history_tools'?: string;
    /**
     * 資格・免許
     * @type {string}
     * @memberof SearchUsersByDirect
     */
    'q_title'?: string;
    /**
     * 学校名
     * @type {string}
     * @memberof SearchUsersByDirect
     */
    'e_school_name'?: string;
    /**
     * TOEIC点数
     * @type {number}
     * @memberof SearchUsersByDirect
     */
    'q_toeic_score'?: number;
    /**
     * TOEFL点数
     * @type {number}
     * @memberof SearchUsersByDirect
     */
    'q_toefl_score'?: number;
    /**
     * ダイレクトへの登録
     * @type {boolean}
     * @memberof SearchUsersByDirect
     */
    'connected_to_mbdirect'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchUsersByDirect
     */
    'matchbox_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof SearchUsersByDirect
     */
    'offer_status'?: SearchUsersByDirectOfferStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchUsersByDirect
     */
    'offer_update_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchUsersByDirect
     */
    'offer_amount'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchUsersByDirect
     */
    'offer_pickup_amount'?: string;
    /**
     * 
     * @type {number}
     * @memberof SearchUsersByDirect
     */
    'offer_mw_status'?: SearchUsersByDirectOfferMwStatusEnum;
    /**
     * 確認用タグ 
     * @type {Array<string>}
     * @memberof SearchUsersByDirect
     */
    'user_admin_tags'?: Array<string>;
    /**
     * 就業状況 選択式 
     * @type {number}
     * @memberof SearchUsersByDirect
     */
    'mc_situation'?: number;
    /**
     * 転職希望時期 選択式（マスタから選択）
     * @type {number}
     * @memberof SearchUsersByDirect
     */
    'mc_preferred_change_date'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum SearchUsersByDirectOfferStatusEnum {
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3,
    NUMBER_4 = 4,
    NUMBER_5 = 5,
    NUMBER_6 = 6,
    NUMBER_7 = 7
}
/**
    * @export
    * @enum {string}
    */
export enum SearchUsersByDirectOfferMwStatusEnum {
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3
}

/**
 * 
 * @export
 * @interface SearchUsersMcExperiencedJob
 */
export interface SearchUsersMcExperiencedJob {
    /**
     * 
     * @type {number}
     * @memberof SearchUsersMcExperiencedJob
     */
    'job'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof SearchUsersMcExperiencedJob
     */
    'job_year'?: Array<number>;
}
/**
 * 
 * @export
 * @interface Status
 */
export interface Status {
    /**
     * 
     * @type {string}
     * @memberof Status
     */
    'result': StatusResultEnum;
    /**
     * 
     * @type {string}
     * @memberof Status
     */
    'error_message'?: string;
    /**
     * 
     * @type {number}
     * @memberof Status
     */
    'error_code'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum StatusResultEnum {
    Success = 'success',
    Fail = 'fail'
}

/**
 * 求職者情報ベース
 * @export
 * @interface User
 */
export interface User {
    /**
     * P+数字乱数8桁 主にポートフォリオの公開URLで使用
     * @type {string}
     * @memberof User
     */
    'user_id'?: string;
    /**
     * Eメールアドレス
     * @type {string}
     * @memberof User
     */
    'email'?: string;
    /**
     * 流入経路
     * @type {string}
     * @memberof User
     */
    'come_from'?: string;
    /**
     * Direct利用状況
     * @type {boolean}
     * @memberof User
     */
    'use_direct'?: boolean;
    /**
     * matchbox を使うかどうか
     * @type {boolean}
     * @memberof User
     */
    'use_matchbox'?: boolean;
    /**
     * 今までのご経験（300字以内）mynavi-creatorで使用
     * @type {string}
     * @memberof User
     */
    'description'?: string;
    /**
     * ユーザーのタイプ
     * @type {string}
     * @memberof User
     */
    'user_type'?: UserUserTypeEnum;
    /**
     * 職業 記入した職業の文字列が返ってくる
     * @type {string}
     * @memberof User
     */
    'job'?: string;
    /**
     * 一般ユーザーID C+数字乱数8桁（Ex. C12183640）
     * @type {string}
     * @memberof User
     */
    'matchbox_id'?: string;
    /**
     * ユーザーアイコン : POST / PATCH のリクエスト時はData URI形式`data:image/png;base64,iV...`で送信。レスポンスの際はS3に保存したURIを返却。
     * @type {string}
     * @memberof User
     */
    'icon'?: string;
    /**
     * CP2に連携しているかのフラグ  0 : 未連携 1 : 連携済  連携判断については[CP2連携項目について](/#section/CP2)を参照
     * @type {number}
     * @memberof User
     */
    'cp2_status'?: number;
    /**
     * 求職者 ユーザー名
     * @type {string}
     * @memberof User
     */
    'name': string;
    /**
     * 求職者 ふりがな  バリデーション - 平仮名 + 空白スペース
     * @type {string}
     * @memberof User
     */
    'furigana': string;
    /**
     * 誕生年  バリデーション - 半角数字 - 1900 - 2021（または現在年） まで
     * @type {number}
     * @memberof User
     */
    'birth_year': number;
    /**
     * 誕生月  バリデーション - 半角数字 - 1 - 12 まで
     * @type {number}
     * @memberof User
     */
    'birth_month': number;
    /**
     * 誕生日  バリデーション - 半角数字 - 1 - 31 まで
     * @type {number}
     * @memberof User
     */
    'birth_day': number;
    /**
     * 都道府県 選択項目は実装側定義参照
     * @type {number}
     * @memberof User
     */
    'prefecture'?: number;
    /**
     * 電話番号  バリデーション - 半角数字 - ハイフンなしの 10 - 11 桁までの数値 - 表示時もハイフンなしで表示する  仕様 - 文字列の方がフロント側で扱いやすいので文字列相当の数値として扱う
     * @type {string}
     * @memberof User
     */
    'tel'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum UserUserTypeEnum {
    User = 'user',
    DirectUser = 'direct_user',
    DirectManager = 'direct_manager',
    Admin = 'admin'
}

/**
 * 
 * @export
 * @interface UserAllOf
 */
export interface UserAllOf {
    /**
     * P+数字乱数8桁 主にポートフォリオの公開URLで使用
     * @type {string}
     * @memberof UserAllOf
     */
    'user_id'?: string;
    /**
     * Eメールアドレス
     * @type {string}
     * @memberof UserAllOf
     */
    'email'?: string;
    /**
     * 流入経路
     * @type {string}
     * @memberof UserAllOf
     */
    'come_from'?: string;
    /**
     * Direct利用状況
     * @type {boolean}
     * @memberof UserAllOf
     */
    'use_direct'?: boolean;
    /**
     * matchbox を使うかどうか
     * @type {boolean}
     * @memberof UserAllOf
     */
    'use_matchbox'?: boolean;
    /**
     * 今までのご経験（300字以内）mynavi-creatorで使用
     * @type {string}
     * @memberof UserAllOf
     */
    'description'?: string;
    /**
     * ユーザーのタイプ
     * @type {string}
     * @memberof UserAllOf
     */
    'user_type'?: UserAllOfUserTypeEnum;
    /**
     * 職業 記入した職業の文字列が返ってくる
     * @type {string}
     * @memberof UserAllOf
     */
    'job'?: string;
    /**
     * 一般ユーザーID C+数字乱数8桁（Ex. C12183640）
     * @type {string}
     * @memberof UserAllOf
     */
    'matchbox_id'?: string;
    /**
     * ユーザーアイコン : POST / PATCH のリクエスト時はData URI形式`data:image/png;base64,iV...`で送信。レスポンスの際はS3に保存したURIを返却。
     * @type {string}
     * @memberof UserAllOf
     */
    'icon'?: string;
    /**
     * CP2に連携しているかのフラグ  0 : 未連携 1 : 連携済  連携判断については[CP2連携項目について](/#section/CP2)を参照
     * @type {number}
     * @memberof UserAllOf
     */
    'cp2_status'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum UserAllOfUserTypeEnum {
    User = 'user',
    DirectUser = 'direct_user',
    DirectManager = 'direct_manager',
    Admin = 'admin'
}

/**
 * どのユーザー情報でも利用するベースになるやつ
 * @export
 * @interface UserBaseModel
 */
export interface UserBaseModel {
    /**
     * 求職者 ユーザー名
     * @type {string}
     * @memberof UserBaseModel
     */
    'name': string;
    /**
     * 求職者 ふりがな  バリデーション - 平仮名 + 空白スペース
     * @type {string}
     * @memberof UserBaseModel
     */
    'furigana': string;
    /**
     * 誕生年  バリデーション - 半角数字 - 1900 - 2021（または現在年） まで
     * @type {number}
     * @memberof UserBaseModel
     */
    'birth_year': number;
    /**
     * 誕生月  バリデーション - 半角数字 - 1 - 12 まで
     * @type {number}
     * @memberof UserBaseModel
     */
    'birth_month': number;
    /**
     * 誕生日  バリデーション - 半角数字 - 1 - 31 まで
     * @type {number}
     * @memberof UserBaseModel
     */
    'birth_day': number;
}
/**
 * メールアドレス変更
 * @export
 * @interface UserEmailChange
 */
export interface UserEmailChange {
    /**
     * 新しいメールアドレス
     * @type {string}
     * @memberof UserEmailChange
     */
    'email': string;
}
/**
 * メールアドレス変更 トークンチェック
 * @export
 * @interface UserEmailChangeToken
 */
export interface UserEmailChangeToken {
    /**
     * メールアドレス変更トークン
     * @type {string}
     * @memberof UserEmailChangeToken
     */
    'token': string;
}
/**
 * ユーザー情報
 * @export
 * @interface UserInfo
 */
export interface UserInfo {
    /**
     * 
     * @type {boolean}
     * @memberof UserInfo
     */
    'mc_connected'?: boolean;
    /**
     * v2の規約に同意済みか。（移行ユーザー初期の場合のみfalse）
     * @type {boolean}
     * @memberof UserInfo
     */
    'v2_agreement': boolean;
    /**
     * 移行ユーザーがログインをしたか。フロントからの上書き禁止
     * @type {boolean}
     * @memberof UserInfo
     */
    'migrated_login': boolean;
    /**
     * 移行ユーザーかどうか。フロントからの上書き禁止
     * @type {boolean}
     * @memberof UserInfo
     */
    'migrated_user': boolean;
    /**
     * 
     * @type {ImagePhoto}
     * @memberof UserInfo
     */
    'photo'?: ImagePhoto;
    /**
     * P+数字乱数8桁 主にポートフォリオの公開URLで使用
     * @type {string}
     * @memberof UserInfo
     */
    'user_id'?: string;
    /**
     * Eメールアドレス
     * @type {string}
     * @memberof UserInfo
     */
    'email'?: string;
    /**
     * 流入経路
     * @type {string}
     * @memberof UserInfo
     */
    'come_from'?: string;
    /**
     * Direct利用状況
     * @type {boolean}
     * @memberof UserInfo
     */
    'use_direct'?: boolean;
    /**
     * matchbox を使うかどうか
     * @type {boolean}
     * @memberof UserInfo
     */
    'use_matchbox'?: boolean;
    /**
     * 今までのご経験（300字以内）mynavi-creatorで使用
     * @type {string}
     * @memberof UserInfo
     */
    'description'?: string;
    /**
     * ユーザーのタイプ
     * @type {string}
     * @memberof UserInfo
     */
    'user_type'?: UserInfoUserTypeEnum;
    /**
     * 職業 記入した職業の文字列が返ってくる
     * @type {string}
     * @memberof UserInfo
     */
    'job'?: string;
    /**
     * 一般ユーザーID C+数字乱数8桁（Ex. C12183640）
     * @type {string}
     * @memberof UserInfo
     */
    'matchbox_id'?: string;
    /**
     * ユーザーアイコン : POST / PATCH のリクエスト時はData URI形式`data:image/png;base64,iV...`で送信。レスポンスの際はS3に保存したURIを返却。
     * @type {string}
     * @memberof UserInfo
     */
    'icon'?: string;
    /**
     * CP2に連携しているかのフラグ  0 : 未連携 1 : 連携済  連携判断については[CP2連携項目について](/#section/CP2)を参照
     * @type {number}
     * @memberof UserInfo
     */
    'cp2_status'?: number;
    /**
     * 求職者 ユーザー名
     * @type {string}
     * @memberof UserInfo
     */
    'name': string;
    /**
     * 求職者 ふりがな  バリデーション - 平仮名 + 空白スペース
     * @type {string}
     * @memberof UserInfo
     */
    'furigana': string;
    /**
     * 誕生年  バリデーション - 半角数字 - 1900 - 2021（または現在年） まで
     * @type {number}
     * @memberof UserInfo
     */
    'birth_year': number;
    /**
     * 誕生月  バリデーション - 半角数字 - 1 - 12 まで
     * @type {number}
     * @memberof UserInfo
     */
    'birth_month': number;
    /**
     * 誕生日  バリデーション - 半角数字 - 1 - 31 まで
     * @type {number}
     * @memberof UserInfo
     */
    'birth_day': number;
    /**
     * 都道府県 選択項目は実装側定義参照
     * @type {number}
     * @memberof UserInfo
     */
    'prefecture'?: number;
    /**
     * 電話番号  バリデーション - 半角数字 - ハイフンなしの 10 - 11 桁までの数値 - 表示時もハイフンなしで表示する  仕様 - 文字列の方がフロント側で扱いやすいので文字列相当の数値として扱う
     * @type {string}
     * @memberof UserInfo
     */
    'tel'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum UserInfoUserTypeEnum {
    User = 'user',
    DirectUser = 'direct_user',
    DirectManager = 'direct_manager',
    Admin = 'admin'
}

/**
 * 
 * @export
 * @interface UserInfoAllOf
 */
export interface UserInfoAllOf {
    /**
     * 
     * @type {boolean}
     * @memberof UserInfoAllOf
     */
    'mc_connected'?: boolean;
    /**
     * v2の規約に同意済みか。（移行ユーザー初期の場合のみfalse）
     * @type {boolean}
     * @memberof UserInfoAllOf
     */
    'v2_agreement': boolean;
    /**
     * 移行ユーザーがログインをしたか。フロントからの上書き禁止
     * @type {boolean}
     * @memberof UserInfoAllOf
     */
    'migrated_login': boolean;
    /**
     * 移行ユーザーかどうか。フロントからの上書き禁止
     * @type {boolean}
     * @memberof UserInfoAllOf
     */
    'migrated_user': boolean;
    /**
     * 
     * @type {ImagePhoto}
     * @memberof UserInfoAllOf
     */
    'photo'?: ImagePhoto;
}
/**
 * 
 * @export
 * @interface UserIsLogin
 */
export interface UserIsLogin {
    /**
     * 
     * @type {string}
     * @memberof UserIsLogin
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof UserIsLogin
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UserIsLogin
     */
    'icon': string;
    /**
     * 
     * @type {string}
     * @memberof UserIsLogin
     */
    'user_type': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserIsLogin
     */
    'mc_connected': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserIsLogin
     */
    'is_login': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserIsLogin
     */
    'result': UserIsLoginResultEnum;
    /**
     * 
     * @type {string}
     * @memberof UserIsLogin
     */
    'error_message'?: string;
    /**
     * 
     * @type {number}
     * @memberof UserIsLogin
     */
    'error_code'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum UserIsLoginResultEnum {
    Success = 'success',
    Fail = 'fail'
}

/**
 * 
 * @export
 * @interface UserIsLoginAllOf
 */
export interface UserIsLoginAllOf {
    /**
     * 
     * @type {string}
     * @memberof UserIsLoginAllOf
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof UserIsLoginAllOf
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UserIsLoginAllOf
     */
    'icon': string;
    /**
     * 
     * @type {string}
     * @memberof UserIsLoginAllOf
     */
    'user_type': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserIsLoginAllOf
     */
    'mc_connected': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserIsLoginAllOf
     */
    'is_login': boolean;
}
/**
 * 
 * @export
 * @interface UserIsNotLogin
 */
export interface UserIsNotLogin {
    /**
     * 
     * @type {boolean}
     * @memberof UserIsNotLogin
     */
    'is_login': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserIsNotLogin
     */
    'result': string;
}
/**
 * 自作ポートフォリオ情報
 * @export
 * @interface UserOwnPortfolio
 */
export interface UserOwnPortfolio {
    /**
     * 自作ポートフォリオURL
     * @type {string}
     * @memberof UserOwnPortfolio
     */
    'url'?: string;
    /**
     * 補足情報
     * @type {string}
     * @memberof UserOwnPortfolio
     */
    'supplementary_info'?: string;
    /**
     * 自作ポートフォリオ最終更新日
     * @type {string}
     * @memberof UserOwnPortfolio
     */
    'last_update_own_portfolio'?: string;
}
/**
 * ユーザー情報更新リクエスト項目
 * @export
 * @interface UserPatchRequest
 */
export interface UserPatchRequest {
    /**
     * 求職者 ユーザー名
     * @type {string}
     * @memberof UserPatchRequest
     */
    'name': string;
    /**
     * 求職者 ふりがな  バリデーション - 平仮名 + 空白スペース
     * @type {string}
     * @memberof UserPatchRequest
     */
    'furigana': string;
    /**
     * 誕生年  バリデーション - 半角数字 - 1900 - 2021（または現在年） まで
     * @type {number}
     * @memberof UserPatchRequest
     */
    'birth_year': number;
    /**
     * 誕生月  バリデーション - 半角数字 - 1 - 12 まで
     * @type {number}
     * @memberof UserPatchRequest
     */
    'birth_month': number;
    /**
     * 誕生日  バリデーション - 半角数字 - 1 - 31 まで
     * @type {number}
     * @memberof UserPatchRequest
     */
    'birth_day': number;
    /**
     * 都道府県 選択項目は実装側定義参照
     * @type {number}
     * @memberof UserPatchRequest
     */
    'prefecture'?: number;
    /**
     * 電話番号  バリデーション - 半角数字 - ハイフンなしの 10 - 11 桁までの数値 - 表示時もハイフンなしで表示する  仕様 - 文字列の方がフロント側で扱いやすいので文字列相当の数値として扱う
     * @type {string}
     * @memberof UserPatchRequest
     */
    'tel'?: string;
    /**
     * 職業 記入した職業の文字列が返ってくる
     * @type {string}
     * @memberof UserPatchRequest
     */
    'job'?: string;
    /**
     * Direct利用状況
     * @type {boolean}
     * @memberof UserPatchRequest
     */
    'use_direct'?: boolean;
    /**
     * ユーザーアイコン : POST / PATCH のリクエスト時はData URI形式`data:image/png;base64,iV...`で送信。レスポンスの際はS3に保存したURIを返却。
     * @type {string}
     * @memberof UserPatchRequest
     */
    'icon'?: string;
    /**
     * 一般ユーザーID C+数字乱数8桁（Ex. C12183640）
     * @type {string}
     * @memberof UserPatchRequest
     */
    'matchbox_id': string;
}
/**
 * 
 * @export
 * @interface UserPatchRequestAllOf
 */
export interface UserPatchRequestAllOf {
    /**
     * 職業 記入した職業の文字列が返ってくる
     * @type {string}
     * @memberof UserPatchRequestAllOf
     */
    'job'?: string;
    /**
     * Direct利用状況
     * @type {boolean}
     * @memberof UserPatchRequestAllOf
     */
    'use_direct'?: boolean;
    /**
     * ユーザーアイコン : POST / PATCH のリクエスト時はData URI形式`data:image/png;base64,iV...`で送信。レスポンスの際はS3に保存したURIを返却。
     * @type {string}
     * @memberof UserPatchRequestAllOf
     */
    'icon'?: string;
    /**
     * 一般ユーザーID C+数字乱数8桁（Ex. C12183640）
     * @type {string}
     * @memberof UserPatchRequestAllOf
     */
    'matchbox_id': string;
}
/**
 * ユーザー情報のプロフィール設定モデル
 * @export
 * @interface UserProfileModel
 */
export interface UserProfileModel {
    /**
     * 求職者 ユーザー名
     * @type {string}
     * @memberof UserProfileModel
     */
    'name': string;
    /**
     * 求職者 ふりがな  バリデーション - 平仮名 + 空白スペース
     * @type {string}
     * @memberof UserProfileModel
     */
    'furigana': string;
    /**
     * 誕生年  バリデーション - 半角数字 - 1900 - 2021（または現在年） まで
     * @type {number}
     * @memberof UserProfileModel
     */
    'birth_year': number;
    /**
     * 誕生月  バリデーション - 半角数字 - 1 - 12 まで
     * @type {number}
     * @memberof UserProfileModel
     */
    'birth_month': number;
    /**
     * 誕生日  バリデーション - 半角数字 - 1 - 31 まで
     * @type {number}
     * @memberof UserProfileModel
     */
    'birth_day': number;
    /**
     * 都道府県 選択項目は実装側定義参照
     * @type {number}
     * @memberof UserProfileModel
     */
    'prefecture'?: number;
    /**
     * 電話番号  バリデーション - 半角数字 - ハイフンなしの 10 - 11 桁までの数値 - 表示時もハイフンなしで表示する  仕様 - 文字列の方がフロント側で扱いやすいので文字列相当の数値として扱う
     * @type {string}
     * @memberof UserProfileModel
     */
    'tel'?: string;
}
/**
 * 
 * @export
 * @interface UserProfileModelAllOf
 */
export interface UserProfileModelAllOf {
    /**
     * 都道府県 選択項目は実装側定義参照
     * @type {number}
     * @memberof UserProfileModelAllOf
     */
    'prefecture'?: number;
    /**
     * 電話番号  バリデーション - 半角数字 - ハイフンなしの 10 - 11 桁までの数値 - 表示時もハイフンなしで表示する  仕様 - 文字列の方がフロント側で扱いやすいので文字列相当の数値として扱う
     * @type {string}
     * @memberof UserProfileModelAllOf
     */
    'tel'?: string;
}
/**
 * 
 * @export
 * @interface UserResumeInfo
 */
export interface UserResumeInfo {
    /**
     * 郵便番号  バリデーション - 半角数字 - ハイフンなしの7桁数値相当の文字列  仕様 - フロント側では `3桁 - 4桁` の表記に変換
     * @type {string}
     * @memberof UserResumeInfo
     */
    'postal_code'?: string;
    /**
     * v1の仕様を引き継いだAddress群 1,2,3がある  address1 の場合は「ふりがな」用途で利用しているため以下のバリデーションを設定する  バリデーション - 平仮名 + 空白スペース
     * @type {string}
     * @memberof UserResumeInfo
     */
    'address1'?: string;
    /**
     * v1の仕様を引き継いだAddress群 1,2,3がある  address1 の場合は「ふりがな」用途で利用しているため以下のバリデーションを設定する  バリデーション - 平仮名 + 空白スペース
     * @type {string}
     * @memberof UserResumeInfo
     */
    'address2'?: string;
    /**
     * v1の仕様を引き継いだAddress群 1,2,3がある  address1 の場合は「ふりがな」用途で利用しているため以下のバリデーションを設定する  バリデーション - 平仮名 + 空白スペース
     * @type {string}
     * @memberof UserResumeInfo
     */
    'address3'?: string;
    /**
     * 男女 (0:未設定(default), 1:女子, 2:男子)
     * @type {number}
     * @memberof UserResumeInfo
     */
    'gender'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UserResumeInfo
     */
    'mc_connected'?: boolean;
    /**
     * v2の規約に同意済みか。（移行ユーザー初期の場合のみfalse）
     * @type {boolean}
     * @memberof UserResumeInfo
     */
    'v2_agreement': boolean;
    /**
     * 移行ユーザーがログインをしたか。フロントからの上書き禁止
     * @type {boolean}
     * @memberof UserResumeInfo
     */
    'migrated_login': boolean;
    /**
     * 移行ユーザーかどうか。フロントからの上書き禁止
     * @type {boolean}
     * @memberof UserResumeInfo
     */
    'migrated_user': boolean;
    /**
     * 
     * @type {ImagePhoto}
     * @memberof UserResumeInfo
     */
    'photo'?: ImagePhoto;
    /**
     * P+数字乱数8桁 主にポートフォリオの公開URLで使用
     * @type {string}
     * @memberof UserResumeInfo
     */
    'user_id'?: string;
    /**
     * Eメールアドレス
     * @type {string}
     * @memberof UserResumeInfo
     */
    'email'?: string;
    /**
     * 流入経路
     * @type {string}
     * @memberof UserResumeInfo
     */
    'come_from'?: string;
    /**
     * Direct利用状況
     * @type {boolean}
     * @memberof UserResumeInfo
     */
    'use_direct'?: boolean;
    /**
     * matchbox を使うかどうか
     * @type {boolean}
     * @memberof UserResumeInfo
     */
    'use_matchbox'?: boolean;
    /**
     * 今までのご経験（300字以内）mynavi-creatorで使用
     * @type {string}
     * @memberof UserResumeInfo
     */
    'description'?: string;
    /**
     * ユーザーのタイプ
     * @type {string}
     * @memberof UserResumeInfo
     */
    'user_type'?: UserResumeInfoUserTypeEnum;
    /**
     * 職業 記入した職業の文字列が返ってくる
     * @type {string}
     * @memberof UserResumeInfo
     */
    'job'?: string;
    /**
     * 一般ユーザーID C+数字乱数8桁（Ex. C12183640）
     * @type {string}
     * @memberof UserResumeInfo
     */
    'matchbox_id'?: string;
    /**
     * ユーザーアイコン : POST / PATCH のリクエスト時はData URI形式`data:image/png;base64,iV...`で送信。レスポンスの際はS3に保存したURIを返却。
     * @type {string}
     * @memberof UserResumeInfo
     */
    'icon'?: string;
    /**
     * CP2に連携しているかのフラグ  0 : 未連携 1 : 連携済  連携判断については[CP2連携項目について](/#section/CP2)を参照
     * @type {number}
     * @memberof UserResumeInfo
     */
    'cp2_status'?: number;
    /**
     * 求職者 ユーザー名
     * @type {string}
     * @memberof UserResumeInfo
     */
    'name': string;
    /**
     * 求職者 ふりがな  バリデーション - 平仮名 + 空白スペース
     * @type {string}
     * @memberof UserResumeInfo
     */
    'furigana': string;
    /**
     * 誕生年  バリデーション - 半角数字 - 1900 - 2021（または現在年） まで
     * @type {number}
     * @memberof UserResumeInfo
     */
    'birth_year': number;
    /**
     * 誕生月  バリデーション - 半角数字 - 1 - 12 まで
     * @type {number}
     * @memberof UserResumeInfo
     */
    'birth_month': number;
    /**
     * 誕生日  バリデーション - 半角数字 - 1 - 31 まで
     * @type {number}
     * @memberof UserResumeInfo
     */
    'birth_day': number;
    /**
     * 都道府県 選択項目は実装側定義参照
     * @type {number}
     * @memberof UserResumeInfo
     */
    'prefecture'?: number;
    /**
     * 電話番号  バリデーション - 半角数字 - ハイフンなしの 10 - 11 桁までの数値 - 表示時もハイフンなしで表示する  仕様 - 文字列の方がフロント側で扱いやすいので文字列相当の数値として扱う
     * @type {string}
     * @memberof UserResumeInfo
     */
    'tel'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum UserResumeInfoUserTypeEnum {
    User = 'user',
    DirectUser = 'direct_user',
    DirectManager = 'direct_manager',
    Admin = 'admin'
}

/**
 * 
 * @export
 * @interface UserResumeInfoAllOf
 */
export interface UserResumeInfoAllOf {
    /**
     * 郵便番号  バリデーション - 半角数字 - ハイフンなしの7桁数値相当の文字列  仕様 - フロント側では `3桁 - 4桁` の表記に変換
     * @type {string}
     * @memberof UserResumeInfoAllOf
     */
    'postal_code'?: string;
    /**
     * v1の仕様を引き継いだAddress群 1,2,3がある  address1 の場合は「ふりがな」用途で利用しているため以下のバリデーションを設定する  バリデーション - 平仮名 + 空白スペース
     * @type {string}
     * @memberof UserResumeInfoAllOf
     */
    'address1'?: string;
    /**
     * v1の仕様を引き継いだAddress群 1,2,3がある  address1 の場合は「ふりがな」用途で利用しているため以下のバリデーションを設定する  バリデーション - 平仮名 + 空白スペース
     * @type {string}
     * @memberof UserResumeInfoAllOf
     */
    'address2'?: string;
    /**
     * v1の仕様を引き継いだAddress群 1,2,3がある  address1 の場合は「ふりがな」用途で利用しているため以下のバリデーションを設定する  バリデーション - 平仮名 + 空白スペース
     * @type {string}
     * @memberof UserResumeInfoAllOf
     */
    'address3'?: string;
    /**
     * 男女 (0:未設定(default), 1:女子, 2:男子)
     * @type {number}
     * @memberof UserResumeInfoAllOf
     */
    'gender'?: number;
}
/**
 * タグ詳細
 * @export
 * @interface UserTag
 */
export interface UserTag {
    /**
     * タグID
     * @type {string}
     * @memberof UserTag
     */
    'id': string;
    /**
     * タグ名
     * @type {string}
     * @memberof UserTag
     */
    'name': string;
    /**
     * 検索結果URL
     * @type {string}
     * @memberof UserTag
     */
    'path': string;
    /**
     * 表示
     * @type {boolean}
     * @memberof UserTag
     */
    'active': boolean;
}
/**
 * タグ詳細
 * @export
 * @interface UserTagDirect
 */
export interface UserTagDirect {
    /**
     * タグID
     * @type {string}
     * @memberof UserTagDirect
     */
    'id': string;
    /**
     * タグ名
     * @type {string}
     * @memberof UserTagDirect
     */
    'name': string;
}
/**
 * 求職者タグ詳細
 * @export
 * @interface UserTagMatchboxId
 */
export interface UserTagMatchboxId {
    /**
     * タグID
     * @type {string}
     * @memberof UserTagMatchboxId
     */
    'id': string;
    /**
     * タグ名
     * @type {string}
     * @memberof UserTagMatchboxId
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface UserTagParam
 */
export interface UserTagParam {
    /**
     * 
     * @type {string}
     * @memberof UserTagParam
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UserTagParam
     */
    'path': string;
}
/**
 * 
 * @export
 * @interface UserTagPatchParam
 */
export interface UserTagPatchParam {
    /**
     * 
     * @type {string}
     * @memberof UserTagPatchParam
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UserTagPatchParam
     */
    'path': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserTagPatchParam
     */
    'active'?: boolean;
}
/**
 * 保存した検索条件にタグを紐付ける tags には UserTagId を配列で送る
 * @export
 * @interface UserTagToSearchResultBatchSaveParam
 */
export interface UserTagToSearchResultBatchSaveParam {
    /**
     * 
     * @type {string}
     * @memberof UserTagToSearchResultBatchSaveParam
     */
    'search_condition_id': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserTagToSearchResultBatchSaveParam
     */
    'tags'?: Array<string>;
}
/**
 * UserTagIdを配列で送る
 * @export
 * @interface UserTagsPatchParam
 */
export interface UserTagsPatchParam {
    /**
     * 
     * @type {Array<string>}
     * @memberof UserTagsPatchParam
     */
    'items'?: Array<string>;
}

/**
 * ADMINApi - axios parameter creator
 * @export
 */
export const ADMINApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 検索条件を削除
         * @summary 企業向け検索条件削除
         * @param {number} adminDirectSearchConditionId 管理者用のDirect向け検索条件のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminDirectSearchConditionId: async (adminDirectSearchConditionId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminDirectSearchConditionId' is not null or undefined
            assertParamExists('deleteAdminDirectSearchConditionId', 'adminDirectSearchConditionId', adminDirectSearchConditionId)
            const localVarPath = `/api/v2/admin/direct/search_condition/{AdminDirectSearchConditionId}`
                .replace(`{${"AdminDirectSearchConditionId"}}`, encodeURIComponent(String(adminDirectSearchConditionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 入力代行職務経歴・削除
         * @summary 入力代行職務経歴・削除
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {string} careerId 職歴ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminInputAgencyCareerHistoryCareers: async (userId: string, careerId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteAdminInputAgencyCareerHistoryCareers', 'userId', userId)
            // verify required parameter 'careerId' is not null or undefined
            assertParamExists('deleteAdminInputAgencyCareerHistoryCareers', 'careerId', careerId)
            const localVarPath = `/api/v2/admin/input_agency/career_history/{UserId}/careers/{CareerId}`
                .replace(`{${"UserId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"CareerId"}}`, encodeURIComponent(String(careerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 入力代行プロジェクト・削除
         * @summary 入力代行プロジェクト・削除
         * @param {string} projectId プロジェクトID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminInputAgencyCareerHistoryProjects: async (projectId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('deleteAdminInputAgencyCareerHistoryProjects', 'projectId', projectId)
            const localVarPath = `/api/v2/admin/input_agency/career_history/projects/{ProjectId}`
                .replace(`{${"ProjectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 入力代行資格/免許・削除
         * @summary 入力代行資格/免許・削除
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {string} qualificationId 資格ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminInputAgencyCareerHistoryQualifications: async (userId: string, qualificationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteAdminInputAgencyCareerHistoryQualifications', 'userId', userId)
            // verify required parameter 'qualificationId' is not null or undefined
            assertParamExists('deleteAdminInputAgencyCareerHistoryQualifications', 'qualificationId', qualificationId)
            const localVarPath = `/api/v2/admin/input_agency/career_history/{UserId}/qualifications/{QualificationId}`
                .replace(`{${"UserId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"QualificationId"}}`, encodeURIComponent(String(qualificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 入力代行スキル削除
         * @summary 入力代行スキル削除
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {string} skillId スキルID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminInputAgencyCareerHistorySkill: async (userId: string, skillId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteAdminInputAgencyCareerHistorySkill', 'userId', userId)
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('deleteAdminInputAgencyCareerHistorySkill', 'skillId', skillId)
            const localVarPath = `/api/v2/admin/input_agency/career_history/{UserId}/skills/{SkillId}`
                .replace(`{${"UserId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"SkillId"}}`, encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 入力代行学歴・削除
         * @summary 入力代行学歴・削除
         * @param {string} educationId 学歴ID
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminInputAgencyResumeUserIdEducations: async (educationId: string, userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'educationId' is not null or undefined
            assertParamExists('deleteAdminInputAgencyResumeUserIdEducations', 'educationId', educationId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteAdminInputAgencyResumeUserIdEducations', 'userId', userId)
            const localVarPath = `/api/v2/admin/input_agency/resume/{UserId}/educations/{educationId}`
                .replace(`{${"educationId"}}`, encodeURIComponent(String(educationId)))
                .replace(`{${"UserId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * メモを削除する
         * @summary メモを削除する
         * @param {number} noteId noteのid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminNote: async (noteId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('deleteAdminNote', 'noteId', noteId)
            const localVarPath = `/api/v2/admin/note/{noteId}`
                .replace(`{${"noteId"}}`, encodeURIComponent(String(noteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 検索条件を削除
         * @summary マイナビ向け検索条件削除
         * @param {number} adminSearchConditionId マイナビ向け検索条件のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminSearchConditionId: async (adminSearchConditionId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminSearchConditionId' is not null or undefined
            assertParamExists('deleteAdminSearchConditionId', 'adminSearchConditionId', adminSearchConditionId)
            const localVarPath = `/api/v2/admin/search_condition/{AdminSearchConditionId}`
                .replace(`{${"AdminSearchConditionId"}}`, encodeURIComponent(String(adminSearchConditionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 企業におすすめした検索条件を取り消す
         * @summary 企業におすすめした検索条件を取り消す
         * @param {number} directSearchConditionId Directの検索条件ID
         * @param {string} directCompanyId 内部的な企業ID
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminSuggestId: async (directSearchConditionId: number, directCompanyId: string, body?: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'directSearchConditionId' is not null or undefined
            assertParamExists('deleteAdminSuggestId', 'directSearchConditionId', directSearchConditionId)
            // verify required parameter 'directCompanyId' is not null or undefined
            assertParamExists('deleteAdminSuggestId', 'directCompanyId', directCompanyId)
            const localVarPath = `/api/v2/admin/suggest/{DirectSearchConditionId}/{DirectCompanyId}`
                .replace(`{${"DirectSearchConditionId"}}`, encodeURIComponent(String(directSearchConditionId)))
                .replace(`{${"DirectCompanyId"}}`, encodeURIComponent(String(directCompanyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 即時削除処理を行う  退会処理は別？要確認
         * @summary 求職者削除
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminUserId: async (userMatchboxId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userMatchboxId' is not null or undefined
            assertParamExists('deleteAdminUserId', 'userMatchboxId', userMatchboxId)
            const localVarPath = `/api/v2/admin/user/{UserMatchboxId}`
                .replace(`{${"UserMatchboxId"}}`, encodeURIComponent(String(userMatchboxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * * ファイルの削除を行う
         * @summary 画像などのファイル削除
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {string} fileId アップロード時に返却されるファイルID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminUserIdFiles: async (userId: string, fileId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteAdminUserIdFiles', 'userId', userId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('deleteAdminUserIdFiles', 'fileId', fileId)
            const localVarPath = `/api/v2/admin/files/{UserId}/{fileId}`
                .replace(`{${"UserId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * タグ削除
         * @summary タグ 削除
         * @param {string} userTagId ユーザータグID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminUserTagId: async (userTagId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userTagId' is not null or undefined
            assertParamExists('deleteAdminUserTagId', 'userTagId', userTagId)
            const localVarPath = `/api/v2/admin/user_tag/{UserTagId}`
                .replace(`{${"UserTagId"}}`, encodeURIComponent(String(userTagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * * サイト概要を確認するAPI、Daily, Weekly, Monthly,で確認する。 * 期間指定をするので、処理が重くなっても、指定された期日は全部出す * 完成度は portfolio_progress / resume_progress の値をもとに計算する   * それぞれに 10個の true, false が入ってるので、trueが1つ10%になる   * true の数ｘ10 で計算すれば良くて端数は基本でない * GET だとURLエンコード必要なので注意。POSTでもいいかも。
         * @summary サイト概要 取得
         * @param {string} type 概要抽出のタイプ
         * @param {string} term 期間は毎回指定してください。
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAdminAnalysisOverview: async (type: string, term: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getAdminAnalysisOverview', 'type', type)
            // verify required parameter 'term' is not null or undefined
            assertParamExists('getAdminAnalysisOverview', 'term', term)
            const localVarPath = `/api/v2/admin/analysis/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (term !== undefined) {
                localVarQueryParameter['term'] = term;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 職務経歴書
         * @summary 職務経歴書
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminCareerHistory: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getAdminCareerHistory', 'userId', userId)
            const localVarPath = `/api/v2/admin/career_history/{UserId}`
                .replace(`{${"UserId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adminユーザー向けの職務経歴書ページをPDF化します。 該当URLは `/admin/cv/{UserMatchboxId}`
         * @summary 求職者の職務経歴書PDFダウンロード
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminCareerHistoryDownload: async (userMatchboxId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userMatchboxId' is not null or undefined
            assertParamExists('getAdminCareerHistoryDownload', 'userMatchboxId', userMatchboxId)
            const localVarPath = `/api/v2/admin/career_history/{UserMatchboxId}/download`
                .replace(`{${"UserMatchboxId"}}`, encodeURIComponent(String(userMatchboxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 企業情報
         * @summary 企業情報
         * @param {string} directCompanyId 内部的な企業ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminCompany: async (directCompanyId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'directCompanyId' is not null or undefined
            assertParamExists('getAdminCompany', 'directCompanyId', directCompanyId)
            const localVarPath = `/api/v2/admin/company/{DirectCompanyId}`
                .replace(`{${"DirectCompanyId"}}`, encodeURIComponent(String(directCompanyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * `direct_*` or `admin` アカウントからGET可能
         * @summary 企業ユーザー情報詳細
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminCompanyUser: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getAdminCompanyUser', 'userId', userId)
            const localVarPath = `/api/v2/admin/company_user/{UserId}`
                .replace(`{${"UserId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 企業内ユーザー一覧
         * @summary 企業内ユーザー一覧
         * @param {string} limit 
         * @param {string} offset 
         * @param {string} sortBy 
         * @param {string} sortOrder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminCompanyUsers: async (limit: string, offset: string, sortBy: string, sortOrder: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getAdminCompanyUsers', 'limit', limit)
            // verify required parameter 'offset' is not null or undefined
            assertParamExists('getAdminCompanyUsers', 'offset', offset)
            // verify required parameter 'sortBy' is not null or undefined
            assertParamExists('getAdminCompanyUsers', 'sortBy', sortBy)
            // verify required parameter 'sortOrder' is not null or undefined
            assertParamExists('getAdminCompanyUsers', 'sortOrder', sortOrder)
            const localVarPath = `/api/v2/admin/company_users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 検索条件を取得
         * @summary 企業向け検索条件詳細
         * @param {number} adminDirectSearchConditionId 管理者用のDirect向け検索条件のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminDirectSearchConditionId: async (adminDirectSearchConditionId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminDirectSearchConditionId' is not null or undefined
            assertParamExists('getAdminDirectSearchConditionId', 'adminDirectSearchConditionId', adminDirectSearchConditionId)
            const localVarPath = `/api/v2/admin/direct/search_condition/{AdminDirectSearchConditionId}`
                .replace(`{${"AdminDirectSearchConditionId"}}`, encodeURIComponent(String(adminDirectSearchConditionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * # 仕様 - 保存されている情報は全てDirect側の「Matchboxのおすすめ検索」に表示する - メール配信設定を紐付けられた企業には検索条件のデータが変更されたらメールを送信
         * @summary 企業向け保存した検索条件一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminDirectSearchConditions: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/admin/direct/search_conditions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 求職者の入力代行サービスの登録状況を取得する
         * @summary 求職者入力代行情報取得
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminInputAgency: async (userMatchboxId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userMatchboxId' is not null or undefined
            assertParamExists('getAdminInputAgency', 'userMatchboxId', userMatchboxId)
            const localVarPath = `/api/v2/admin/input_agency/{UserMatchboxId}`
                .replace(`{${"UserMatchboxId"}}`, encodeURIComponent(String(userMatchboxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 入力代行職務経歴書取得
         * @summary 入力代行職務経歴書取得
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminInputAgencyCareerHistory: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getAdminInputAgencyCareerHistory', 'userId', userId)
            const localVarPath = `/api/v2/admin/input_agency/career_history/{UserId}`
                .replace(`{${"UserId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 入力代行履歴書取得
         * @summary 入力代行履歴書取得
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminInputAgencyResume: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getAdminInputAgencyResume', 'userId', userId)
            const localVarPath = `/api/v2/admin/input_agency/resume/{UserId}`
                .replace(`{${"UserId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ログイン状態を見る 必要な情報は精査
         * @summary 管理者のログイン状態
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminIsLogin: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/admin/is-login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ログアウトをする 
         * @summary 管理者ログアウト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminLogout: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/admin/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 企業・求職者に送信したメモ一覧
         * @summary 企業・求職者に送信したメモ一覧
         * @param {number} [companyId] CAのみ利用可能
         * @param {string} [matchboxId] 求職者 ID B + 8桁乱数
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminNotes: async (companyId?: number, matchboxId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/admin/notes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (matchboxId !== undefined) {
                localVarQueryParameter['matchbox_id'] = matchboxId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 仕様するsortキー * ピックアップ日 created_at * 更新日 updated_at * みんなの意見 reactions * アクション has_action  並び順 1. statusが1でmw_statusが2か3以外 2. statusが2か6か7でmw_statusが2か3以外 3. statusが2か6か7でmw_statusが2 4. statusが1以外でmw_statusが3以外 5. statusが３でmw_status3以外 6. 1 ~ 5と7以外 7. statusが4か5かmw_statusが3
         * @summary 管理者オファー一覧
         * @param {string} limit 
         * @param {string} offset 
         * @param {string} sortBy 
         * @param {string} sortOrder 
         * @param {Array<number>} [status] ステータス。DirectまたはMWアカウントのみ利用可 Arrayで送る為、status[]。
         * @param {number} [rate] マッチ度。Directアカウントのみ利用可。
         * @param {number} [job] 職種。Directアカウントのみ利用可。
         * @param {string} [matchboxId] MWアカウントのみ利用可。求職者へのオファー一覧
         * @param {1 | 2 | 3} [mwStatus] MWアカウントのみ利用可。対応状況
         * @param {string} [companyName] MWアカウントのみ利用可。企業名
         * @param {string} [name] MWアカウントのみ利用可。求職者名
         * @param {number} [companyId] MWアカウントのみ利用可。企業id
         * @param {string} [offerId] OfferデータID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminOffers: async (limit: string, offset: string, sortBy: string, sortOrder: string, status?: Array<number>, rate?: number, job?: number, matchboxId?: string, mwStatus?: 1 | 2 | 3, companyName?: string, name?: string, companyId?: number, offerId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getAdminOffers', 'limit', limit)
            // verify required parameter 'offset' is not null or undefined
            assertParamExists('getAdminOffers', 'offset', offset)
            // verify required parameter 'sortBy' is not null or undefined
            assertParamExists('getAdminOffers', 'sortBy', sortBy)
            // verify required parameter 'sortOrder' is not null or undefined
            assertParamExists('getAdminOffers', 'sortOrder', sortOrder)
            const localVarPath = `/api/v2/admin/offers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (status) {
                localVarQueryParameter['status[]'] = status;
            }

            if (rate !== undefined) {
                localVarQueryParameter['rate'] = rate;
            }

            if (job !== undefined) {
                localVarQueryParameter['job'] = job;
            }

            if (matchboxId !== undefined) {
                localVarQueryParameter['matchbox_id'] = matchboxId;
            }

            if (mwStatus !== undefined) {
                localVarQueryParameter['mw_status'] = mwStatus;
            }

            if (companyName !== undefined) {
                localVarQueryParameter['company_name'] = companyName;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['company_id'] = companyId;
            }

            if (offerId !== undefined) {
                localVarQueryParameter['offer_id'] = offerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * * 公開されているポートフォリオの作品のリストを取得します
         * @summary 求職者の公開ポートフォリオ作品リスト
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminPortfolio: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getAdminPortfolio', 'userId', userId)
            const localVarPath = `/api/v2/admin/portfolio/{UserId}`
                .replace(`{${"UserId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adminユーザー向けの公開ポートフォリオ作品リストページをPDF化します。 該当URLは `/admin/portfolio/{UserMatchboxId}`
         * @summary 求職者の公開ポートフォリオ作品リストPDFダウンロード
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAdminPortfolioDownload: async (userMatchboxId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userMatchboxId' is not null or undefined
            assertParamExists('getAdminPortfolioDownload', 'userMatchboxId', userMatchboxId)
            const localVarPath = `/api/v2/admin/portfolio/{UserMatchboxId}/download`
                .replace(`{${"UserMatchboxId"}}`, encodeURIComponent(String(userMatchboxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * PDFダウンロード
         * @summary ポートフォリオPDFダウンロード
         * @param {number} pDFTicketID PDF生成ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminPortfolioDownloadPdf: async (pDFTicketID: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pDFTicketID' is not null or undefined
            assertParamExists('getAdminPortfolioDownloadPdf', 'pDFTicketID', pDFTicketID)
            const localVarPath = `/api/v2/admin/rtfolio/download-pdf/{PDFTicketID}`
                .replace(`{${"PDFTicketID"}}`, encodeURIComponent(String(pDFTicketID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * PDFの生成をリクエスト
         * @summary ポートフォリオPDF生成をリクエスト
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminPortfolioRequestToGeneratePdf: async (userMatchboxId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userMatchboxId' is not null or undefined
            assertParamExists('getAdminPortfolioRequestToGeneratePdf', 'userMatchboxId', userMatchboxId)
            const localVarPath = `/api/v2/admin/portfolio/{UserMatchboxId}/request-to-generate-pdf`
                .replace(`{${"UserMatchboxId"}}`, encodeURIComponent(String(userMatchboxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * PDF生成のステータスを確認
         * @summary ポートフォリオPDF生成ステータス確認
         * @param {number} pDFTicketID PDF生成ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminPortfolioStatusOfPdf: async (pDFTicketID: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pDFTicketID' is not null or undefined
            assertParamExists('getAdminPortfolioStatusOfPdf', 'pDFTicketID', pDFTicketID)
            const localVarPath = `/api/v2/admin/portfolio/status-of-pdf/{PDFTicketID}`
                .replace(`{${"PDFTicketID"}}`, encodeURIComponent(String(pDFTicketID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ピックアップに対する社員の反応を取得する
         * @summary リアクション一覧
         * @param {string} offerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminReactions: async (offerId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offerId' is not null or undefined
            assertParamExists('getAdminReactions', 'offerId', offerId)
            const localVarPath = `/api/v2/admin/reactions/{offer_id}`
                .replace(`{${"offer_id"}}`, encodeURIComponent(String(offerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 履歴書情報・一覧取得
         * @summary 履歴書情報・一覧取得
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminResume: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getAdminResume', 'userId', userId)
            const localVarPath = `/api/v2/admin/resume/{UserId}`
                .replace(`{${"UserId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adminユーザー向けの履歴書情報ページをPDF化します。 該当URLは `/admin/resume/{UserMatchboxId}`
         * @summary 求職者の履歴書情報PDFダウンロード
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminResumeDownload: async (userMatchboxId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userMatchboxId' is not null or undefined
            assertParamExists('getAdminResumeDownload', 'userMatchboxId', userMatchboxId)
            const localVarPath = `/api/v2/admin/resume/{UserMatchboxId}/download`
                .replace(`{${"UserMatchboxId"}}`, encodeURIComponent(String(userMatchboxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 検索条件を取得
         * @summary マイナビ向け検索条件詳細
         * @param {number} adminSearchConditionId マイナビ向け検索条件のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminSearchConditionId: async (adminSearchConditionId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminSearchConditionId' is not null or undefined
            assertParamExists('getAdminSearchConditionId', 'adminSearchConditionId', adminSearchConditionId)
            const localVarPath = `/api/v2/admin/search_condition/{AdminSearchConditionId}`
                .replace(`{${"AdminSearchConditionId"}}`, encodeURIComponent(String(adminSearchConditionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * マイナビ向け保存検索条件一覧
         * @summary マイナビ向け保存した検索条件一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminSearchConditions: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/admin/search_conditions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ログインユーザー情報取得  v1では一般ユーザーに管理者権限を与えてる形でアカウントを発行していたがv2からはセキュリティ強化のため一般ユーザーと管理者のデータは明確に分けることになったため管理者アカウントを発行するのはシステム側に依頼し手動で発行するものとする。  アカウント発行時は以下の情報をシステム側に依頼する  ・メールアドレス ・名前 ・部署名 ・役職名 ・アイコン画像 ・種別  種別はadminひとつになるが内部的に以下を振り分けるため登録時に指定する。  MW_A：マイナビ（MATCHBOXの専任者）_マイナビ向けのメールが全部飛んでくる人 MW_B：マイナビ（MATCHBOXに登録されてる各企業担当者）_担当する企業に関わるメールだけが飛んでくる人
         * @summary ログインユーザー情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminUser: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/admin/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 求職者の情報詳細を取得
         * @summary 求職者情報詳細
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminUserId: async (userMatchboxId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userMatchboxId' is not null or undefined
            assertParamExists('getAdminUserId', 'userMatchboxId', userMatchboxId)
            const localVarPath = `/api/v2/admin/user/{UserMatchboxId}`
                .replace(`{${"UserMatchboxId"}}`, encodeURIComponent(String(userMatchboxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * タグ詳細
         * @summary タグ詳細
         * @param {string} userTagId ユーザータグID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminUserTagId: async (userTagId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userTagId' is not null or undefined
            assertParamExists('getAdminUserTagId', 'userTagId', userTagId)
            const localVarPath = `/api/v2/admin/user_tag/{UserTagId}`
                .replace(`{${"UserTagId"}}`, encodeURIComponent(String(userTagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 保存されてる検索条件に紐づくタグ一覧 レスポンスの構造は求職者詳細用のタグと同じ 企業向けの検索条件のみに紐づく
         * @summary 検索条件に保存された求職者タグ一覧
         * @param {string} [searchConditionId] 保存した検索条件のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminUserTagToSearchResult: async (searchConditionId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/admin/direct/user_tag_to_search_result`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchConditionId !== undefined) {
                localVarQueryParameter['search_condition_id'] = searchConditionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * タグ一覧  全件取得
         * @summary タグ一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminUserTags: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/admin/user_tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 指定した求職者に紐づいているタグ一覧 active が true のものだけ
         * @summary 求職者タグ一覧
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminUserTagsMbid: async (userMatchboxId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userMatchboxId' is not null or undefined
            assertParamExists('getAdminUserTagsMbid', 'userMatchboxId', userMatchboxId)
            const localVarPath = `/api/v2/admin/user_tag_mbid/{UserMatchboxId}`
                .replace(`{${"UserMatchboxId"}}`, encodeURIComponent(String(userMatchboxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * `skills` `careers` `qualifications`は（職務経歴書用の内部的なorder番号がない場合）order番号を持つデータの一番後ろから表示します。  新たにPATCHを送信した際に、内部的なorder番号を更新します。
         * @summary 求職者職務経歴書更新
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {CareerHistory} [careerHistory] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminCareerHistory: async (userId: string, careerHistory?: CareerHistory, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('patchAdminCareerHistory', 'userId', userId)
            const localVarPath = `/api/v2/admin/career_history/{UserId}`
                .replace(`{${"UserId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(careerHistory, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 企業情報編集
         * @summary 企業情報編集
         * @param {string} directCompanyId 内部的な企業ID
         * @param {AdminCompany} [adminCompany] * 会社の状態( status )   * active / アクティブ   * inactive / 停止   * before_delete / 退会。ヶ月で削除されるかどうか確認中
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminCompany: async (directCompanyId: string, adminCompany?: AdminCompany, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'directCompanyId' is not null or undefined
            assertParamExists('patchAdminCompany', 'directCompanyId', directCompanyId)
            const localVarPath = `/api/v2/admin/company/{DirectCompanyId}`
                .replace(`{${"DirectCompanyId"}}`, encodeURIComponent(String(directCompanyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCompany, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 検索条件のメール配信設定変更する
         * @summary 検索条件のメール配信設定変更
         * @param {number} directSearchConditionId Directの検索条件ID
         * @param {InlineObject1} [inlineObject1] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminDirectMailId: async (directSearchConditionId: number, inlineObject1?: InlineObject1, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'directSearchConditionId' is not null or undefined
            assertParamExists('patchAdminDirectMailId', 'directSearchConditionId', directSearchConditionId)
            const localVarPath = `/api/v2/admin/direct_mail/{DirectSearchConditionId}`
                .replace(`{${"DirectSearchConditionId"}}`, encodeURIComponent(String(directSearchConditionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 検索条件を編集
         * @summary 企業向け検索条件更新
         * @param {number} adminDirectSearchConditionId 管理者用のDirect向け検索条件のID
         * @param {DirectSearchConditionRequest} [directSearchConditionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminDirectSearchConditionId: async (adminDirectSearchConditionId: number, directSearchConditionRequest?: DirectSearchConditionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminDirectSearchConditionId' is not null or undefined
            assertParamExists('patchAdminDirectSearchConditionId', 'adminDirectSearchConditionId', adminDirectSearchConditionId)
            const localVarPath = `/api/v2/admin/direct/search_condition/{AdminDirectSearchConditionId}`
                .replace(`{${"AdminDirectSearchConditionId"}}`, encodeURIComponent(String(adminDirectSearchConditionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(directSearchConditionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 並び替え
         * @summary 企業向け保存した検索条件一覧の並び替え
         * @param {InlineObject5} [inlineObject5] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminDirectSearchConditions: async (inlineObject5?: InlineObject5, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/admin/direct/search_conditions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject5, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 求職者の入力代行サービスの登録状況を更新する
         * @summary 求職者入力代行情報更新
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {InlineObject8} [inlineObject8] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminInputAgency: async (userMatchboxId: string, inlineObject8?: InlineObject8, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userMatchboxId' is not null or undefined
            assertParamExists('patchAdminInputAgency', 'userMatchboxId', userMatchboxId)
            const localVarPath = `/api/v2/admin/input_agency/{UserMatchboxId}`
                .replace(`{${"UserMatchboxId"}}`, encodeURIComponent(String(userMatchboxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject8, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * `skills` `careers` `qualifications`は（職務経歴書用の内部的なorder番号がない場合）order番号を持つデータの一番後ろから表示します。  新たにPATCHを送信した際に、内部的なorder番号を更新します。
         * @summary 入力代行職務経歴書更新
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {CareerHistory} [careerHistory] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminInputAgencyCareerHistory: async (userId: string, careerHistory?: CareerHistory, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('patchAdminInputAgencyCareerHistory', 'userId', userId)
            const localVarPath = `/api/v2/admin/input_agency/career_history/{UserId}`
                .replace(`{${"UserId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(careerHistory, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 入力代行職務経歴・編集
         * @summary 入力代行職務経歴・編集
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {Career} [career] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminInputAgencyCareerHistoryUserIdCareers: async (userId: string, career?: Career, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('patchAdminInputAgencyCareerHistoryUserIdCareers', 'userId', userId)
            const localVarPath = `/api/v2/admin/input_agency/career_history/{UserId}/careers`
                .replace(`{${"UserId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(career, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 入力代行資格/免許・更新
         * @summary 入力代行資格/免許・更新
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {Qualification} [qualification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminInputAgencyCareerHistoryUserIdQualifications: async (userId: string, qualification?: Qualification, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('patchAdminInputAgencyCareerHistoryUserIdQualifications', 'userId', userId)
            const localVarPath = `/api/v2/admin/input_agency/career_history/{UserId}/qualifications`
                .replace(`{${"UserId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(qualification, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * * 履歴書作成に必要な情報を更新する * 資格、学歴、職務経歴の情報は多いので、送信時には省く（レスポンスには返ってくる） * 資格、職務経歴の表示順序は、内部的に履歴書用のorder番号を持ち、職務経歴書とは別に独立して保存します。  ---  新たな職歴などが追加された場合（履歴書用の内部的なorder番号がない場合）order番号を持つ職歴の一番後ろから表示します。履歴書編集画面で並び替えを行いPATCHを送信した際に、order番号を更新します。
         * @summary 入力代行履歴書更新
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {Resume} [resume] 証明写真 user.user_info.photo は以下の形式でリクエストする  &#x60;&#x60;&#x60; {   f_id: \&quot;POST /api/v2/files で返ってきた f_id\&quot; } &#x60;&#x60;&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminInputAgencyResume: async (userId: string, resume?: Resume, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('patchAdminInputAgencyResume', 'userId', userId)
            const localVarPath = `/api/v2/admin/input_agency/resume/{UserId}`
                .replace(`{${"UserId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resume, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 入力代行学歴・編集
         * @summary 入力代行学歴・編集
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {EducationPatchRequest} [educationPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminInputAgencyResumeUserIdEducations: async (userId: string, educationPatchRequest?: EducationPatchRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('patchAdminInputAgencyResumeUserIdEducations', 'userId', userId)
            const localVarPath = `/api/v2/admin/input_agency/resume/{UserId}/educations`
                .replace(`{${"UserId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(educationPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 自社アカウントが書いたメモを既読にする
         * @summary メモを既読にする
         * @param {AdminNotePatchParam} [adminNotePatchParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminNote: async (adminNotePatchParam?: AdminNotePatchParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/admin/note`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminNotePatchParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * mwの対応状況を変更する
         * @summary オファーの承認・非承認
         * @param {OfferPatchParam} [offerPatchParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminOffer: async (offerPatchParam?: OfferPatchParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/admin/offer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(offerPatchParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 検索条件を編集
         * @summary マイナビ向け検索条件更新
         * @param {number} adminSearchConditionId マイナビ向け検索条件のID
         * @param {AdminSearchConditionRequest} [adminSearchConditionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminSearchConditionId: async (adminSearchConditionId: number, adminSearchConditionRequest?: AdminSearchConditionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminSearchConditionId' is not null or undefined
            assertParamExists('patchAdminSearchConditionId', 'adminSearchConditionId', adminSearchConditionId)
            const localVarPath = `/api/v2/admin/search_condition/{AdminSearchConditionId}`
                .replace(`{${"AdminSearchConditionId"}}`, encodeURIComponent(String(adminSearchConditionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminSearchConditionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 並び替え
         * @summary マイナビ向け保存した検索条件一覧の並び替え
         * @param {InlineObject3} [inlineObject3] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminSearchConditions: async (inlineObject3?: InlineObject3, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/admin/search_conditions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject3, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * * 求職者ユーザーの情報の変更 * 変更があったものだけを送信するようにしたい * PUTしたら、GETした時と同じ情報が返ってくる * アカウント停止/非アクティブ化も行えるようにする * DS-USER-INFO-ADDITINAL に追加して user_status と status (ポートフォリオの公開状態)を変更できるように * 返り値は DS-USER-INFO-ADDITINAL に追加して user_status, user_entry_id, status, portfolio_progress, resume_progress がかえるように
         * @summary 求職者情報変更
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {AdminMatchboxUserRequest} [adminMatchboxUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminUserId: async (userMatchboxId: string, adminMatchboxUserRequest?: AdminMatchboxUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userMatchboxId' is not null or undefined
            assertParamExists('patchAdminUserId', 'userMatchboxId', userMatchboxId)
            const localVarPath = `/api/v2/admin/user/{UserMatchboxId}`
                .replace(`{${"UserMatchboxId"}}`, encodeURIComponent(String(userMatchboxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminMatchboxUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * タグ変更
         * @summary タグ 変更
         * @param {string} userTagId ユーザータグID
         * @param {UserTagPatchParam} [userTagPatchParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminUserTagId: async (userTagId: string, userTagPatchParam?: UserTagPatchParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userTagId' is not null or undefined
            assertParamExists('patchAdminUserTagId', 'userTagId', userTagId)
            const localVarPath = `/api/v2/admin/user_tag/{UserTagId}`
                .replace(`{${"UserTagId"}}`, encodeURIComponent(String(userTagId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userTagPatchParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * タグ並び替え
         * @summary タグ一覧 並び順変更
         * @param {UserTagsPatchParam} [userTagsPatchParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminUserTags: async (userTagsPatchParam?: UserTagsPatchParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/admin/user_tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userTagsPatchParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * タグ変更 送らなかったものは削除
         * @summary 求職者 タグ一覧 変更
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {UserTagsPatchParam} [userTagsPatchParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminUserTagsMbid: async (userMatchboxId: string, userTagsPatchParam?: UserTagsPatchParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userMatchboxId' is not null or undefined
            assertParamExists('patchAdminUserTagsMbid', 'userMatchboxId', userMatchboxId)
            const localVarPath = `/api/v2/admin/user_tag_mbid/{UserMatchboxId}`
                .replace(`{${"UserMatchboxId"}}`, encodeURIComponent(String(userMatchboxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userTagsPatchParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 紐付けする企業検索  マイナビ管理画面から企業情報登録時に紐づける企業情報のプロパティ名が block_company_id なのは求職者がブロック対象にする企業を検索するときは外部からインポートした企業情報を登録するためでその法人番号 が block_company_id と定義してる。  MATCHBOX DIRECT を使用する企業 company とその block_company_id が紐づいていないと、ブロックしたはずの企業に求職者情報が表示されてしまうので、企業側も法人番号と紐付けをしている。  また複数設定できるのはある会社(A)をある求職者(X)がブロックしていたと後にA社が分社化してB社ができた場合、求職者Xのブロックする企業にB社も入れないため複数企業を紐づけられるようになっている。  法人番号のカラム名が block_company_id なのは company と分けるため block_companies というDB に入れているため。
         * @summary 紐付けする企業検索
         * @param {BlockCompanyPostParam} [blockCompanyPostParam] &#x60;sort_by&#x60;は&#x60;kana&#x60;を送る想定
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminBlockCompanies: async (blockCompanyPostParam?: BlockCompanyPostParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/admin/block_companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(blockCompanyPostParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * idは登録時に不要
         * @summary 企業登録
         * @param {AdminCompanyPostParam} [adminCompanyPostParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminCompany: async (adminCompanyPostParam?: AdminCompanyPostParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/admin/company`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCompanyPostParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * パスワードを変更します 仕様は冒頭説明箇所を参照
         * @summary 企業ユーザーパスワード変更
         * @param {string} directMatchboxId 企業ユーザーID （B+数字乱数8桁）
         * @param {InlineObject} [inlineObject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminCompanyUserPasswordChange: async (directMatchboxId: string, inlineObject?: InlineObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'directMatchboxId' is not null or undefined
            assertParamExists('postAdminCompanyUserPasswordChange', 'directMatchboxId', directMatchboxId)
            const localVarPath = `/api/v2/admin/company_user/{DirectMatchboxId}/password_change`
                .replace(`{${"DirectMatchboxId"}}`, encodeURIComponent(String(directMatchboxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ## sort_by項目  - registration
         * @summary Direct企業検索
         * @param {AdminSearchCompaniesRequest} [adminSearchCompaniesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminDirectCompanies: async (adminSearchCompaniesRequest?: AdminSearchCompaniesRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/admin/search_companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminSearchCompaniesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 管理者用の企業向け検索条件保存  マイナビ向けの検索条件とは別途保存  ## バックエンド仕様について  バックエンド側では検索条件を JSON でそのまま DB に登録しているので基本的に保存時のリクエストデータの変更に関してはバックエンドに依頼する必要はない。  そのため基本的にどのような構造のデータでも入れることは可能だが検索側のリクエストパラメーターと合わせる必要はあるのでこちらの構造を変更する場合は合わせて検索側も対応しバックエンド側に依頼する。
         * @summary 企業向け検索条件保存
         * @param {DirectSearchConditionRequest} [directSearchConditionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminDirectSearchCondition: async (directSearchConditionRequest?: DirectSearchConditionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/admin/direct/search_condition`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(directSearchConditionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ## sort_by  - アカウント開設日 registration_date - 最終ログイン日 last_login - 転職希望時期 mc_preferred_change_date - ポートフォリオ作品数 portfolio_item_count
         * @summary 企業向けユーザー検索
         * @param {DirectSearchUserRequest} [directSearchUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminDirectSearchUsers: async (directSearchUserRequest?: DirectSearchUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/admin/direct/search_users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(directSearchUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * c_id はないので、null で送信する 
         * @summary 入力代行職務経歴・追加
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {Career} [career] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminInputAgencyCareerHistoryUserIdCareers: async (userId: string, career?: Career, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('postAdminInputAgencyCareerHistoryUserIdCareers', 'userId', userId)
            const localVarPath = `/api/v2/admin/input_agency/career_history/{UserId}/careers`
                .replace(`{${"UserId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(career, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * q_id はないので、null で送信する
         * @summary 入力代行資格/免許・追加
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {Qualification} [qualification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminInputAgencyCareerHistoryUserIdQualifications: async (userId: string, qualification?: Qualification, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('postAdminInputAgencyCareerHistoryUserIdQualifications', 'userId', userId)
            const localVarPath = `/api/v2/admin/input_agency/career_history/{UserId}/qualifications`
                .replace(`{${"UserId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(qualification, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 新規なのでe_id は空文字で送信
         * @summary 入力代行学歴・追加
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {EducationPostRequest} [educationPostRequest] 入力代行学歴・追加
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminInputAgencyResumeUserIdEducations: async (userId: string, educationPostRequest?: EducationPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('postAdminInputAgencyResumeUserIdEducations', 'userId', userId)
            const localVarPath = `/api/v2/admin/input_agency/resume/{UserId}/educations`
                .replace(`{${"UserId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(educationPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ログインをする  ## 開発サーバーテストアカウント  ID : matchbox-dev-notify+dockertestadmin@s2factory.co.jp  PW : test  v1では一般ユーザーに管理者権限を与えてる形でアカウントを発行していたがv2からはセキュリティ強化のため一般ユーザーと管理者のデータは明確に分けることになったため管理者アカウントを発行するのはシステム側に依頼し手動で発行するものとする。
         * @summary 管理者ログイン
         * @param {string} email メールアドレス
         * @param {string} password パスワード
         * @param {string} [type] 以前の as_ca&#x3D;1 と同様。 caとownerがある
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminLogin: async (email: string, password: string, type?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('postAdminLogin', 'email', email)
            // verify required parameter 'password' is not null or undefined
            assertParamExists('postAdminLogin', 'password', password)
            const localVarPath = `/api/v2/admin/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (email !== undefined) { 
                localVarFormParams.set('email', email as any);
            }
    
            if (password !== undefined) { 
                localVarFormParams.set('password', password as any);
            }
    
            if (type !== undefined) { 
                localVarFormParams.set('type', type as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 企業・求職者へメモを残す
         * @summary 企業・求職者にメモを残す
         * @param {AdminNotePostParam} [adminNotePostParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminNote: async (adminNotePostParam?: AdminNotePostParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/admin/note`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminNotePostParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 管理者用の検索条件保存 Diret側とは項目が変わる  ## バックエンド仕様について  バックエンド側では検索条件を JSON でそのまま DB に登録しているので基本的に保存時のリクエストデータの変更に関してはバックエンドに依頼する必要はない。  そのため基本的にどのような構造のデータでも入れることは可能だが検索側のリクエストパラメーターと合わせる必要はあるのでこちらの構造を変更する場合は合わせて検索側も対応しバックエンド側に依頼する。
         * @summary マイナビ向け検索条件保存
         * @param {AdminSearchConditionRequest} [adminSearchConditionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminSearchCondition: async (adminSearchConditionRequest?: AdminSearchConditionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/admin/search_condition`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminSearchConditionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * * 管理ツールなので、少しくらい遅くてもフリーワード検索は実現させたい * age は計算が必要なので毎日１度計算しておく  ## sort_by  - アカウント開設日 registration_date - 最終ログイン日 last_login - 転職希望時期 mc_preferred_change_date - ポートフォリオ作品数 portfolio_item_count
         * @summary マイナビ向けユーザー検索
         * @param {AdminSearchUserRequest} [adminSearchUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminSearchUsers: async (adminSearchUserRequest?: AdminSearchUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/admin/search_users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminSearchUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 特定のadminユーザーが求職者検索を行い、 matchbox_idに該当する求職者が検索結果に表示された際のis_readプロパティをtrueに  管理画面はマイナビ向けと企業向けのユーザー検索があるが情報は共有するものとする  ## ユーザー情報の更新を監視する項目  求職者が以下情報を更新すると該当ユーザーのis_readをfalseに  - ポートフォリオ - 履歴書 - 職務経歴 - マイナビクリエイター希望項目 - ユーザー情報
         * @summary 検索結果表示求職者ユーザーの既読状態を更新
         * @param {InlineObject4} [inlineObject4] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminSearchUsersRead: async (inlineObject4?: InlineObject4, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/admin/search_users/read`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject4, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * * POST /admin/search_users/ と同じパラメータを使うことができる * 叩いた後にはCSVがダウンロードされる
         * @summary ユーザー 検索 CSV ダウンロード
         * @param {string} [contentTypeApplicationJsonCharsetUTF8] 
         * @param {Pagination & SearchUsers | SearchUsersByDirect} [paginationSearchUsersSearchUsersByDirect] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminSearchUsersToCsv: async (contentTypeApplicationJsonCharsetUTF8?: string, paginationSearchUsersSearchUsersByDirect?: Pagination & SearchUsers | SearchUsersByDirect, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/admin/search_users_to_csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (contentTypeApplicationJsonCharsetUTF8 !== undefined && contentTypeApplicationJsonCharsetUTF8 !== null) {
                localVarHeaderParameter['Content-Type: application/json; charset&#x3D;UTF-8'] = String(contentTypeApplicationJsonCharsetUTF8);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paginationSearchUsersSearchUsersByDirect, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 保存した検索条件を企業におすすめする  選択条件に対して既に登録済みの企業が含まれていても送信可能に。 重複して登録はマージする
         * @summary 企業に検索条件をおすすめする
         * @param {InlineObject6} [inlineObject6] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminSuggest: async (inlineObject6?: InlineObject6, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/admin/suggest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject6, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * * ファイルのアップロード行う * アップロードが完了後、サムネイルのURLとファイルのIDを返す
         * @summary 画像などのファイルアップロード
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {any} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminUserIdFiles: async (userId: string, files: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('postAdminUserIdFiles', 'userId', userId)
            // verify required parameter 'files' is not null or undefined
            assertParamExists('postAdminUserIdFiles', 'files', files)
            const localVarPath = `/api/v2/admin/files/{UserId}`
                .replace(`{${"UserId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (files !== undefined) { 
                localVarFormParams.append('files', files as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 求職者のパスワードを変更します 仕様は冒頭説明箇所を参照
         * @summary 求職者パスワード変更
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {InlineObject7} [inlineObject7] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminUserPasswordChange: async (userMatchboxId: string, inlineObject7?: InlineObject7, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userMatchboxId' is not null or undefined
            assertParamExists('postAdminUserPasswordChange', 'userMatchboxId', userMatchboxId)
            const localVarPath = `/api/v2/admin/user/{UserMatchboxId}/password_change`
                .replace(`{${"UserMatchboxId"}}`, encodeURIComponent(String(userMatchboxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject7, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * タグ作成
         * @summary タグ新規作成
         * @param {UserTagParam} [userTagParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminUserTag: async (userTagParam?: UserTagParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/admin/user_tag`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userTagParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 保存されてる検索条件に対してタグを一括保存 企業向けの検索条件のみに紐づく
         * @summary 検索条件への求職者タグ一括保存
         * @param {UserTagToSearchResultBatchSaveParam} [userTagToSearchResultBatchSaveParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminUserTagToSearchResult: async (userTagToSearchResultBatchSaveParam?: UserTagToSearchResultBatchSaveParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/admin/direct/user_tag_to_search_result`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userTagToSearchResultBatchSaveParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ADMINApi - functional programming interface
 * @export
 */
export const ADMINApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ADMINApiAxiosParamCreator(configuration)
    return {
        /**
         * 検索条件を削除
         * @summary 企業向け検索条件削除
         * @param {number} adminDirectSearchConditionId 管理者用のDirect向け検索条件のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAdminDirectSearchConditionId(adminDirectSearchConditionId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAdminDirectSearchConditionId(adminDirectSearchConditionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 入力代行職務経歴・削除
         * @summary 入力代行職務経歴・削除
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {string} careerId 職歴ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAdminInputAgencyCareerHistoryCareers(userId: string, careerId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAdminInputAgencyCareerHistoryCareers(userId, careerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 入力代行プロジェクト・削除
         * @summary 入力代行プロジェクト・削除
         * @param {string} projectId プロジェクトID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAdminInputAgencyCareerHistoryProjects(projectId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAdminInputAgencyCareerHistoryProjects(projectId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 入力代行資格/免許・削除
         * @summary 入力代行資格/免許・削除
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {string} qualificationId 資格ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAdminInputAgencyCareerHistoryQualifications(userId: string, qualificationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAdminInputAgencyCareerHistoryQualifications(userId, qualificationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 入力代行スキル削除
         * @summary 入力代行スキル削除
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {string} skillId スキルID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAdminInputAgencyCareerHistorySkill(userId: string, skillId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAdminInputAgencyCareerHistorySkill(userId, skillId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 入力代行学歴・削除
         * @summary 入力代行学歴・削除
         * @param {string} educationId 学歴ID
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAdminInputAgencyResumeUserIdEducations(educationId: string, userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EducationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAdminInputAgencyResumeUserIdEducations(educationId, userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * メモを削除する
         * @summary メモを削除する
         * @param {number} noteId noteのid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAdminNote(noteId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAdminNote(noteId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 検索条件を削除
         * @summary マイナビ向け検索条件削除
         * @param {number} adminSearchConditionId マイナビ向け検索条件のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAdminSearchConditionId(adminSearchConditionId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAdminSearchConditionId(adminSearchConditionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 企業におすすめした検索条件を取り消す
         * @summary 企業におすすめした検索条件を取り消す
         * @param {number} directSearchConditionId Directの検索条件ID
         * @param {string} directCompanyId 内部的な企業ID
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAdminSuggestId(directSearchConditionId: number, directCompanyId: string, body?: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAdminSuggestId(directSearchConditionId, directCompanyId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 即時削除処理を行う  退会処理は別？要確認
         * @summary 求職者削除
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAdminUserId(userMatchboxId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAdminUserId(userMatchboxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * * ファイルの削除を行う
         * @summary 画像などのファイル削除
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {string} fileId アップロード時に返却されるファイルID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAdminUserIdFiles(userId: string, fileId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAdminUserIdFiles(userId, fileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * タグ削除
         * @summary タグ 削除
         * @param {string} userTagId ユーザータグID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAdminUserTagId(userTagId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAdminUserTagId(userTagId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * * サイト概要を確認するAPI、Daily, Weekly, Monthly,で確認する。 * 期間指定をするので、処理が重くなっても、指定された期日は全部出す * 完成度は portfolio_progress / resume_progress の値をもとに計算する   * それぞれに 10個の true, false が入ってるので、trueが1つ10%になる   * true の数ｘ10 で計算すれば良くて端数は基本でない * GET だとURLエンコード必要なので注意。POSTでもいいかも。
         * @summary サイト概要 取得
         * @param {string} type 概要抽出のタイプ
         * @param {string} term 期間は毎回指定してください。
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getAdminAnalysisOverview(type: string, term: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnalysisResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminAnalysisOverview(type, term, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 職務経歴書
         * @summary 職務経歴書
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminCareerHistory(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CareerHistory & Status & UserInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminCareerHistory(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Adminユーザー向けの職務経歴書ページをPDF化します。 該当URLは `/admin/cv/{UserMatchboxId}`
         * @summary 求職者の職務経歴書PDFダウンロード
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminCareerHistoryDownload(userMatchboxId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminCareerHistoryDownload(userMatchboxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 企業情報
         * @summary 企業情報
         * @param {string} directCompanyId 内部的な企業ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminCompany(directCompanyId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Status & object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminCompany(directCompanyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * `direct_*` or `admin` アカウントからGET可能
         * @summary 企業ユーザー情報詳細
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminCompanyUser(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyUser & Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminCompanyUser(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 企業内ユーザー一覧
         * @summary 企業内ユーザー一覧
         * @param {string} limit 
         * @param {string} offset 
         * @param {string} sortBy 
         * @param {string} sortOrder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminCompanyUsers(limit: string, offset: string, sortBy: string, sortOrder: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object & PaginationOffset & Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminCompanyUsers(limit, offset, sortBy, sortOrder, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 検索条件を取得
         * @summary 企業向け検索条件詳細
         * @param {number} adminDirectSearchConditionId 管理者用のDirect向け検索条件のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminDirectSearchConditionId(adminDirectSearchConditionId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DirectSearchConditionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminDirectSearchConditionId(adminDirectSearchConditionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * # 仕様 - 保存されている情報は全てDirect側の「Matchboxのおすすめ検索」に表示する - メール配信設定を紐付けられた企業には検索条件のデータが変更されたらメールを送信
         * @summary 企業向け保存した検索条件一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminDirectSearchConditions(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminDirectSearchConditionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminDirectSearchConditions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 求職者の入力代行サービスの登録状況を取得する
         * @summary 求職者入力代行情報取得
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminInputAgency(userMatchboxId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InputAgencyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminInputAgency(userMatchboxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 入力代行職務経歴書取得
         * @summary 入力代行職務経歴書取得
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminInputAgencyCareerHistory(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CareerHistory & Status & UserInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminInputAgencyCareerHistory(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 入力代行履歴書取得
         * @summary 入力代行履歴書取得
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminInputAgencyResume(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Resume & Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminInputAgencyResume(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ログイン状態を見る 必要な情報は精査
         * @summary 管理者のログイン状態
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminIsLogin(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserIsLogin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminIsLogin(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ログアウトをする 
         * @summary 管理者ログアウト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminLogout(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminLogout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 企業・求職者に送信したメモ一覧
         * @summary 企業・求職者に送信したメモ一覧
         * @param {number} [companyId] CAのみ利用可能
         * @param {string} [matchboxId] 求職者 ID B + 8桁乱数
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminNotes(companyId?: number, matchboxId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminNotesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminNotes(companyId, matchboxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 仕様するsortキー * ピックアップ日 created_at * 更新日 updated_at * みんなの意見 reactions * アクション has_action  並び順 1. statusが1でmw_statusが2か3以外 2. statusが2か6か7でmw_statusが2か3以外 3. statusが2か6か7でmw_statusが2 4. statusが1以外でmw_statusが3以外 5. statusが３でmw_status3以外 6. 1 ~ 5と7以外 7. statusが4か5かmw_statusが3
         * @summary 管理者オファー一覧
         * @param {string} limit 
         * @param {string} offset 
         * @param {string} sortBy 
         * @param {string} sortOrder 
         * @param {Array<number>} [status] ステータス。DirectまたはMWアカウントのみ利用可 Arrayで送る為、status[]。
         * @param {number} [rate] マッチ度。Directアカウントのみ利用可。
         * @param {number} [job] 職種。Directアカウントのみ利用可。
         * @param {string} [matchboxId] MWアカウントのみ利用可。求職者へのオファー一覧
         * @param {1 | 2 | 3} [mwStatus] MWアカウントのみ利用可。対応状況
         * @param {string} [companyName] MWアカウントのみ利用可。企業名
         * @param {string} [name] MWアカウントのみ利用可。求職者名
         * @param {number} [companyId] MWアカウントのみ利用可。企業id
         * @param {string} [offerId] OfferデータID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminOffers(limit: string, offset: string, sortBy: string, sortOrder: string, status?: Array<number>, rate?: number, job?: number, matchboxId?: string, mwStatus?: 1 | 2 | 3, companyName?: string, name?: string, companyId?: number, offerId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OffersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminOffers(limit, offset, sortBy, sortOrder, status, rate, job, matchboxId, mwStatus, companyName, name, companyId, offerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * * 公開されているポートフォリオの作品のリストを取得します
         * @summary 求職者の公開ポートフォリオ作品リスト
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminPortfolio(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Portfolio & Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminPortfolio(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Adminユーザー向けの公開ポートフォリオ作品リストページをPDF化します。 該当URLは `/admin/portfolio/{UserMatchboxId}`
         * @summary 求職者の公開ポートフォリオ作品リストPDFダウンロード
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getAdminPortfolioDownload(userMatchboxId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminPortfolioDownload(userMatchboxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * PDFダウンロード
         * @summary ポートフォリオPDFダウンロード
         * @param {number} pDFTicketID PDF生成ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminPortfolioDownloadPdf(pDFTicketID: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminPortfolioDownloadPdf(pDFTicketID, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * PDFの生成をリクエスト
         * @summary ポートフォリオPDF生成をリクエスト
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminPortfolioRequestToGeneratePdf(userMatchboxId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess & PDFTicketId>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminPortfolioRequestToGeneratePdf(userMatchboxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * PDF生成のステータスを確認
         * @summary ポートフォリオPDF生成ステータス確認
         * @param {number} pDFTicketID PDF生成ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminPortfolioStatusOfPdf(pDFTicketID: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PDFTicketStatus & ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminPortfolioStatusOfPdf(pDFTicketID, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ピックアップに対する社員の反応を取得する
         * @summary リアクション一覧
         * @param {string} offerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminReactions(offerId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReactionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminReactions(offerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 履歴書情報・一覧取得
         * @summary 履歴書情報・一覧取得
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminResume(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Resume & Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminResume(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Adminユーザー向けの履歴書情報ページをPDF化します。 該当URLは `/admin/resume/{UserMatchboxId}`
         * @summary 求職者の履歴書情報PDFダウンロード
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminResumeDownload(userMatchboxId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminResumeDownload(userMatchboxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 検索条件を取得
         * @summary マイナビ向け検索条件詳細
         * @param {number} adminSearchConditionId マイナビ向け検索条件のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminSearchConditionId(adminSearchConditionId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSearchConditionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminSearchConditionId(adminSearchConditionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * マイナビ向け保存検索条件一覧
         * @summary マイナビ向け保存した検索条件一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminSearchConditions(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSearchConditionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminSearchConditions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ログインユーザー情報取得  v1では一般ユーザーに管理者権限を与えてる形でアカウントを発行していたがv2からはセキュリティ強化のため一般ユーザーと管理者のデータは明確に分けることになったため管理者アカウントを発行するのはシステム側に依頼し手動で発行するものとする。  アカウント発行時は以下の情報をシステム側に依頼する  ・メールアドレス ・名前 ・部署名 ・役職名 ・アイコン画像 ・種別  種別はadminひとつになるが内部的に以下を振り分けるため登録時に指定する。  MW_A：マイナビ（MATCHBOXの専任者）_マイナビ向けのメールが全部飛んでくる人 MW_B：マイナビ（MATCHBOXに登録されてる各企業担当者）_担当する企業に関わるメールだけが飛んでくる人
         * @summary ログインユーザー情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminUser(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminUser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 求職者の情報詳細を取得
         * @summary 求職者情報詳細
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminUserId(userMatchboxId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminMatchboxUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminUserId(userMatchboxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * タグ詳細
         * @summary タグ詳細
         * @param {string} userTagId ユーザータグID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminUserTagId(userTagId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminUserTagResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminUserTagId(userTagId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 保存されてる検索条件に紐づくタグ一覧 レスポンスの構造は求職者詳細用のタグと同じ 企業向けの検索条件のみに紐づく
         * @summary 検索条件に保存された求職者タグ一覧
         * @param {string} [searchConditionId] 保存した検索条件のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminUserTagToSearchResult(searchConditionId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminUserTagsMatchboxIdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminUserTagToSearchResult(searchConditionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * タグ一覧  全件取得
         * @summary タグ一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminUserTags(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminUserTagsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminUserTags(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 指定した求職者に紐づいているタグ一覧 active が true のものだけ
         * @summary 求職者タグ一覧
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminUserTagsMbid(userMatchboxId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminUserTagsMatchboxIdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminUserTagsMbid(userMatchboxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * `skills` `careers` `qualifications`は（職務経歴書用の内部的なorder番号がない場合）order番号を持つデータの一番後ろから表示します。  新たにPATCHを送信した際に、内部的なorder番号を更新します。
         * @summary 求職者職務経歴書更新
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {CareerHistory} [careerHistory] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchAdminCareerHistory(userId: string, careerHistory?: CareerHistory, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CareerHistory & Status & UserInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchAdminCareerHistory(userId, careerHistory, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 企業情報編集
         * @summary 企業情報編集
         * @param {string} directCompanyId 内部的な企業ID
         * @param {AdminCompany} [adminCompany] * 会社の状態( status )   * active / アクティブ   * inactive / 停止   * before_delete / 退会。ヶ月で削除されるかどうか確認中
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchAdminCompany(directCompanyId: string, adminCompany?: AdminCompany, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCompany & Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchAdminCompany(directCompanyId, adminCompany, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 検索条件のメール配信設定変更する
         * @summary 検索条件のメール配信設定変更
         * @param {number} directSearchConditionId Directの検索条件ID
         * @param {InlineObject1} [inlineObject1] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchAdminDirectMailId(directSearchConditionId: number, inlineObject1?: InlineObject1, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchAdminDirectMailId(directSearchConditionId, inlineObject1, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 検索条件を編集
         * @summary 企業向け検索条件更新
         * @param {number} adminDirectSearchConditionId 管理者用のDirect向け検索条件のID
         * @param {DirectSearchConditionRequest} [directSearchConditionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchAdminDirectSearchConditionId(adminDirectSearchConditionId: number, directSearchConditionRequest?: DirectSearchConditionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchAdminDirectSearchConditionId(adminDirectSearchConditionId, directSearchConditionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 並び替え
         * @summary 企業向け保存した検索条件一覧の並び替え
         * @param {InlineObject5} [inlineObject5] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchAdminDirectSearchConditions(inlineObject5?: InlineObject5, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchAdminDirectSearchConditions(inlineObject5, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 求職者の入力代行サービスの登録状況を更新する
         * @summary 求職者入力代行情報更新
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {InlineObject8} [inlineObject8] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchAdminInputAgency(userMatchboxId: string, inlineObject8?: InlineObject8, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchAdminInputAgency(userMatchboxId, inlineObject8, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * `skills` `careers` `qualifications`は（職務経歴書用の内部的なorder番号がない場合）order番号を持つデータの一番後ろから表示します。  新たにPATCHを送信した際に、内部的なorder番号を更新します。
         * @summary 入力代行職務経歴書更新
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {CareerHistory} [careerHistory] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchAdminInputAgencyCareerHistory(userId: string, careerHistory?: CareerHistory, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CareerHistory & Status & UserInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchAdminInputAgencyCareerHistory(userId, careerHistory, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 入力代行職務経歴・編集
         * @summary 入力代行職務経歴・編集
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {Career} [career] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchAdminInputAgencyCareerHistoryUserIdCareers(userId: string, career?: Career, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object & Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchAdminInputAgencyCareerHistoryUserIdCareers(userId, career, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 入力代行資格/免許・更新
         * @summary 入力代行資格/免許・更新
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {Qualification} [qualification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchAdminInputAgencyCareerHistoryUserIdQualifications(userId: string, qualification?: Qualification, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object & Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchAdminInputAgencyCareerHistoryUserIdQualifications(userId, qualification, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * * 履歴書作成に必要な情報を更新する * 資格、学歴、職務経歴の情報は多いので、送信時には省く（レスポンスには返ってくる） * 資格、職務経歴の表示順序は、内部的に履歴書用のorder番号を持ち、職務経歴書とは別に独立して保存します。  ---  新たな職歴などが追加された場合（履歴書用の内部的なorder番号がない場合）order番号を持つ職歴の一番後ろから表示します。履歴書編集画面で並び替えを行いPATCHを送信した際に、order番号を更新します。
         * @summary 入力代行履歴書更新
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {Resume} [resume] 証明写真 user.user_info.photo は以下の形式でリクエストする  &#x60;&#x60;&#x60; {   f_id: \&quot;POST /api/v2/files で返ってきた f_id\&quot; } &#x60;&#x60;&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchAdminInputAgencyResume(userId: string, resume?: Resume, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Resume & ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchAdminInputAgencyResume(userId, resume, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 入力代行学歴・編集
         * @summary 入力代行学歴・編集
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {EducationPatchRequest} [educationPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchAdminInputAgencyResumeUserIdEducations(userId: string, educationPatchRequest?: EducationPatchRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EducationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchAdminInputAgencyResumeUserIdEducations(userId, educationPatchRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 自社アカウントが書いたメモを既読にする
         * @summary メモを既読にする
         * @param {AdminNotePatchParam} [adminNotePatchParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchAdminNote(adminNotePatchParam?: AdminNotePatchParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchAdminNote(adminNotePatchParam, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * mwの対応状況を変更する
         * @summary オファーの承認・非承認
         * @param {OfferPatchParam} [offerPatchParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchAdminOffer(offerPatchParam?: OfferPatchParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchAdminOffer(offerPatchParam, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 検索条件を編集
         * @summary マイナビ向け検索条件更新
         * @param {number} adminSearchConditionId マイナビ向け検索条件のID
         * @param {AdminSearchConditionRequest} [adminSearchConditionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchAdminSearchConditionId(adminSearchConditionId: number, adminSearchConditionRequest?: AdminSearchConditionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchAdminSearchConditionId(adminSearchConditionId, adminSearchConditionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 並び替え
         * @summary マイナビ向け保存した検索条件一覧の並び替え
         * @param {InlineObject3} [inlineObject3] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchAdminSearchConditions(inlineObject3?: InlineObject3, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchAdminSearchConditions(inlineObject3, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * * 求職者ユーザーの情報の変更 * 変更があったものだけを送信するようにしたい * PUTしたら、GETした時と同じ情報が返ってくる * アカウント停止/非アクティブ化も行えるようにする * DS-USER-INFO-ADDITINAL に追加して user_status と status (ポートフォリオの公開状態)を変更できるように * 返り値は DS-USER-INFO-ADDITINAL に追加して user_status, user_entry_id, status, portfolio_progress, resume_progress がかえるように
         * @summary 求職者情報変更
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {AdminMatchboxUserRequest} [adminMatchboxUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchAdminUserId(userMatchboxId: string, adminMatchboxUserRequest?: AdminMatchboxUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminDirectUserSearchModel & ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchAdminUserId(userMatchboxId, adminMatchboxUserRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * タグ変更
         * @summary タグ 変更
         * @param {string} userTagId ユーザータグID
         * @param {UserTagPatchParam} [userTagPatchParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchAdminUserTagId(userTagId: string, userTagPatchParam?: UserTagPatchParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminUserTagResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchAdminUserTagId(userTagId, userTagPatchParam, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * タグ並び替え
         * @summary タグ一覧 並び順変更
         * @param {UserTagsPatchParam} [userTagsPatchParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchAdminUserTags(userTagsPatchParam?: UserTagsPatchParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminUserTagsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchAdminUserTags(userTagsPatchParam, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * タグ変更 送らなかったものは削除
         * @summary 求職者 タグ一覧 変更
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {UserTagsPatchParam} [userTagsPatchParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchAdminUserTagsMbid(userMatchboxId: string, userTagsPatchParam?: UserTagsPatchParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminUserTagsMatchboxIdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchAdminUserTagsMbid(userMatchboxId, userTagsPatchParam, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 紐付けする企業検索  マイナビ管理画面から企業情報登録時に紐づける企業情報のプロパティ名が block_company_id なのは求職者がブロック対象にする企業を検索するときは外部からインポートした企業情報を登録するためでその法人番号 が block_company_id と定義してる。  MATCHBOX DIRECT を使用する企業 company とその block_company_id が紐づいていないと、ブロックしたはずの企業に求職者情報が表示されてしまうので、企業側も法人番号と紐付けをしている。  また複数設定できるのはある会社(A)をある求職者(X)がブロックしていたと後にA社が分社化してB社ができた場合、求職者Xのブロックする企業にB社も入れないため複数企業を紐づけられるようになっている。  法人番号のカラム名が block_company_id なのは company と分けるため block_companies というDB に入れているため。
         * @summary 紐付けする企業検索
         * @param {BlockCompanyPostParam} [blockCompanyPostParam] &#x60;sort_by&#x60;は&#x60;kana&#x60;を送る想定
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAdminBlockCompanies(blockCompanyPostParam?: BlockCompanyPostParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess & object & PaginationOffset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAdminBlockCompanies(blockCompanyPostParam, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * idは登録時に不要
         * @summary 企業登録
         * @param {AdminCompanyPostParam} [adminCompanyPostParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAdminCompany(adminCompanyPostParam?: AdminCompanyPostParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAdminCompany(adminCompanyPostParam, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * パスワードを変更します 仕様は冒頭説明箇所を参照
         * @summary 企業ユーザーパスワード変更
         * @param {string} directMatchboxId 企業ユーザーID （B+数字乱数8桁）
         * @param {InlineObject} [inlineObject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAdminCompanyUserPasswordChange(directMatchboxId: string, inlineObject?: InlineObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAdminCompanyUserPasswordChange(directMatchboxId, inlineObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ## sort_by項目  - registration
         * @summary Direct企業検索
         * @param {AdminSearchCompaniesRequest} [adminSearchCompaniesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAdminDirectCompanies(adminSearchCompaniesRequest?: AdminSearchCompaniesRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSearchCompaniesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAdminDirectCompanies(adminSearchCompaniesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 管理者用の企業向け検索条件保存  マイナビ向けの検索条件とは別途保存  ## バックエンド仕様について  バックエンド側では検索条件を JSON でそのまま DB に登録しているので基本的に保存時のリクエストデータの変更に関してはバックエンドに依頼する必要はない。  そのため基本的にどのような構造のデータでも入れることは可能だが検索側のリクエストパラメーターと合わせる必要はあるのでこちらの構造を変更する場合は合わせて検索側も対応しバックエンド側に依頼する。
         * @summary 企業向け検索条件保存
         * @param {DirectSearchConditionRequest} [directSearchConditionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAdminDirectSearchCondition(directSearchConditionRequest?: DirectSearchConditionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaveSearchConditionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAdminDirectSearchCondition(directSearchConditionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ## sort_by  - アカウント開設日 registration_date - 最終ログイン日 last_login - 転職希望時期 mc_preferred_change_date - ポートフォリオ作品数 portfolio_item_count
         * @summary 企業向けユーザー検索
         * @param {DirectSearchUserRequest} [directSearchUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAdminDirectSearchUsers(directSearchUserRequest?: DirectSearchUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DirectSearchUsersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAdminDirectSearchUsers(directSearchUserRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * c_id はないので、null で送信する 
         * @summary 入力代行職務経歴・追加
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {Career} [career] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAdminInputAgencyCareerHistoryUserIdCareers(userId: string, career?: Career, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object & Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAdminInputAgencyCareerHistoryUserIdCareers(userId, career, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * q_id はないので、null で送信する
         * @summary 入力代行資格/免許・追加
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {Qualification} [qualification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAdminInputAgencyCareerHistoryUserIdQualifications(userId: string, qualification?: Qualification, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object & Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAdminInputAgencyCareerHistoryUserIdQualifications(userId, qualification, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 新規なのでe_id は空文字で送信
         * @summary 入力代行学歴・追加
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {EducationPostRequest} [educationPostRequest] 入力代行学歴・追加
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAdminInputAgencyResumeUserIdEducations(userId: string, educationPostRequest?: EducationPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EducationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAdminInputAgencyResumeUserIdEducations(userId, educationPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ログインをする  ## 開発サーバーテストアカウント  ID : matchbox-dev-notify+dockertestadmin@s2factory.co.jp  PW : test  v1では一般ユーザーに管理者権限を与えてる形でアカウントを発行していたがv2からはセキュリティ強化のため一般ユーザーと管理者のデータは明確に分けることになったため管理者アカウントを発行するのはシステム側に依頼し手動で発行するものとする。
         * @summary 管理者ログイン
         * @param {string} email メールアドレス
         * @param {string} password パスワード
         * @param {string} [type] 以前の as_ca&#x3D;1 と同様。 caとownerがある
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAdminLogin(email: string, password: string, type?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAdminLogin(email, password, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 企業・求職者へメモを残す
         * @summary 企業・求職者にメモを残す
         * @param {AdminNotePostParam} [adminNotePostParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAdminNote(adminNotePostParam?: AdminNotePostParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Note & Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAdminNote(adminNotePostParam, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 管理者用の検索条件保存 Diret側とは項目が変わる  ## バックエンド仕様について  バックエンド側では検索条件を JSON でそのまま DB に登録しているので基本的に保存時のリクエストデータの変更に関してはバックエンドに依頼する必要はない。  そのため基本的にどのような構造のデータでも入れることは可能だが検索側のリクエストパラメーターと合わせる必要はあるのでこちらの構造を変更する場合は合わせて検索側も対応しバックエンド側に依頼する。
         * @summary マイナビ向け検索条件保存
         * @param {AdminSearchConditionRequest} [adminSearchConditionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAdminSearchCondition(adminSearchConditionRequest?: AdminSearchConditionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaveSearchConditionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAdminSearchCondition(adminSearchConditionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * * 管理ツールなので、少しくらい遅くてもフリーワード検索は実現させたい * age は計算が必要なので毎日１度計算しておく  ## sort_by  - アカウント開設日 registration_date - 最終ログイン日 last_login - 転職希望時期 mc_preferred_change_date - ポートフォリオ作品数 portfolio_item_count
         * @summary マイナビ向けユーザー検索
         * @param {AdminSearchUserRequest} [adminSearchUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAdminSearchUsers(adminSearchUserRequest?: AdminSearchUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSearchUsersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAdminSearchUsers(adminSearchUserRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 特定のadminユーザーが求職者検索を行い、 matchbox_idに該当する求職者が検索結果に表示された際のis_readプロパティをtrueに  管理画面はマイナビ向けと企業向けのユーザー検索があるが情報は共有するものとする  ## ユーザー情報の更新を監視する項目  求職者が以下情報を更新すると該当ユーザーのis_readをfalseに  - ポートフォリオ - 履歴書 - 職務経歴 - マイナビクリエイター希望項目 - ユーザー情報
         * @summary 検索結果表示求職者ユーザーの既読状態を更新
         * @param {InlineObject4} [inlineObject4] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAdminSearchUsersRead(inlineObject4?: InlineObject4, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAdminSearchUsersRead(inlineObject4, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * * POST /admin/search_users/ と同じパラメータを使うことができる * 叩いた後にはCSVがダウンロードされる
         * @summary ユーザー 検索 CSV ダウンロード
         * @param {string} [contentTypeApplicationJsonCharsetUTF8] 
         * @param {Pagination & SearchUsers | SearchUsersByDirect} [paginationSearchUsersSearchUsersByDirect] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAdminSearchUsersToCsv(contentTypeApplicationJsonCharsetUTF8?: string, paginationSearchUsersSearchUsersByDirect?: Pagination & SearchUsers | SearchUsersByDirect, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAdminSearchUsersToCsv(contentTypeApplicationJsonCharsetUTF8, paginationSearchUsersSearchUsersByDirect, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 保存した検索条件を企業におすすめする  選択条件に対して既に登録済みの企業が含まれていても送信可能に。 重複して登録はマージする
         * @summary 企業に検索条件をおすすめする
         * @param {InlineObject6} [inlineObject6] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAdminSuggest(inlineObject6?: InlineObject6, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAdminSuggest(inlineObject6, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * * ファイルのアップロード行う * アップロードが完了後、サムネイルのURLとファイルのIDを返す
         * @summary 画像などのファイルアップロード
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {any} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAdminUserIdFiles(userId: string, files: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAdminUserIdFiles(userId, files, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 求職者のパスワードを変更します 仕様は冒頭説明箇所を参照
         * @summary 求職者パスワード変更
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {InlineObject7} [inlineObject7] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAdminUserPasswordChange(userMatchboxId: string, inlineObject7?: InlineObject7, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAdminUserPasswordChange(userMatchboxId, inlineObject7, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * タグ作成
         * @summary タグ新規作成
         * @param {UserTagParam} [userTagParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAdminUserTag(userTagParam?: UserTagParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAdminUserTag(userTagParam, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 保存されてる検索条件に対してタグを一括保存 企業向けの検索条件のみに紐づく
         * @summary 検索条件への求職者タグ一括保存
         * @param {UserTagToSearchResultBatchSaveParam} [userTagToSearchResultBatchSaveParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAdminUserTagToSearchResult(userTagToSearchResultBatchSaveParam?: UserTagToSearchResultBatchSaveParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAdminUserTagToSearchResult(userTagToSearchResultBatchSaveParam, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ADMINApi - factory interface
 * @export
 */
export const ADMINApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ADMINApiFp(configuration)
    return {
        /**
         * 検索条件を削除
         * @summary 企業向け検索条件削除
         * @param {number} adminDirectSearchConditionId 管理者用のDirect向け検索条件のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminDirectSearchConditionId(adminDirectSearchConditionId: number, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.deleteAdminDirectSearchConditionId(adminDirectSearchConditionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 入力代行職務経歴・削除
         * @summary 入力代行職務経歴・削除
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {string} careerId 職歴ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminInputAgencyCareerHistoryCareers(userId: string, careerId: string, options?: any): AxiosPromise<Status> {
            return localVarFp.deleteAdminInputAgencyCareerHistoryCareers(userId, careerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 入力代行プロジェクト・削除
         * @summary 入力代行プロジェクト・削除
         * @param {string} projectId プロジェクトID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminInputAgencyCareerHistoryProjects(projectId: string, options?: any): AxiosPromise<Status> {
            return localVarFp.deleteAdminInputAgencyCareerHistoryProjects(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 入力代行資格/免許・削除
         * @summary 入力代行資格/免許・削除
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {string} qualificationId 資格ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminInputAgencyCareerHistoryQualifications(userId: string, qualificationId: string, options?: any): AxiosPromise<Status> {
            return localVarFp.deleteAdminInputAgencyCareerHistoryQualifications(userId, qualificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 入力代行スキル削除
         * @summary 入力代行スキル削除
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {string} skillId スキルID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminInputAgencyCareerHistorySkill(userId: string, skillId: string, options?: any): AxiosPromise<Status> {
            return localVarFp.deleteAdminInputAgencyCareerHistorySkill(userId, skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 入力代行学歴・削除
         * @summary 入力代行学歴・削除
         * @param {string} educationId 学歴ID
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminInputAgencyResumeUserIdEducations(educationId: string, userId: string, options?: any): AxiosPromise<EducationResponse> {
            return localVarFp.deleteAdminInputAgencyResumeUserIdEducations(educationId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * メモを削除する
         * @summary メモを削除する
         * @param {number} noteId noteのid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminNote(noteId: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteAdminNote(noteId, options).then((request) => request(axios, basePath));
        },
        /**
         * 検索条件を削除
         * @summary マイナビ向け検索条件削除
         * @param {number} adminSearchConditionId マイナビ向け検索条件のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminSearchConditionId(adminSearchConditionId: number, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.deleteAdminSearchConditionId(adminSearchConditionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 企業におすすめした検索条件を取り消す
         * @summary 企業におすすめした検索条件を取り消す
         * @param {number} directSearchConditionId Directの検索条件ID
         * @param {string} directCompanyId 内部的な企業ID
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminSuggestId(directSearchConditionId: number, directCompanyId: string, body?: object, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.deleteAdminSuggestId(directSearchConditionId, directCompanyId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 即時削除処理を行う  退会処理は別？要確認
         * @summary 求職者削除
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminUserId(userMatchboxId: string, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.deleteAdminUserId(userMatchboxId, options).then((request) => request(axios, basePath));
        },
        /**
         * * ファイルの削除を行う
         * @summary 画像などのファイル削除
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {string} fileId アップロード時に返却されるファイルID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminUserIdFiles(userId: string, fileId: string, options?: any): AxiosPromise<Status> {
            return localVarFp.deleteAdminUserIdFiles(userId, fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * タグ削除
         * @summary タグ 削除
         * @param {string} userTagId ユーザータグID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminUserTagId(userTagId: string, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.deleteAdminUserTagId(userTagId, options).then((request) => request(axios, basePath));
        },
        /**
         * * サイト概要を確認するAPI、Daily, Weekly, Monthly,で確認する。 * 期間指定をするので、処理が重くなっても、指定された期日は全部出す * 完成度は portfolio_progress / resume_progress の値をもとに計算する   * それぞれに 10個の true, false が入ってるので、trueが1つ10%になる   * true の数ｘ10 で計算すれば良くて端数は基本でない * GET だとURLエンコード必要なので注意。POSTでもいいかも。
         * @summary サイト概要 取得
         * @param {string} type 概要抽出のタイプ
         * @param {string} term 期間は毎回指定してください。
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAdminAnalysisOverview(type: string, term: string, options?: any): AxiosPromise<AnalysisResponse> {
            return localVarFp.getAdminAnalysisOverview(type, term, options).then((request) => request(axios, basePath));
        },
        /**
         * 職務経歴書
         * @summary 職務経歴書
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminCareerHistory(userId: string, options?: any): AxiosPromise<CareerHistory & Status & UserInfo> {
            return localVarFp.getAdminCareerHistory(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Adminユーザー向けの職務経歴書ページをPDF化します。 該当URLは `/admin/cv/{UserMatchboxId}`
         * @summary 求職者の職務経歴書PDFダウンロード
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminCareerHistoryDownload(userMatchboxId: string, options?: any): AxiosPromise<string> {
            return localVarFp.getAdminCareerHistoryDownload(userMatchboxId, options).then((request) => request(axios, basePath));
        },
        /**
         * 企業情報
         * @summary 企業情報
         * @param {string} directCompanyId 内部的な企業ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminCompany(directCompanyId: string, options?: any): AxiosPromise<Status & object> {
            return localVarFp.getAdminCompany(directCompanyId, options).then((request) => request(axios, basePath));
        },
        /**
         * `direct_*` or `admin` アカウントからGET可能
         * @summary 企業ユーザー情報詳細
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminCompanyUser(userId: string, options?: any): AxiosPromise<CompanyUser & Status> {
            return localVarFp.getAdminCompanyUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 企業内ユーザー一覧
         * @summary 企業内ユーザー一覧
         * @param {string} limit 
         * @param {string} offset 
         * @param {string} sortBy 
         * @param {string} sortOrder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminCompanyUsers(limit: string, offset: string, sortBy: string, sortOrder: string, options?: any): AxiosPromise<object & PaginationOffset & Status> {
            return localVarFp.getAdminCompanyUsers(limit, offset, sortBy, sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * 検索条件を取得
         * @summary 企業向け検索条件詳細
         * @param {number} adminDirectSearchConditionId 管理者用のDirect向け検索条件のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminDirectSearchConditionId(adminDirectSearchConditionId: number, options?: any): AxiosPromise<DirectSearchConditionResponse> {
            return localVarFp.getAdminDirectSearchConditionId(adminDirectSearchConditionId, options).then((request) => request(axios, basePath));
        },
        /**
         * # 仕様 - 保存されている情報は全てDirect側の「Matchboxのおすすめ検索」に表示する - メール配信設定を紐付けられた企業には検索条件のデータが変更されたらメールを送信
         * @summary 企業向け保存した検索条件一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminDirectSearchConditions(options?: any): AxiosPromise<AdminDirectSearchConditionsResponse> {
            return localVarFp.getAdminDirectSearchConditions(options).then((request) => request(axios, basePath));
        },
        /**
         * 求職者の入力代行サービスの登録状況を取得する
         * @summary 求職者入力代行情報取得
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminInputAgency(userMatchboxId: string, options?: any): AxiosPromise<InputAgencyResponse> {
            return localVarFp.getAdminInputAgency(userMatchboxId, options).then((request) => request(axios, basePath));
        },
        /**
         * 入力代行職務経歴書取得
         * @summary 入力代行職務経歴書取得
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminInputAgencyCareerHistory(userId: string, options?: any): AxiosPromise<CareerHistory & Status & UserInfo> {
            return localVarFp.getAdminInputAgencyCareerHistory(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 入力代行履歴書取得
         * @summary 入力代行履歴書取得
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminInputAgencyResume(userId: string, options?: any): AxiosPromise<Resume & Status> {
            return localVarFp.getAdminInputAgencyResume(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * ログイン状態を見る 必要な情報は精査
         * @summary 管理者のログイン状態
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminIsLogin(options?: any): AxiosPromise<UserIsLogin> {
            return localVarFp.getAdminIsLogin(options).then((request) => request(axios, basePath));
        },
        /**
         * ログアウトをする 
         * @summary 管理者ログアウト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminLogout(options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.getAdminLogout(options).then((request) => request(axios, basePath));
        },
        /**
         * 企業・求職者に送信したメモ一覧
         * @summary 企業・求職者に送信したメモ一覧
         * @param {number} [companyId] CAのみ利用可能
         * @param {string} [matchboxId] 求職者 ID B + 8桁乱数
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminNotes(companyId?: number, matchboxId?: string, options?: any): AxiosPromise<AdminNotesResponse> {
            return localVarFp.getAdminNotes(companyId, matchboxId, options).then((request) => request(axios, basePath));
        },
        /**
         * 仕様するsortキー * ピックアップ日 created_at * 更新日 updated_at * みんなの意見 reactions * アクション has_action  並び順 1. statusが1でmw_statusが2か3以外 2. statusが2か6か7でmw_statusが2か3以外 3. statusが2か6か7でmw_statusが2 4. statusが1以外でmw_statusが3以外 5. statusが３でmw_status3以外 6. 1 ~ 5と7以外 7. statusが4か5かmw_statusが3
         * @summary 管理者オファー一覧
         * @param {string} limit 
         * @param {string} offset 
         * @param {string} sortBy 
         * @param {string} sortOrder 
         * @param {Array<number>} [status] ステータス。DirectまたはMWアカウントのみ利用可 Arrayで送る為、status[]。
         * @param {number} [rate] マッチ度。Directアカウントのみ利用可。
         * @param {number} [job] 職種。Directアカウントのみ利用可。
         * @param {string} [matchboxId] MWアカウントのみ利用可。求職者へのオファー一覧
         * @param {1 | 2 | 3} [mwStatus] MWアカウントのみ利用可。対応状況
         * @param {string} [companyName] MWアカウントのみ利用可。企業名
         * @param {string} [name] MWアカウントのみ利用可。求職者名
         * @param {number} [companyId] MWアカウントのみ利用可。企業id
         * @param {string} [offerId] OfferデータID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminOffers(limit: string, offset: string, sortBy: string, sortOrder: string, status?: Array<number>, rate?: number, job?: number, matchboxId?: string, mwStatus?: 1 | 2 | 3, companyName?: string, name?: string, companyId?: number, offerId?: string, options?: any): AxiosPromise<OffersResponse> {
            return localVarFp.getAdminOffers(limit, offset, sortBy, sortOrder, status, rate, job, matchboxId, mwStatus, companyName, name, companyId, offerId, options).then((request) => request(axios, basePath));
        },
        /**
         * * 公開されているポートフォリオの作品のリストを取得します
         * @summary 求職者の公開ポートフォリオ作品リスト
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminPortfolio(userId: string, options?: any): AxiosPromise<Portfolio & Status> {
            return localVarFp.getAdminPortfolio(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Adminユーザー向けの公開ポートフォリオ作品リストページをPDF化します。 該当URLは `/admin/portfolio/{UserMatchboxId}`
         * @summary 求職者の公開ポートフォリオ作品リストPDFダウンロード
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAdminPortfolioDownload(userMatchboxId: string, options?: any): AxiosPromise<string> {
            return localVarFp.getAdminPortfolioDownload(userMatchboxId, options).then((request) => request(axios, basePath));
        },
        /**
         * PDFダウンロード
         * @summary ポートフォリオPDFダウンロード
         * @param {number} pDFTicketID PDF生成ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminPortfolioDownloadPdf(pDFTicketID: number, options?: any): AxiosPromise<void> {
            return localVarFp.getAdminPortfolioDownloadPdf(pDFTicketID, options).then((request) => request(axios, basePath));
        },
        /**
         * PDFの生成をリクエスト
         * @summary ポートフォリオPDF生成をリクエスト
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminPortfolioRequestToGeneratePdf(userMatchboxId: string, options?: any): AxiosPromise<ResponseSuccess & PDFTicketId> {
            return localVarFp.getAdminPortfolioRequestToGeneratePdf(userMatchboxId, options).then((request) => request(axios, basePath));
        },
        /**
         * PDF生成のステータスを確認
         * @summary ポートフォリオPDF生成ステータス確認
         * @param {number} pDFTicketID PDF生成ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminPortfolioStatusOfPdf(pDFTicketID: number, options?: any): AxiosPromise<PDFTicketStatus & ResponseSuccess> {
            return localVarFp.getAdminPortfolioStatusOfPdf(pDFTicketID, options).then((request) => request(axios, basePath));
        },
        /**
         * ピックアップに対する社員の反応を取得する
         * @summary リアクション一覧
         * @param {string} offerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminReactions(offerId: string, options?: any): AxiosPromise<ReactionsResponse> {
            return localVarFp.getAdminReactions(offerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 履歴書情報・一覧取得
         * @summary 履歴書情報・一覧取得
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminResume(userId: string, options?: any): AxiosPromise<Resume & Status> {
            return localVarFp.getAdminResume(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Adminユーザー向けの履歴書情報ページをPDF化します。 該当URLは `/admin/resume/{UserMatchboxId}`
         * @summary 求職者の履歴書情報PDFダウンロード
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminResumeDownload(userMatchboxId: string, options?: any): AxiosPromise<string> {
            return localVarFp.getAdminResumeDownload(userMatchboxId, options).then((request) => request(axios, basePath));
        },
        /**
         * 検索条件を取得
         * @summary マイナビ向け検索条件詳細
         * @param {number} adminSearchConditionId マイナビ向け検索条件のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminSearchConditionId(adminSearchConditionId: number, options?: any): AxiosPromise<AdminSearchConditionResponse> {
            return localVarFp.getAdminSearchConditionId(adminSearchConditionId, options).then((request) => request(axios, basePath));
        },
        /**
         * マイナビ向け保存検索条件一覧
         * @summary マイナビ向け保存した検索条件一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminSearchConditions(options?: any): AxiosPromise<AdminSearchConditionsResponse> {
            return localVarFp.getAdminSearchConditions(options).then((request) => request(axios, basePath));
        },
        /**
         * ログインユーザー情報取得  v1では一般ユーザーに管理者権限を与えてる形でアカウントを発行していたがv2からはセキュリティ強化のため一般ユーザーと管理者のデータは明確に分けることになったため管理者アカウントを発行するのはシステム側に依頼し手動で発行するものとする。  アカウント発行時は以下の情報をシステム側に依頼する  ・メールアドレス ・名前 ・部署名 ・役職名 ・アイコン画像 ・種別  種別はadminひとつになるが内部的に以下を振り分けるため登録時に指定する。  MW_A：マイナビ（MATCHBOXの専任者）_マイナビ向けのメールが全部飛んでくる人 MW_B：マイナビ（MATCHBOXに登録されてる各企業担当者）_担当する企業に関わるメールだけが飛んでくる人
         * @summary ログインユーザー情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminUser(options?: any): AxiosPromise<AdminUserResponse> {
            return localVarFp.getAdminUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 求職者の情報詳細を取得
         * @summary 求職者情報詳細
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminUserId(userMatchboxId: string, options?: any): AxiosPromise<AdminMatchboxUserResponse> {
            return localVarFp.getAdminUserId(userMatchboxId, options).then((request) => request(axios, basePath));
        },
        /**
         * タグ詳細
         * @summary タグ詳細
         * @param {string} userTagId ユーザータグID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminUserTagId(userTagId: string, options?: any): AxiosPromise<AdminUserTagResponse> {
            return localVarFp.getAdminUserTagId(userTagId, options).then((request) => request(axios, basePath));
        },
        /**
         * 保存されてる検索条件に紐づくタグ一覧 レスポンスの構造は求職者詳細用のタグと同じ 企業向けの検索条件のみに紐づく
         * @summary 検索条件に保存された求職者タグ一覧
         * @param {string} [searchConditionId] 保存した検索条件のID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminUserTagToSearchResult(searchConditionId?: string, options?: any): AxiosPromise<AdminUserTagsMatchboxIdResponse> {
            return localVarFp.getAdminUserTagToSearchResult(searchConditionId, options).then((request) => request(axios, basePath));
        },
        /**
         * タグ一覧  全件取得
         * @summary タグ一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminUserTags(options?: any): AxiosPromise<AdminUserTagsResponse> {
            return localVarFp.getAdminUserTags(options).then((request) => request(axios, basePath));
        },
        /**
         * 指定した求職者に紐づいているタグ一覧 active が true のものだけ
         * @summary 求職者タグ一覧
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminUserTagsMbid(userMatchboxId: string, options?: any): AxiosPromise<AdminUserTagsMatchboxIdResponse> {
            return localVarFp.getAdminUserTagsMbid(userMatchboxId, options).then((request) => request(axios, basePath));
        },
        /**
         * `skills` `careers` `qualifications`は（職務経歴書用の内部的なorder番号がない場合）order番号を持つデータの一番後ろから表示します。  新たにPATCHを送信した際に、内部的なorder番号を更新します。
         * @summary 求職者職務経歴書更新
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {CareerHistory} [careerHistory] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminCareerHistory(userId: string, careerHistory?: CareerHistory, options?: any): AxiosPromise<CareerHistory & Status & UserInfo> {
            return localVarFp.patchAdminCareerHistory(userId, careerHistory, options).then((request) => request(axios, basePath));
        },
        /**
         * 企業情報編集
         * @summary 企業情報編集
         * @param {string} directCompanyId 内部的な企業ID
         * @param {AdminCompany} [adminCompany] * 会社の状態( status )   * active / アクティブ   * inactive / 停止   * before_delete / 退会。ヶ月で削除されるかどうか確認中
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminCompany(directCompanyId: string, adminCompany?: AdminCompany, options?: any): AxiosPromise<AdminCompany & Status> {
            return localVarFp.patchAdminCompany(directCompanyId, adminCompany, options).then((request) => request(axios, basePath));
        },
        /**
         * 検索条件のメール配信設定変更する
         * @summary 検索条件のメール配信設定変更
         * @param {number} directSearchConditionId Directの検索条件ID
         * @param {InlineObject1} [inlineObject1] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminDirectMailId(directSearchConditionId: number, inlineObject1?: InlineObject1, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.patchAdminDirectMailId(directSearchConditionId, inlineObject1, options).then((request) => request(axios, basePath));
        },
        /**
         * 検索条件を編集
         * @summary 企業向け検索条件更新
         * @param {number} adminDirectSearchConditionId 管理者用のDirect向け検索条件のID
         * @param {DirectSearchConditionRequest} [directSearchConditionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminDirectSearchConditionId(adminDirectSearchConditionId: number, directSearchConditionRequest?: DirectSearchConditionRequest, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.patchAdminDirectSearchConditionId(adminDirectSearchConditionId, directSearchConditionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 並び替え
         * @summary 企業向け保存した検索条件一覧の並び替え
         * @param {InlineObject5} [inlineObject5] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminDirectSearchConditions(inlineObject5?: InlineObject5, options?: any): AxiosPromise<void> {
            return localVarFp.patchAdminDirectSearchConditions(inlineObject5, options).then((request) => request(axios, basePath));
        },
        /**
         * 求職者の入力代行サービスの登録状況を更新する
         * @summary 求職者入力代行情報更新
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {InlineObject8} [inlineObject8] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminInputAgency(userMatchboxId: string, inlineObject8?: InlineObject8, options?: any): AxiosPromise<Status> {
            return localVarFp.patchAdminInputAgency(userMatchboxId, inlineObject8, options).then((request) => request(axios, basePath));
        },
        /**
         * `skills` `careers` `qualifications`は（職務経歴書用の内部的なorder番号がない場合）order番号を持つデータの一番後ろから表示します。  新たにPATCHを送信した際に、内部的なorder番号を更新します。
         * @summary 入力代行職務経歴書更新
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {CareerHistory} [careerHistory] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminInputAgencyCareerHistory(userId: string, careerHistory?: CareerHistory, options?: any): AxiosPromise<CareerHistory & Status & UserInfo> {
            return localVarFp.patchAdminInputAgencyCareerHistory(userId, careerHistory, options).then((request) => request(axios, basePath));
        },
        /**
         * 入力代行職務経歴・編集
         * @summary 入力代行職務経歴・編集
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {Career} [career] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminInputAgencyCareerHistoryUserIdCareers(userId: string, career?: Career, options?: any): AxiosPromise<object & Status> {
            return localVarFp.patchAdminInputAgencyCareerHistoryUserIdCareers(userId, career, options).then((request) => request(axios, basePath));
        },
        /**
         * 入力代行資格/免許・更新
         * @summary 入力代行資格/免許・更新
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {Qualification} [qualification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminInputAgencyCareerHistoryUserIdQualifications(userId: string, qualification?: Qualification, options?: any): AxiosPromise<object & Status> {
            return localVarFp.patchAdminInputAgencyCareerHistoryUserIdQualifications(userId, qualification, options).then((request) => request(axios, basePath));
        },
        /**
         * * 履歴書作成に必要な情報を更新する * 資格、学歴、職務経歴の情報は多いので、送信時には省く（レスポンスには返ってくる） * 資格、職務経歴の表示順序は、内部的に履歴書用のorder番号を持ち、職務経歴書とは別に独立して保存します。  ---  新たな職歴などが追加された場合（履歴書用の内部的なorder番号がない場合）order番号を持つ職歴の一番後ろから表示します。履歴書編集画面で並び替えを行いPATCHを送信した際に、order番号を更新します。
         * @summary 入力代行履歴書更新
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {Resume} [resume] 証明写真 user.user_info.photo は以下の形式でリクエストする  &#x60;&#x60;&#x60; {   f_id: \&quot;POST /api/v2/files で返ってきた f_id\&quot; } &#x60;&#x60;&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminInputAgencyResume(userId: string, resume?: Resume, options?: any): AxiosPromise<Resume & ResponseSuccess> {
            return localVarFp.patchAdminInputAgencyResume(userId, resume, options).then((request) => request(axios, basePath));
        },
        /**
         * 入力代行学歴・編集
         * @summary 入力代行学歴・編集
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {EducationPatchRequest} [educationPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminInputAgencyResumeUserIdEducations(userId: string, educationPatchRequest?: EducationPatchRequest, options?: any): AxiosPromise<EducationResponse> {
            return localVarFp.patchAdminInputAgencyResumeUserIdEducations(userId, educationPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 自社アカウントが書いたメモを既読にする
         * @summary メモを既読にする
         * @param {AdminNotePatchParam} [adminNotePatchParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminNote(adminNotePatchParam?: AdminNotePatchParam, options?: any): AxiosPromise<void> {
            return localVarFp.patchAdminNote(adminNotePatchParam, options).then((request) => request(axios, basePath));
        },
        /**
         * mwの対応状況を変更する
         * @summary オファーの承認・非承認
         * @param {OfferPatchParam} [offerPatchParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminOffer(offerPatchParam?: OfferPatchParam, options?: any): AxiosPromise<OfferResponse> {
            return localVarFp.patchAdminOffer(offerPatchParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 検索条件を編集
         * @summary マイナビ向け検索条件更新
         * @param {number} adminSearchConditionId マイナビ向け検索条件のID
         * @param {AdminSearchConditionRequest} [adminSearchConditionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminSearchConditionId(adminSearchConditionId: number, adminSearchConditionRequest?: AdminSearchConditionRequest, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.patchAdminSearchConditionId(adminSearchConditionId, adminSearchConditionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 並び替え
         * @summary マイナビ向け保存した検索条件一覧の並び替え
         * @param {InlineObject3} [inlineObject3] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminSearchConditions(inlineObject3?: InlineObject3, options?: any): AxiosPromise<void> {
            return localVarFp.patchAdminSearchConditions(inlineObject3, options).then((request) => request(axios, basePath));
        },
        /**
         * * 求職者ユーザーの情報の変更 * 変更があったものだけを送信するようにしたい * PUTしたら、GETした時と同じ情報が返ってくる * アカウント停止/非アクティブ化も行えるようにする * DS-USER-INFO-ADDITINAL に追加して user_status と status (ポートフォリオの公開状態)を変更できるように * 返り値は DS-USER-INFO-ADDITINAL に追加して user_status, user_entry_id, status, portfolio_progress, resume_progress がかえるように
         * @summary 求職者情報変更
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {AdminMatchboxUserRequest} [adminMatchboxUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminUserId(userMatchboxId: string, adminMatchboxUserRequest?: AdminMatchboxUserRequest, options?: any): AxiosPromise<AdminDirectUserSearchModel & ResponseSuccess> {
            return localVarFp.patchAdminUserId(userMatchboxId, adminMatchboxUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * タグ変更
         * @summary タグ 変更
         * @param {string} userTagId ユーザータグID
         * @param {UserTagPatchParam} [userTagPatchParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminUserTagId(userTagId: string, userTagPatchParam?: UserTagPatchParam, options?: any): AxiosPromise<AdminUserTagResponse> {
            return localVarFp.patchAdminUserTagId(userTagId, userTagPatchParam, options).then((request) => request(axios, basePath));
        },
        /**
         * タグ並び替え
         * @summary タグ一覧 並び順変更
         * @param {UserTagsPatchParam} [userTagsPatchParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminUserTags(userTagsPatchParam?: UserTagsPatchParam, options?: any): AxiosPromise<AdminUserTagsResponse> {
            return localVarFp.patchAdminUserTags(userTagsPatchParam, options).then((request) => request(axios, basePath));
        },
        /**
         * タグ変更 送らなかったものは削除
         * @summary 求職者 タグ一覧 変更
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {UserTagsPatchParam} [userTagsPatchParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdminUserTagsMbid(userMatchboxId: string, userTagsPatchParam?: UserTagsPatchParam, options?: any): AxiosPromise<AdminUserTagsMatchboxIdResponse> {
            return localVarFp.patchAdminUserTagsMbid(userMatchboxId, userTagsPatchParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 紐付けする企業検索  マイナビ管理画面から企業情報登録時に紐づける企業情報のプロパティ名が block_company_id なのは求職者がブロック対象にする企業を検索するときは外部からインポートした企業情報を登録するためでその法人番号 が block_company_id と定義してる。  MATCHBOX DIRECT を使用する企業 company とその block_company_id が紐づいていないと、ブロックしたはずの企業に求職者情報が表示されてしまうので、企業側も法人番号と紐付けをしている。  また複数設定できるのはある会社(A)をある求職者(X)がブロックしていたと後にA社が分社化してB社ができた場合、求職者Xのブロックする企業にB社も入れないため複数企業を紐づけられるようになっている。  法人番号のカラム名が block_company_id なのは company と分けるため block_companies というDB に入れているため。
         * @summary 紐付けする企業検索
         * @param {BlockCompanyPostParam} [blockCompanyPostParam] &#x60;sort_by&#x60;は&#x60;kana&#x60;を送る想定
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminBlockCompanies(blockCompanyPostParam?: BlockCompanyPostParam, options?: any): AxiosPromise<ResponseSuccess & object & PaginationOffset> {
            return localVarFp.postAdminBlockCompanies(blockCompanyPostParam, options).then((request) => request(axios, basePath));
        },
        /**
         * idは登録時に不要
         * @summary 企業登録
         * @param {AdminCompanyPostParam} [adminCompanyPostParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminCompany(adminCompanyPostParam?: AdminCompanyPostParam, options?: any): AxiosPromise<void> {
            return localVarFp.postAdminCompany(adminCompanyPostParam, options).then((request) => request(axios, basePath));
        },
        /**
         * パスワードを変更します 仕様は冒頭説明箇所を参照
         * @summary 企業ユーザーパスワード変更
         * @param {string} directMatchboxId 企業ユーザーID （B+数字乱数8桁）
         * @param {InlineObject} [inlineObject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminCompanyUserPasswordChange(directMatchboxId: string, inlineObject?: InlineObject, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.postAdminCompanyUserPasswordChange(directMatchboxId, inlineObject, options).then((request) => request(axios, basePath));
        },
        /**
         * ## sort_by項目  - registration
         * @summary Direct企業検索
         * @param {AdminSearchCompaniesRequest} [adminSearchCompaniesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminDirectCompanies(adminSearchCompaniesRequest?: AdminSearchCompaniesRequest, options?: any): AxiosPromise<AdminSearchCompaniesResponse> {
            return localVarFp.postAdminDirectCompanies(adminSearchCompaniesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 管理者用の企業向け検索条件保存  マイナビ向けの検索条件とは別途保存  ## バックエンド仕様について  バックエンド側では検索条件を JSON でそのまま DB に登録しているので基本的に保存時のリクエストデータの変更に関してはバックエンドに依頼する必要はない。  そのため基本的にどのような構造のデータでも入れることは可能だが検索側のリクエストパラメーターと合わせる必要はあるのでこちらの構造を変更する場合は合わせて検索側も対応しバックエンド側に依頼する。
         * @summary 企業向け検索条件保存
         * @param {DirectSearchConditionRequest} [directSearchConditionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminDirectSearchCondition(directSearchConditionRequest?: DirectSearchConditionRequest, options?: any): AxiosPromise<SaveSearchConditionResponse> {
            return localVarFp.postAdminDirectSearchCondition(directSearchConditionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ## sort_by  - アカウント開設日 registration_date - 最終ログイン日 last_login - 転職希望時期 mc_preferred_change_date - ポートフォリオ作品数 portfolio_item_count
         * @summary 企業向けユーザー検索
         * @param {DirectSearchUserRequest} [directSearchUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminDirectSearchUsers(directSearchUserRequest?: DirectSearchUserRequest, options?: any): AxiosPromise<DirectSearchUsersResponse> {
            return localVarFp.postAdminDirectSearchUsers(directSearchUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * c_id はないので、null で送信する 
         * @summary 入力代行職務経歴・追加
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {Career} [career] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminInputAgencyCareerHistoryUserIdCareers(userId: string, career?: Career, options?: any): AxiosPromise<object & Status> {
            return localVarFp.postAdminInputAgencyCareerHistoryUserIdCareers(userId, career, options).then((request) => request(axios, basePath));
        },
        /**
         * q_id はないので、null で送信する
         * @summary 入力代行資格/免許・追加
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {Qualification} [qualification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminInputAgencyCareerHistoryUserIdQualifications(userId: string, qualification?: Qualification, options?: any): AxiosPromise<object & Status> {
            return localVarFp.postAdminInputAgencyCareerHistoryUserIdQualifications(userId, qualification, options).then((request) => request(axios, basePath));
        },
        /**
         * 新規なのでe_id は空文字で送信
         * @summary 入力代行学歴・追加
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {EducationPostRequest} [educationPostRequest] 入力代行学歴・追加
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminInputAgencyResumeUserIdEducations(userId: string, educationPostRequest?: EducationPostRequest, options?: any): AxiosPromise<EducationResponse> {
            return localVarFp.postAdminInputAgencyResumeUserIdEducations(userId, educationPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ログインをする  ## 開発サーバーテストアカウント  ID : matchbox-dev-notify+dockertestadmin@s2factory.co.jp  PW : test  v1では一般ユーザーに管理者権限を与えてる形でアカウントを発行していたがv2からはセキュリティ強化のため一般ユーザーと管理者のデータは明確に分けることになったため管理者アカウントを発行するのはシステム側に依頼し手動で発行するものとする。
         * @summary 管理者ログイン
         * @param {string} email メールアドレス
         * @param {string} password パスワード
         * @param {string} [type] 以前の as_ca&#x3D;1 と同様。 caとownerがある
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminLogin(email: string, password: string, type?: string, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.postAdminLogin(email, password, type, options).then((request) => request(axios, basePath));
        },
        /**
         * 企業・求職者へメモを残す
         * @summary 企業・求職者にメモを残す
         * @param {AdminNotePostParam} [adminNotePostParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminNote(adminNotePostParam?: AdminNotePostParam, options?: any): AxiosPromise<Note & Status> {
            return localVarFp.postAdminNote(adminNotePostParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 管理者用の検索条件保存 Diret側とは項目が変わる  ## バックエンド仕様について  バックエンド側では検索条件を JSON でそのまま DB に登録しているので基本的に保存時のリクエストデータの変更に関してはバックエンドに依頼する必要はない。  そのため基本的にどのような構造のデータでも入れることは可能だが検索側のリクエストパラメーターと合わせる必要はあるのでこちらの構造を変更する場合は合わせて検索側も対応しバックエンド側に依頼する。
         * @summary マイナビ向け検索条件保存
         * @param {AdminSearchConditionRequest} [adminSearchConditionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminSearchCondition(adminSearchConditionRequest?: AdminSearchConditionRequest, options?: any): AxiosPromise<SaveSearchConditionResponse> {
            return localVarFp.postAdminSearchCondition(adminSearchConditionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * * 管理ツールなので、少しくらい遅くてもフリーワード検索は実現させたい * age は計算が必要なので毎日１度計算しておく  ## sort_by  - アカウント開設日 registration_date - 最終ログイン日 last_login - 転職希望時期 mc_preferred_change_date - ポートフォリオ作品数 portfolio_item_count
         * @summary マイナビ向けユーザー検索
         * @param {AdminSearchUserRequest} [adminSearchUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminSearchUsers(adminSearchUserRequest?: AdminSearchUserRequest, options?: any): AxiosPromise<AdminSearchUsersResponse> {
            return localVarFp.postAdminSearchUsers(adminSearchUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 特定のadminユーザーが求職者検索を行い、 matchbox_idに該当する求職者が検索結果に表示された際のis_readプロパティをtrueに  管理画面はマイナビ向けと企業向けのユーザー検索があるが情報は共有するものとする  ## ユーザー情報の更新を監視する項目  求職者が以下情報を更新すると該当ユーザーのis_readをfalseに  - ポートフォリオ - 履歴書 - 職務経歴 - マイナビクリエイター希望項目 - ユーザー情報
         * @summary 検索結果表示求職者ユーザーの既読状態を更新
         * @param {InlineObject4} [inlineObject4] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminSearchUsersRead(inlineObject4?: InlineObject4, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.postAdminSearchUsersRead(inlineObject4, options).then((request) => request(axios, basePath));
        },
        /**
         * * POST /admin/search_users/ と同じパラメータを使うことができる * 叩いた後にはCSVがダウンロードされる
         * @summary ユーザー 検索 CSV ダウンロード
         * @param {string} [contentTypeApplicationJsonCharsetUTF8] 
         * @param {Pagination & SearchUsers | SearchUsersByDirect} [paginationSearchUsersSearchUsersByDirect] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminSearchUsersToCsv(contentTypeApplicationJsonCharsetUTF8?: string, paginationSearchUsersSearchUsersByDirect?: Pagination & SearchUsers | SearchUsersByDirect, options?: any): AxiosPromise<void> {
            return localVarFp.postAdminSearchUsersToCsv(contentTypeApplicationJsonCharsetUTF8, paginationSearchUsersSearchUsersByDirect, options).then((request) => request(axios, basePath));
        },
        /**
         * 保存した検索条件を企業におすすめする  選択条件に対して既に登録済みの企業が含まれていても送信可能に。 重複して登録はマージする
         * @summary 企業に検索条件をおすすめする
         * @param {InlineObject6} [inlineObject6] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminSuggest(inlineObject6?: InlineObject6, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.postAdminSuggest(inlineObject6, options).then((request) => request(axios, basePath));
        },
        /**
         * * ファイルのアップロード行う * アップロードが完了後、サムネイルのURLとファイルのIDを返す
         * @summary 画像などのファイルアップロード
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {any} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminUserIdFiles(userId: string, files: any, options?: any): AxiosPromise<FileResponse> {
            return localVarFp.postAdminUserIdFiles(userId, files, options).then((request) => request(axios, basePath));
        },
        /**
         * 求職者のパスワードを変更します 仕様は冒頭説明箇所を参照
         * @summary 求職者パスワード変更
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {InlineObject7} [inlineObject7] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminUserPasswordChange(userMatchboxId: string, inlineObject7?: InlineObject7, options?: any): AxiosPromise<Status> {
            return localVarFp.postAdminUserPasswordChange(userMatchboxId, inlineObject7, options).then((request) => request(axios, basePath));
        },
        /**
         * タグ作成
         * @summary タグ新規作成
         * @param {UserTagParam} [userTagParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminUserTag(userTagParam?: UserTagParam, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.postAdminUserTag(userTagParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 保存されてる検索条件に対してタグを一括保存 企業向けの検索条件のみに紐づく
         * @summary 検索条件への求職者タグ一括保存
         * @param {UserTagToSearchResultBatchSaveParam} [userTagToSearchResultBatchSaveParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAdminUserTagToSearchResult(userTagToSearchResultBatchSaveParam?: UserTagToSearchResultBatchSaveParam, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.postAdminUserTagToSearchResult(userTagToSearchResultBatchSaveParam, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ADMINApi - object-oriented interface
 * @export
 * @class ADMINApi
 * @extends {BaseAPI}
 */
export class ADMINApi extends BaseAPI {
    /**
     * 検索条件を削除
     * @summary 企業向け検索条件削除
     * @param {number} adminDirectSearchConditionId 管理者用のDirect向け検索条件のID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public deleteAdminDirectSearchConditionId(adminDirectSearchConditionId: number, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).deleteAdminDirectSearchConditionId(adminDirectSearchConditionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 入力代行職務経歴・削除
     * @summary 入力代行職務経歴・削除
     * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
     * @param {string} careerId 職歴ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public deleteAdminInputAgencyCareerHistoryCareers(userId: string, careerId: string, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).deleteAdminInputAgencyCareerHistoryCareers(userId, careerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 入力代行プロジェクト・削除
     * @summary 入力代行プロジェクト・削除
     * @param {string} projectId プロジェクトID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public deleteAdminInputAgencyCareerHistoryProjects(projectId: string, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).deleteAdminInputAgencyCareerHistoryProjects(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 入力代行資格/免許・削除
     * @summary 入力代行資格/免許・削除
     * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
     * @param {string} qualificationId 資格ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public deleteAdminInputAgencyCareerHistoryQualifications(userId: string, qualificationId: string, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).deleteAdminInputAgencyCareerHistoryQualifications(userId, qualificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 入力代行スキル削除
     * @summary 入力代行スキル削除
     * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
     * @param {string} skillId スキルID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public deleteAdminInputAgencyCareerHistorySkill(userId: string, skillId: string, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).deleteAdminInputAgencyCareerHistorySkill(userId, skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 入力代行学歴・削除
     * @summary 入力代行学歴・削除
     * @param {string} educationId 学歴ID
     * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public deleteAdminInputAgencyResumeUserIdEducations(educationId: string, userId: string, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).deleteAdminInputAgencyResumeUserIdEducations(educationId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * メモを削除する
     * @summary メモを削除する
     * @param {number} noteId noteのid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public deleteAdminNote(noteId: number, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).deleteAdminNote(noteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 検索条件を削除
     * @summary マイナビ向け検索条件削除
     * @param {number} adminSearchConditionId マイナビ向け検索条件のID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public deleteAdminSearchConditionId(adminSearchConditionId: number, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).deleteAdminSearchConditionId(adminSearchConditionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 企業におすすめした検索条件を取り消す
     * @summary 企業におすすめした検索条件を取り消す
     * @param {number} directSearchConditionId Directの検索条件ID
     * @param {string} directCompanyId 内部的な企業ID
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public deleteAdminSuggestId(directSearchConditionId: number, directCompanyId: string, body?: object, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).deleteAdminSuggestId(directSearchConditionId, directCompanyId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 即時削除処理を行う  退会処理は別？要確認
     * @summary 求職者削除
     * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public deleteAdminUserId(userMatchboxId: string, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).deleteAdminUserId(userMatchboxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * * ファイルの削除を行う
     * @summary 画像などのファイル削除
     * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
     * @param {string} fileId アップロード時に返却されるファイルID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public deleteAdminUserIdFiles(userId: string, fileId: string, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).deleteAdminUserIdFiles(userId, fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * タグ削除
     * @summary タグ 削除
     * @param {string} userTagId ユーザータグID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public deleteAdminUserTagId(userTagId: string, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).deleteAdminUserTagId(userTagId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * * サイト概要を確認するAPI、Daily, Weekly, Monthly,で確認する。 * 期間指定をするので、処理が重くなっても、指定された期日は全部出す * 完成度は portfolio_progress / resume_progress の値をもとに計算する   * それぞれに 10個の true, false が入ってるので、trueが1つ10%になる   * true の数ｘ10 で計算すれば良くて端数は基本でない * GET だとURLエンコード必要なので注意。POSTでもいいかも。
     * @summary サイト概要 取得
     * @param {string} type 概要抽出のタイプ
     * @param {string} term 期間は毎回指定してください。
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public getAdminAnalysisOverview(type: string, term: string, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).getAdminAnalysisOverview(type, term, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 職務経歴書
     * @summary 職務経歴書
     * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public getAdminCareerHistory(userId: string, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).getAdminCareerHistory(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Adminユーザー向けの職務経歴書ページをPDF化します。 該当URLは `/admin/cv/{UserMatchboxId}`
     * @summary 求職者の職務経歴書PDFダウンロード
     * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public getAdminCareerHistoryDownload(userMatchboxId: string, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).getAdminCareerHistoryDownload(userMatchboxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 企業情報
     * @summary 企業情報
     * @param {string} directCompanyId 内部的な企業ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public getAdminCompany(directCompanyId: string, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).getAdminCompany(directCompanyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * `direct_*` or `admin` アカウントからGET可能
     * @summary 企業ユーザー情報詳細
     * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public getAdminCompanyUser(userId: string, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).getAdminCompanyUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 企業内ユーザー一覧
     * @summary 企業内ユーザー一覧
     * @param {string} limit 
     * @param {string} offset 
     * @param {string} sortBy 
     * @param {string} sortOrder 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public getAdminCompanyUsers(limit: string, offset: string, sortBy: string, sortOrder: string, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).getAdminCompanyUsers(limit, offset, sortBy, sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 検索条件を取得
     * @summary 企業向け検索条件詳細
     * @param {number} adminDirectSearchConditionId 管理者用のDirect向け検索条件のID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public getAdminDirectSearchConditionId(adminDirectSearchConditionId: number, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).getAdminDirectSearchConditionId(adminDirectSearchConditionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * # 仕様 - 保存されている情報は全てDirect側の「Matchboxのおすすめ検索」に表示する - メール配信設定を紐付けられた企業には検索条件のデータが変更されたらメールを送信
     * @summary 企業向け保存した検索条件一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public getAdminDirectSearchConditions(options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).getAdminDirectSearchConditions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 求職者の入力代行サービスの登録状況を取得する
     * @summary 求職者入力代行情報取得
     * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public getAdminInputAgency(userMatchboxId: string, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).getAdminInputAgency(userMatchboxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 入力代行職務経歴書取得
     * @summary 入力代行職務経歴書取得
     * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public getAdminInputAgencyCareerHistory(userId: string, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).getAdminInputAgencyCareerHistory(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 入力代行履歴書取得
     * @summary 入力代行履歴書取得
     * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public getAdminInputAgencyResume(userId: string, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).getAdminInputAgencyResume(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ログイン状態を見る 必要な情報は精査
     * @summary 管理者のログイン状態
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public getAdminIsLogin(options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).getAdminIsLogin(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ログアウトをする 
     * @summary 管理者ログアウト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public getAdminLogout(options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).getAdminLogout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 企業・求職者に送信したメモ一覧
     * @summary 企業・求職者に送信したメモ一覧
     * @param {number} [companyId] CAのみ利用可能
     * @param {string} [matchboxId] 求職者 ID B + 8桁乱数
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public getAdminNotes(companyId?: number, matchboxId?: string, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).getAdminNotes(companyId, matchboxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 仕様するsortキー * ピックアップ日 created_at * 更新日 updated_at * みんなの意見 reactions * アクション has_action  並び順 1. statusが1でmw_statusが2か3以外 2. statusが2か6か7でmw_statusが2か3以外 3. statusが2か6か7でmw_statusが2 4. statusが1以外でmw_statusが3以外 5. statusが３でmw_status3以外 6. 1 ~ 5と7以外 7. statusが4か5かmw_statusが3
     * @summary 管理者オファー一覧
     * @param {string} limit 
     * @param {string} offset 
     * @param {string} sortBy 
     * @param {string} sortOrder 
     * @param {Array<number>} [status] ステータス。DirectまたはMWアカウントのみ利用可 Arrayで送る為、status[]。
     * @param {number} [rate] マッチ度。Directアカウントのみ利用可。
     * @param {number} [job] 職種。Directアカウントのみ利用可。
     * @param {string} [matchboxId] MWアカウントのみ利用可。求職者へのオファー一覧
     * @param {1 | 2 | 3} [mwStatus] MWアカウントのみ利用可。対応状況
     * @param {string} [companyName] MWアカウントのみ利用可。企業名
     * @param {string} [name] MWアカウントのみ利用可。求職者名
     * @param {number} [companyId] MWアカウントのみ利用可。企業id
     * @param {string} [offerId] OfferデータID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public getAdminOffers(limit: string, offset: string, sortBy: string, sortOrder: string, status?: Array<number>, rate?: number, job?: number, matchboxId?: string, mwStatus?: 1 | 2 | 3, companyName?: string, name?: string, companyId?: number, offerId?: string, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).getAdminOffers(limit, offset, sortBy, sortOrder, status, rate, job, matchboxId, mwStatus, companyName, name, companyId, offerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * * 公開されているポートフォリオの作品のリストを取得します
     * @summary 求職者の公開ポートフォリオ作品リスト
     * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public getAdminPortfolio(userId: string, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).getAdminPortfolio(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Adminユーザー向けの公開ポートフォリオ作品リストページをPDF化します。 該当URLは `/admin/portfolio/{UserMatchboxId}`
     * @summary 求職者の公開ポートフォリオ作品リストPDFダウンロード
     * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public getAdminPortfolioDownload(userMatchboxId: string, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).getAdminPortfolioDownload(userMatchboxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * PDFダウンロード
     * @summary ポートフォリオPDFダウンロード
     * @param {number} pDFTicketID PDF生成ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public getAdminPortfolioDownloadPdf(pDFTicketID: number, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).getAdminPortfolioDownloadPdf(pDFTicketID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * PDFの生成をリクエスト
     * @summary ポートフォリオPDF生成をリクエスト
     * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public getAdminPortfolioRequestToGeneratePdf(userMatchboxId: string, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).getAdminPortfolioRequestToGeneratePdf(userMatchboxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * PDF生成のステータスを確認
     * @summary ポートフォリオPDF生成ステータス確認
     * @param {number} pDFTicketID PDF生成ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public getAdminPortfolioStatusOfPdf(pDFTicketID: number, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).getAdminPortfolioStatusOfPdf(pDFTicketID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ピックアップに対する社員の反応を取得する
     * @summary リアクション一覧
     * @param {string} offerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public getAdminReactions(offerId: string, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).getAdminReactions(offerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 履歴書情報・一覧取得
     * @summary 履歴書情報・一覧取得
     * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public getAdminResume(userId: string, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).getAdminResume(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Adminユーザー向けの履歴書情報ページをPDF化します。 該当URLは `/admin/resume/{UserMatchboxId}`
     * @summary 求職者の履歴書情報PDFダウンロード
     * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public getAdminResumeDownload(userMatchboxId: string, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).getAdminResumeDownload(userMatchboxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 検索条件を取得
     * @summary マイナビ向け検索条件詳細
     * @param {number} adminSearchConditionId マイナビ向け検索条件のID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public getAdminSearchConditionId(adminSearchConditionId: number, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).getAdminSearchConditionId(adminSearchConditionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * マイナビ向け保存検索条件一覧
     * @summary マイナビ向け保存した検索条件一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public getAdminSearchConditions(options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).getAdminSearchConditions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ログインユーザー情報取得  v1では一般ユーザーに管理者権限を与えてる形でアカウントを発行していたがv2からはセキュリティ強化のため一般ユーザーと管理者のデータは明確に分けることになったため管理者アカウントを発行するのはシステム側に依頼し手動で発行するものとする。  アカウント発行時は以下の情報をシステム側に依頼する  ・メールアドレス ・名前 ・部署名 ・役職名 ・アイコン画像 ・種別  種別はadminひとつになるが内部的に以下を振り分けるため登録時に指定する。  MW_A：マイナビ（MATCHBOXの専任者）_マイナビ向けのメールが全部飛んでくる人 MW_B：マイナビ（MATCHBOXに登録されてる各企業担当者）_担当する企業に関わるメールだけが飛んでくる人
     * @summary ログインユーザー情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public getAdminUser(options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).getAdminUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 求職者の情報詳細を取得
     * @summary 求職者情報詳細
     * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public getAdminUserId(userMatchboxId: string, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).getAdminUserId(userMatchboxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * タグ詳細
     * @summary タグ詳細
     * @param {string} userTagId ユーザータグID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public getAdminUserTagId(userTagId: string, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).getAdminUserTagId(userTagId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 保存されてる検索条件に紐づくタグ一覧 レスポンスの構造は求職者詳細用のタグと同じ 企業向けの検索条件のみに紐づく
     * @summary 検索条件に保存された求職者タグ一覧
     * @param {string} [searchConditionId] 保存した検索条件のID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public getAdminUserTagToSearchResult(searchConditionId?: string, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).getAdminUserTagToSearchResult(searchConditionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * タグ一覧  全件取得
     * @summary タグ一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public getAdminUserTags(options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).getAdminUserTags(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 指定した求職者に紐づいているタグ一覧 active が true のものだけ
     * @summary 求職者タグ一覧
     * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public getAdminUserTagsMbid(userMatchboxId: string, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).getAdminUserTagsMbid(userMatchboxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * `skills` `careers` `qualifications`は（職務経歴書用の内部的なorder番号がない場合）order番号を持つデータの一番後ろから表示します。  新たにPATCHを送信した際に、内部的なorder番号を更新します。
     * @summary 求職者職務経歴書更新
     * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
     * @param {CareerHistory} [careerHistory] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public patchAdminCareerHistory(userId: string, careerHistory?: CareerHistory, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).patchAdminCareerHistory(userId, careerHistory, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 企業情報編集
     * @summary 企業情報編集
     * @param {string} directCompanyId 内部的な企業ID
     * @param {AdminCompany} [adminCompany] * 会社の状態( status )   * active / アクティブ   * inactive / 停止   * before_delete / 退会。ヶ月で削除されるかどうか確認中
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public patchAdminCompany(directCompanyId: string, adminCompany?: AdminCompany, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).patchAdminCompany(directCompanyId, adminCompany, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 検索条件のメール配信設定変更する
     * @summary 検索条件のメール配信設定変更
     * @param {number} directSearchConditionId Directの検索条件ID
     * @param {InlineObject1} [inlineObject1] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public patchAdminDirectMailId(directSearchConditionId: number, inlineObject1?: InlineObject1, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).patchAdminDirectMailId(directSearchConditionId, inlineObject1, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 検索条件を編集
     * @summary 企業向け検索条件更新
     * @param {number} adminDirectSearchConditionId 管理者用のDirect向け検索条件のID
     * @param {DirectSearchConditionRequest} [directSearchConditionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public patchAdminDirectSearchConditionId(adminDirectSearchConditionId: number, directSearchConditionRequest?: DirectSearchConditionRequest, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).patchAdminDirectSearchConditionId(adminDirectSearchConditionId, directSearchConditionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 並び替え
     * @summary 企業向け保存した検索条件一覧の並び替え
     * @param {InlineObject5} [inlineObject5] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public patchAdminDirectSearchConditions(inlineObject5?: InlineObject5, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).patchAdminDirectSearchConditions(inlineObject5, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 求職者の入力代行サービスの登録状況を更新する
     * @summary 求職者入力代行情報更新
     * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
     * @param {InlineObject8} [inlineObject8] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public patchAdminInputAgency(userMatchboxId: string, inlineObject8?: InlineObject8, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).patchAdminInputAgency(userMatchboxId, inlineObject8, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * `skills` `careers` `qualifications`は（職務経歴書用の内部的なorder番号がない場合）order番号を持つデータの一番後ろから表示します。  新たにPATCHを送信した際に、内部的なorder番号を更新します。
     * @summary 入力代行職務経歴書更新
     * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
     * @param {CareerHistory} [careerHistory] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public patchAdminInputAgencyCareerHistory(userId: string, careerHistory?: CareerHistory, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).patchAdminInputAgencyCareerHistory(userId, careerHistory, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 入力代行職務経歴・編集
     * @summary 入力代行職務経歴・編集
     * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
     * @param {Career} [career] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public patchAdminInputAgencyCareerHistoryUserIdCareers(userId: string, career?: Career, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).patchAdminInputAgencyCareerHistoryUserIdCareers(userId, career, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 入力代行資格/免許・更新
     * @summary 入力代行資格/免許・更新
     * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
     * @param {Qualification} [qualification] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public patchAdminInputAgencyCareerHistoryUserIdQualifications(userId: string, qualification?: Qualification, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).patchAdminInputAgencyCareerHistoryUserIdQualifications(userId, qualification, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * * 履歴書作成に必要な情報を更新する * 資格、学歴、職務経歴の情報は多いので、送信時には省く（レスポンスには返ってくる） * 資格、職務経歴の表示順序は、内部的に履歴書用のorder番号を持ち、職務経歴書とは別に独立して保存します。  ---  新たな職歴などが追加された場合（履歴書用の内部的なorder番号がない場合）order番号を持つ職歴の一番後ろから表示します。履歴書編集画面で並び替えを行いPATCHを送信した際に、order番号を更新します。
     * @summary 入力代行履歴書更新
     * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
     * @param {Resume} [resume] 証明写真 user.user_info.photo は以下の形式でリクエストする  &#x60;&#x60;&#x60; {   f_id: \&quot;POST /api/v2/files で返ってきた f_id\&quot; } &#x60;&#x60;&#x60;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public patchAdminInputAgencyResume(userId: string, resume?: Resume, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).patchAdminInputAgencyResume(userId, resume, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 入力代行学歴・編集
     * @summary 入力代行学歴・編集
     * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
     * @param {EducationPatchRequest} [educationPatchRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public patchAdminInputAgencyResumeUserIdEducations(userId: string, educationPatchRequest?: EducationPatchRequest, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).patchAdminInputAgencyResumeUserIdEducations(userId, educationPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 自社アカウントが書いたメモを既読にする
     * @summary メモを既読にする
     * @param {AdminNotePatchParam} [adminNotePatchParam] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public patchAdminNote(adminNotePatchParam?: AdminNotePatchParam, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).patchAdminNote(adminNotePatchParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * mwの対応状況を変更する
     * @summary オファーの承認・非承認
     * @param {OfferPatchParam} [offerPatchParam] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public patchAdminOffer(offerPatchParam?: OfferPatchParam, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).patchAdminOffer(offerPatchParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 検索条件を編集
     * @summary マイナビ向け検索条件更新
     * @param {number} adminSearchConditionId マイナビ向け検索条件のID
     * @param {AdminSearchConditionRequest} [adminSearchConditionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public patchAdminSearchConditionId(adminSearchConditionId: number, adminSearchConditionRequest?: AdminSearchConditionRequest, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).patchAdminSearchConditionId(adminSearchConditionId, adminSearchConditionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 並び替え
     * @summary マイナビ向け保存した検索条件一覧の並び替え
     * @param {InlineObject3} [inlineObject3] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public patchAdminSearchConditions(inlineObject3?: InlineObject3, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).patchAdminSearchConditions(inlineObject3, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * * 求職者ユーザーの情報の変更 * 変更があったものだけを送信するようにしたい * PUTしたら、GETした時と同じ情報が返ってくる * アカウント停止/非アクティブ化も行えるようにする * DS-USER-INFO-ADDITINAL に追加して user_status と status (ポートフォリオの公開状態)を変更できるように * 返り値は DS-USER-INFO-ADDITINAL に追加して user_status, user_entry_id, status, portfolio_progress, resume_progress がかえるように
     * @summary 求職者情報変更
     * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
     * @param {AdminMatchboxUserRequest} [adminMatchboxUserRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public patchAdminUserId(userMatchboxId: string, adminMatchboxUserRequest?: AdminMatchboxUserRequest, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).patchAdminUserId(userMatchboxId, adminMatchboxUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * タグ変更
     * @summary タグ 変更
     * @param {string} userTagId ユーザータグID
     * @param {UserTagPatchParam} [userTagPatchParam] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public patchAdminUserTagId(userTagId: string, userTagPatchParam?: UserTagPatchParam, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).patchAdminUserTagId(userTagId, userTagPatchParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * タグ並び替え
     * @summary タグ一覧 並び順変更
     * @param {UserTagsPatchParam} [userTagsPatchParam] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public patchAdminUserTags(userTagsPatchParam?: UserTagsPatchParam, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).patchAdminUserTags(userTagsPatchParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * タグ変更 送らなかったものは削除
     * @summary 求職者 タグ一覧 変更
     * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
     * @param {UserTagsPatchParam} [userTagsPatchParam] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public patchAdminUserTagsMbid(userMatchboxId: string, userTagsPatchParam?: UserTagsPatchParam, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).patchAdminUserTagsMbid(userMatchboxId, userTagsPatchParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 紐付けする企業検索  マイナビ管理画面から企業情報登録時に紐づける企業情報のプロパティ名が block_company_id なのは求職者がブロック対象にする企業を検索するときは外部からインポートした企業情報を登録するためでその法人番号 が block_company_id と定義してる。  MATCHBOX DIRECT を使用する企業 company とその block_company_id が紐づいていないと、ブロックしたはずの企業に求職者情報が表示されてしまうので、企業側も法人番号と紐付けをしている。  また複数設定できるのはある会社(A)をある求職者(X)がブロックしていたと後にA社が分社化してB社ができた場合、求職者Xのブロックする企業にB社も入れないため複数企業を紐づけられるようになっている。  法人番号のカラム名が block_company_id なのは company と分けるため block_companies というDB に入れているため。
     * @summary 紐付けする企業検索
     * @param {BlockCompanyPostParam} [blockCompanyPostParam] &#x60;sort_by&#x60;は&#x60;kana&#x60;を送る想定
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public postAdminBlockCompanies(blockCompanyPostParam?: BlockCompanyPostParam, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).postAdminBlockCompanies(blockCompanyPostParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * idは登録時に不要
     * @summary 企業登録
     * @param {AdminCompanyPostParam} [adminCompanyPostParam] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public postAdminCompany(adminCompanyPostParam?: AdminCompanyPostParam, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).postAdminCompany(adminCompanyPostParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * パスワードを変更します 仕様は冒頭説明箇所を参照
     * @summary 企業ユーザーパスワード変更
     * @param {string} directMatchboxId 企業ユーザーID （B+数字乱数8桁）
     * @param {InlineObject} [inlineObject] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public postAdminCompanyUserPasswordChange(directMatchboxId: string, inlineObject?: InlineObject, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).postAdminCompanyUserPasswordChange(directMatchboxId, inlineObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ## sort_by項目  - registration
     * @summary Direct企業検索
     * @param {AdminSearchCompaniesRequest} [adminSearchCompaniesRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public postAdminDirectCompanies(adminSearchCompaniesRequest?: AdminSearchCompaniesRequest, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).postAdminDirectCompanies(adminSearchCompaniesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 管理者用の企業向け検索条件保存  マイナビ向けの検索条件とは別途保存  ## バックエンド仕様について  バックエンド側では検索条件を JSON でそのまま DB に登録しているので基本的に保存時のリクエストデータの変更に関してはバックエンドに依頼する必要はない。  そのため基本的にどのような構造のデータでも入れることは可能だが検索側のリクエストパラメーターと合わせる必要はあるのでこちらの構造を変更する場合は合わせて検索側も対応しバックエンド側に依頼する。
     * @summary 企業向け検索条件保存
     * @param {DirectSearchConditionRequest} [directSearchConditionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public postAdminDirectSearchCondition(directSearchConditionRequest?: DirectSearchConditionRequest, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).postAdminDirectSearchCondition(directSearchConditionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ## sort_by  - アカウント開設日 registration_date - 最終ログイン日 last_login - 転職希望時期 mc_preferred_change_date - ポートフォリオ作品数 portfolio_item_count
     * @summary 企業向けユーザー検索
     * @param {DirectSearchUserRequest} [directSearchUserRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public postAdminDirectSearchUsers(directSearchUserRequest?: DirectSearchUserRequest, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).postAdminDirectSearchUsers(directSearchUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * c_id はないので、null で送信する 
     * @summary 入力代行職務経歴・追加
     * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
     * @param {Career} [career] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public postAdminInputAgencyCareerHistoryUserIdCareers(userId: string, career?: Career, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).postAdminInputAgencyCareerHistoryUserIdCareers(userId, career, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * q_id はないので、null で送信する
     * @summary 入力代行資格/免許・追加
     * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
     * @param {Qualification} [qualification] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public postAdminInputAgencyCareerHistoryUserIdQualifications(userId: string, qualification?: Qualification, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).postAdminInputAgencyCareerHistoryUserIdQualifications(userId, qualification, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 新規なのでe_id は空文字で送信
     * @summary 入力代行学歴・追加
     * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
     * @param {EducationPostRequest} [educationPostRequest] 入力代行学歴・追加
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public postAdminInputAgencyResumeUserIdEducations(userId: string, educationPostRequest?: EducationPostRequest, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).postAdminInputAgencyResumeUserIdEducations(userId, educationPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ログインをする  ## 開発サーバーテストアカウント  ID : matchbox-dev-notify+dockertestadmin@s2factory.co.jp  PW : test  v1では一般ユーザーに管理者権限を与えてる形でアカウントを発行していたがv2からはセキュリティ強化のため一般ユーザーと管理者のデータは明確に分けることになったため管理者アカウントを発行するのはシステム側に依頼し手動で発行するものとする。
     * @summary 管理者ログイン
     * @param {string} email メールアドレス
     * @param {string} password パスワード
     * @param {string} [type] 以前の as_ca&#x3D;1 と同様。 caとownerがある
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public postAdminLogin(email: string, password: string, type?: string, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).postAdminLogin(email, password, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 企業・求職者へメモを残す
     * @summary 企業・求職者にメモを残す
     * @param {AdminNotePostParam} [adminNotePostParam] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public postAdminNote(adminNotePostParam?: AdminNotePostParam, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).postAdminNote(adminNotePostParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 管理者用の検索条件保存 Diret側とは項目が変わる  ## バックエンド仕様について  バックエンド側では検索条件を JSON でそのまま DB に登録しているので基本的に保存時のリクエストデータの変更に関してはバックエンドに依頼する必要はない。  そのため基本的にどのような構造のデータでも入れることは可能だが検索側のリクエストパラメーターと合わせる必要はあるのでこちらの構造を変更する場合は合わせて検索側も対応しバックエンド側に依頼する。
     * @summary マイナビ向け検索条件保存
     * @param {AdminSearchConditionRequest} [adminSearchConditionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public postAdminSearchCondition(adminSearchConditionRequest?: AdminSearchConditionRequest, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).postAdminSearchCondition(adminSearchConditionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * * 管理ツールなので、少しくらい遅くてもフリーワード検索は実現させたい * age は計算が必要なので毎日１度計算しておく  ## sort_by  - アカウント開設日 registration_date - 最終ログイン日 last_login - 転職希望時期 mc_preferred_change_date - ポートフォリオ作品数 portfolio_item_count
     * @summary マイナビ向けユーザー検索
     * @param {AdminSearchUserRequest} [adminSearchUserRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public postAdminSearchUsers(adminSearchUserRequest?: AdminSearchUserRequest, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).postAdminSearchUsers(adminSearchUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 特定のadminユーザーが求職者検索を行い、 matchbox_idに該当する求職者が検索結果に表示された際のis_readプロパティをtrueに  管理画面はマイナビ向けと企業向けのユーザー検索があるが情報は共有するものとする  ## ユーザー情報の更新を監視する項目  求職者が以下情報を更新すると該当ユーザーのis_readをfalseに  - ポートフォリオ - 履歴書 - 職務経歴 - マイナビクリエイター希望項目 - ユーザー情報
     * @summary 検索結果表示求職者ユーザーの既読状態を更新
     * @param {InlineObject4} [inlineObject4] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public postAdminSearchUsersRead(inlineObject4?: InlineObject4, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).postAdminSearchUsersRead(inlineObject4, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * * POST /admin/search_users/ と同じパラメータを使うことができる * 叩いた後にはCSVがダウンロードされる
     * @summary ユーザー 検索 CSV ダウンロード
     * @param {string} [contentTypeApplicationJsonCharsetUTF8] 
     * @param {Pagination & SearchUsers | SearchUsersByDirect} [paginationSearchUsersSearchUsersByDirect] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public postAdminSearchUsersToCsv(contentTypeApplicationJsonCharsetUTF8?: string, paginationSearchUsersSearchUsersByDirect?: Pagination & SearchUsers | SearchUsersByDirect, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).postAdminSearchUsersToCsv(contentTypeApplicationJsonCharsetUTF8, paginationSearchUsersSearchUsersByDirect, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 保存した検索条件を企業におすすめする  選択条件に対して既に登録済みの企業が含まれていても送信可能に。 重複して登録はマージする
     * @summary 企業に検索条件をおすすめする
     * @param {InlineObject6} [inlineObject6] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public postAdminSuggest(inlineObject6?: InlineObject6, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).postAdminSuggest(inlineObject6, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * * ファイルのアップロード行う * アップロードが完了後、サムネイルのURLとファイルのIDを返す
     * @summary 画像などのファイルアップロード
     * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
     * @param {any} files 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public postAdminUserIdFiles(userId: string, files: any, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).postAdminUserIdFiles(userId, files, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 求職者のパスワードを変更します 仕様は冒頭説明箇所を参照
     * @summary 求職者パスワード変更
     * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
     * @param {InlineObject7} [inlineObject7] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public postAdminUserPasswordChange(userMatchboxId: string, inlineObject7?: InlineObject7, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).postAdminUserPasswordChange(userMatchboxId, inlineObject7, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * タグ作成
     * @summary タグ新規作成
     * @param {UserTagParam} [userTagParam] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public postAdminUserTag(userTagParam?: UserTagParam, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).postAdminUserTag(userTagParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 保存されてる検索条件に対してタグを一括保存 企業向けの検索条件のみに紐づく
     * @summary 検索条件への求職者タグ一括保存
     * @param {UserTagToSearchResultBatchSaveParam} [userTagToSearchResultBatchSaveParam] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ADMINApi
     */
    public postAdminUserTagToSearchResult(userTagToSearchResultBatchSaveParam?: UserTagToSearchResultBatchSaveParam, options?: AxiosRequestConfig) {
        return ADMINApiFp(this.configuration).postAdminUserTagToSearchResult(userTagToSearchResultBatchSaveParam, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ログアウトをする 
         * @summary ログアウト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthLogout: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ログインをする
         * @summary ログイン
         * @param {string} email メールアドレス
         * @param {string} password パスワード
         * @param {string} [type] 以前の as_ca&#x3D;1 と同様。 caとownerがある
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAuthLogin: async (email: string, password: string, type?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('postAuthLogin', 'email', email)
            // verify required parameter 'password' is not null or undefined
            assertParamExists('postAuthLogin', 'password', password)
            const localVarPath = `/api/v2/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (email !== undefined) { 
                localVarFormParams.set('email', email as any);
            }
    
            if (password !== undefined) { 
                localVarFormParams.set('password', password as any);
            }
    
            if (type !== undefined) { 
                localVarFormParams.set('type', type as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * ログアウトをする 
         * @summary ログアウト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuthLogout(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuthLogout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ログインをする
         * @summary ログイン
         * @param {string} email メールアドレス
         * @param {string} password パスワード
         * @param {string} [type] 以前の as_ca&#x3D;1 と同様。 caとownerがある
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAuthLogin(email: string, password: string, type?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAuthLogin(email, password, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * ログアウトをする 
         * @summary ログアウト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthLogout(options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.getAuthLogout(options).then((request) => request(axios, basePath));
        },
        /**
         * ログインをする
         * @summary ログイン
         * @param {string} email メールアドレス
         * @param {string} password パスワード
         * @param {string} [type] 以前の as_ca&#x3D;1 と同様。 caとownerがある
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAuthLogin(email: string, password: string, type?: string, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.postAuthLogin(email, password, type, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * ログアウトをする 
     * @summary ログアウト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public getAuthLogout(options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).getAuthLogout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ログインをする
     * @summary ログイン
     * @param {string} email メールアドレス
     * @param {string} password パスワード
     * @param {string} [type] 以前の as_ca&#x3D;1 と同様。 caとownerがある
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public postAuthLogin(email: string, password: string, type?: string, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).postAuthLogin(email, password, type, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CareerHistoryApi - axios parameter creator
 * @export
 */
export const CareerHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * * 職務経歴書をPDF化します  レスポンスヘッダーについては仕様書説明項目の `PDF生成APIのレスポンスヘッダーについて`を参照
         * @summary 職務経歴書PDFダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        careerHistoryDownload: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/career_history/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 職歴削除
         * @summary 職務経歴・削除
         * @param {string} careerId 職歴ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCareerHistoryCareers: async (careerId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'careerId' is not null or undefined
            assertParamExists('deleteCareerHistoryCareers', 'careerId', careerId)
            const localVarPath = `/api/v2/career_history/careers/{CareerId}`
                .replace(`{${"CareerId"}}`, encodeURIComponent(String(careerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * プロジェクト削除
         * @summary プロジェクト削除
         * @param {string} projectId プロジェクトID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCareerHistoryProjects: async (projectId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('deleteCareerHistoryProjects', 'projectId', projectId)
            const localVarPath = `/api/v2/career_history/projects/{ProjectId}`
                .replace(`{${"ProjectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 資格・免許削除
         * @summary 資格/免許・削除
         * @param {string} qualificationId 資格ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCareerHistoryQualifications: async (qualificationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'qualificationId' is not null or undefined
            assertParamExists('deleteCareerHistoryQualifications', 'qualificationId', qualificationId)
            const localVarPath = `/api/v2/career_history/qualifications/{QualificationId}`
                .replace(`{${"QualificationId"}}`, encodeURIComponent(String(qualificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * スキル削除
         * @summary スキル削除
         * @param {string} skillId スキルID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCareerHistorySkill: async (skillId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('deleteCareerHistorySkill', 'skillId', skillId)
            const localVarPath = `/api/v2/career_history/skills/{SkillId}`
                .replace(`{${"SkillId"}}`, encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 職務経歴書
         * @summary 職務経歴書
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerHistory: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getCareerHistory', 'userId', userId)
            const localVarPath = `/api/v2/career_history/{UserId}`
                .replace(`{${"UserId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 職務経歴書
         * @summary 公開スキル一覧
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerHistorySkills: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getCareerHistorySkills', 'userId', userId)
            const localVarPath = `/api/v2/career_history/{UserId}/skills`
                .replace(`{${"UserId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 入力代行済職務経歴書取得
         * @summary 入力代行済職務経歴書取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInputAgencyCareerHistory: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/input_agency/career_history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * `skills` `careers` `qualifications`は（職務経歴書用の内部的なorder番号がない場合）order番号を持つデータの一番後ろから表示します。  新たにPATCHを送信した際に、内部的なorder番号を更新します。 ※S2さんにフィジビリティ要確認
         * @summary 職務経歴書更新
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {CareerHistory} [careerHistory] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCareerHistory: async (userId: string, careerHistory?: CareerHistory, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('patchCareerHistory', 'userId', userId)
            const localVarPath = `/api/v2/career_history/{UserId}`
                .replace(`{${"UserId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(careerHistory, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 職務経歴・編集
         * @summary 職務経歴・編集
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {Career} [career] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCareerHistoryUserIdCareers: async (userId: string, career?: Career, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('patchCareerHistoryUserIdCareers', 'userId', userId)
            const localVarPath = `/api/v2/career_history/{UserId}/careers`
                .replace(`{${"UserId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(career, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 編集
         * @summary 資格
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {Qualification} [qualification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCareerHistoryUserIdQualifications: async (userId: string, qualification?: Qualification, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('patchCareerHistoryUserIdQualifications', 'userId', userId)
            const localVarPath = `/api/v2/career_history/{UserId}/qualifications`
                .replace(`{${"UserId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(qualification, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * c_id はないので、null で送信する 
         * @summary 職務経歴・追加
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {Career} [career] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCareerHistoryUserIdCareers: async (userId: string, career?: Career, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('postCareerHistoryUserIdCareers', 'userId', userId)
            const localVarPath = `/api/v2/career_history/{UserId}/careers`
                .replace(`{${"UserId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(career, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * q_id はないので、null で送信する
         * @summary 資格
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {Qualification} [qualification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCareerHistoryUserIdQualifications: async (userId: string, qualification?: Qualification, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('postCareerHistoryUserIdQualifications', 'userId', userId)
            const localVarPath = `/api/v2/career_history/{UserId}/qualifications`
                .replace(`{${"UserId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(qualification, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CareerHistoryApi - functional programming interface
 * @export
 */
export const CareerHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CareerHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * * 職務経歴書をPDF化します  レスポンスヘッダーについては仕様書説明項目の `PDF生成APIのレスポンスヘッダーについて`を参照
         * @summary 職務経歴書PDFダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async careerHistoryDownload(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.careerHistoryDownload(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 職歴削除
         * @summary 職務経歴・削除
         * @param {string} careerId 職歴ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCareerHistoryCareers(careerId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCareerHistoryCareers(careerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * プロジェクト削除
         * @summary プロジェクト削除
         * @param {string} projectId プロジェクトID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCareerHistoryProjects(projectId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCareerHistoryProjects(projectId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 資格・免許削除
         * @summary 資格/免許・削除
         * @param {string} qualificationId 資格ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCareerHistoryQualifications(qualificationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCareerHistoryQualifications(qualificationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * スキル削除
         * @summary スキル削除
         * @param {string} skillId スキルID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCareerHistorySkill(skillId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCareerHistorySkill(skillId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 職務経歴書
         * @summary 職務経歴書
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCareerHistory(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CareerHistory & Status & UserInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCareerHistory(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 職務経歴書
         * @summary 公開スキル一覧
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCareerHistorySkills(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Status & object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCareerHistorySkills(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 入力代行済職務経歴書取得
         * @summary 入力代行済職務経歴書取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInputAgencyCareerHistory(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CareerHistory & Status & UserInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInputAgencyCareerHistory(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * `skills` `careers` `qualifications`は（職務経歴書用の内部的なorder番号がない場合）order番号を持つデータの一番後ろから表示します。  新たにPATCHを送信した際に、内部的なorder番号を更新します。 ※S2さんにフィジビリティ要確認
         * @summary 職務経歴書更新
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {CareerHistory} [careerHistory] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchCareerHistory(userId: string, careerHistory?: CareerHistory, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CareerHistory & Status & UserInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchCareerHistory(userId, careerHistory, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 職務経歴・編集
         * @summary 職務経歴・編集
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {Career} [career] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchCareerHistoryUserIdCareers(userId: string, career?: Career, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object & Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchCareerHistoryUserIdCareers(userId, career, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 編集
         * @summary 資格
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {Qualification} [qualification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchCareerHistoryUserIdQualifications(userId: string, qualification?: Qualification, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object & Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchCareerHistoryUserIdQualifications(userId, qualification, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * c_id はないので、null で送信する 
         * @summary 職務経歴・追加
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {Career} [career] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCareerHistoryUserIdCareers(userId: string, career?: Career, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object & Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCareerHistoryUserIdCareers(userId, career, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * q_id はないので、null で送信する
         * @summary 資格
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {Qualification} [qualification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCareerHistoryUserIdQualifications(userId: string, qualification?: Qualification, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object & Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCareerHistoryUserIdQualifications(userId, qualification, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CareerHistoryApi - factory interface
 * @export
 */
export const CareerHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CareerHistoryApiFp(configuration)
    return {
        /**
         * * 職務経歴書をPDF化します  レスポンスヘッダーについては仕様書説明項目の `PDF生成APIのレスポンスヘッダーについて`を参照
         * @summary 職務経歴書PDFダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        careerHistoryDownload(options?: any): AxiosPromise<object> {
            return localVarFp.careerHistoryDownload(options).then((request) => request(axios, basePath));
        },
        /**
         * 職歴削除
         * @summary 職務経歴・削除
         * @param {string} careerId 職歴ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCareerHistoryCareers(careerId: string, options?: any): AxiosPromise<Status> {
            return localVarFp.deleteCareerHistoryCareers(careerId, options).then((request) => request(axios, basePath));
        },
        /**
         * プロジェクト削除
         * @summary プロジェクト削除
         * @param {string} projectId プロジェクトID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCareerHistoryProjects(projectId: string, options?: any): AxiosPromise<Status> {
            return localVarFp.deleteCareerHistoryProjects(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 資格・免許削除
         * @summary 資格/免許・削除
         * @param {string} qualificationId 資格ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCareerHistoryQualifications(qualificationId: string, options?: any): AxiosPromise<Status> {
            return localVarFp.deleteCareerHistoryQualifications(qualificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * スキル削除
         * @summary スキル削除
         * @param {string} skillId スキルID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCareerHistorySkill(skillId: string, options?: any): AxiosPromise<Status> {
            return localVarFp.deleteCareerHistorySkill(skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 職務経歴書
         * @summary 職務経歴書
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerHistory(userId: string, options?: any): AxiosPromise<CareerHistory & Status & UserInfo> {
            return localVarFp.getCareerHistory(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 職務経歴書
         * @summary 公開スキル一覧
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCareerHistorySkills(userId: string, options?: any): AxiosPromise<Status & object> {
            return localVarFp.getCareerHistorySkills(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 入力代行済職務経歴書取得
         * @summary 入力代行済職務経歴書取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInputAgencyCareerHistory(options?: any): AxiosPromise<CareerHistory & Status & UserInfo> {
            return localVarFp.getInputAgencyCareerHistory(options).then((request) => request(axios, basePath));
        },
        /**
         * `skills` `careers` `qualifications`は（職務経歴書用の内部的なorder番号がない場合）order番号を持つデータの一番後ろから表示します。  新たにPATCHを送信した際に、内部的なorder番号を更新します。 ※S2さんにフィジビリティ要確認
         * @summary 職務経歴書更新
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {CareerHistory} [careerHistory] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCareerHistory(userId: string, careerHistory?: CareerHistory, options?: any): AxiosPromise<CareerHistory & Status & UserInfo> {
            return localVarFp.patchCareerHistory(userId, careerHistory, options).then((request) => request(axios, basePath));
        },
        /**
         * 職務経歴・編集
         * @summary 職務経歴・編集
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {Career} [career] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCareerHistoryUserIdCareers(userId: string, career?: Career, options?: any): AxiosPromise<object & Status> {
            return localVarFp.patchCareerHistoryUserIdCareers(userId, career, options).then((request) => request(axios, basePath));
        },
        /**
         * 編集
         * @summary 資格
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {Qualification} [qualification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCareerHistoryUserIdQualifications(userId: string, qualification?: Qualification, options?: any): AxiosPromise<object & Status> {
            return localVarFp.patchCareerHistoryUserIdQualifications(userId, qualification, options).then((request) => request(axios, basePath));
        },
        /**
         * c_id はないので、null で送信する 
         * @summary 職務経歴・追加
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {Career} [career] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCareerHistoryUserIdCareers(userId: string, career?: Career, options?: any): AxiosPromise<object & Status> {
            return localVarFp.postCareerHistoryUserIdCareers(userId, career, options).then((request) => request(axios, basePath));
        },
        /**
         * q_id はないので、null で送信する
         * @summary 資格
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {Qualification} [qualification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCareerHistoryUserIdQualifications(userId: string, qualification?: Qualification, options?: any): AxiosPromise<object & Status> {
            return localVarFp.postCareerHistoryUserIdQualifications(userId, qualification, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CareerHistoryApi - object-oriented interface
 * @export
 * @class CareerHistoryApi
 * @extends {BaseAPI}
 */
export class CareerHistoryApi extends BaseAPI {
    /**
     * * 職務経歴書をPDF化します  レスポンスヘッダーについては仕様書説明項目の `PDF生成APIのレスポンスヘッダーについて`を参照
     * @summary 職務経歴書PDFダウンロード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerHistoryApi
     */
    public careerHistoryDownload(options?: AxiosRequestConfig) {
        return CareerHistoryApiFp(this.configuration).careerHistoryDownload(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 職歴削除
     * @summary 職務経歴・削除
     * @param {string} careerId 職歴ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerHistoryApi
     */
    public deleteCareerHistoryCareers(careerId: string, options?: AxiosRequestConfig) {
        return CareerHistoryApiFp(this.configuration).deleteCareerHistoryCareers(careerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * プロジェクト削除
     * @summary プロジェクト削除
     * @param {string} projectId プロジェクトID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerHistoryApi
     */
    public deleteCareerHistoryProjects(projectId: string, options?: AxiosRequestConfig) {
        return CareerHistoryApiFp(this.configuration).deleteCareerHistoryProjects(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 資格・免許削除
     * @summary 資格/免許・削除
     * @param {string} qualificationId 資格ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerHistoryApi
     */
    public deleteCareerHistoryQualifications(qualificationId: string, options?: AxiosRequestConfig) {
        return CareerHistoryApiFp(this.configuration).deleteCareerHistoryQualifications(qualificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * スキル削除
     * @summary スキル削除
     * @param {string} skillId スキルID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerHistoryApi
     */
    public deleteCareerHistorySkill(skillId: string, options?: AxiosRequestConfig) {
        return CareerHistoryApiFp(this.configuration).deleteCareerHistorySkill(skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 職務経歴書
     * @summary 職務経歴書
     * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerHistoryApi
     */
    public getCareerHistory(userId: string, options?: AxiosRequestConfig) {
        return CareerHistoryApiFp(this.configuration).getCareerHistory(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 職務経歴書
     * @summary 公開スキル一覧
     * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerHistoryApi
     */
    public getCareerHistorySkills(userId: string, options?: AxiosRequestConfig) {
        return CareerHistoryApiFp(this.configuration).getCareerHistorySkills(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 入力代行済職務経歴書取得
     * @summary 入力代行済職務経歴書取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerHistoryApi
     */
    public getInputAgencyCareerHistory(options?: AxiosRequestConfig) {
        return CareerHistoryApiFp(this.configuration).getInputAgencyCareerHistory(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * `skills` `careers` `qualifications`は（職務経歴書用の内部的なorder番号がない場合）order番号を持つデータの一番後ろから表示します。  新たにPATCHを送信した際に、内部的なorder番号を更新します。 ※S2さんにフィジビリティ要確認
     * @summary 職務経歴書更新
     * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
     * @param {CareerHistory} [careerHistory] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerHistoryApi
     */
    public patchCareerHistory(userId: string, careerHistory?: CareerHistory, options?: AxiosRequestConfig) {
        return CareerHistoryApiFp(this.configuration).patchCareerHistory(userId, careerHistory, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 職務経歴・編集
     * @summary 職務経歴・編集
     * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
     * @param {Career} [career] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerHistoryApi
     */
    public patchCareerHistoryUserIdCareers(userId: string, career?: Career, options?: AxiosRequestConfig) {
        return CareerHistoryApiFp(this.configuration).patchCareerHistoryUserIdCareers(userId, career, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 編集
     * @summary 資格
     * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
     * @param {Qualification} [qualification] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerHistoryApi
     */
    public patchCareerHistoryUserIdQualifications(userId: string, qualification?: Qualification, options?: AxiosRequestConfig) {
        return CareerHistoryApiFp(this.configuration).patchCareerHistoryUserIdQualifications(userId, qualification, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * c_id はないので、null で送信する 
     * @summary 職務経歴・追加
     * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
     * @param {Career} [career] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerHistoryApi
     */
    public postCareerHistoryUserIdCareers(userId: string, career?: Career, options?: AxiosRequestConfig) {
        return CareerHistoryApiFp(this.configuration).postCareerHistoryUserIdCareers(userId, career, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * q_id はないので、null で送信する
     * @summary 資格
     * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
     * @param {Qualification} [qualification] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CareerHistoryApi
     */
    public postCareerHistoryUserIdQualifications(userId: string, qualification?: Qualification, options?: AxiosRequestConfig) {
        return CareerHistoryApiFp(this.configuration).postCareerHistoryUserIdQualifications(userId, qualification, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DirectApi - axios parameter creator
 * @export
 */
export const DirectApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * userTypeが `direct_manager` のアカウントのみ利用可能
         * @summary 企業ユーザーグループ 削除
         * @param {string} companyGroupId 企業内グループID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDirectCompanyGroupCompanyGroupId: async (companyGroupId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyGroupId' is not null or undefined
            assertParamExists('deleteDirectCompanyGroupCompanyGroupId', 'companyGroupId', companyGroupId)
            const localVarPath = `/api/v2/direct/company_group/{CompanyGroupId}`
                .replace(`{${"CompanyGroupId"}}`, encodeURIComponent(String(companyGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * * アカウント停止/非アクティブ化 * すぐにデータ削除
         * @summary 企業ユーザー情報の削除
         * @param {string} directMatchboxId 企業ユーザーID （B+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDirectCompanyUserId: async (directMatchboxId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'directMatchboxId' is not null or undefined
            assertParamExists('deleteDirectCompanyUserId', 'directMatchboxId', directMatchboxId)
            const localVarPath = `/api/v2/direct/company_user/{DirectMatchboxId}`
                .replace(`{${"DirectMatchboxId"}}`, encodeURIComponent(String(directMatchboxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * メモを削除する
         * @summary メモを削除する
         * @param {number} noteId noteのid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDirectNote: async (noteId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('deleteDirectNote', 'noteId', noteId)
            const localVarPath = `/api/v2/direct/note/{noteId}`
                .replace(`{${"noteId"}}`, encodeURIComponent(String(noteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 求職者へのピックアップを解除する
         * @summary オファーの解除
         * @param {string} offerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDirectOffer: async (offerId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offerId' is not null or undefined
            assertParamExists('deleteDirectOffer', 'offerId', offerId)
            const localVarPath = `/api/v2/direct/offer/{offer_id}`
                .replace(`{${"offer_id"}}`, encodeURIComponent(String(offerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 削除
         * @summary ポジション削除
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDirectOfferPositionId: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteDirectOfferPositionId', 'id', id)
            const localVarPath = `/api/v2/direct/offer_position/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 検索条件を削除
         * @summary 検索条件削除
         * @param {number} directSearchConditionId Directの検索条件ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDirectSearchConditionId: async (directSearchConditionId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'directSearchConditionId' is not null or undefined
            assertParamExists('deleteDirectSearchConditionId', 'directSearchConditionId', directSearchConditionId)
            const localVarPath = `/api/v2/direct/search_condition/{DirectSearchConditionId}`
                .replace(`{${"DirectSearchConditionId"}}`, encodeURIComponent(String(directSearchConditionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * directユーザーからのアクセスの場合、UserInfo は伏せる
         * @summary 職務経歴書
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectCareerHistory: async (userMatchboxId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userMatchboxId' is not null or undefined
            assertParamExists('getDirectCareerHistory', 'userMatchboxId', userMatchboxId)
            const localVarPath = `/api/v2/direct/career_history/{UserMatchboxId}`
                .replace(`{${"UserMatchboxId"}}`, encodeURIComponent(String(userMatchboxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Directユーザー向けの職務経歴書ページをPDF化します。 該当URLは `/direct/cv/{UserMatchboxId}`
         * @summary 求職者の職務経歴書PDFダウンロード
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectCareerHistoryDownload: async (userMatchboxId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userMatchboxId' is not null or undefined
            assertParamExists('getDirectCareerHistoryDownload', 'userMatchboxId', userMatchboxId)
            const localVarPath = `/api/v2/direct/career_history/{UserMatchboxId}/download`
                .replace(`{${"UserMatchboxId"}}`, encodeURIComponent(String(userMatchboxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 自社情報
         * @summary 企業情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectCompany: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/direct/company`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 企業内グループ詳細
         * @summary 企業ユーザーグループ詳細
         * @param {string} companyGroupId 企業内グループID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectCompanyGroupId: async (companyGroupId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyGroupId' is not null or undefined
            assertParamExists('getDirectCompanyGroupId', 'companyGroupId', companyGroupId)
            const localVarPath = `/api/v2/direct/company_group/{CompanyGroupId}`
                .replace(`{${"CompanyGroupId"}}`, encodeURIComponent(String(companyGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 企業内グループ一覧  全件取得
         * @summary 企業内グループ一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectCompanyGroups: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/direct/company_groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 企業ユーザー情報詳細
         * @summary 企業ユーザー情報詳細
         * @param {string} directMatchboxId 企業ユーザーID （B+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectCompanyUserId: async (directMatchboxId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'directMatchboxId' is not null or undefined
            assertParamExists('getDirectCompanyUserId', 'directMatchboxId', directMatchboxId)
            const localVarPath = `/api/v2/direct/company_user/{DirectMatchboxId}`
                .replace(`{${"DirectMatchboxId"}}`, encodeURIComponent(String(directMatchboxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 企業内ユーザー一覧  Queryを省略した場合 `limit=20 offset=0 sort_by=created_at` となる
         * @summary 企業内ユーザー一覧
         * @param {number} [limit] 一覧取得時に1ページに出す件数
         * @param {number} [offset] 一覧検索時の1ページの始まりの番号
         * @param {string} [sortBy] 並び替え時に基準データ sort_order がない場合はdesc固定
         * @param {string} [userName] ユーザー名
         * @param {string} [mail] メールアドレス
         * @param {string} [group] 企業ユーザーグループのID
         * @param {'direct_manager' | 'direct_user' | 'direct_hr'} [userType] 企業ユーザータイプ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectCompanyUsers: async (limit?: number, offset?: number, sortBy?: string, userName?: string, mail?: string, group?: string, userType?: 'direct_manager' | 'direct_user' | 'direct_hr', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/direct/company_users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (userName !== undefined) {
                localVarQueryParameter['user_name'] = userName;
            }

            if (mail !== undefined) {
                localVarQueryParameter['mail'] = mail;
            }

            if (group !== undefined) {
                localVarQueryParameter['group'] = group;
            }

            if (userType !== undefined) {
                localVarQueryParameter['user_type'] = userType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ログイン状態を見る
         * @summary ログイン状態／ユーザー情報の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectIsLogin: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/direct/is-login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ログアウトをする 
         * @summary ログアウト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectLogout: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/direct/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 企業・求職者に送信したメモ一覧
         * @summary 企業・求職者に送信したメモ一覧
         * @param {string} [matchboxId] Directユーザーのみ利用可能
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectNotes: async (matchboxId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/direct/notes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (matchboxId !== undefined) {
                localVarQueryParameter['matchbox_id'] = matchboxId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ポジション詳細取得
         * @summary ポジション詳細
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectOfferPositionId: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDirectOfferPositionId', 'id', id)
            const localVarPath = `/api/v2/direct/offer_position/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 一覧
         * @summary ポジション管理
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectOfferPositions: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/direct/offer_positions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * * Directアカウント：自社がオーナーのもののみ表示
         * @summary オファー一覧
         * @param {string} limit 
         * @param {string} offset 
         * @param {string} sortBy 
         * @param {string} sortOrder 
         * @param {number} [status] ステータス。DirectまたはMWアカウントのみ利用可。
         * @param {number} [rate] マッチ度。Directアカウントのみ利用可。
         * @param {number} [job] 職種。Directアカウントのみ利用可。
         * @param {number} [position] ポジション
         * @param {string} [matchboxId] 求職者へのオファー一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectOffers: async (limit: string, offset: string, sortBy: string, sortOrder: string, status?: number, rate?: number, job?: number, position?: number, matchboxId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getDirectOffers', 'limit', limit)
            // verify required parameter 'offset' is not null or undefined
            assertParamExists('getDirectOffers', 'offset', offset)
            // verify required parameter 'sortBy' is not null or undefined
            assertParamExists('getDirectOffers', 'sortBy', sortBy)
            // verify required parameter 'sortOrder' is not null or undefined
            assertParamExists('getDirectOffers', 'sortOrder', sortOrder)
            const localVarPath = `/api/v2/direct/offers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (rate !== undefined) {
                localVarQueryParameter['rate'] = rate;
            }

            if (job !== undefined) {
                localVarQueryParameter['job'] = job;
            }

            if (position !== undefined) {
                localVarQueryParameter['position'] = position;
            }

            if (matchboxId !== undefined) {
                localVarQueryParameter['matchbox_id'] = matchboxId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * * 公開されているポートフォリオの作品のリストを取得します * 他人に非公開の場合などは見れないという旨のレスポンスが返ります * その時は、パスワードをつけて POSTでリクエストをすると表示される情報のデータが返ります。
         * @summary 求職者の公開ポートフォリオ作品リスト
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {string} [password] パスワード付き公開の場合に必要になる
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectPortfolio: async (userMatchboxId: string, password?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userMatchboxId' is not null or undefined
            assertParamExists('getDirectPortfolio', 'userMatchboxId', userMatchboxId)
            const localVarPath = `/api/v2/direct/portfolio/{UserMatchboxId}`
                .replace(`{${"UserMatchboxId"}}`, encodeURIComponent(String(userMatchboxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (password !== undefined) {
                localVarQueryParameter['password'] = password;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ピックアップに対する社員の反応を取得する
         * @summary リアクション一覧
         * @param {string} offerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectReactions: async (offerId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'offerId' is not null or undefined
            assertParamExists('getDirectReactions', 'offerId', offerId)
            const localVarPath = `/api/v2/direct/reactions/{offer_id}`
                .replace(`{${"offer_id"}}`, encodeURIComponent(String(offerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 検索条件を取得
         * @summary 検索条件詳細
         * @param {number} directSearchConditionId Directの検索条件ID
         * @param {boolean} [recommend] おすすめの検索条件かどうか
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectSearchConditionId: async (directSearchConditionId: number, recommend?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'directSearchConditionId' is not null or undefined
            assertParamExists('getDirectSearchConditionId', 'directSearchConditionId', directSearchConditionId)
            const localVarPath = `/api/v2/direct/search_condition/{DirectSearchConditionId}`
                .replace(`{${"DirectSearchConditionId"}}`, encodeURIComponent(String(directSearchConditionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (recommend !== undefined) {
                localVarQueryParameter['recommend'] = recommend;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 保存した検索条件一覧
         * @summary 保存した検索条件一覧
         * @param {boolean} [recommended] MATCHBOXのおすすめ検索条件
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectSearchConditions: async (recommended?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/direct/search_conditions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (recommended !== undefined) {
                localVarQueryParameter['recommended'] = recommended;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * タグに紐づいたユーザー情報一覧
         * @summary タグ ユーザー情報一覧
         * @param {string} userTagPath MW側で設定したタグのパス
         * @param {number} [limit] 取得件数 指定がない場合は20
         * @param {number} [offset] 次のページ番号 指定がない場合は0
         * @param {string} [sortBy] 検索項目 項目はdescription参照
         * @param {string} [sortOrder] 検索順序 asc | desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectTagSearchUsersId: async (userTagPath: string, limit?: number, offset?: number, sortBy?: string, sortOrder?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userTagPath' is not null or undefined
            assertParamExists('getDirectTagSearchUsersId', 'userTagPath', userTagPath)
            const localVarPath = `/api/v2/direct/tag_search_users/{UserTagPath}`
                .replace(`{${"UserTagPath"}}`, encodeURIComponent(String(userTagPath)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ユーザー情報取得
         * @summary ユーザー情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectUser: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/direct/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ユーザー情報詳細 取得
         * @summary ユーザー情報詳細
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectUserMatchboxId: async (userMatchboxId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userMatchboxId' is not null or undefined
            assertParamExists('getDirectUserMatchboxId', 'userMatchboxId', userMatchboxId)
            const localVarPath = `/api/v2/direct/user/{UserMatchboxId}`
                .replace(`{${"UserMatchboxId"}}`, encodeURIComponent(String(userMatchboxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * タグに紐づいたユーザー情報一覧
         * @summary タグ情報取得
         * @param {string} userTagPath MW側で設定したタグのパス
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectUserTagPath: async (userTagPath: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userTagPath' is not null or undefined
            assertParamExists('getDirectUserTagPath', 'userTagPath', userTagPath)
            const localVarPath = `/api/v2/direct/user_tag/{UserTagPath}`
                .replace(`{${"UserTagPath"}}`, encodeURIComponent(String(userTagPath)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * direct_adminのユーザーがPATCHした場合のみ有効
         * @summary 企業情報編集
         * @param {DirectCompanyModel} [directCompanyModel] 自社情報編集
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDirectCompany: async (directCompanyModel?: DirectCompanyModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/direct/company`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(directCompanyModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * userTypeが `direct_manager` のアカウントのみ利用可能
         * @summary 企業ユーザーグループ 変更
         * @param {string} companyGroupId 企業内グループID
         * @param {CompanyGroupParam} [companyGroupParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDirectCompanyGroupCompanyGroupId: async (companyGroupId: string, companyGroupParam?: CompanyGroupParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyGroupId' is not null or undefined
            assertParamExists('patchDirectCompanyGroupCompanyGroupId', 'companyGroupId', companyGroupId)
            const localVarPath = `/api/v2/direct/company_group/{CompanyGroupId}`
                .replace(`{${"CompanyGroupId"}}`, encodeURIComponent(String(companyGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyGroupParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * userTypeが `direct_manager` のアカウントのみ利用可能
         * @summary 企業内グループ一覧 並び順変更
         * @param {InlineObject11} [inlineObject11] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDirectCompanyGroups: async (inlineObject11?: InlineObject11, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/direct/company_groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject11, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * userTypeが `direct_manager` のアカウントのみ利用可能  https://www.figma.com/file/tDn9C162xYWTXkvFMaipAn/Final-Design-and-Design-system?node-id=4694%3A66093
         * @summary 企業ユーザー情報の変更
         * @param {string} directMatchboxId 企業ユーザーID （B+数字乱数8桁）
         * @param {DirectCompanyUserParam} [directCompanyUserParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDirectCompanyUserId: async (directMatchboxId: string, directCompanyUserParam?: DirectCompanyUserParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'directMatchboxId' is not null or undefined
            assertParamExists('patchDirectCompanyUserId', 'directMatchboxId', directMatchboxId)
            const localVarPath = `/api/v2/direct/company_user/{DirectMatchboxId}`
                .replace(`{${"DirectMatchboxId"}}`, encodeURIComponent(String(directMatchboxId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(directCompanyUserParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 並び替え
         * @summary 企業ユーザー一覧 並び順変更
         * @param {InlineObject10} [inlineObject10] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDirectCompanyUsers: async (inlineObject10?: InlineObject10, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/direct/company_users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject10, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 検索条件のメール配信設定変更する
         * @summary 検索条件のメール配信設定変更
         * @param {number} directSearchConditionId Directの検索条件ID
         * @param {InlineObject15} [inlineObject15] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDirectDirectMailId: async (directSearchConditionId: number, inlineObject15?: InlineObject15, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'directSearchConditionId' is not null or undefined
            assertParamExists('patchDirectDirectMailId', 'directSearchConditionId', directSearchConditionId)
            const localVarPath = `/api/v2/direct/direct_mail/{DirectSearchConditionId}`
                .replace(`{${"DirectSearchConditionId"}}`, encodeURIComponent(String(directSearchConditionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject15, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 自社アカウントが書いたメモを既読にする
         * @summary メモを既読にする
         * @param {AdminNotePatchParam} [adminNotePatchParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDirectNote: async (adminNotePatchParam?: AdminNotePatchParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/direct/note`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminNotePatchParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * オファーのステータス変更
         * @summary オファーのステータス変更
         * @param {DirectOfferPatchParam} [directOfferPatchParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDirectOffer: async (directOfferPatchParam?: DirectOfferPatchParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/direct/offer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(directOfferPatchParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 更新
         * @summary ポジション更新
         * @param {string} id 
         * @param {DirectOfferPositionParam} [directOfferPositionParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDirectOfferPositionId: async (id: string, directOfferPositionParam?: DirectOfferPositionParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchDirectOfferPositionId', 'id', id)
            const localVarPath = `/api/v2/direct/offer_position/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(directOfferPositionParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 並び替え
         * @summary ポジション管理 並び替え
         * @param {InlineObject19} [inlineObject19] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDirectOfferPositions: async (inlineObject19?: InlineObject19, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/direct/offer_positions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject19, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ピックアップに対するリアクションの修正
         * @summary リアクションを更新する
         * @param {ReactionPatchParam} [reactionPatchParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDirectReaction: async (reactionPatchParam?: ReactionPatchParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/direct/reaction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reactionPatchParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 検索条件を編集
         * @summary 検索条件更新
         * @param {number} directSearchConditionId Directの検索条件ID
         * @param {DirectSearchConditionRequest} [directSearchConditionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDirectSearchConditionId: async (directSearchConditionId: number, directSearchConditionRequest?: DirectSearchConditionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'directSearchConditionId' is not null or undefined
            assertParamExists('patchDirectSearchConditionId', 'directSearchConditionId', directSearchConditionId)
            const localVarPath = `/api/v2/direct/search_condition/{DirectSearchConditionId}`
                .replace(`{${"DirectSearchConditionId"}}`, encodeURIComponent(String(directSearchConditionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(directSearchConditionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 並び替え
         * @summary 保存した検索条件一覧の並び替え
         * @param {boolean} [recommended] MATCHBOXのおすすめ検索条件
         * @param {InlineObject14} [inlineObject14] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDirectSearchConditions: async (recommended?: boolean, inlineObject14?: InlineObject14, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/direct/search_conditions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (recommended !== undefined) {
                localVarQueryParameter['recommended'] = recommended;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject14, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ログインユーザーの情報変更
         * @summary ユーザー情報変更
         * @param {DirectUserParam} [directUserParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDirectUser: async (directUserParam?: DirectUserParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/direct/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(directUserParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * userTypeが `direct_manager` のアカウントのみ利用可能  企業内グループ作成
         * @summary 企業ユーザーグループ新規作成
         * @param {CompanyGroupParam} [companyGroupParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDirectCompanyGroup: async (companyGroupParam?: CompanyGroupParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/direct/company_group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyGroupParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 企業ユーザーのメールアドレスの変更  https://www.figma.com/file/tDn9C162xYWTXkvFMaipAn/Final-Design-and-Design-system?node-id=2249%3A423
         * @summary ユーザー情報 メールアドレス変更
         * @param {UserEmailChange} [userEmailChange] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDirectEmailChange: async (userEmailChange?: UserEmailChange, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/direct/email_change`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userEmailChange, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 企業ユーザーのメールアドレスの変更時のトークンチェック トークンが正しければそのまま変更完了処理までする  https://www.figma.com/file/tDn9C162xYWTXkvFMaipAn/Final-Design-and-Design-system?node-id=2249%3A423
         * @summary ユーザー情報 メールアドレス変更 トークンチェック & 変更完了
         * @param {UserEmailChangeToken} [userEmailChangeToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDirectEmailChangeValidateToken: async (userEmailChangeToken?: UserEmailChangeToken, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/direct/email_change/validate_token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userEmailChangeToken, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 新規企業ユーザーを招待する
         * @summary 新規企業ユーザーを招待する
         * @param {InlineObject12} [inlineObject12] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDirectInvite: async (inlineObject12?: InlineObject12, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/direct/invite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject12, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ログインをする  ## 開発サーバーテストアカウント  ID : matchbox-dev-notify+dockertestcompanymanager@s2factory.co.jp  PW : test
         * @summary ログイン
         * @param {string} email メールアドレス
         * @param {string} password パスワード
         * @param {string} [type] 以前の as_ca&#x3D;1 と同様。 caとownerがある
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDirectLogin: async (email: string, password: string, type?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('postDirectLogin', 'email', email)
            // verify required parameter 'password' is not null or undefined
            assertParamExists('postDirectLogin', 'password', password)
            const localVarPath = `/api/v2/direct/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (email !== undefined) { 
                localVarFormParams.set('email', email as any);
            }
    
            if (password !== undefined) { 
                localVarFormParams.set('password', password as any);
            }
    
            if (type !== undefined) { 
                localVarFormParams.set('type', type as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * MWが企業へ、またはDirectユーザーが求職者へメモを残す
         * @summary 企業・求職者にメモを残す
         * @param {AdminNotePostParam} [adminNotePostParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDirectNote: async (adminNotePostParam?: AdminNotePostParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/direct/note`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminNotePostParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 求職者をピックアップする
         * @summary オファー送信
         * @param {OfferPostParam} [offerPostParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDirectOffer: async (offerPostParam?: OfferPostParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/direct/offer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(offerPostParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ポジション新規作成
         * @summary ポジション新規作成
         * @param {DirectOfferPositionParam} [directOfferPositionParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDirectOfferPosition: async (directOfferPositionParam?: DirectOfferPositionParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/direct/offer_position`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(directOfferPositionParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * パスワードを変更します 仕様は冒頭説明箇所を参照
         * @summary パスワード変更
         * @param {PasswordChangeParam} [passwordChangeParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDirectPasswordChange: async (passwordChangeParam?: PasswordChangeParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/direct/password_change`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passwordChangeParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * パスワードをリセットします  ---  * v2ではPOST成功時に登録メールアドレスに登録メールを送信してパスワードを別途設定する。
         * @summary パスワードリセット
         * @param {PasswordResetParam} [passwordResetParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDirectPasswordReset: async (passwordResetParam?: PasswordResetParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/direct/password_reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passwordResetParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * パスワード再設定 仕様は冒頭説明箇所を参照
         * @summary ログイン画面からのパスワード再設定
         * @param {RequestPassword} [requestPassword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDirectPasswordResetPassword: async (requestPassword?: RequestPassword, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/direct/password_reset/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestPassword, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * トークンチェック
         * @summary ログイン画面からのパスワード再設定 トークンチェック
         * @param {RequestTokenCheck} [requestTokenCheck] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDirectPasswordResetValidateToken: async (requestTokenCheck?: RequestTokenCheck, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/direct/password_reset/validate_token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestTokenCheck, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ピックアップに対するリアクションを送信する 
         * @summary リアクション送信
         * @param {ReactionPostParam} [reactionPostParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDirectReaction: async (reactionPostParam?: ReactionPostParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/direct/reaction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reactionPostParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 仕様は冒頭説明箇所を参照
         * @summary 企業ユーザーのパスワード登録
         * @param {RequestPassword} [requestPassword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDirectRegistrationPassword: async (requestPassword?: RequestPassword, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/direct/registration/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestPassword, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 登録時にユーザーに発行されるトークンのチェック
         * @summary トークンチェック
         * @param {RequestTokenCheck} [requestTokenCheck] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDirectRegistrationValidateToken: async (requestTokenCheck?: RequestTokenCheck, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/direct/registration/validate_token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestTokenCheck, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 名前を付けて検索条件を保存する  ## バックエンド仕様について  バックエンド側では検索条件を JSON でそのまま DB に登録しているので基本的に保存時のリクエストデータの変更に関してはバックエンドに依頼する必要はない。  そのため基本的にどのような構造のデータでも入れることは可能だが検索側のリクエストパラメーターと合わせる必要はあるのでこちらの構造を変更する場合は合わせて検索側も対応しバックエンド側に依頼する。
         * @summary 検索条件保存
         * @param {DirectSearchConditionRequest} [directSearchConditionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDirectSearchCondition: async (directSearchConditionRequest?: DirectSearchConditionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/direct/search_condition`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(directSearchConditionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * * 管理ツールなので、少しくらい遅くてもフリーワード検索は実現させたい * age は計算が必要なので毎日１度計算しておく  ## sort_by  - アカウント開設日 registration_date - 最終ログイン日 last_login - 転職希望時期 mc_preferred_change_date - ポートフォリオ作品数 portfolio_item_count
         * @summary 求職者ユーザー検索
         * @param {DirectSearchUserRequest} [directSearchUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDirectSearchUsers: async (directSearchUserRequest?: DirectSearchUserRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/direct/search_users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(directSearchUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 特定のdirectユーザーが求職者検索を行い、 matchbox_idに該当する求職者が検索結果に表示された際のis_readプロパティをtrueに  ## ユーザー情報の更新を監視する項目  求職者が以下情報を更新すると該当ユーザーのis_readをfalseに  - ポートフォリオ - 履歴書 - 職務経歴 - マイナビクリエイター希望項目 - ユーザー情報
         * @summary 検索結果表示求職者ユーザーの既読状態を更新
         * @param {InlineObject16} [inlineObject16] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDirectSearchUsersRead: async (inlineObject16?: InlineObject16, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/direct/search_users/read`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject16, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DirectApi - functional programming interface
 * @export
 */
export const DirectApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DirectApiAxiosParamCreator(configuration)
    return {
        /**
         * userTypeが `direct_manager` のアカウントのみ利用可能
         * @summary 企業ユーザーグループ 削除
         * @param {string} companyGroupId 企業内グループID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDirectCompanyGroupCompanyGroupId(companyGroupId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDirectCompanyGroupCompanyGroupId(companyGroupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * * アカウント停止/非アクティブ化 * すぐにデータ削除
         * @summary 企業ユーザー情報の削除
         * @param {string} directMatchboxId 企業ユーザーID （B+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDirectCompanyUserId(directMatchboxId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDirectCompanyUserId(directMatchboxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * メモを削除する
         * @summary メモを削除する
         * @param {number} noteId noteのid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDirectNote(noteId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDirectNote(noteId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 求職者へのピックアップを解除する
         * @summary オファーの解除
         * @param {string} offerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDirectOffer(offerId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDirectOffer(offerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 削除
         * @summary ポジション削除
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDirectOfferPositionId(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCommon>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDirectOfferPositionId(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 検索条件を削除
         * @summary 検索条件削除
         * @param {number} directSearchConditionId Directの検索条件ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDirectSearchConditionId(directSearchConditionId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDirectSearchConditionId(directSearchConditionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * directユーザーからのアクセスの場合、UserInfo は伏せる
         * @summary 職務経歴書
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDirectCareerHistory(userMatchboxId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CareerHistory & Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDirectCareerHistory(userMatchboxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Directユーザー向けの職務経歴書ページをPDF化します。 該当URLは `/direct/cv/{UserMatchboxId}`
         * @summary 求職者の職務経歴書PDFダウンロード
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDirectCareerHistoryDownload(userMatchboxId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDirectCareerHistoryDownload(userMatchboxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 自社情報
         * @summary 企業情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDirectCompany(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DirectCompanyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDirectCompany(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 企業内グループ詳細
         * @summary 企業ユーザーグループ詳細
         * @param {string} companyGroupId 企業内グループID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDirectCompanyGroupId(companyGroupId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DirectCompanyGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDirectCompanyGroupId(companyGroupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 企業内グループ一覧  全件取得
         * @summary 企業内グループ一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDirectCompanyGroups(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DirectCompanyGroupsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDirectCompanyGroups(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 企業ユーザー情報詳細
         * @summary 企業ユーザー情報詳細
         * @param {string} directMatchboxId 企業ユーザーID （B+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDirectCompanyUserId(directMatchboxId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DirectUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDirectCompanyUserId(directMatchboxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 企業内ユーザー一覧  Queryを省略した場合 `limit=20 offset=0 sort_by=created_at` となる
         * @summary 企業内ユーザー一覧
         * @param {number} [limit] 一覧取得時に1ページに出す件数
         * @param {number} [offset] 一覧検索時の1ページの始まりの番号
         * @param {string} [sortBy] 並び替え時に基準データ sort_order がない場合はdesc固定
         * @param {string} [userName] ユーザー名
         * @param {string} [mail] メールアドレス
         * @param {string} [group] 企業ユーザーグループのID
         * @param {'direct_manager' | 'direct_user' | 'direct_hr'} [userType] 企業ユーザータイプ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDirectCompanyUsers(limit?: number, offset?: number, sortBy?: string, userName?: string, mail?: string, group?: string, userType?: 'direct_manager' | 'direct_user' | 'direct_hr', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DirectCompanyUsersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDirectCompanyUsers(limit, offset, sortBy, userName, mail, group, userType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ログイン状態を見る
         * @summary ログイン状態／ユーザー情報の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDirectIsLogin(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DirectIsLoginResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDirectIsLogin(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ログアウトをする 
         * @summary ログアウト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDirectLogout(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDirectLogout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 企業・求職者に送信したメモ一覧
         * @summary 企業・求職者に送信したメモ一覧
         * @param {string} [matchboxId] Directユーザーのみ利用可能
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDirectNotes(matchboxId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDirectNotes(matchboxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ポジション詳細取得
         * @summary ポジション詳細
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDirectOfferPositionId(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCommon & OfferPositionDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDirectOfferPositionId(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 一覧
         * @summary ポジション管理
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDirectOfferPositions(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCommon & OfferPositionsData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDirectOfferPositions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * * Directアカウント：自社がオーナーのもののみ表示
         * @summary オファー一覧
         * @param {string} limit 
         * @param {string} offset 
         * @param {string} sortBy 
         * @param {string} sortOrder 
         * @param {number} [status] ステータス。DirectまたはMWアカウントのみ利用可。
         * @param {number} [rate] マッチ度。Directアカウントのみ利用可。
         * @param {number} [job] 職種。Directアカウントのみ利用可。
         * @param {number} [position] ポジション
         * @param {string} [matchboxId] 求職者へのオファー一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDirectOffers(limit: string, offset: string, sortBy: string, sortOrder: string, status?: number, rate?: number, job?: number, position?: number, matchboxId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OffersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDirectOffers(limit, offset, sortBy, sortOrder, status, rate, job, position, matchboxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * * 公開されているポートフォリオの作品のリストを取得します * 他人に非公開の場合などは見れないという旨のレスポンスが返ります * その時は、パスワードをつけて POSTでリクエストをすると表示される情報のデータが返ります。
         * @summary 求職者の公開ポートフォリオ作品リスト
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {string} [password] パスワード付き公開の場合に必要になる
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDirectPortfolio(userMatchboxId: string, password?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Portfolio & Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDirectPortfolio(userMatchboxId, password, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ピックアップに対する社員の反応を取得する
         * @summary リアクション一覧
         * @param {string} offerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDirectReactions(offerId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReactionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDirectReactions(offerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 検索条件を取得
         * @summary 検索条件詳細
         * @param {number} directSearchConditionId Directの検索条件ID
         * @param {boolean} [recommend] おすすめの検索条件かどうか
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDirectSearchConditionId(directSearchConditionId: number, recommend?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DirectSearchConditionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDirectSearchConditionId(directSearchConditionId, recommend, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 保存した検索条件一覧
         * @summary 保存した検索条件一覧
         * @param {boolean} [recommended] MATCHBOXのおすすめ検索条件
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDirectSearchConditions(recommended?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DirectSearchConditionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDirectSearchConditions(recommended, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * タグに紐づいたユーザー情報一覧
         * @summary タグ ユーザー情報一覧
         * @param {string} userTagPath MW側で設定したタグのパス
         * @param {number} [limit] 取得件数 指定がない場合は20
         * @param {number} [offset] 次のページ番号 指定がない場合は0
         * @param {string} [sortBy] 検索項目 項目はdescription参照
         * @param {string} [sortOrder] 検索順序 asc | desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDirectTagSearchUsersId(userTagPath: string, limit?: number, offset?: number, sortBy?: string, sortOrder?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DirectSearchUsersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDirectTagSearchUsersId(userTagPath, limit, offset, sortBy, sortOrder, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ユーザー情報取得
         * @summary ユーザー情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDirectUser(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DirectUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDirectUser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ユーザー情報詳細 取得
         * @summary ユーザー情報詳細
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDirectUserMatchboxId(userMatchboxId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object & Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDirectUserMatchboxId(userMatchboxId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * タグに紐づいたユーザー情報一覧
         * @summary タグ情報取得
         * @param {string} userTagPath MW側で設定したタグのパス
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDirectUserTagPath(userTagPath: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DirectUserTagResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDirectUserTagPath(userTagPath, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * direct_adminのユーザーがPATCHした場合のみ有効
         * @summary 企業情報編集
         * @param {DirectCompanyModel} [directCompanyModel] 自社情報編集
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchDirectCompany(directCompanyModel?: DirectCompanyModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchDirectCompany(directCompanyModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * userTypeが `direct_manager` のアカウントのみ利用可能
         * @summary 企業ユーザーグループ 変更
         * @param {string} companyGroupId 企業内グループID
         * @param {CompanyGroupParam} [companyGroupParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchDirectCompanyGroupCompanyGroupId(companyGroupId: string, companyGroupParam?: CompanyGroupParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DirectCompanyGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchDirectCompanyGroupCompanyGroupId(companyGroupId, companyGroupParam, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * userTypeが `direct_manager` のアカウントのみ利用可能
         * @summary 企業内グループ一覧 並び順変更
         * @param {InlineObject11} [inlineObject11] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchDirectCompanyGroups(inlineObject11?: InlineObject11, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DirectCompanyGroupsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchDirectCompanyGroups(inlineObject11, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * userTypeが `direct_manager` のアカウントのみ利用可能  https://www.figma.com/file/tDn9C162xYWTXkvFMaipAn/Final-Design-and-Design-system?node-id=4694%3A66093
         * @summary 企業ユーザー情報の変更
         * @param {string} directMatchboxId 企業ユーザーID （B+数字乱数8桁）
         * @param {DirectCompanyUserParam} [directCompanyUserParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchDirectCompanyUserId(directMatchboxId: string, directCompanyUserParam?: DirectCompanyUserParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DirectUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchDirectCompanyUserId(directMatchboxId, directCompanyUserParam, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 並び替え
         * @summary 企業ユーザー一覧 並び順変更
         * @param {InlineObject10} [inlineObject10] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchDirectCompanyUsers(inlineObject10?: InlineObject10, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchDirectCompanyUsers(inlineObject10, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 検索条件のメール配信設定変更する
         * @summary 検索条件のメール配信設定変更
         * @param {number} directSearchConditionId Directの検索条件ID
         * @param {InlineObject15} [inlineObject15] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchDirectDirectMailId(directSearchConditionId: number, inlineObject15?: InlineObject15, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchDirectDirectMailId(directSearchConditionId, inlineObject15, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 自社アカウントが書いたメモを既読にする
         * @summary メモを既読にする
         * @param {AdminNotePatchParam} [adminNotePatchParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchDirectNote(adminNotePatchParam?: AdminNotePatchParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchDirectNote(adminNotePatchParam, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * オファーのステータス変更
         * @summary オファーのステータス変更
         * @param {DirectOfferPatchParam} [directOfferPatchParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchDirectOffer(directOfferPatchParam?: DirectOfferPatchParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchDirectOffer(directOfferPatchParam, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 更新
         * @summary ポジション更新
         * @param {string} id 
         * @param {DirectOfferPositionParam} [directOfferPositionParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchDirectOfferPositionId(id: string, directOfferPositionParam?: DirectOfferPositionParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCommon>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchDirectOfferPositionId(id, directOfferPositionParam, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 並び替え
         * @summary ポジション管理 並び替え
         * @param {InlineObject19} [inlineObject19] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchDirectOfferPositions(inlineObject19?: InlineObject19, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCommon & OfferPositionsData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchDirectOfferPositions(inlineObject19, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ピックアップに対するリアクションの修正
         * @summary リアクションを更新する
         * @param {ReactionPatchParam} [reactionPatchParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchDirectReaction(reactionPatchParam?: ReactionPatchParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchDirectReaction(reactionPatchParam, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 検索条件を編集
         * @summary 検索条件更新
         * @param {number} directSearchConditionId Directの検索条件ID
         * @param {DirectSearchConditionRequest} [directSearchConditionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchDirectSearchConditionId(directSearchConditionId: number, directSearchConditionRequest?: DirectSearchConditionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchDirectSearchConditionId(directSearchConditionId, directSearchConditionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 並び替え
         * @summary 保存した検索条件一覧の並び替え
         * @param {boolean} [recommended] MATCHBOXのおすすめ検索条件
         * @param {InlineObject14} [inlineObject14] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchDirectSearchConditions(recommended?: boolean, inlineObject14?: InlineObject14, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchDirectSearchConditions(recommended, inlineObject14, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ログインユーザーの情報変更
         * @summary ユーザー情報変更
         * @param {DirectUserParam} [directUserParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchDirectUser(directUserParam?: DirectUserParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DirectUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchDirectUser(directUserParam, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * userTypeが `direct_manager` のアカウントのみ利用可能  企業内グループ作成
         * @summary 企業ユーザーグループ新規作成
         * @param {CompanyGroupParam} [companyGroupParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDirectCompanyGroup(companyGroupParam?: CompanyGroupParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDirectCompanyGroup(companyGroupParam, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 企業ユーザーのメールアドレスの変更  https://www.figma.com/file/tDn9C162xYWTXkvFMaipAn/Final-Design-and-Design-system?node-id=2249%3A423
         * @summary ユーザー情報 メールアドレス変更
         * @param {UserEmailChange} [userEmailChange] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDirectEmailChange(userEmailChange?: UserEmailChange, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDirectEmailChange(userEmailChange, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 企業ユーザーのメールアドレスの変更時のトークンチェック トークンが正しければそのまま変更完了処理までする  https://www.figma.com/file/tDn9C162xYWTXkvFMaipAn/Final-Design-and-Design-system?node-id=2249%3A423
         * @summary ユーザー情報 メールアドレス変更 トークンチェック & 変更完了
         * @param {UserEmailChangeToken} [userEmailChangeToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDirectEmailChangeValidateToken(userEmailChangeToken?: UserEmailChangeToken, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDirectEmailChangeValidateToken(userEmailChangeToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 新規企業ユーザーを招待する
         * @summary 新規企業ユーザーを招待する
         * @param {InlineObject12} [inlineObject12] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDirectInvite(inlineObject12?: InlineObject12, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDirectInvite(inlineObject12, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ログインをする  ## 開発サーバーテストアカウント  ID : matchbox-dev-notify+dockertestcompanymanager@s2factory.co.jp  PW : test
         * @summary ログイン
         * @param {string} email メールアドレス
         * @param {string} password パスワード
         * @param {string} [type] 以前の as_ca&#x3D;1 と同様。 caとownerがある
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDirectLogin(email: string, password: string, type?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDirectLogin(email, password, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * MWが企業へ、またはDirectユーザーが求職者へメモを残す
         * @summary 企業・求職者にメモを残す
         * @param {AdminNotePostParam} [adminNotePostParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDirectNote(adminNotePostParam?: AdminNotePostParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Note & Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDirectNote(adminNotePostParam, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 求職者をピックアップする
         * @summary オファー送信
         * @param {OfferPostParam} [offerPostParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDirectOffer(offerPostParam?: OfferPostParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDirectOffer(offerPostParam, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ポジション新規作成
         * @summary ポジション新規作成
         * @param {DirectOfferPositionParam} [directOfferPositionParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDirectOfferPosition(directOfferPositionParam?: DirectOfferPositionParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCommon>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDirectOfferPosition(directOfferPositionParam, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * パスワードを変更します 仕様は冒頭説明箇所を参照
         * @summary パスワード変更
         * @param {PasswordChangeParam} [passwordChangeParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDirectPasswordChange(passwordChangeParam?: PasswordChangeParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDirectPasswordChange(passwordChangeParam, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * パスワードをリセットします  ---  * v2ではPOST成功時に登録メールアドレスに登録メールを送信してパスワードを別途設定する。
         * @summary パスワードリセット
         * @param {PasswordResetParam} [passwordResetParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDirectPasswordReset(passwordResetParam?: PasswordResetParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDirectPasswordReset(passwordResetParam, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * パスワード再設定 仕様は冒頭説明箇所を参照
         * @summary ログイン画面からのパスワード再設定
         * @param {RequestPassword} [requestPassword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDirectPasswordResetPassword(requestPassword?: RequestPassword, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDirectPasswordResetPassword(requestPassword, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * トークンチェック
         * @summary ログイン画面からのパスワード再設定 トークンチェック
         * @param {RequestTokenCheck} [requestTokenCheck] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDirectPasswordResetValidateToken(requestTokenCheck?: RequestTokenCheck, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDirectPasswordResetValidateToken(requestTokenCheck, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ピックアップに対するリアクションを送信する 
         * @summary リアクション送信
         * @param {ReactionPostParam} [reactionPostParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDirectReaction(reactionPostParam?: ReactionPostParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReactionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDirectReaction(reactionPostParam, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 仕様は冒頭説明箇所を参照
         * @summary 企業ユーザーのパスワード登録
         * @param {RequestPassword} [requestPassword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDirectRegistrationPassword(requestPassword?: RequestPassword, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess & object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDirectRegistrationPassword(requestPassword, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 登録時にユーザーに発行されるトークンのチェック
         * @summary トークンチェック
         * @param {RequestTokenCheck} [requestTokenCheck] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDirectRegistrationValidateToken(requestTokenCheck?: RequestTokenCheck, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDirectRegistrationValidateToken(requestTokenCheck, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 名前を付けて検索条件を保存する  ## バックエンド仕様について  バックエンド側では検索条件を JSON でそのまま DB に登録しているので基本的に保存時のリクエストデータの変更に関してはバックエンドに依頼する必要はない。  そのため基本的にどのような構造のデータでも入れることは可能だが検索側のリクエストパラメーターと合わせる必要はあるのでこちらの構造を変更する場合は合わせて検索側も対応しバックエンド側に依頼する。
         * @summary 検索条件保存
         * @param {DirectSearchConditionRequest} [directSearchConditionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDirectSearchCondition(directSearchConditionRequest?: DirectSearchConditionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DirectSearchConditionModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDirectSearchCondition(directSearchConditionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * * 管理ツールなので、少しくらい遅くてもフリーワード検索は実現させたい * age は計算が必要なので毎日１度計算しておく  ## sort_by  - アカウント開設日 registration_date - 最終ログイン日 last_login - 転職希望時期 mc_preferred_change_date - ポートフォリオ作品数 portfolio_item_count
         * @summary 求職者ユーザー検索
         * @param {DirectSearchUserRequest} [directSearchUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDirectSearchUsers(directSearchUserRequest?: DirectSearchUserRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DirectSearchUsersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDirectSearchUsers(directSearchUserRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 特定のdirectユーザーが求職者検索を行い、 matchbox_idに該当する求職者が検索結果に表示された際のis_readプロパティをtrueに  ## ユーザー情報の更新を監視する項目  求職者が以下情報を更新すると該当ユーザーのis_readをfalseに  - ポートフォリオ - 履歴書 - 職務経歴 - マイナビクリエイター希望項目 - ユーザー情報
         * @summary 検索結果表示求職者ユーザーの既読状態を更新
         * @param {InlineObject16} [inlineObject16] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDirectSearchUsersRead(inlineObject16?: InlineObject16, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDirectSearchUsersRead(inlineObject16, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DirectApi - factory interface
 * @export
 */
export const DirectApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DirectApiFp(configuration)
    return {
        /**
         * userTypeが `direct_manager` のアカウントのみ利用可能
         * @summary 企業ユーザーグループ 削除
         * @param {string} companyGroupId 企業内グループID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDirectCompanyGroupCompanyGroupId(companyGroupId: string, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.deleteDirectCompanyGroupCompanyGroupId(companyGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * * アカウント停止/非アクティブ化 * すぐにデータ削除
         * @summary 企業ユーザー情報の削除
         * @param {string} directMatchboxId 企業ユーザーID （B+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDirectCompanyUserId(directMatchboxId: string, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.deleteDirectCompanyUserId(directMatchboxId, options).then((request) => request(axios, basePath));
        },
        /**
         * メモを削除する
         * @summary メモを削除する
         * @param {number} noteId noteのid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDirectNote(noteId: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteDirectNote(noteId, options).then((request) => request(axios, basePath));
        },
        /**
         * 求職者へのピックアップを解除する
         * @summary オファーの解除
         * @param {string} offerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDirectOffer(offerId: string, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.deleteDirectOffer(offerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 削除
         * @summary ポジション削除
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDirectOfferPositionId(id: string, options?: any): AxiosPromise<ResponseCommon> {
            return localVarFp.deleteDirectOfferPositionId(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 検索条件を削除
         * @summary 検索条件削除
         * @param {number} directSearchConditionId Directの検索条件ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDirectSearchConditionId(directSearchConditionId: number, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.deleteDirectSearchConditionId(directSearchConditionId, options).then((request) => request(axios, basePath));
        },
        /**
         * directユーザーからのアクセスの場合、UserInfo は伏せる
         * @summary 職務経歴書
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectCareerHistory(userMatchboxId: string, options?: any): AxiosPromise<CareerHistory & Status> {
            return localVarFp.getDirectCareerHistory(userMatchboxId, options).then((request) => request(axios, basePath));
        },
        /**
         * Directユーザー向けの職務経歴書ページをPDF化します。 該当URLは `/direct/cv/{UserMatchboxId}`
         * @summary 求職者の職務経歴書PDFダウンロード
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectCareerHistoryDownload(userMatchboxId: string, options?: any): AxiosPromise<string> {
            return localVarFp.getDirectCareerHistoryDownload(userMatchboxId, options).then((request) => request(axios, basePath));
        },
        /**
         * 自社情報
         * @summary 企業情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectCompany(options?: any): AxiosPromise<DirectCompanyResponse> {
            return localVarFp.getDirectCompany(options).then((request) => request(axios, basePath));
        },
        /**
         * 企業内グループ詳細
         * @summary 企業ユーザーグループ詳細
         * @param {string} companyGroupId 企業内グループID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectCompanyGroupId(companyGroupId: string, options?: any): AxiosPromise<DirectCompanyGroupResponse> {
            return localVarFp.getDirectCompanyGroupId(companyGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 企業内グループ一覧  全件取得
         * @summary 企業内グループ一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectCompanyGroups(options?: any): AxiosPromise<DirectCompanyGroupsResponse> {
            return localVarFp.getDirectCompanyGroups(options).then((request) => request(axios, basePath));
        },
        /**
         * 企業ユーザー情報詳細
         * @summary 企業ユーザー情報詳細
         * @param {string} directMatchboxId 企業ユーザーID （B+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectCompanyUserId(directMatchboxId: string, options?: any): AxiosPromise<DirectUserResponse> {
            return localVarFp.getDirectCompanyUserId(directMatchboxId, options).then((request) => request(axios, basePath));
        },
        /**
         * 企業内ユーザー一覧  Queryを省略した場合 `limit=20 offset=0 sort_by=created_at` となる
         * @summary 企業内ユーザー一覧
         * @param {number} [limit] 一覧取得時に1ページに出す件数
         * @param {number} [offset] 一覧検索時の1ページの始まりの番号
         * @param {string} [sortBy] 並び替え時に基準データ sort_order がない場合はdesc固定
         * @param {string} [userName] ユーザー名
         * @param {string} [mail] メールアドレス
         * @param {string} [group] 企業ユーザーグループのID
         * @param {'direct_manager' | 'direct_user' | 'direct_hr'} [userType] 企業ユーザータイプ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectCompanyUsers(limit?: number, offset?: number, sortBy?: string, userName?: string, mail?: string, group?: string, userType?: 'direct_manager' | 'direct_user' | 'direct_hr', options?: any): AxiosPromise<DirectCompanyUsersResponse> {
            return localVarFp.getDirectCompanyUsers(limit, offset, sortBy, userName, mail, group, userType, options).then((request) => request(axios, basePath));
        },
        /**
         * ログイン状態を見る
         * @summary ログイン状態／ユーザー情報の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectIsLogin(options?: any): AxiosPromise<DirectIsLoginResponse> {
            return localVarFp.getDirectIsLogin(options).then((request) => request(axios, basePath));
        },
        /**
         * ログアウトをする 
         * @summary ログアウト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectLogout(options?: any): AxiosPromise<Status> {
            return localVarFp.getDirectLogout(options).then((request) => request(axios, basePath));
        },
        /**
         * 企業・求職者に送信したメモ一覧
         * @summary 企業・求職者に送信したメモ一覧
         * @param {string} [matchboxId] Directユーザーのみ利用可能
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectNotes(matchboxId?: string, options?: any): AxiosPromise<NotesResponse> {
            return localVarFp.getDirectNotes(matchboxId, options).then((request) => request(axios, basePath));
        },
        /**
         * ポジション詳細取得
         * @summary ポジション詳細
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectOfferPositionId(id: string, options?: any): AxiosPromise<ResponseCommon & OfferPositionDataResponse> {
            return localVarFp.getDirectOfferPositionId(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 一覧
         * @summary ポジション管理
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectOfferPositions(options?: any): AxiosPromise<ResponseCommon & OfferPositionsData> {
            return localVarFp.getDirectOfferPositions(options).then((request) => request(axios, basePath));
        },
        /**
         * * Directアカウント：自社がオーナーのもののみ表示
         * @summary オファー一覧
         * @param {string} limit 
         * @param {string} offset 
         * @param {string} sortBy 
         * @param {string} sortOrder 
         * @param {number} [status] ステータス。DirectまたはMWアカウントのみ利用可。
         * @param {number} [rate] マッチ度。Directアカウントのみ利用可。
         * @param {number} [job] 職種。Directアカウントのみ利用可。
         * @param {number} [position] ポジション
         * @param {string} [matchboxId] 求職者へのオファー一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectOffers(limit: string, offset: string, sortBy: string, sortOrder: string, status?: number, rate?: number, job?: number, position?: number, matchboxId?: string, options?: any): AxiosPromise<OffersResponse> {
            return localVarFp.getDirectOffers(limit, offset, sortBy, sortOrder, status, rate, job, position, matchboxId, options).then((request) => request(axios, basePath));
        },
        /**
         * * 公開されているポートフォリオの作品のリストを取得します * 他人に非公開の場合などは見れないという旨のレスポンスが返ります * その時は、パスワードをつけて POSTでリクエストをすると表示される情報のデータが返ります。
         * @summary 求職者の公開ポートフォリオ作品リスト
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {string} [password] パスワード付き公開の場合に必要になる
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectPortfolio(userMatchboxId: string, password?: string, options?: any): AxiosPromise<Portfolio & Status> {
            return localVarFp.getDirectPortfolio(userMatchboxId, password, options).then((request) => request(axios, basePath));
        },
        /**
         * ピックアップに対する社員の反応を取得する
         * @summary リアクション一覧
         * @param {string} offerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectReactions(offerId: string, options?: any): AxiosPromise<ReactionsResponse> {
            return localVarFp.getDirectReactions(offerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 検索条件を取得
         * @summary 検索条件詳細
         * @param {number} directSearchConditionId Directの検索条件ID
         * @param {boolean} [recommend] おすすめの検索条件かどうか
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectSearchConditionId(directSearchConditionId: number, recommend?: boolean, options?: any): AxiosPromise<DirectSearchConditionResponse> {
            return localVarFp.getDirectSearchConditionId(directSearchConditionId, recommend, options).then((request) => request(axios, basePath));
        },
        /**
         * 保存した検索条件一覧
         * @summary 保存した検索条件一覧
         * @param {boolean} [recommended] MATCHBOXのおすすめ検索条件
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectSearchConditions(recommended?: boolean, options?: any): AxiosPromise<DirectSearchConditionsResponse> {
            return localVarFp.getDirectSearchConditions(recommended, options).then((request) => request(axios, basePath));
        },
        /**
         * タグに紐づいたユーザー情報一覧
         * @summary タグ ユーザー情報一覧
         * @param {string} userTagPath MW側で設定したタグのパス
         * @param {number} [limit] 取得件数 指定がない場合は20
         * @param {number} [offset] 次のページ番号 指定がない場合は0
         * @param {string} [sortBy] 検索項目 項目はdescription参照
         * @param {string} [sortOrder] 検索順序 asc | desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectTagSearchUsersId(userTagPath: string, limit?: number, offset?: number, sortBy?: string, sortOrder?: string, options?: any): AxiosPromise<DirectSearchUsersResponse> {
            return localVarFp.getDirectTagSearchUsersId(userTagPath, limit, offset, sortBy, sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * ユーザー情報取得
         * @summary ユーザー情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectUser(options?: any): AxiosPromise<DirectUserResponse> {
            return localVarFp.getDirectUser(options).then((request) => request(axios, basePath));
        },
        /**
         * ユーザー情報詳細 取得
         * @summary ユーザー情報詳細
         * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectUserMatchboxId(userMatchboxId: string, options?: any): AxiosPromise<object & Status> {
            return localVarFp.getDirectUserMatchboxId(userMatchboxId, options).then((request) => request(axios, basePath));
        },
        /**
         * タグに紐づいたユーザー情報一覧
         * @summary タグ情報取得
         * @param {string} userTagPath MW側で設定したタグのパス
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDirectUserTagPath(userTagPath: string, options?: any): AxiosPromise<DirectUserTagResponse> {
            return localVarFp.getDirectUserTagPath(userTagPath, options).then((request) => request(axios, basePath));
        },
        /**
         * direct_adminのユーザーがPATCHした場合のみ有効
         * @summary 企業情報編集
         * @param {DirectCompanyModel} [directCompanyModel] 自社情報編集
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDirectCompany(directCompanyModel?: DirectCompanyModel, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.patchDirectCompany(directCompanyModel, options).then((request) => request(axios, basePath));
        },
        /**
         * userTypeが `direct_manager` のアカウントのみ利用可能
         * @summary 企業ユーザーグループ 変更
         * @param {string} companyGroupId 企業内グループID
         * @param {CompanyGroupParam} [companyGroupParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDirectCompanyGroupCompanyGroupId(companyGroupId: string, companyGroupParam?: CompanyGroupParam, options?: any): AxiosPromise<DirectCompanyGroupResponse> {
            return localVarFp.patchDirectCompanyGroupCompanyGroupId(companyGroupId, companyGroupParam, options).then((request) => request(axios, basePath));
        },
        /**
         * userTypeが `direct_manager` のアカウントのみ利用可能
         * @summary 企業内グループ一覧 並び順変更
         * @param {InlineObject11} [inlineObject11] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDirectCompanyGroups(inlineObject11?: InlineObject11, options?: any): AxiosPromise<DirectCompanyGroupsResponse> {
            return localVarFp.patchDirectCompanyGroups(inlineObject11, options).then((request) => request(axios, basePath));
        },
        /**
         * userTypeが `direct_manager` のアカウントのみ利用可能  https://www.figma.com/file/tDn9C162xYWTXkvFMaipAn/Final-Design-and-Design-system?node-id=4694%3A66093
         * @summary 企業ユーザー情報の変更
         * @param {string} directMatchboxId 企業ユーザーID （B+数字乱数8桁）
         * @param {DirectCompanyUserParam} [directCompanyUserParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDirectCompanyUserId(directMatchboxId: string, directCompanyUserParam?: DirectCompanyUserParam, options?: any): AxiosPromise<DirectUserResponse> {
            return localVarFp.patchDirectCompanyUserId(directMatchboxId, directCompanyUserParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 並び替え
         * @summary 企業ユーザー一覧 並び順変更
         * @param {InlineObject10} [inlineObject10] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDirectCompanyUsers(inlineObject10?: InlineObject10, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.patchDirectCompanyUsers(inlineObject10, options).then((request) => request(axios, basePath));
        },
        /**
         * 検索条件のメール配信設定変更する
         * @summary 検索条件のメール配信設定変更
         * @param {number} directSearchConditionId Directの検索条件ID
         * @param {InlineObject15} [inlineObject15] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDirectDirectMailId(directSearchConditionId: number, inlineObject15?: InlineObject15, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.patchDirectDirectMailId(directSearchConditionId, inlineObject15, options).then((request) => request(axios, basePath));
        },
        /**
         * 自社アカウントが書いたメモを既読にする
         * @summary メモを既読にする
         * @param {AdminNotePatchParam} [adminNotePatchParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDirectNote(adminNotePatchParam?: AdminNotePatchParam, options?: any): AxiosPromise<void> {
            return localVarFp.patchDirectNote(adminNotePatchParam, options).then((request) => request(axios, basePath));
        },
        /**
         * オファーのステータス変更
         * @summary オファーのステータス変更
         * @param {DirectOfferPatchParam} [directOfferPatchParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDirectOffer(directOfferPatchParam?: DirectOfferPatchParam, options?: any): AxiosPromise<OfferResponse> {
            return localVarFp.patchDirectOffer(directOfferPatchParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 更新
         * @summary ポジション更新
         * @param {string} id 
         * @param {DirectOfferPositionParam} [directOfferPositionParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDirectOfferPositionId(id: string, directOfferPositionParam?: DirectOfferPositionParam, options?: any): AxiosPromise<ResponseCommon> {
            return localVarFp.patchDirectOfferPositionId(id, directOfferPositionParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 並び替え
         * @summary ポジション管理 並び替え
         * @param {InlineObject19} [inlineObject19] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDirectOfferPositions(inlineObject19?: InlineObject19, options?: any): AxiosPromise<ResponseCommon & OfferPositionsData> {
            return localVarFp.patchDirectOfferPositions(inlineObject19, options).then((request) => request(axios, basePath));
        },
        /**
         * ピックアップに対するリアクションの修正
         * @summary リアクションを更新する
         * @param {ReactionPatchParam} [reactionPatchParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDirectReaction(reactionPatchParam?: ReactionPatchParam, options?: any): AxiosPromise<void> {
            return localVarFp.patchDirectReaction(reactionPatchParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 検索条件を編集
         * @summary 検索条件更新
         * @param {number} directSearchConditionId Directの検索条件ID
         * @param {DirectSearchConditionRequest} [directSearchConditionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDirectSearchConditionId(directSearchConditionId: number, directSearchConditionRequest?: DirectSearchConditionRequest, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.patchDirectSearchConditionId(directSearchConditionId, directSearchConditionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 並び替え
         * @summary 保存した検索条件一覧の並び替え
         * @param {boolean} [recommended] MATCHBOXのおすすめ検索条件
         * @param {InlineObject14} [inlineObject14] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDirectSearchConditions(recommended?: boolean, inlineObject14?: InlineObject14, options?: any): AxiosPromise<void> {
            return localVarFp.patchDirectSearchConditions(recommended, inlineObject14, options).then((request) => request(axios, basePath));
        },
        /**
         * ログインユーザーの情報変更
         * @summary ユーザー情報変更
         * @param {DirectUserParam} [directUserParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDirectUser(directUserParam?: DirectUserParam, options?: any): AxiosPromise<DirectUserResponse> {
            return localVarFp.patchDirectUser(directUserParam, options).then((request) => request(axios, basePath));
        },
        /**
         * userTypeが `direct_manager` のアカウントのみ利用可能  企業内グループ作成
         * @summary 企業ユーザーグループ新規作成
         * @param {CompanyGroupParam} [companyGroupParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDirectCompanyGroup(companyGroupParam?: CompanyGroupParam, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.postDirectCompanyGroup(companyGroupParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 企業ユーザーのメールアドレスの変更  https://www.figma.com/file/tDn9C162xYWTXkvFMaipAn/Final-Design-and-Design-system?node-id=2249%3A423
         * @summary ユーザー情報 メールアドレス変更
         * @param {UserEmailChange} [userEmailChange] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDirectEmailChange(userEmailChange?: UserEmailChange, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.postDirectEmailChange(userEmailChange, options).then((request) => request(axios, basePath));
        },
        /**
         * 企業ユーザーのメールアドレスの変更時のトークンチェック トークンが正しければそのまま変更完了処理までする  https://www.figma.com/file/tDn9C162xYWTXkvFMaipAn/Final-Design-and-Design-system?node-id=2249%3A423
         * @summary ユーザー情報 メールアドレス変更 トークンチェック & 変更完了
         * @param {UserEmailChangeToken} [userEmailChangeToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDirectEmailChangeValidateToken(userEmailChangeToken?: UserEmailChangeToken, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.postDirectEmailChangeValidateToken(userEmailChangeToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 新規企業ユーザーを招待する
         * @summary 新規企業ユーザーを招待する
         * @param {InlineObject12} [inlineObject12] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDirectInvite(inlineObject12?: InlineObject12, options?: any): AxiosPromise<void> {
            return localVarFp.postDirectInvite(inlineObject12, options).then((request) => request(axios, basePath));
        },
        /**
         * ログインをする  ## 開発サーバーテストアカウント  ID : matchbox-dev-notify+dockertestcompanymanager@s2factory.co.jp  PW : test
         * @summary ログイン
         * @param {string} email メールアドレス
         * @param {string} password パスワード
         * @param {string} [type] 以前の as_ca&#x3D;1 と同様。 caとownerがある
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDirectLogin(email: string, password: string, type?: string, options?: any): AxiosPromise<Status> {
            return localVarFp.postDirectLogin(email, password, type, options).then((request) => request(axios, basePath));
        },
        /**
         * MWが企業へ、またはDirectユーザーが求職者へメモを残す
         * @summary 企業・求職者にメモを残す
         * @param {AdminNotePostParam} [adminNotePostParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDirectNote(adminNotePostParam?: AdminNotePostParam, options?: any): AxiosPromise<Note & Status> {
            return localVarFp.postDirectNote(adminNotePostParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 求職者をピックアップする
         * @summary オファー送信
         * @param {OfferPostParam} [offerPostParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDirectOffer(offerPostParam?: OfferPostParam, options?: any): AxiosPromise<OfferResponse> {
            return localVarFp.postDirectOffer(offerPostParam, options).then((request) => request(axios, basePath));
        },
        /**
         * ポジション新規作成
         * @summary ポジション新規作成
         * @param {DirectOfferPositionParam} [directOfferPositionParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDirectOfferPosition(directOfferPositionParam?: DirectOfferPositionParam, options?: any): AxiosPromise<ResponseCommon> {
            return localVarFp.postDirectOfferPosition(directOfferPositionParam, options).then((request) => request(axios, basePath));
        },
        /**
         * パスワードを変更します 仕様は冒頭説明箇所を参照
         * @summary パスワード変更
         * @param {PasswordChangeParam} [passwordChangeParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDirectPasswordChange(passwordChangeParam?: PasswordChangeParam, options?: any): AxiosPromise<Status> {
            return localVarFp.postDirectPasswordChange(passwordChangeParam, options).then((request) => request(axios, basePath));
        },
        /**
         * パスワードをリセットします  ---  * v2ではPOST成功時に登録メールアドレスに登録メールを送信してパスワードを別途設定する。
         * @summary パスワードリセット
         * @param {PasswordResetParam} [passwordResetParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDirectPasswordReset(passwordResetParam?: PasswordResetParam, options?: any): AxiosPromise<Status> {
            return localVarFp.postDirectPasswordReset(passwordResetParam, options).then((request) => request(axios, basePath));
        },
        /**
         * パスワード再設定 仕様は冒頭説明箇所を参照
         * @summary ログイン画面からのパスワード再設定
         * @param {RequestPassword} [requestPassword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDirectPasswordResetPassword(requestPassword?: RequestPassword, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.postDirectPasswordResetPassword(requestPassword, options).then((request) => request(axios, basePath));
        },
        /**
         * トークンチェック
         * @summary ログイン画面からのパスワード再設定 トークンチェック
         * @param {RequestTokenCheck} [requestTokenCheck] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDirectPasswordResetValidateToken(requestTokenCheck?: RequestTokenCheck, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.postDirectPasswordResetValidateToken(requestTokenCheck, options).then((request) => request(axios, basePath));
        },
        /**
         * ピックアップに対するリアクションを送信する 
         * @summary リアクション送信
         * @param {ReactionPostParam} [reactionPostParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDirectReaction(reactionPostParam?: ReactionPostParam, options?: any): AxiosPromise<ReactionResponse> {
            return localVarFp.postDirectReaction(reactionPostParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 仕様は冒頭説明箇所を参照
         * @summary 企業ユーザーのパスワード登録
         * @param {RequestPassword} [requestPassword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDirectRegistrationPassword(requestPassword?: RequestPassword, options?: any): AxiosPromise<ResponseSuccess & object> {
            return localVarFp.postDirectRegistrationPassword(requestPassword, options).then((request) => request(axios, basePath));
        },
        /**
         * 登録時にユーザーに発行されるトークンのチェック
         * @summary トークンチェック
         * @param {RequestTokenCheck} [requestTokenCheck] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDirectRegistrationValidateToken(requestTokenCheck?: RequestTokenCheck, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.postDirectRegistrationValidateToken(requestTokenCheck, options).then((request) => request(axios, basePath));
        },
        /**
         * 名前を付けて検索条件を保存する  ## バックエンド仕様について  バックエンド側では検索条件を JSON でそのまま DB に登録しているので基本的に保存時のリクエストデータの変更に関してはバックエンドに依頼する必要はない。  そのため基本的にどのような構造のデータでも入れることは可能だが検索側のリクエストパラメーターと合わせる必要はあるのでこちらの構造を変更する場合は合わせて検索側も対応しバックエンド側に依頼する。
         * @summary 検索条件保存
         * @param {DirectSearchConditionRequest} [directSearchConditionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDirectSearchCondition(directSearchConditionRequest?: DirectSearchConditionRequest, options?: any): AxiosPromise<DirectSearchConditionModel> {
            return localVarFp.postDirectSearchCondition(directSearchConditionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * * 管理ツールなので、少しくらい遅くてもフリーワード検索は実現させたい * age は計算が必要なので毎日１度計算しておく  ## sort_by  - アカウント開設日 registration_date - 最終ログイン日 last_login - 転職希望時期 mc_preferred_change_date - ポートフォリオ作品数 portfolio_item_count
         * @summary 求職者ユーザー検索
         * @param {DirectSearchUserRequest} [directSearchUserRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDirectSearchUsers(directSearchUserRequest?: DirectSearchUserRequest, options?: any): AxiosPromise<DirectSearchUsersResponse> {
            return localVarFp.postDirectSearchUsers(directSearchUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 特定のdirectユーザーが求職者検索を行い、 matchbox_idに該当する求職者が検索結果に表示された際のis_readプロパティをtrueに  ## ユーザー情報の更新を監視する項目  求職者が以下情報を更新すると該当ユーザーのis_readをfalseに  - ポートフォリオ - 履歴書 - 職務経歴 - マイナビクリエイター希望項目 - ユーザー情報
         * @summary 検索結果表示求職者ユーザーの既読状態を更新
         * @param {InlineObject16} [inlineObject16] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDirectSearchUsersRead(inlineObject16?: InlineObject16, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.postDirectSearchUsersRead(inlineObject16, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DirectApi - object-oriented interface
 * @export
 * @class DirectApi
 * @extends {BaseAPI}
 */
export class DirectApi extends BaseAPI {
    /**
     * userTypeが `direct_manager` のアカウントのみ利用可能
     * @summary 企業ユーザーグループ 削除
     * @param {string} companyGroupId 企業内グループID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public deleteDirectCompanyGroupCompanyGroupId(companyGroupId: string, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).deleteDirectCompanyGroupCompanyGroupId(companyGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * * アカウント停止/非アクティブ化 * すぐにデータ削除
     * @summary 企業ユーザー情報の削除
     * @param {string} directMatchboxId 企業ユーザーID （B+数字乱数8桁）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public deleteDirectCompanyUserId(directMatchboxId: string, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).deleteDirectCompanyUserId(directMatchboxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * メモを削除する
     * @summary メモを削除する
     * @param {number} noteId noteのid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public deleteDirectNote(noteId: number, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).deleteDirectNote(noteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 求職者へのピックアップを解除する
     * @summary オファーの解除
     * @param {string} offerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public deleteDirectOffer(offerId: string, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).deleteDirectOffer(offerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 削除
     * @summary ポジション削除
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public deleteDirectOfferPositionId(id: string, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).deleteDirectOfferPositionId(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 検索条件を削除
     * @summary 検索条件削除
     * @param {number} directSearchConditionId Directの検索条件ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public deleteDirectSearchConditionId(directSearchConditionId: number, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).deleteDirectSearchConditionId(directSearchConditionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * directユーザーからのアクセスの場合、UserInfo は伏せる
     * @summary 職務経歴書
     * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public getDirectCareerHistory(userMatchboxId: string, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).getDirectCareerHistory(userMatchboxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Directユーザー向けの職務経歴書ページをPDF化します。 該当URLは `/direct/cv/{UserMatchboxId}`
     * @summary 求職者の職務経歴書PDFダウンロード
     * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public getDirectCareerHistoryDownload(userMatchboxId: string, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).getDirectCareerHistoryDownload(userMatchboxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 自社情報
     * @summary 企業情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public getDirectCompany(options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).getDirectCompany(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 企業内グループ詳細
     * @summary 企業ユーザーグループ詳細
     * @param {string} companyGroupId 企業内グループID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public getDirectCompanyGroupId(companyGroupId: string, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).getDirectCompanyGroupId(companyGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 企業内グループ一覧  全件取得
     * @summary 企業内グループ一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public getDirectCompanyGroups(options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).getDirectCompanyGroups(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 企業ユーザー情報詳細
     * @summary 企業ユーザー情報詳細
     * @param {string} directMatchboxId 企業ユーザーID （B+数字乱数8桁）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public getDirectCompanyUserId(directMatchboxId: string, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).getDirectCompanyUserId(directMatchboxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 企業内ユーザー一覧  Queryを省略した場合 `limit=20 offset=0 sort_by=created_at` となる
     * @summary 企業内ユーザー一覧
     * @param {number} [limit] 一覧取得時に1ページに出す件数
     * @param {number} [offset] 一覧検索時の1ページの始まりの番号
     * @param {string} [sortBy] 並び替え時に基準データ sort_order がない場合はdesc固定
     * @param {string} [userName] ユーザー名
     * @param {string} [mail] メールアドレス
     * @param {string} [group] 企業ユーザーグループのID
     * @param {'direct_manager' | 'direct_user' | 'direct_hr'} [userType] 企業ユーザータイプ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public getDirectCompanyUsers(limit?: number, offset?: number, sortBy?: string, userName?: string, mail?: string, group?: string, userType?: 'direct_manager' | 'direct_user' | 'direct_hr', options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).getDirectCompanyUsers(limit, offset, sortBy, userName, mail, group, userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ログイン状態を見る
     * @summary ログイン状態／ユーザー情報の取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public getDirectIsLogin(options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).getDirectIsLogin(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ログアウトをする 
     * @summary ログアウト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public getDirectLogout(options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).getDirectLogout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 企業・求職者に送信したメモ一覧
     * @summary 企業・求職者に送信したメモ一覧
     * @param {string} [matchboxId] Directユーザーのみ利用可能
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public getDirectNotes(matchboxId?: string, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).getDirectNotes(matchboxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ポジション詳細取得
     * @summary ポジション詳細
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public getDirectOfferPositionId(id: string, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).getDirectOfferPositionId(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 一覧
     * @summary ポジション管理
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public getDirectOfferPositions(options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).getDirectOfferPositions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * * Directアカウント：自社がオーナーのもののみ表示
     * @summary オファー一覧
     * @param {string} limit 
     * @param {string} offset 
     * @param {string} sortBy 
     * @param {string} sortOrder 
     * @param {number} [status] ステータス。DirectまたはMWアカウントのみ利用可。
     * @param {number} [rate] マッチ度。Directアカウントのみ利用可。
     * @param {number} [job] 職種。Directアカウントのみ利用可。
     * @param {number} [position] ポジション
     * @param {string} [matchboxId] 求職者へのオファー一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public getDirectOffers(limit: string, offset: string, sortBy: string, sortOrder: string, status?: number, rate?: number, job?: number, position?: number, matchboxId?: string, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).getDirectOffers(limit, offset, sortBy, sortOrder, status, rate, job, position, matchboxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * * 公開されているポートフォリオの作品のリストを取得します * 他人に非公開の場合などは見れないという旨のレスポンスが返ります * その時は、パスワードをつけて POSTでリクエストをすると表示される情報のデータが返ります。
     * @summary 求職者の公開ポートフォリオ作品リスト
     * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
     * @param {string} [password] パスワード付き公開の場合に必要になる
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public getDirectPortfolio(userMatchboxId: string, password?: string, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).getDirectPortfolio(userMatchboxId, password, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ピックアップに対する社員の反応を取得する
     * @summary リアクション一覧
     * @param {string} offerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public getDirectReactions(offerId: string, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).getDirectReactions(offerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 検索条件を取得
     * @summary 検索条件詳細
     * @param {number} directSearchConditionId Directの検索条件ID
     * @param {boolean} [recommend] おすすめの検索条件かどうか
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public getDirectSearchConditionId(directSearchConditionId: number, recommend?: boolean, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).getDirectSearchConditionId(directSearchConditionId, recommend, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 保存した検索条件一覧
     * @summary 保存した検索条件一覧
     * @param {boolean} [recommended] MATCHBOXのおすすめ検索条件
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public getDirectSearchConditions(recommended?: boolean, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).getDirectSearchConditions(recommended, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * タグに紐づいたユーザー情報一覧
     * @summary タグ ユーザー情報一覧
     * @param {string} userTagPath MW側で設定したタグのパス
     * @param {number} [limit] 取得件数 指定がない場合は20
     * @param {number} [offset] 次のページ番号 指定がない場合は0
     * @param {string} [sortBy] 検索項目 項目はdescription参照
     * @param {string} [sortOrder] 検索順序 asc | desc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public getDirectTagSearchUsersId(userTagPath: string, limit?: number, offset?: number, sortBy?: string, sortOrder?: string, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).getDirectTagSearchUsersId(userTagPath, limit, offset, sortBy, sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ユーザー情報取得
     * @summary ユーザー情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public getDirectUser(options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).getDirectUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ユーザー情報詳細 取得
     * @summary ユーザー情報詳細
     * @param {string} userMatchboxId 求職者ID （C+数字乱数8桁）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public getDirectUserMatchboxId(userMatchboxId: string, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).getDirectUserMatchboxId(userMatchboxId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * タグに紐づいたユーザー情報一覧
     * @summary タグ情報取得
     * @param {string} userTagPath MW側で設定したタグのパス
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public getDirectUserTagPath(userTagPath: string, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).getDirectUserTagPath(userTagPath, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * direct_adminのユーザーがPATCHした場合のみ有効
     * @summary 企業情報編集
     * @param {DirectCompanyModel} [directCompanyModel] 自社情報編集
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public patchDirectCompany(directCompanyModel?: DirectCompanyModel, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).patchDirectCompany(directCompanyModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * userTypeが `direct_manager` のアカウントのみ利用可能
     * @summary 企業ユーザーグループ 変更
     * @param {string} companyGroupId 企業内グループID
     * @param {CompanyGroupParam} [companyGroupParam] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public patchDirectCompanyGroupCompanyGroupId(companyGroupId: string, companyGroupParam?: CompanyGroupParam, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).patchDirectCompanyGroupCompanyGroupId(companyGroupId, companyGroupParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * userTypeが `direct_manager` のアカウントのみ利用可能
     * @summary 企業内グループ一覧 並び順変更
     * @param {InlineObject11} [inlineObject11] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public patchDirectCompanyGroups(inlineObject11?: InlineObject11, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).patchDirectCompanyGroups(inlineObject11, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * userTypeが `direct_manager` のアカウントのみ利用可能  https://www.figma.com/file/tDn9C162xYWTXkvFMaipAn/Final-Design-and-Design-system?node-id=4694%3A66093
     * @summary 企業ユーザー情報の変更
     * @param {string} directMatchboxId 企業ユーザーID （B+数字乱数8桁）
     * @param {DirectCompanyUserParam} [directCompanyUserParam] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public patchDirectCompanyUserId(directMatchboxId: string, directCompanyUserParam?: DirectCompanyUserParam, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).patchDirectCompanyUserId(directMatchboxId, directCompanyUserParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 並び替え
     * @summary 企業ユーザー一覧 並び順変更
     * @param {InlineObject10} [inlineObject10] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public patchDirectCompanyUsers(inlineObject10?: InlineObject10, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).patchDirectCompanyUsers(inlineObject10, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 検索条件のメール配信設定変更する
     * @summary 検索条件のメール配信設定変更
     * @param {number} directSearchConditionId Directの検索条件ID
     * @param {InlineObject15} [inlineObject15] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public patchDirectDirectMailId(directSearchConditionId: number, inlineObject15?: InlineObject15, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).patchDirectDirectMailId(directSearchConditionId, inlineObject15, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 自社アカウントが書いたメモを既読にする
     * @summary メモを既読にする
     * @param {AdminNotePatchParam} [adminNotePatchParam] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public patchDirectNote(adminNotePatchParam?: AdminNotePatchParam, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).patchDirectNote(adminNotePatchParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * オファーのステータス変更
     * @summary オファーのステータス変更
     * @param {DirectOfferPatchParam} [directOfferPatchParam] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public patchDirectOffer(directOfferPatchParam?: DirectOfferPatchParam, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).patchDirectOffer(directOfferPatchParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 更新
     * @summary ポジション更新
     * @param {string} id 
     * @param {DirectOfferPositionParam} [directOfferPositionParam] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public patchDirectOfferPositionId(id: string, directOfferPositionParam?: DirectOfferPositionParam, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).patchDirectOfferPositionId(id, directOfferPositionParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 並び替え
     * @summary ポジション管理 並び替え
     * @param {InlineObject19} [inlineObject19] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public patchDirectOfferPositions(inlineObject19?: InlineObject19, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).patchDirectOfferPositions(inlineObject19, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ピックアップに対するリアクションの修正
     * @summary リアクションを更新する
     * @param {ReactionPatchParam} [reactionPatchParam] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public patchDirectReaction(reactionPatchParam?: ReactionPatchParam, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).patchDirectReaction(reactionPatchParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 検索条件を編集
     * @summary 検索条件更新
     * @param {number} directSearchConditionId Directの検索条件ID
     * @param {DirectSearchConditionRequest} [directSearchConditionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public patchDirectSearchConditionId(directSearchConditionId: number, directSearchConditionRequest?: DirectSearchConditionRequest, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).patchDirectSearchConditionId(directSearchConditionId, directSearchConditionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 並び替え
     * @summary 保存した検索条件一覧の並び替え
     * @param {boolean} [recommended] MATCHBOXのおすすめ検索条件
     * @param {InlineObject14} [inlineObject14] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public patchDirectSearchConditions(recommended?: boolean, inlineObject14?: InlineObject14, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).patchDirectSearchConditions(recommended, inlineObject14, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ログインユーザーの情報変更
     * @summary ユーザー情報変更
     * @param {DirectUserParam} [directUserParam] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public patchDirectUser(directUserParam?: DirectUserParam, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).patchDirectUser(directUserParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * userTypeが `direct_manager` のアカウントのみ利用可能  企業内グループ作成
     * @summary 企業ユーザーグループ新規作成
     * @param {CompanyGroupParam} [companyGroupParam] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public postDirectCompanyGroup(companyGroupParam?: CompanyGroupParam, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).postDirectCompanyGroup(companyGroupParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 企業ユーザーのメールアドレスの変更  https://www.figma.com/file/tDn9C162xYWTXkvFMaipAn/Final-Design-and-Design-system?node-id=2249%3A423
     * @summary ユーザー情報 メールアドレス変更
     * @param {UserEmailChange} [userEmailChange] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public postDirectEmailChange(userEmailChange?: UserEmailChange, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).postDirectEmailChange(userEmailChange, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 企業ユーザーのメールアドレスの変更時のトークンチェック トークンが正しければそのまま変更完了処理までする  https://www.figma.com/file/tDn9C162xYWTXkvFMaipAn/Final-Design-and-Design-system?node-id=2249%3A423
     * @summary ユーザー情報 メールアドレス変更 トークンチェック & 変更完了
     * @param {UserEmailChangeToken} [userEmailChangeToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public postDirectEmailChangeValidateToken(userEmailChangeToken?: UserEmailChangeToken, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).postDirectEmailChangeValidateToken(userEmailChangeToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 新規企業ユーザーを招待する
     * @summary 新規企業ユーザーを招待する
     * @param {InlineObject12} [inlineObject12] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public postDirectInvite(inlineObject12?: InlineObject12, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).postDirectInvite(inlineObject12, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ログインをする  ## 開発サーバーテストアカウント  ID : matchbox-dev-notify+dockertestcompanymanager@s2factory.co.jp  PW : test
     * @summary ログイン
     * @param {string} email メールアドレス
     * @param {string} password パスワード
     * @param {string} [type] 以前の as_ca&#x3D;1 と同様。 caとownerがある
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public postDirectLogin(email: string, password: string, type?: string, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).postDirectLogin(email, password, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * MWが企業へ、またはDirectユーザーが求職者へメモを残す
     * @summary 企業・求職者にメモを残す
     * @param {AdminNotePostParam} [adminNotePostParam] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public postDirectNote(adminNotePostParam?: AdminNotePostParam, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).postDirectNote(adminNotePostParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 求職者をピックアップする
     * @summary オファー送信
     * @param {OfferPostParam} [offerPostParam] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public postDirectOffer(offerPostParam?: OfferPostParam, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).postDirectOffer(offerPostParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ポジション新規作成
     * @summary ポジション新規作成
     * @param {DirectOfferPositionParam} [directOfferPositionParam] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public postDirectOfferPosition(directOfferPositionParam?: DirectOfferPositionParam, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).postDirectOfferPosition(directOfferPositionParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * パスワードを変更します 仕様は冒頭説明箇所を参照
     * @summary パスワード変更
     * @param {PasswordChangeParam} [passwordChangeParam] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public postDirectPasswordChange(passwordChangeParam?: PasswordChangeParam, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).postDirectPasswordChange(passwordChangeParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * パスワードをリセットします  ---  * v2ではPOST成功時に登録メールアドレスに登録メールを送信してパスワードを別途設定する。
     * @summary パスワードリセット
     * @param {PasswordResetParam} [passwordResetParam] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public postDirectPasswordReset(passwordResetParam?: PasswordResetParam, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).postDirectPasswordReset(passwordResetParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * パスワード再設定 仕様は冒頭説明箇所を参照
     * @summary ログイン画面からのパスワード再設定
     * @param {RequestPassword} [requestPassword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public postDirectPasswordResetPassword(requestPassword?: RequestPassword, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).postDirectPasswordResetPassword(requestPassword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * トークンチェック
     * @summary ログイン画面からのパスワード再設定 トークンチェック
     * @param {RequestTokenCheck} [requestTokenCheck] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public postDirectPasswordResetValidateToken(requestTokenCheck?: RequestTokenCheck, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).postDirectPasswordResetValidateToken(requestTokenCheck, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ピックアップに対するリアクションを送信する 
     * @summary リアクション送信
     * @param {ReactionPostParam} [reactionPostParam] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public postDirectReaction(reactionPostParam?: ReactionPostParam, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).postDirectReaction(reactionPostParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 仕様は冒頭説明箇所を参照
     * @summary 企業ユーザーのパスワード登録
     * @param {RequestPassword} [requestPassword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public postDirectRegistrationPassword(requestPassword?: RequestPassword, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).postDirectRegistrationPassword(requestPassword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 登録時にユーザーに発行されるトークンのチェック
     * @summary トークンチェック
     * @param {RequestTokenCheck} [requestTokenCheck] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public postDirectRegistrationValidateToken(requestTokenCheck?: RequestTokenCheck, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).postDirectRegistrationValidateToken(requestTokenCheck, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 名前を付けて検索条件を保存する  ## バックエンド仕様について  バックエンド側では検索条件を JSON でそのまま DB に登録しているので基本的に保存時のリクエストデータの変更に関してはバックエンドに依頼する必要はない。  そのため基本的にどのような構造のデータでも入れることは可能だが検索側のリクエストパラメーターと合わせる必要はあるのでこちらの構造を変更する場合は合わせて検索側も対応しバックエンド側に依頼する。
     * @summary 検索条件保存
     * @param {DirectSearchConditionRequest} [directSearchConditionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public postDirectSearchCondition(directSearchConditionRequest?: DirectSearchConditionRequest, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).postDirectSearchCondition(directSearchConditionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * * 管理ツールなので、少しくらい遅くてもフリーワード検索は実現させたい * age は計算が必要なので毎日１度計算しておく  ## sort_by  - アカウント開設日 registration_date - 最終ログイン日 last_login - 転職希望時期 mc_preferred_change_date - ポートフォリオ作品数 portfolio_item_count
     * @summary 求職者ユーザー検索
     * @param {DirectSearchUserRequest} [directSearchUserRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public postDirectSearchUsers(directSearchUserRequest?: DirectSearchUserRequest, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).postDirectSearchUsers(directSearchUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 特定のdirectユーザーが求職者検索を行い、 matchbox_idに該当する求職者が検索結果に表示された際のis_readプロパティをtrueに  ## ユーザー情報の更新を監視する項目  求職者が以下情報を更新すると該当ユーザーのis_readをfalseに  - ポートフォリオ - 履歴書 - 職務経歴 - マイナビクリエイター希望項目 - ユーザー情報
     * @summary 検索結果表示求職者ユーザーの既読状態を更新
     * @param {InlineObject16} [inlineObject16] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DirectApi
     */
    public postDirectSearchUsersRead(inlineObject16?: InlineObject16, options?: AxiosRequestConfig) {
        return DirectApiFp(this.configuration).postDirectSearchUsersRead(inlineObject16, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MasterApi - axios parameter creator
 * @export
 */
export const MasterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * CP2連携項目については冒頭説明箇所参照  adminユーザーのみ使用可能  返却する値は新規ものがCP2から来た場合はMATCHBOX側のシステムで自動追加、削除や編集がされた場合はMW内部のエンジニアが手動で変更対応をする。  またCP2側では同じ名称で担当者名が指定されることがあるため value + title で表示されている、そのためMatchbox側も以下のようにしオプション名にvalue値を含めて表示するものとする。  ``` {   value: \'1\',   children: \'1 マイナビ担当者\' } ```  プロパティ名はフロント側で加工しやすいようにこの名称としてある、またvalue値がstringなのはHTMLのselect要素はvalueにstringしか受け取らないため数値相当の値も全てstringとして受けるものとする。
         * @summary 管理画面用 : CP2連携項目定義リスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminMasterCp2: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/admin/master/cp2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MasterApi - functional programming interface
 * @export
 */
export const MasterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MasterApiAxiosParamCreator(configuration)
    return {
        /**
         * CP2連携項目については冒頭説明箇所参照  adminユーザーのみ使用可能  返却する値は新規ものがCP2から来た場合はMATCHBOX側のシステムで自動追加、削除や編集がされた場合はMW内部のエンジニアが手動で変更対応をする。  またCP2側では同じ名称で担当者名が指定されることがあるため value + title で表示されている、そのためMatchbox側も以下のようにしオプション名にvalue値を含めて表示するものとする。  ``` {   value: \'1\',   children: \'1 マイナビ担当者\' } ```  プロパティ名はフロント側で加工しやすいようにこの名称としてある、またvalue値がstringなのはHTMLのselect要素はvalueにstringしか受け取らないため数値相当の値も全てstringとして受けるものとする。
         * @summary 管理画面用 : CP2連携項目定義リスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminMasterCp2(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminMasterCp2Model & ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminMasterCp2(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MasterApi - factory interface
 * @export
 */
export const MasterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MasterApiFp(configuration)
    return {
        /**
         * CP2連携項目については冒頭説明箇所参照  adminユーザーのみ使用可能  返却する値は新規ものがCP2から来た場合はMATCHBOX側のシステムで自動追加、削除や編集がされた場合はMW内部のエンジニアが手動で変更対応をする。  またCP2側では同じ名称で担当者名が指定されることがあるため value + title で表示されている、そのためMatchbox側も以下のようにしオプション名にvalue値を含めて表示するものとする。  ``` {   value: \'1\',   children: \'1 マイナビ担当者\' } ```  プロパティ名はフロント側で加工しやすいようにこの名称としてある、またvalue値がstringなのはHTMLのselect要素はvalueにstringしか受け取らないため数値相当の値も全てstringとして受けるものとする。
         * @summary 管理画面用 : CP2連携項目定義リスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminMasterCp2(options?: any): AxiosPromise<AdminMasterCp2Model & ResponseSuccess> {
            return localVarFp.getAdminMasterCp2(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MasterApi - object-oriented interface
 * @export
 * @class MasterApi
 * @extends {BaseAPI}
 */
export class MasterApi extends BaseAPI {
    /**
     * CP2連携項目については冒頭説明箇所参照  adminユーザーのみ使用可能  返却する値は新規ものがCP2から来た場合はMATCHBOX側のシステムで自動追加、削除や編集がされた場合はMW内部のエンジニアが手動で変更対応をする。  またCP2側では同じ名称で担当者名が指定されることがあるため value + title で表示されている、そのためMatchbox側も以下のようにしオプション名にvalue値を含めて表示するものとする。  ``` {   value: \'1\',   children: \'1 マイナビ担当者\' } ```  プロパティ名はフロント側で加工しやすいようにこの名称としてある、またvalue値がstringなのはHTMLのselect要素はvalueにstringしか受け取らないため数値相当の値も全てstringとして受けるものとする。
     * @summary 管理画面用 : CP2連携項目定義リスト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MasterApi
     */
    public getAdminMasterCp2(options?: AxiosRequestConfig) {
        return MasterApiFp(this.configuration).getAdminMasterCp2(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MyNaviApi - axios parameter creator
 * @export
 */
export const MyNaviApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * マイナビクリエイター希望項目・取得
         * @summary マイナビクリエイター希望項目・取得
         * @param {MyNavi} [myNavi] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMynaviCreator: async (myNavi?: MyNavi, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/mynavi-creator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(myNavi, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * マイナビクリエイター希望項目・編集
         * @summary マイナビクリエイター希望項目・編集
         * @param {MyNavi} [myNavi] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchMynaviCreator: async (myNavi?: MyNavi, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/mynavi-creator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(myNavi, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MyNaviApi - functional programming interface
 * @export
 */
export const MyNaviApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MyNaviApiAxiosParamCreator(configuration)
    return {
        /**
         * マイナビクリエイター希望項目・取得
         * @summary マイナビクリエイター希望項目・取得
         * @param {MyNavi} [myNavi] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMynaviCreator(myNavi?: MyNavi, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMyNav>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMynaviCreator(myNavi, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * マイナビクリエイター希望項目・編集
         * @summary マイナビクリエイター希望項目・編集
         * @param {MyNavi} [myNavi] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchMynaviCreator(myNavi?: MyNavi, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMyNav>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchMynaviCreator(myNavi, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MyNaviApi - factory interface
 * @export
 */
export const MyNaviApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MyNaviApiFp(configuration)
    return {
        /**
         * マイナビクリエイター希望項目・取得
         * @summary マイナビクリエイター希望項目・取得
         * @param {MyNavi} [myNavi] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMynaviCreator(myNavi?: MyNavi, options?: any): AxiosPromise<ResponseMyNav> {
            return localVarFp.getMynaviCreator(myNavi, options).then((request) => request(axios, basePath));
        },
        /**
         * マイナビクリエイター希望項目・編集
         * @summary マイナビクリエイター希望項目・編集
         * @param {MyNavi} [myNavi] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchMynaviCreator(myNavi?: MyNavi, options?: any): AxiosPromise<ResponseMyNav> {
            return localVarFp.patchMynaviCreator(myNavi, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MyNaviApi - object-oriented interface
 * @export
 * @class MyNaviApi
 * @extends {BaseAPI}
 */
export class MyNaviApi extends BaseAPI {
    /**
     * マイナビクリエイター希望項目・取得
     * @summary マイナビクリエイター希望項目・取得
     * @param {MyNavi} [myNavi] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyNaviApi
     */
    public getMynaviCreator(myNavi?: MyNavi, options?: AxiosRequestConfig) {
        return MyNaviApiFp(this.configuration).getMynaviCreator(myNavi, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * マイナビクリエイター希望項目・編集
     * @summary マイナビクリエイター希望項目・編集
     * @param {MyNavi} [myNavi] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyNaviApi
     */
    public patchMynaviCreator(myNavi?: MyNavi, options?: AxiosRequestConfig) {
        return MyNaviApiFp(this.configuration).patchMynaviCreator(myNavi, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PortfolioApi - axios parameter creator
 * @export
 */
export const PortfolioApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * * ファイルの削除を行う
         * @summary 画像などのファイル削除
         * @param {string} fileId アップロード時に返却されるファイルID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFiles: async (fileId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('deleteFiles', 'fileId', fileId)
            const localVarPath = `/api/v2/files/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 作品の削除を行う
         * @summary 作品削除
         * @param {string} itemId 作品ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePortfolioItem: async (itemId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('deletePortfolioItem', 'itemId', itemId)
            const localVarPath = `/api/v2/portfolio_item/{ItemId}`
                .replace(`{${"ItemId"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ページの削除を行う
         * @summary ページの削除
         * @param {string} pId ポートフォリオページのid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePortfolioPage: async (pId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pId' is not null or undefined
            assertParamExists('deletePortfolioPage', 'pId', pId)
            const localVarPath = `/api/v2/portfolio_page/{p_id}`
                .replace(`{${"p_id"}}`, encodeURIComponent(String(pId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 自作ポートフォリオ情報の取得を行う
         * @summary 自作ポートフォリオ情報取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnPortfolio: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/own_portfolio`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * * 公開されているポートフォリオの作品のリストを取得します * 他人に非公開の場合などは見れないという旨のレスポンスが返ります * その時は、パスワードをつけて POSTでリクエストをすると表示される情報のデータが返ります。
         * @summary 公開されている作品リスト
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {string} [password] パスワード付き公開の場合に必要になる
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolio: async (userId: string, password?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getPortfolio', 'userId', userId)
            const localVarPath = `/api/v2/portfolio/{UserId}`
                .replace(`{${"UserId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (password !== undefined) {
                localVarQueryParameter['password'] = password;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * * ポートフォリオをPDF化します 該当URLは `/mypage/portfolio/{UserId}/`  レスポンスヘッダーについては仕様書説明項目の `PDF生成APIのレスポンスヘッダーについて`を参照
         * @summary ポートフォリオ一覧 PDF ダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioDownload: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/portfolio/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * PDFダウンロード
         * @summary ポートフォリオPDFダウンロード
         * @param {number} pDFTicketID PDF生成ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioDownloadPdf: async (pDFTicketID: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pDFTicketID' is not null or undefined
            assertParamExists('getPortfolioDownloadPdf', 'pDFTicketID', pDFTicketID)
            const localVarPath = `/api/v2/portfolio/download-pdf/{PDFTicketID}`
                .replace(`{${"PDFTicketID"}}`, encodeURIComponent(String(pDFTicketID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * * 公開されているポートフォリオの作品のリストを取得します * 他人に非公開の場合などは見れないという旨のレスポンスが返ります
         * @summary 編集中の作品リスト取得
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioEdit: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getPortfolioEdit', 'userId', userId)
            const localVarPath = `/api/v2/portfolio_edit/{UserId}`
                .replace(`{${"UserId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * * ポートフォリオをPDF化します 該当URLは `/mypage/portfolio/{UserId}/profile`  レスポンスヘッダーについては仕様書説明項目の `PDF生成APIのレスポンスヘッダーについて`を参照
         * @summary ポートフォリオプロフィール PDF ダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioProfileDownload: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/portfolio/profile/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ``` 1.カバー画像を設定している // main_image 2.自己紹介を登録している // introduction 3.作品の概要を登録している // items[0].i_description が設定されている 4.作品のメイン画像を設定している // items[0].i_image が設定されている 5.作品の関わり方を登録している // いずれかの質問に答えている 6.作品のポイントを登録している // いずれかの質問に答えている 7.作品のサブ画像を登録している // items[0].i_pages[x].p_contents の中に画像がある 8.ポートフォリオを公開している // status が open 9.作品を５個登録しよう // items の length が 4(0始まりの場合) 10.PDFをダウンロードしよう ```
         * @summary ポートフォリオ入力度
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioProgress: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getPortfolioProgress', 'userId', userId)
            const localVarPath = `/api/v2/portfolio_progress/{UserId}`
                .replace(`{${"UserId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ``` ## 1 作品概要 * `i_image` または `i_embedlink` が空ではない * `i_tags`（カテゴリー）の最後の項目が空文字でない * `i_title` （作品タイトル）が空ではない * `i_description` （概要）が空ではない * `i_start_date` （制作時期 ）が空ではない * `i_end_date` （制作時期 ）が空ではない * `b_4` の質問（制作にかかった期間）の `qa_answer` の最後の項目が空文字でない  上記**すべて**が満たされる場合  ## 2 案件への関わり方 * `b_v2_1` の質問（職種）の `qa_answer` の最後の項目が空文字でない * `b_v2_2 ` の質問（担当内容）の `qa_answer` の最後の項目が空文字でない * `b_v2_8`の質問（経験）の `qa_answer` の最後の項目が空文字でない * `b_v2_7`の質問（使用ツール）の `qa_answer` の最後の項目が空文字でない  上記**すべて**が満たされる場合  ## 3 制作のポイント * `qa_id` が`c_*`のいずれかの質問の `qa_question`が空ではない かつ `qa_answer` の最後の項目が空文字でない   ## 4 画像・動画など * `p_contents[1].p_page_layout` が `style-v-2` かつ `p_contents[1].p_contents[0]` `p_contents[1].p_contents[1] `それぞれが、以下のいずれかの条件に合致する   * `f_url` が空ではない   * `m_type`が`all`かつ`m_contents[*].f_url`がすべて空ではない   * `m_type`が`sp`かつ`m_contents[0].f_url`が空ではない   * `embed`が空ではない * `p_contents[1].p_page_layout`が `style-2`かつ   * `p_contents[1].p_contents[*].f_url` がすべて空ではない * `p_contents[1].p_page_layout`が `style-4`かつ   * `p_contents[1].p_contents[*].f_url` がすべて空ではない * `p_contents[1].p_page_layout`が `style-8`かつ   * `p_contents[1].p_contents[*].f_url` がすべて空ではない  上記の**いずれか**が満たされる場合 ```
         * @summary ポートフォリオ入力度（作品毎）
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {string} workId 作品詳細id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioProgressDetail: async (userId: string, workId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getPortfolioProgressDetail', 'userId', userId)
            // verify required parameter 'workId' is not null or undefined
            assertParamExists('getPortfolioProgressDetail', 'workId', workId)
            const localVarPath = `/api/v2/portfolio_progress/{UserId}/{WorkId}`
                .replace(`{${"UserId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"WorkId"}}`, encodeURIComponent(String(workId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * PDFの生成をリクエスト
         * @summary ポートフォリオPDF生成をリクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioRequestToGeneratePdf: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/portfolio/request-to-generate-pdf`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * PDF生成のステータスを確認
         * @summary ポートフォリオPDF生成ステータス確認
         * @param {number} pDFTicketID PDF生成ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioStatusOfPdf: async (pDFTicketID: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pDFTicketID' is not null or undefined
            assertParamExists('getPortfolioStatusOfPdf', 'pDFTicketID', pDFTicketID)
            const localVarPath = `/api/v2/portfolio/status-of-pdf/{PDFTicketID}`
                .replace(`{${"PDFTicketID"}}`, encodeURIComponent(String(pDFTicketID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * * ポートフォリオをPDF化します 該当URLは `/mypage/portfolio/{UserId}/{WorkId}`  レスポンスヘッダーについては仕様書説明項目の `PDF生成APIのレスポンスヘッダーについて`を参照
         * @summary ポートフォリオ詳細 PDF ダウンロード
         * @param {string} workId 作品ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioUserIdDownload: async (workId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workId' is not null or undefined
            assertParamExists('getPortfolioUserIdDownload', 'workId', workId)
            const localVarPath = `/api/v2/portfolio/{WorkId}/download`
                .replace(`{${"WorkId"}}`, encodeURIComponent(String(workId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 自作ポートフォリオ情報の更新を行う
         * @summary 自作ポートフォリオ情報更新
         * @param {OwnPortfolioRequest} [ownPortfolioRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchOwnPortfolio: async (ownPortfolioRequest?: OwnPortfolioRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/own_portfolio`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ownPortfolioRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 作品リストを編集
         * @summary 作品リストを編集
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {Portfolio} [portfolio] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPortfolioEdit: async (userId: string, portfolio?: Portfolio, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('patchPortfolioEdit', 'userId', userId)
            const localVarPath = `/api/v2/portfolio_edit/{UserId}`
                .replace(`{${"UserId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(portfolio, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * OGPから画像と、対象サービスのebmed用 iframe source URLを取得
         * @summary URLからebmed用のリンクを取得
         * @param {PortfolioItemPostParam} [portfolioItemPostParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postEmbed: async (portfolioItemPostParam?: PortfolioItemPostParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/embed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(portfolioItemPostParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * * ファイルのアップロード行う * アップロードが完了後、サムネイルのURLとファイルのIDを返す
         * @summary 画像などのファイルアップロード
         * @param {any} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFiles: async (files: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'files' is not null or undefined
            assertParamExists('postFiles', 'files', files)
            const localVarPath = `/api/v2/files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (files !== undefined) { 
                localVarFormParams.append('files', files as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 自作ポートフォリオ情報の登録を行う
         * @summary 自作ポートフォリオ情報登録
         * @param {OwnPortfolioRequest} [ownPortfolioRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOwnPortfolio: async (ownPortfolioRequest?: OwnPortfolioRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/own_portfolio`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ownPortfolioRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * `i_image`, `i_embedlink`, `i_title`, `i_description`をOGPから抽出して、PortfolioItemをかえす
         * @summary URLから作品を追加
         * @param {PortfolioItemPostParam} [portfolioItemPostParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPortfolioItem: async (portfolioItemPostParam?: PortfolioItemPostParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/portfolio_item`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(portfolioItemPostParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 管理画面で編集したポートフォリオの内容を、公開用APIにも反映します。
         * @summary ポートフォリオ公開
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPortfolioPublish: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('postPortfolioPublish', 'userId', userId)
            const localVarPath = `/api/v2/portfolio_edit/{UserId}/publish`
                .replace(`{${"UserId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PortfolioApi - functional programming interface
 * @export
 */
export const PortfolioApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PortfolioApiAxiosParamCreator(configuration)
    return {
        /**
         * * ファイルの削除を行う
         * @summary 画像などのファイル削除
         * @param {string} fileId アップロード時に返却されるファイルID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFiles(fileId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFiles(fileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 作品の削除を行う
         * @summary 作品削除
         * @param {string} itemId 作品ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePortfolioItem(itemId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Portfolio>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePortfolioItem(itemId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ページの削除を行う
         * @summary ページの削除
         * @param {string} pId ポートフォリオページのid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePortfolioPage(pId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Portfolio>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePortfolioPage(pId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 自作ポートフォリオ情報の取得を行う
         * @summary 自作ポートフォリオ情報取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOwnPortfolio(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OwnPortfolioResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOwnPortfolio(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * * 公開されているポートフォリオの作品のリストを取得します * 他人に非公開の場合などは見れないという旨のレスポンスが返ります * その時は、パスワードをつけて POSTでリクエストをすると表示される情報のデータが返ります。
         * @summary 公開されている作品リスト
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {string} [password] パスワード付き公開の場合に必要になる
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPortfolio(userId: string, password?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Portfolio & Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPortfolio(userId, password, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * * ポートフォリオをPDF化します 該当URLは `/mypage/portfolio/{UserId}/`  レスポンスヘッダーについては仕様書説明項目の `PDF生成APIのレスポンスヘッダーについて`を参照
         * @summary ポートフォリオ一覧 PDF ダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPortfolioDownload(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPortfolioDownload(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * PDFダウンロード
         * @summary ポートフォリオPDFダウンロード
         * @param {number} pDFTicketID PDF生成ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPortfolioDownloadPdf(pDFTicketID: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPortfolioDownloadPdf(pDFTicketID, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * * 公開されているポートフォリオの作品のリストを取得します * 他人に非公開の場合などは見れないという旨のレスポンスが返ります
         * @summary 編集中の作品リスト取得
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPortfolioEdit(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Portfolio & Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPortfolioEdit(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * * ポートフォリオをPDF化します 該当URLは `/mypage/portfolio/{UserId}/profile`  レスポンスヘッダーについては仕様書説明項目の `PDF生成APIのレスポンスヘッダーについて`を参照
         * @summary ポートフォリオプロフィール PDF ダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPortfolioProfileDownload(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPortfolioProfileDownload(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ``` 1.カバー画像を設定している // main_image 2.自己紹介を登録している // introduction 3.作品の概要を登録している // items[0].i_description が設定されている 4.作品のメイン画像を設定している // items[0].i_image が設定されている 5.作品の関わり方を登録している // いずれかの質問に答えている 6.作品のポイントを登録している // いずれかの質問に答えている 7.作品のサブ画像を登録している // items[0].i_pages[x].p_contents の中に画像がある 8.ポートフォリオを公開している // status が open 9.作品を５個登録しよう // items の length が 4(0始まりの場合) 10.PDFをダウンロードしよう ```
         * @summary ポートフォリオ入力度
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPortfolioProgress(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortfolioProgressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPortfolioProgress(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ``` ## 1 作品概要 * `i_image` または `i_embedlink` が空ではない * `i_tags`（カテゴリー）の最後の項目が空文字でない * `i_title` （作品タイトル）が空ではない * `i_description` （概要）が空ではない * `i_start_date` （制作時期 ）が空ではない * `i_end_date` （制作時期 ）が空ではない * `b_4` の質問（制作にかかった期間）の `qa_answer` の最後の項目が空文字でない  上記**すべて**が満たされる場合  ## 2 案件への関わり方 * `b_v2_1` の質問（職種）の `qa_answer` の最後の項目が空文字でない * `b_v2_2 ` の質問（担当内容）の `qa_answer` の最後の項目が空文字でない * `b_v2_8`の質問（経験）の `qa_answer` の最後の項目が空文字でない * `b_v2_7`の質問（使用ツール）の `qa_answer` の最後の項目が空文字でない  上記**すべて**が満たされる場合  ## 3 制作のポイント * `qa_id` が`c_*`のいずれかの質問の `qa_question`が空ではない かつ `qa_answer` の最後の項目が空文字でない   ## 4 画像・動画など * `p_contents[1].p_page_layout` が `style-v-2` かつ `p_contents[1].p_contents[0]` `p_contents[1].p_contents[1] `それぞれが、以下のいずれかの条件に合致する   * `f_url` が空ではない   * `m_type`が`all`かつ`m_contents[*].f_url`がすべて空ではない   * `m_type`が`sp`かつ`m_contents[0].f_url`が空ではない   * `embed`が空ではない * `p_contents[1].p_page_layout`が `style-2`かつ   * `p_contents[1].p_contents[*].f_url` がすべて空ではない * `p_contents[1].p_page_layout`が `style-4`かつ   * `p_contents[1].p_contents[*].f_url` がすべて空ではない * `p_contents[1].p_page_layout`が `style-8`かつ   * `p_contents[1].p_contents[*].f_url` がすべて空ではない  上記の**いずれか**が満たされる場合 ```
         * @summary ポートフォリオ入力度（作品毎）
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {string} workId 作品詳細id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPortfolioProgressDetail(userId: string, workId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortfolioProgressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPortfolioProgressDetail(userId, workId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * PDFの生成をリクエスト
         * @summary ポートフォリオPDF生成をリクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPortfolioRequestToGeneratePdf(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess & PDFTicketId>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPortfolioRequestToGeneratePdf(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * PDF生成のステータスを確認
         * @summary ポートフォリオPDF生成ステータス確認
         * @param {number} pDFTicketID PDF生成ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPortfolioStatusOfPdf(pDFTicketID: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PDFTicketStatus & ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPortfolioStatusOfPdf(pDFTicketID, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * * ポートフォリオをPDF化します 該当URLは `/mypage/portfolio/{UserId}/{WorkId}`  レスポンスヘッダーについては仕様書説明項目の `PDF生成APIのレスポンスヘッダーについて`を参照
         * @summary ポートフォリオ詳細 PDF ダウンロード
         * @param {string} workId 作品ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPortfolioUserIdDownload(workId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPortfolioUserIdDownload(workId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 自作ポートフォリオ情報の更新を行う
         * @summary 自作ポートフォリオ情報更新
         * @param {OwnPortfolioRequest} [ownPortfolioRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchOwnPortfolio(ownPortfolioRequest?: OwnPortfolioRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OwnPortfolioResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchOwnPortfolio(ownPortfolioRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 作品リストを編集
         * @summary 作品リストを編集
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {Portfolio} [portfolio] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchPortfolioEdit(userId: string, portfolio?: Portfolio, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Portfolio & Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchPortfolioEdit(userId, portfolio, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * OGPから画像と、対象サービスのebmed用 iframe source URLを取得
         * @summary URLからebmed用のリンクを取得
         * @param {PortfolioItemPostParam} [portfolioItemPostParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postEmbed(portfolioItemPostParam?: PortfolioItemPostParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Embed & Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postEmbed(portfolioItemPostParam, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * * ファイルのアップロード行う * アップロードが完了後、サムネイルのURLとファイルのIDを返す
         * @summary 画像などのファイルアップロード
         * @param {any} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postFiles(files: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postFiles(files, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 自作ポートフォリオ情報の登録を行う
         * @summary 自作ポートフォリオ情報登録
         * @param {OwnPortfolioRequest} [ownPortfolioRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postOwnPortfolio(ownPortfolioRequest?: OwnPortfolioRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OwnPortfolioResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postOwnPortfolio(ownPortfolioRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * `i_image`, `i_embedlink`, `i_title`, `i_description`をOGPから抽出して、PortfolioItemをかえす
         * @summary URLから作品を追加
         * @param {PortfolioItemPostParam} [portfolioItemPostParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postPortfolioItem(portfolioItemPostParam?: PortfolioItemPostParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortfolioItemResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postPortfolioItem(portfolioItemPostParam, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 管理画面で編集したポートフォリオの内容を、公開用APIにも反映します。
         * @summary ポートフォリオ公開
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postPortfolioPublish(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postPortfolioPublish(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PortfolioApi - factory interface
 * @export
 */
export const PortfolioApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PortfolioApiFp(configuration)
    return {
        /**
         * * ファイルの削除を行う
         * @summary 画像などのファイル削除
         * @param {string} fileId アップロード時に返却されるファイルID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFiles(fileId: string, options?: any): AxiosPromise<Status> {
            return localVarFp.deleteFiles(fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 作品の削除を行う
         * @summary 作品削除
         * @param {string} itemId 作品ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePortfolioItem(itemId: string, options?: any): AxiosPromise<Portfolio> {
            return localVarFp.deletePortfolioItem(itemId, options).then((request) => request(axios, basePath));
        },
        /**
         * ページの削除を行う
         * @summary ページの削除
         * @param {string} pId ポートフォリオページのid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePortfolioPage(pId: string, options?: any): AxiosPromise<Portfolio> {
            return localVarFp.deletePortfolioPage(pId, options).then((request) => request(axios, basePath));
        },
        /**
         * 自作ポートフォリオ情報の取得を行う
         * @summary 自作ポートフォリオ情報取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnPortfolio(options?: any): AxiosPromise<OwnPortfolioResponse> {
            return localVarFp.getOwnPortfolio(options).then((request) => request(axios, basePath));
        },
        /**
         * * 公開されているポートフォリオの作品のリストを取得します * 他人に非公開の場合などは見れないという旨のレスポンスが返ります * その時は、パスワードをつけて POSTでリクエストをすると表示される情報のデータが返ります。
         * @summary 公開されている作品リスト
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {string} [password] パスワード付き公開の場合に必要になる
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolio(userId: string, password?: string, options?: any): AxiosPromise<Portfolio & Status> {
            return localVarFp.getPortfolio(userId, password, options).then((request) => request(axios, basePath));
        },
        /**
         * * ポートフォリオをPDF化します 該当URLは `/mypage/portfolio/{UserId}/`  レスポンスヘッダーについては仕様書説明項目の `PDF生成APIのレスポンスヘッダーについて`を参照
         * @summary ポートフォリオ一覧 PDF ダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioDownload(options?: any): AxiosPromise<void> {
            return localVarFp.getPortfolioDownload(options).then((request) => request(axios, basePath));
        },
        /**
         * PDFダウンロード
         * @summary ポートフォリオPDFダウンロード
         * @param {number} pDFTicketID PDF生成ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioDownloadPdf(pDFTicketID: number, options?: any): AxiosPromise<void> {
            return localVarFp.getPortfolioDownloadPdf(pDFTicketID, options).then((request) => request(axios, basePath));
        },
        /**
         * * 公開されているポートフォリオの作品のリストを取得します * 他人に非公開の場合などは見れないという旨のレスポンスが返ります
         * @summary 編集中の作品リスト取得
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioEdit(userId: string, options?: any): AxiosPromise<Portfolio & Status> {
            return localVarFp.getPortfolioEdit(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * * ポートフォリオをPDF化します 該当URLは `/mypage/portfolio/{UserId}/profile`  レスポンスヘッダーについては仕様書説明項目の `PDF生成APIのレスポンスヘッダーについて`を参照
         * @summary ポートフォリオプロフィール PDF ダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioProfileDownload(options?: any): AxiosPromise<void> {
            return localVarFp.getPortfolioProfileDownload(options).then((request) => request(axios, basePath));
        },
        /**
         * ``` 1.カバー画像を設定している // main_image 2.自己紹介を登録している // introduction 3.作品の概要を登録している // items[0].i_description が設定されている 4.作品のメイン画像を設定している // items[0].i_image が設定されている 5.作品の関わり方を登録している // いずれかの質問に答えている 6.作品のポイントを登録している // いずれかの質問に答えている 7.作品のサブ画像を登録している // items[0].i_pages[x].p_contents の中に画像がある 8.ポートフォリオを公開している // status が open 9.作品を５個登録しよう // items の length が 4(0始まりの場合) 10.PDFをダウンロードしよう ```
         * @summary ポートフォリオ入力度
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioProgress(userId: string, options?: any): AxiosPromise<PortfolioProgressResponse> {
            return localVarFp.getPortfolioProgress(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * ``` ## 1 作品概要 * `i_image` または `i_embedlink` が空ではない * `i_tags`（カテゴリー）の最後の項目が空文字でない * `i_title` （作品タイトル）が空ではない * `i_description` （概要）が空ではない * `i_start_date` （制作時期 ）が空ではない * `i_end_date` （制作時期 ）が空ではない * `b_4` の質問（制作にかかった期間）の `qa_answer` の最後の項目が空文字でない  上記**すべて**が満たされる場合  ## 2 案件への関わり方 * `b_v2_1` の質問（職種）の `qa_answer` の最後の項目が空文字でない * `b_v2_2 ` の質問（担当内容）の `qa_answer` の最後の項目が空文字でない * `b_v2_8`の質問（経験）の `qa_answer` の最後の項目が空文字でない * `b_v2_7`の質問（使用ツール）の `qa_answer` の最後の項目が空文字でない  上記**すべて**が満たされる場合  ## 3 制作のポイント * `qa_id` が`c_*`のいずれかの質問の `qa_question`が空ではない かつ `qa_answer` の最後の項目が空文字でない   ## 4 画像・動画など * `p_contents[1].p_page_layout` が `style-v-2` かつ `p_contents[1].p_contents[0]` `p_contents[1].p_contents[1] `それぞれが、以下のいずれかの条件に合致する   * `f_url` が空ではない   * `m_type`が`all`かつ`m_contents[*].f_url`がすべて空ではない   * `m_type`が`sp`かつ`m_contents[0].f_url`が空ではない   * `embed`が空ではない * `p_contents[1].p_page_layout`が `style-2`かつ   * `p_contents[1].p_contents[*].f_url` がすべて空ではない * `p_contents[1].p_page_layout`が `style-4`かつ   * `p_contents[1].p_contents[*].f_url` がすべて空ではない * `p_contents[1].p_page_layout`が `style-8`かつ   * `p_contents[1].p_contents[*].f_url` がすべて空ではない  上記の**いずれか**が満たされる場合 ```
         * @summary ポートフォリオ入力度（作品毎）
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {string} workId 作品詳細id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioProgressDetail(userId: string, workId: string, options?: any): AxiosPromise<PortfolioProgressResponse> {
            return localVarFp.getPortfolioProgressDetail(userId, workId, options).then((request) => request(axios, basePath));
        },
        /**
         * PDFの生成をリクエスト
         * @summary ポートフォリオPDF生成をリクエスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioRequestToGeneratePdf(options?: any): AxiosPromise<ResponseSuccess & PDFTicketId> {
            return localVarFp.getPortfolioRequestToGeneratePdf(options).then((request) => request(axios, basePath));
        },
        /**
         * PDF生成のステータスを確認
         * @summary ポートフォリオPDF生成ステータス確認
         * @param {number} pDFTicketID PDF生成ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioStatusOfPdf(pDFTicketID: number, options?: any): AxiosPromise<PDFTicketStatus & ResponseSuccess> {
            return localVarFp.getPortfolioStatusOfPdf(pDFTicketID, options).then((request) => request(axios, basePath));
        },
        /**
         * * ポートフォリオをPDF化します 該当URLは `/mypage/portfolio/{UserId}/{WorkId}`  レスポンスヘッダーについては仕様書説明項目の `PDF生成APIのレスポンスヘッダーについて`を参照
         * @summary ポートフォリオ詳細 PDF ダウンロード
         * @param {string} workId 作品ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioUserIdDownload(workId: string, options?: any): AxiosPromise<void> {
            return localVarFp.getPortfolioUserIdDownload(workId, options).then((request) => request(axios, basePath));
        },
        /**
         * 自作ポートフォリオ情報の更新を行う
         * @summary 自作ポートフォリオ情報更新
         * @param {OwnPortfolioRequest} [ownPortfolioRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchOwnPortfolio(ownPortfolioRequest?: OwnPortfolioRequest, options?: any): AxiosPromise<OwnPortfolioResponse> {
            return localVarFp.patchOwnPortfolio(ownPortfolioRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 作品リストを編集
         * @summary 作品リストを編集
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {Portfolio} [portfolio] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPortfolioEdit(userId: string, portfolio?: Portfolio, options?: any): AxiosPromise<Portfolio & Status> {
            return localVarFp.patchPortfolioEdit(userId, portfolio, options).then((request) => request(axios, basePath));
        },
        /**
         * OGPから画像と、対象サービスのebmed用 iframe source URLを取得
         * @summary URLからebmed用のリンクを取得
         * @param {PortfolioItemPostParam} [portfolioItemPostParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postEmbed(portfolioItemPostParam?: PortfolioItemPostParam, options?: any): AxiosPromise<Embed & Status> {
            return localVarFp.postEmbed(portfolioItemPostParam, options).then((request) => request(axios, basePath));
        },
        /**
         * * ファイルのアップロード行う * アップロードが完了後、サムネイルのURLとファイルのIDを返す
         * @summary 画像などのファイルアップロード
         * @param {any} files 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFiles(files: any, options?: any): AxiosPromise<FileResponse> {
            return localVarFp.postFiles(files, options).then((request) => request(axios, basePath));
        },
        /**
         * 自作ポートフォリオ情報の登録を行う
         * @summary 自作ポートフォリオ情報登録
         * @param {OwnPortfolioRequest} [ownPortfolioRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOwnPortfolio(ownPortfolioRequest?: OwnPortfolioRequest, options?: any): AxiosPromise<OwnPortfolioResponse> {
            return localVarFp.postOwnPortfolio(ownPortfolioRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * `i_image`, `i_embedlink`, `i_title`, `i_description`をOGPから抽出して、PortfolioItemをかえす
         * @summary URLから作品を追加
         * @param {PortfolioItemPostParam} [portfolioItemPostParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPortfolioItem(portfolioItemPostParam?: PortfolioItemPostParam, options?: any): AxiosPromise<PortfolioItemResponse> {
            return localVarFp.postPortfolioItem(portfolioItemPostParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 管理画面で編集したポートフォリオの内容を、公開用APIにも反映します。
         * @summary ポートフォリオ公開
         * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPortfolioPublish(userId: string, options?: any): AxiosPromise<void> {
            return localVarFp.postPortfolioPublish(userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PortfolioApi - object-oriented interface
 * @export
 * @class PortfolioApi
 * @extends {BaseAPI}
 */
export class PortfolioApi extends BaseAPI {
    /**
     * * ファイルの削除を行う
     * @summary 画像などのファイル削除
     * @param {string} fileId アップロード時に返却されるファイルID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioApi
     */
    public deleteFiles(fileId: string, options?: AxiosRequestConfig) {
        return PortfolioApiFp(this.configuration).deleteFiles(fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 作品の削除を行う
     * @summary 作品削除
     * @param {string} itemId 作品ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioApi
     */
    public deletePortfolioItem(itemId: string, options?: AxiosRequestConfig) {
        return PortfolioApiFp(this.configuration).deletePortfolioItem(itemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ページの削除を行う
     * @summary ページの削除
     * @param {string} pId ポートフォリオページのid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioApi
     */
    public deletePortfolioPage(pId: string, options?: AxiosRequestConfig) {
        return PortfolioApiFp(this.configuration).deletePortfolioPage(pId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 自作ポートフォリオ情報の取得を行う
     * @summary 自作ポートフォリオ情報取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioApi
     */
    public getOwnPortfolio(options?: AxiosRequestConfig) {
        return PortfolioApiFp(this.configuration).getOwnPortfolio(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * * 公開されているポートフォリオの作品のリストを取得します * 他人に非公開の場合などは見れないという旨のレスポンスが返ります * その時は、パスワードをつけて POSTでリクエストをすると表示される情報のデータが返ります。
     * @summary 公開されている作品リスト
     * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
     * @param {string} [password] パスワード付き公開の場合に必要になる
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioApi
     */
    public getPortfolio(userId: string, password?: string, options?: AxiosRequestConfig) {
        return PortfolioApiFp(this.configuration).getPortfolio(userId, password, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * * ポートフォリオをPDF化します 該当URLは `/mypage/portfolio/{UserId}/`  レスポンスヘッダーについては仕様書説明項目の `PDF生成APIのレスポンスヘッダーについて`を参照
     * @summary ポートフォリオ一覧 PDF ダウンロード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioApi
     */
    public getPortfolioDownload(options?: AxiosRequestConfig) {
        return PortfolioApiFp(this.configuration).getPortfolioDownload(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * PDFダウンロード
     * @summary ポートフォリオPDFダウンロード
     * @param {number} pDFTicketID PDF生成ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioApi
     */
    public getPortfolioDownloadPdf(pDFTicketID: number, options?: AxiosRequestConfig) {
        return PortfolioApiFp(this.configuration).getPortfolioDownloadPdf(pDFTicketID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * * 公開されているポートフォリオの作品のリストを取得します * 他人に非公開の場合などは見れないという旨のレスポンスが返ります
     * @summary 編集中の作品リスト取得
     * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioApi
     */
    public getPortfolioEdit(userId: string, options?: AxiosRequestConfig) {
        return PortfolioApiFp(this.configuration).getPortfolioEdit(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * * ポートフォリオをPDF化します 該当URLは `/mypage/portfolio/{UserId}/profile`  レスポンスヘッダーについては仕様書説明項目の `PDF生成APIのレスポンスヘッダーについて`を参照
     * @summary ポートフォリオプロフィール PDF ダウンロード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioApi
     */
    public getPortfolioProfileDownload(options?: AxiosRequestConfig) {
        return PortfolioApiFp(this.configuration).getPortfolioProfileDownload(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ``` 1.カバー画像を設定している // main_image 2.自己紹介を登録している // introduction 3.作品の概要を登録している // items[0].i_description が設定されている 4.作品のメイン画像を設定している // items[0].i_image が設定されている 5.作品の関わり方を登録している // いずれかの質問に答えている 6.作品のポイントを登録している // いずれかの質問に答えている 7.作品のサブ画像を登録している // items[0].i_pages[x].p_contents の中に画像がある 8.ポートフォリオを公開している // status が open 9.作品を５個登録しよう // items の length が 4(0始まりの場合) 10.PDFをダウンロードしよう ```
     * @summary ポートフォリオ入力度
     * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioApi
     */
    public getPortfolioProgress(userId: string, options?: AxiosRequestConfig) {
        return PortfolioApiFp(this.configuration).getPortfolioProgress(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ``` ## 1 作品概要 * `i_image` または `i_embedlink` が空ではない * `i_tags`（カテゴリー）の最後の項目が空文字でない * `i_title` （作品タイトル）が空ではない * `i_description` （概要）が空ではない * `i_start_date` （制作時期 ）が空ではない * `i_end_date` （制作時期 ）が空ではない * `b_4` の質問（制作にかかった期間）の `qa_answer` の最後の項目が空文字でない  上記**すべて**が満たされる場合  ## 2 案件への関わり方 * `b_v2_1` の質問（職種）の `qa_answer` の最後の項目が空文字でない * `b_v2_2 ` の質問（担当内容）の `qa_answer` の最後の項目が空文字でない * `b_v2_8`の質問（経験）の `qa_answer` の最後の項目が空文字でない * `b_v2_7`の質問（使用ツール）の `qa_answer` の最後の項目が空文字でない  上記**すべて**が満たされる場合  ## 3 制作のポイント * `qa_id` が`c_*`のいずれかの質問の `qa_question`が空ではない かつ `qa_answer` の最後の項目が空文字でない   ## 4 画像・動画など * `p_contents[1].p_page_layout` が `style-v-2` かつ `p_contents[1].p_contents[0]` `p_contents[1].p_contents[1] `それぞれが、以下のいずれかの条件に合致する   * `f_url` が空ではない   * `m_type`が`all`かつ`m_contents[*].f_url`がすべて空ではない   * `m_type`が`sp`かつ`m_contents[0].f_url`が空ではない   * `embed`が空ではない * `p_contents[1].p_page_layout`が `style-2`かつ   * `p_contents[1].p_contents[*].f_url` がすべて空ではない * `p_contents[1].p_page_layout`が `style-4`かつ   * `p_contents[1].p_contents[*].f_url` がすべて空ではない * `p_contents[1].p_page_layout`が `style-8`かつ   * `p_contents[1].p_contents[*].f_url` がすべて空ではない  上記の**いずれか**が満たされる場合 ```
     * @summary ポートフォリオ入力度（作品毎）
     * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
     * @param {string} workId 作品詳細id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioApi
     */
    public getPortfolioProgressDetail(userId: string, workId: string, options?: AxiosRequestConfig) {
        return PortfolioApiFp(this.configuration).getPortfolioProgressDetail(userId, workId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * PDFの生成をリクエスト
     * @summary ポートフォリオPDF生成をリクエスト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioApi
     */
    public getPortfolioRequestToGeneratePdf(options?: AxiosRequestConfig) {
        return PortfolioApiFp(this.configuration).getPortfolioRequestToGeneratePdf(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * PDF生成のステータスを確認
     * @summary ポートフォリオPDF生成ステータス確認
     * @param {number} pDFTicketID PDF生成ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioApi
     */
    public getPortfolioStatusOfPdf(pDFTicketID: number, options?: AxiosRequestConfig) {
        return PortfolioApiFp(this.configuration).getPortfolioStatusOfPdf(pDFTicketID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * * ポートフォリオをPDF化します 該当URLは `/mypage/portfolio/{UserId}/{WorkId}`  レスポンスヘッダーについては仕様書説明項目の `PDF生成APIのレスポンスヘッダーについて`を参照
     * @summary ポートフォリオ詳細 PDF ダウンロード
     * @param {string} workId 作品ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioApi
     */
    public getPortfolioUserIdDownload(workId: string, options?: AxiosRequestConfig) {
        return PortfolioApiFp(this.configuration).getPortfolioUserIdDownload(workId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 自作ポートフォリオ情報の更新を行う
     * @summary 自作ポートフォリオ情報更新
     * @param {OwnPortfolioRequest} [ownPortfolioRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioApi
     */
    public patchOwnPortfolio(ownPortfolioRequest?: OwnPortfolioRequest, options?: AxiosRequestConfig) {
        return PortfolioApiFp(this.configuration).patchOwnPortfolio(ownPortfolioRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 作品リストを編集
     * @summary 作品リストを編集
     * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
     * @param {Portfolio} [portfolio] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioApi
     */
    public patchPortfolioEdit(userId: string, portfolio?: Portfolio, options?: AxiosRequestConfig) {
        return PortfolioApiFp(this.configuration).patchPortfolioEdit(userId, portfolio, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * OGPから画像と、対象サービスのebmed用 iframe source URLを取得
     * @summary URLからebmed用のリンクを取得
     * @param {PortfolioItemPostParam} [portfolioItemPostParam] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioApi
     */
    public postEmbed(portfolioItemPostParam?: PortfolioItemPostParam, options?: AxiosRequestConfig) {
        return PortfolioApiFp(this.configuration).postEmbed(portfolioItemPostParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * * ファイルのアップロード行う * アップロードが完了後、サムネイルのURLとファイルのIDを返す
     * @summary 画像などのファイルアップロード
     * @param {any} files 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioApi
     */
    public postFiles(files: any, options?: AxiosRequestConfig) {
        return PortfolioApiFp(this.configuration).postFiles(files, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 自作ポートフォリオ情報の登録を行う
     * @summary 自作ポートフォリオ情報登録
     * @param {OwnPortfolioRequest} [ownPortfolioRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioApi
     */
    public postOwnPortfolio(ownPortfolioRequest?: OwnPortfolioRequest, options?: AxiosRequestConfig) {
        return PortfolioApiFp(this.configuration).postOwnPortfolio(ownPortfolioRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * `i_image`, `i_embedlink`, `i_title`, `i_description`をOGPから抽出して、PortfolioItemをかえす
     * @summary URLから作品を追加
     * @param {PortfolioItemPostParam} [portfolioItemPostParam] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioApi
     */
    public postPortfolioItem(portfolioItemPostParam?: PortfolioItemPostParam, options?: AxiosRequestConfig) {
        return PortfolioApiFp(this.configuration).postPortfolioItem(portfolioItemPostParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 管理画面で編集したポートフォリオの内容を、公開用APIにも反映します。
     * @summary ポートフォリオ公開
     * @param {string} userId P+数字乱数8桁  主にポートフォリオの公開用パスとして使用
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioApi
     */
    public postPortfolioPublish(userId: string, options?: AxiosRequestConfig) {
        return PortfolioApiFp(this.configuration).postPortfolioPublish(userId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ResumeApi - axios parameter creator
 * @export
 */
export const ResumeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 学歴の削除を行う
         * @summary 学歴削除
         * @param {string} educationId 学歴ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResumeEducations: async (educationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'educationId' is not null or undefined
            assertParamExists('deleteResumeEducations', 'educationId', educationId)
            const localVarPath = `/api/v2/resume/educations/{educationId}`
                .replace(`{${"educationId"}}`, encodeURIComponent(String(educationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 入力代行済履歴書取得
         * @summary 入力代行済履歴書取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInputAgencyResume: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/input_agency/resume`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 履歴書情報・一覧取得
         * @summary 履歴書情報・一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResume: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/resume`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ``` 1.写真をアップロードしている // userinfo->photo が入ってる 2.性別を入力している // userinfo->gender 3.住所を入力している // userinfo->address1 4.学歴を入力している // userinfo->address1 5.職歴を入力している // 会社名が空ではないcareersが1件以上ある 6.資格を入力している // スコアが0ではない toeic か toeflタイプのQualificationが1件以上ある　または　textタイプでタイトルが空ではないQualificationが1件以上ある 7.志望動機を入力している // statement 8.趣味・特技を入力している // interest_things 9.本人希望を入力している // hope_job 10.PDFをダウンロードしている ```
         * @summary 履歴書入力度 取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResumeProgress: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/resume_progress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * * 公開されている履歴書をPDF化します 該当URLは `/mypage/resume`  レスポンスヘッダーについては仕様書説明項目の `PDF生成APIのレスポンスヘッダーについて`を参照
         * @summary 履歴書 PDF ダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserIdDownload: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/resume/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * * 履歴書作成に必要な情報を更新する * 資格、学歴、職務経歴の情報は多いので、送信時には省く（レスポンスには返ってくる） * 資格、職務経歴の表示順序は、内部的に履歴書用のorder番号を持ち、職務経歴書とは別に独立して保存します。  ---  新たな職歴などが追加された場合（履歴書用の内部的なorder番号がない場合）order番号を持つ職歴の一番後ろから表示します。履歴書編集画面で並び替えを行いPATCHを送信した際に、order番号を更新します。 ※S2さんにフィジビリティ要確認
         * @summary 履歴書更新
         * @param {Resume} [resume] 証明写真 user.user_info.photo は以下の形式でリクエストする  &#x60;&#x60;&#x60; {   f_id: \&quot;POST /api/v2/files で返ってきた f_id\&quot; } &#x60;&#x60;&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchResume: async (resume?: Resume, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/resume`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resume, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 学歴・編集
         * @summary 学歴・編集
         * @param {EducationPatchRequest} [educationPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchResumeUserIdEducations: async (educationPatchRequest?: EducationPatchRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/resume/educations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(educationPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 新規なのでe_id は空文字で送信
         * @summary 学歴・追加
         * @param {EducationPostRequest} [educationPostRequest] 学歴・追加
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResumeUserIdEducations: async (educationPostRequest?: EducationPostRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/resume/educations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(educationPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ResumeApi - functional programming interface
 * @export
 */
export const ResumeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ResumeApiAxiosParamCreator(configuration)
    return {
        /**
         * 学歴の削除を行う
         * @summary 学歴削除
         * @param {string} educationId 学歴ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteResumeEducations(educationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EducationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteResumeEducations(educationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 入力代行済履歴書取得
         * @summary 入力代行済履歴書取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInputAgencyResume(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MBResumeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInputAgencyResume(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 履歴書情報・一覧取得
         * @summary 履歴書情報・一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResume(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MBResumeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getResume(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ``` 1.写真をアップロードしている // userinfo->photo が入ってる 2.性別を入力している // userinfo->gender 3.住所を入力している // userinfo->address1 4.学歴を入力している // userinfo->address1 5.職歴を入力している // 会社名が空ではないcareersが1件以上ある 6.資格を入力している // スコアが0ではない toeic か toeflタイプのQualificationが1件以上ある　または　textタイプでタイトルが空ではないQualificationが1件以上ある 7.志望動機を入力している // statement 8.趣味・特技を入力している // interest_things 9.本人希望を入力している // hope_job 10.PDFをダウンロードしている ```
         * @summary 履歴書入力度 取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResumeProgress(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object & Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getResumeProgress(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * * 公開されている履歴書をPDF化します 該当URLは `/mypage/resume`  レスポンスヘッダーについては仕様書説明項目の `PDF生成APIのレスポンスヘッダーについて`を参照
         * @summary 履歴書 PDF ダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserIdDownload(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserIdDownload(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * * 履歴書作成に必要な情報を更新する * 資格、学歴、職務経歴の情報は多いので、送信時には省く（レスポンスには返ってくる） * 資格、職務経歴の表示順序は、内部的に履歴書用のorder番号を持ち、職務経歴書とは別に独立して保存します。  ---  新たな職歴などが追加された場合（履歴書用の内部的なorder番号がない場合）order番号を持つ職歴の一番後ろから表示します。履歴書編集画面で並び替えを行いPATCHを送信した際に、order番号を更新します。 ※S2さんにフィジビリティ要確認
         * @summary 履歴書更新
         * @param {Resume} [resume] 証明写真 user.user_info.photo は以下の形式でリクエストする  &#x60;&#x60;&#x60; {   f_id: \&quot;POST /api/v2/files で返ってきた f_id\&quot; } &#x60;&#x60;&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchResume(resume?: Resume, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Resume & ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchResume(resume, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 学歴・編集
         * @summary 学歴・編集
         * @param {EducationPatchRequest} [educationPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchResumeUserIdEducations(educationPatchRequest?: EducationPatchRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EducationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchResumeUserIdEducations(educationPatchRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 新規なのでe_id は空文字で送信
         * @summary 学歴・追加
         * @param {EducationPostRequest} [educationPostRequest] 学歴・追加
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postResumeUserIdEducations(educationPostRequest?: EducationPostRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EducationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postResumeUserIdEducations(educationPostRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ResumeApi - factory interface
 * @export
 */
export const ResumeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ResumeApiFp(configuration)
    return {
        /**
         * 学歴の削除を行う
         * @summary 学歴削除
         * @param {string} educationId 学歴ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResumeEducations(educationId: string, options?: any): AxiosPromise<EducationResponse> {
            return localVarFp.deleteResumeEducations(educationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 入力代行済履歴書取得
         * @summary 入力代行済履歴書取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInputAgencyResume(options?: any): AxiosPromise<MBResumeResponse> {
            return localVarFp.getInputAgencyResume(options).then((request) => request(axios, basePath));
        },
        /**
         * 履歴書情報・一覧取得
         * @summary 履歴書情報・一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResume(options?: any): AxiosPromise<MBResumeResponse> {
            return localVarFp.getResume(options).then((request) => request(axios, basePath));
        },
        /**
         * ``` 1.写真をアップロードしている // userinfo->photo が入ってる 2.性別を入力している // userinfo->gender 3.住所を入力している // userinfo->address1 4.学歴を入力している // userinfo->address1 5.職歴を入力している // 会社名が空ではないcareersが1件以上ある 6.資格を入力している // スコアが0ではない toeic か toeflタイプのQualificationが1件以上ある　または　textタイプでタイトルが空ではないQualificationが1件以上ある 7.志望動機を入力している // statement 8.趣味・特技を入力している // interest_things 9.本人希望を入力している // hope_job 10.PDFをダウンロードしている ```
         * @summary 履歴書入力度 取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResumeProgress(options?: any): AxiosPromise<object & Status> {
            return localVarFp.getResumeProgress(options).then((request) => request(axios, basePath));
        },
        /**
         * * 公開されている履歴書をPDF化します 該当URLは `/mypage/resume`  レスポンスヘッダーについては仕様書説明項目の `PDF生成APIのレスポンスヘッダーについて`を参照
         * @summary 履歴書 PDF ダウンロード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserIdDownload(options?: any): AxiosPromise<void> {
            return localVarFp.getUserIdDownload(options).then((request) => request(axios, basePath));
        },
        /**
         * * 履歴書作成に必要な情報を更新する * 資格、学歴、職務経歴の情報は多いので、送信時には省く（レスポンスには返ってくる） * 資格、職務経歴の表示順序は、内部的に履歴書用のorder番号を持ち、職務経歴書とは別に独立して保存します。  ---  新たな職歴などが追加された場合（履歴書用の内部的なorder番号がない場合）order番号を持つ職歴の一番後ろから表示します。履歴書編集画面で並び替えを行いPATCHを送信した際に、order番号を更新します。 ※S2さんにフィジビリティ要確認
         * @summary 履歴書更新
         * @param {Resume} [resume] 証明写真 user.user_info.photo は以下の形式でリクエストする  &#x60;&#x60;&#x60; {   f_id: \&quot;POST /api/v2/files で返ってきた f_id\&quot; } &#x60;&#x60;&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchResume(resume?: Resume, options?: any): AxiosPromise<Resume & ResponseSuccess> {
            return localVarFp.patchResume(resume, options).then((request) => request(axios, basePath));
        },
        /**
         * 学歴・編集
         * @summary 学歴・編集
         * @param {EducationPatchRequest} [educationPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchResumeUserIdEducations(educationPatchRequest?: EducationPatchRequest, options?: any): AxiosPromise<EducationResponse> {
            return localVarFp.patchResumeUserIdEducations(educationPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 新規なのでe_id は空文字で送信
         * @summary 学歴・追加
         * @param {EducationPostRequest} [educationPostRequest] 学歴・追加
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResumeUserIdEducations(educationPostRequest?: EducationPostRequest, options?: any): AxiosPromise<EducationResponse> {
            return localVarFp.postResumeUserIdEducations(educationPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ResumeApi - object-oriented interface
 * @export
 * @class ResumeApi
 * @extends {BaseAPI}
 */
export class ResumeApi extends BaseAPI {
    /**
     * 学歴の削除を行う
     * @summary 学歴削除
     * @param {string} educationId 学歴ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResumeApi
     */
    public deleteResumeEducations(educationId: string, options?: AxiosRequestConfig) {
        return ResumeApiFp(this.configuration).deleteResumeEducations(educationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 入力代行済履歴書取得
     * @summary 入力代行済履歴書取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResumeApi
     */
    public getInputAgencyResume(options?: AxiosRequestConfig) {
        return ResumeApiFp(this.configuration).getInputAgencyResume(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 履歴書情報・一覧取得
     * @summary 履歴書情報・一覧取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResumeApi
     */
    public getResume(options?: AxiosRequestConfig) {
        return ResumeApiFp(this.configuration).getResume(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ``` 1.写真をアップロードしている // userinfo->photo が入ってる 2.性別を入力している // userinfo->gender 3.住所を入力している // userinfo->address1 4.学歴を入力している // userinfo->address1 5.職歴を入力している // 会社名が空ではないcareersが1件以上ある 6.資格を入力している // スコアが0ではない toeic か toeflタイプのQualificationが1件以上ある　または　textタイプでタイトルが空ではないQualificationが1件以上ある 7.志望動機を入力している // statement 8.趣味・特技を入力している // interest_things 9.本人希望を入力している // hope_job 10.PDFをダウンロードしている ```
     * @summary 履歴書入力度 取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResumeApi
     */
    public getResumeProgress(options?: AxiosRequestConfig) {
        return ResumeApiFp(this.configuration).getResumeProgress(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * * 公開されている履歴書をPDF化します 該当URLは `/mypage/resume`  レスポンスヘッダーについては仕様書説明項目の `PDF生成APIのレスポンスヘッダーについて`を参照
     * @summary 履歴書 PDF ダウンロード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResumeApi
     */
    public getUserIdDownload(options?: AxiosRequestConfig) {
        return ResumeApiFp(this.configuration).getUserIdDownload(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * * 履歴書作成に必要な情報を更新する * 資格、学歴、職務経歴の情報は多いので、送信時には省く（レスポンスには返ってくる） * 資格、職務経歴の表示順序は、内部的に履歴書用のorder番号を持ち、職務経歴書とは別に独立して保存します。  ---  新たな職歴などが追加された場合（履歴書用の内部的なorder番号がない場合）order番号を持つ職歴の一番後ろから表示します。履歴書編集画面で並び替えを行いPATCHを送信した際に、order番号を更新します。 ※S2さんにフィジビリティ要確認
     * @summary 履歴書更新
     * @param {Resume} [resume] 証明写真 user.user_info.photo は以下の形式でリクエストする  &#x60;&#x60;&#x60; {   f_id: \&quot;POST /api/v2/files で返ってきた f_id\&quot; } &#x60;&#x60;&#x60;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResumeApi
     */
    public patchResume(resume?: Resume, options?: AxiosRequestConfig) {
        return ResumeApiFp(this.configuration).patchResume(resume, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 学歴・編集
     * @summary 学歴・編集
     * @param {EducationPatchRequest} [educationPatchRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResumeApi
     */
    public patchResumeUserIdEducations(educationPatchRequest?: EducationPatchRequest, options?: AxiosRequestConfig) {
        return ResumeApiFp(this.configuration).patchResumeUserIdEducations(educationPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 新規なのでe_id は空文字で送信
     * @summary 学歴・追加
     * @param {EducationPostRequest} [educationPostRequest] 学歴・追加
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResumeApi
     */
    public postResumeUserIdEducations(educationPostRequest?: EducationPostRequest, options?: AxiosRequestConfig) {
        return ResumeApiFp(this.configuration).postResumeUserIdEducations(educationPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SiteApi - axios parameter creator
 * @export
 */
export const SiteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * * ポートフォリオの公開されているものを表示する。 * 実装初期は選抜されたものにしたいので、ピックアップする仕組みが必要？ * とおもったけど、そもそも使われなさそう。。。？
         * @summary ポートフォリオ 検索
         * @param {string} limit リミット数（ページング用）
         * @param {string} offset オフセット（ページング用）
         * @param {string} sortBy ソートキー (キーはなにが必要が決める必要がある)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearch: async (limit: string, offset: string, sortBy: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getSearch', 'limit', limit)
            // verify required parameter 'offset' is not null or undefined
            assertParamExists('getSearch', 'offset', offset)
            // verify required parameter 'sortBy' is not null or undefined
            assertParamExists('getSearch', 'sortBy', sortBy)
            const localVarPath = `/api/v2/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SiteApi - functional programming interface
 * @export
 */
export const SiteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SiteApiAxiosParamCreator(configuration)
    return {
        /**
         * * ポートフォリオの公開されているものを表示する。 * 実装初期は選抜されたものにしたいので、ピックアップする仕組みが必要？ * とおもったけど、そもそも使われなさそう。。。？
         * @summary ポートフォリオ 検索
         * @param {string} limit リミット数（ページング用）
         * @param {string} offset オフセット（ページング用）
         * @param {string} sortBy ソートキー (キーはなにが必要が決める必要がある)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSearch(limit: string, offset: string, sortBy: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchPortfolioResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSearch(limit, offset, sortBy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SiteApi - factory interface
 * @export
 */
export const SiteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SiteApiFp(configuration)
    return {
        /**
         * * ポートフォリオの公開されているものを表示する。 * 実装初期は選抜されたものにしたいので、ピックアップする仕組みが必要？ * とおもったけど、そもそも使われなさそう。。。？
         * @summary ポートフォリオ 検索
         * @param {string} limit リミット数（ページング用）
         * @param {string} offset オフセット（ページング用）
         * @param {string} sortBy ソートキー (キーはなにが必要が決める必要がある)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearch(limit: string, offset: string, sortBy: string, options?: any): AxiosPromise<SearchPortfolioResponse> {
            return localVarFp.getSearch(limit, offset, sortBy, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SiteApi - object-oriented interface
 * @export
 * @class SiteApi
 * @extends {BaseAPI}
 */
export class SiteApi extends BaseAPI {
    /**
     * * ポートフォリオの公開されているものを表示する。 * 実装初期は選抜されたものにしたいので、ピックアップする仕組みが必要？ * とおもったけど、そもそも使われなさそう。。。？
     * @summary ポートフォリオ 検索
     * @param {string} limit リミット数（ページング用）
     * @param {string} offset オフセット（ページング用）
     * @param {string} sortBy ソートキー (キーはなにが必要が決める必要がある)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SiteApi
     */
    public getSearch(limit: string, offset: string, sortBy: string, options?: AxiosRequestConfig) {
        return SiteApiFp(this.configuration).getSearch(limit, offset, sortBy, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * * 履歴書・職務経歴書の書類を削除
         * @summary 書類削除
         * @param {string} fileId アップロード時に返却されるファイルID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocuments: async (fileId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('deleteDocuments', 'fileId', fileId)
            const localVarPath = `/api/v2/documents/{fileId}`
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * * こんな簡単に削除できてしまっていい・・？
         * @summary ユーザー情報削除
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deleteUser: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ポートフォリオ公開に承認しているかのチェック
         * @summary ポートフォリオ公開承認チェック
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgreedToPublishPortfolio: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/agreed_to_publish_portfolio`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 入力代行サービスの登録状況を取得する
         * @summary 入力代行情報取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInputAgency: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/input_agency`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * マイページ表示に必要な情報の一括取得
         * @summary ログイン後マイページ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMypage: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/mypage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * * 個人アカウント：自分宛てのもののみ表示
         * @summary オファー一覧
         * @param {string} limit 
         * @param {string} offset 
         * @param {string} sortBy 
         * @param {string} sortOrder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOffers: async (limit: string, offset: string, sortBy: string, sortOrder: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getOffers', 'limit', limit)
            // verify required parameter 'offset' is not null or undefined
            assertParamExists('getOffers', 'offset', offset)
            // verify required parameter 'sortBy' is not null or undefined
            assertParamExists('getOffers', 'sortBy', sortBy)
            // verify required parameter 'sortOrder' is not null or undefined
            assertParamExists('getOffers', 'sortOrder', sortOrder)
            const localVarPath = `/api/v2/offers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ユーザー情報取得
         * @summary ユーザー情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ログイン状態の履歴を見る
         * @summary アクセス履歴の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAccessHistory: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/user/access_history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ブロックした企業一覧取得
         * @summary ブロックした企業一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserBlockCompanies: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/user/block_companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ログイン状態を見る 必要な情報は精査
         * @summary ログイン状態／ユーザー情報の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserIsLogin: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/user/is-login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 入力代行サービスの登録状況を更新する
         * @summary 入力代行情報更新
         * @param {InlineObject20} [inlineObject20] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchInputAgency: async (inlineObject20?: InlineObject20, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/input_agency`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject20, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 承認・非承認、既読
         * @summary オファーの承認・非承認
         * @param {OfferPatchParam} [offerPatchParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchOffer: async (offerPatchParam?: OfferPatchParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/offer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(offerPatchParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * * 変更があったものだけを送信するようにしたい * PUTしたら、GETした時と同じ情報が返ってくる
         * @summary ユーザー情報変更
         * @param {UserPatchRequest} [userPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUser: async (userPatchRequest?: UserPatchRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ブロックした企業 変更
         * @summary ブロックする企業一覧を更新
         * @param {BlockCompaniesPatchParam} [blockCompaniesPatchParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUserBlockCompanies: async (blockCompaniesPatchParam?: BlockCompaniesPatchParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/user/block_companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(blockCompaniesPatchParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ポートフォリオ公開承認  不可逆なのでパラメーターなしで叩かれたら承認させる
         * @summary ポートフォリオ公開承認
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAgreedToPublishPortfolio: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/agreed_to_publish_portfolio`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * パスワード再設定 仕様は冒頭説明箇所を参照
         * @summary ログイン画面からのパスワード再設定
         * @param {RequestPassword} [requestPassword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiV2ApiUserPasswordResetPassword: async (requestPassword?: RequestPassword, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/user/password_reset/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestPassword, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * トークンチェック
         * @summary ログイン画面からのパスワード再設定 トークンチェック
         * @param {RequestTokenCheck} [requestTokenCheck] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiV2ApiUserPasswordResetValidateToken: async (requestTokenCheck?: RequestTokenCheck, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/user/password_reset/validate_token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestTokenCheck, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * パスワード設定 仕様は冒頭説明箇所を参照
         * @summary パスワード設定
         * @param {RequestPassword} [requestPassword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiV2UserRegistrationPassword: async (requestPassword?: RequestPassword, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/user/registration/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestPassword, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 登録時にユーザーに発行されるトークンのチェック
         * @summary トークンチェック
         * @param {RequestTokenCheck} [requestTokenCheck] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiV2UserRegistrationValidateToken: async (requestTokenCheck?: RequestTokenCheck, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/user/registration/validate_token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestTokenCheck, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * * ファイルサイズはマイナビクリエイター本体の制限とあわせて2ファイル合計で3MBまでとする * 履歴書・職務経歴書の書類をアップロードする * すでにアップロードされたものがある場合は、参照する際に最新の日付のものが使われる * 制限ファイル拡張子は仕様確認中
         * @summary 書類のアップロード
         * @param {any} files 
         * @param {string} type ドキュメント対応
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDocuments: async (files: any, type: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'files' is not null or undefined
            assertParamExists('postDocuments', 'files', files)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('postDocuments', 'type', type)
            const localVarPath = `/api/v2/documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (files !== undefined) { 
                localVarFormParams.append('files', files as any);
            }
    
            if (type !== undefined) { 
                localVarFormParams.append('type', type as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 入力代行サービスの申し込みを行う
         * @summary 入力代行申し込み
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postInputAgency: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/input_agency`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 同意
         * @summary v2の規約への同意
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserAgreement: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/user/agreement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ブロックする企業検索
         * @summary ブロックする企業検索
         * @param {BlockCompanyPostParam} [blockCompanyPostParam] &#x60;sort_by&#x60;は&#x60;kana&#x60;を送る想定
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserBlockCompanies: async (blockCompanyPostParam?: BlockCompanyPostParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/user/block_companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(blockCompanyPostParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * マイページ メールアドレスの変更  https://www.figma.com/file/tDn9C162xYWTXkvFMaipAn/Final-Design-and-Design-system?node-id=2249%3A423
         * @summary メールアドレス変更
         * @param {UserEmailChange} [userEmailChange] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserEmailChange: async (userEmailChange?: UserEmailChange, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/user/email_change`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userEmailChange, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * マイページ メールアドレスの変更時のトークンチェック トークンが正しければそのまま変更完了処理までする  https://www.figma.com/file/tDn9C162xYWTXkvFMaipAn/Final-Design-and-Design-system?node-id=2249%3A423
         * @summary メールアドレス変更 トークンチェック & 変更完了
         * @param {UserEmailChangeToken} [userEmailChangeToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserEmailChangeValidateToken: async (userEmailChangeToken?: UserEmailChangeToken, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/user/email_change/validate_token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userEmailChangeToken, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * パスワードを変更します 仕様は冒頭説明箇所を参照
         * @summary パスワード変更
         * @param {PasswordChangeParam} [passwordChangeParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserPasswordChange: async (passwordChangeParam?: PasswordChangeParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/user/password_change`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passwordChangeParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * パスワードをリセットします  ---  * v2ではPOST成功時に登録メールアドレスに登録メールを送信してパスワードを別途設定する。
         * @summary パスワードリセット
         * @param {PasswordResetParam} [passwordResetParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserPasswordReset: async (passwordResetParam?: PasswordResetParam, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/user/password_reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passwordResetParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * * 新規ユーザー登録をします * ADMINユーザー登録は別 * ファイル送信は、base64したものを送信する。 * 拡張子、zip、excel（xlsx、xls）、word（docx、doc）、jpeg（jpg）、 * pdfのみを受け付ける。判断はフロント。拡張子偽装は考慮しない * マイナビクリエイター側、マッチボックス側で使用するので、 * どちらかには必要のない項目もある。詳しいまとめは送信項目のまとめを参照。 * 流入経路がmynavicreatorの場合は、ユーザー情報の中にあるmc_connectedがtrueになります * v2ではPOST成功時に登録メールアドレスに登録メールを送信してパスワードを別途設定する。 ---  企業アカウント発行時に `email` `user_type` のみでアカウント発行することは可能か確認。
         * @summary 登録
         * @param {number} [mcPreferredChangeDate] 転職希望時期選択式（マスタから選択）
         * @param {string} [userEntryId] 広告効果測定用エントリーID（フロントで生成する。GAに渡さなくてはいけない。）
         * @param {boolean} [useDirect] Direct利用状況
         * @param {boolean} [useMatchbox] matchbox を使うかどうか
         * @param {string} [userType] ユーザーのタイプ
         * @param {string} [email] Eメールアドレス
         * @param {string} [tel] 電話番号  バリデーション - 半角数字 - ハイフンなしの 10 - 11 桁までの数値 - 表示時もハイフンなしで表示する  仕様 - 文字列の方がフロント側で扱いやすいので文字列相当の数値として扱う
         * @param {string} [name] 求職者 ユーザー名
         * @param {string} [furigana] 求職者 ふりがな  バリデーション - 平仮名 + 空白スペース
         * @param {number} [birthYear] 誕生年  バリデーション - 半角数字 - 1900 - 2021（または現在年） まで
         * @param {number} [birthMonth] 誕生月  バリデーション - 半角数字 - 1 - 12 まで
         * @param {number} [birthDay] 誕生日  バリデーション - 半角数字 - 1 - 31 まで
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserRegistration: async (mcPreferredChangeDate?: number, userEntryId?: string, useDirect?: boolean, useMatchbox?: boolean, userType?: string, email?: string, tel?: string, name?: string, furigana?: string, birthYear?: number, birthMonth?: number, birthDay?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/user/registration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();


            if (mcPreferredChangeDate !== undefined) { 
                localVarFormParams.set('mc_preferred_change_date', mcPreferredChangeDate as any);
            }
    
            if (userEntryId !== undefined) { 
                localVarFormParams.set('user_entry_id', userEntryId as any);
            }
    
            if (useDirect !== undefined) { 
                localVarFormParams.set('use_direct', useDirect as any);
            }
    
            if (useMatchbox !== undefined) { 
                localVarFormParams.set('use_matchbox', useMatchbox as any);
            }
    
            if (userType !== undefined) { 
                localVarFormParams.set('user_type', userType as any);
            }
    
            if (email !== undefined) { 
                localVarFormParams.set('email', email as any);
            }
    
            if (tel !== undefined) { 
                localVarFormParams.set('tel', tel as any);
            }
    
            if (name !== undefined) { 
                localVarFormParams.set('name', name as any);
            }
    
            if (furigana !== undefined) { 
                localVarFormParams.set('furigana', furigana as any);
            }
    
            if (birthYear !== undefined) { 
                localVarFormParams.set('birth_year', birthYear as any);
            }
    
            if (birthMonth !== undefined) { 
                localVarFormParams.set('birth_month', birthMonth as any);
            }
    
            if (birthDay !== undefined) { 
                localVarFormParams.set('birth_day', birthDay as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * MATCHBOX Directへの登録
         * @summary MATCHBOX Directへの登録
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserRegistrationDirect: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/user/registration_direct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * * 履歴書・職務経歴書の書類を削除
         * @summary 書類削除
         * @param {string} fileId アップロード時に返却されるファイルID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDocuments(fileId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDocuments(fileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * * こんな簡単に削除できてしまっていい・・？
         * @summary ユーザー情報削除
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async deleteUser(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ポートフォリオ公開に承認しているかのチェック
         * @summary ポートフォリオ公開承認チェック
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgreedToPublishPortfolio(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCommon & Agreed>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgreedToPublishPortfolio(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 入力代行サービスの登録状況を取得する
         * @summary 入力代行情報取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInputAgency(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InputAgencyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInputAgency(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * マイページ表示に必要な情報の一括取得
         * @summary ログイン後マイページ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMypage(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Mypage & Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMypage(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * * 個人アカウント：自分宛てのもののみ表示
         * @summary オファー一覧
         * @param {string} limit 
         * @param {string} offset 
         * @param {string} sortBy 
         * @param {string} sortOrder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOffers(limit: string, offset: string, sortBy: string, sortOrder: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OffersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOffers(limit, offset, sortBy, sortOrder, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ユーザー情報取得
         * @summary ユーザー情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUser(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MatchboxUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUser(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ログイン状態の履歴を見る
         * @summary アクセス履歴の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserAccessHistory(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object & Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserAccessHistory(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ブロックした企業一覧取得
         * @summary ブロックした企業一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserBlockCompanies(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BlockCompaniesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserBlockCompanies(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ログイン状態を見る 必要な情報は精査
         * @summary ログイン状態／ユーザー情報の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserIsLogin(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserIsLogin>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserIsLogin(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 入力代行サービスの登録状況を更新する
         * @summary 入力代行情報更新
         * @param {InlineObject20} [inlineObject20] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchInputAgency(inlineObject20?: InlineObject20, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchInputAgency(inlineObject20, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 承認・非承認、既読
         * @summary オファーの承認・非承認
         * @param {OfferPatchParam} [offerPatchParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchOffer(offerPatchParam?: OfferPatchParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OfferResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchOffer(offerPatchParam, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * * 変更があったものだけを送信するようにしたい * PUTしたら、GETした時と同じ情報が返ってくる
         * @summary ユーザー情報変更
         * @param {UserPatchRequest} [userPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchUser(userPatchRequest?: UserPatchRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MatchboxUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchUser(userPatchRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ブロックした企業 変更
         * @summary ブロックする企業一覧を更新
         * @param {BlockCompaniesPatchParam} [blockCompaniesPatchParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchUserBlockCompanies(blockCompaniesPatchParam?: BlockCompaniesPatchParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BlockCompaniesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchUserBlockCompanies(blockCompaniesPatchParam, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ポートフォリオ公開承認  不可逆なのでパラメーターなしで叩かれたら承認させる
         * @summary ポートフォリオ公開承認
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAgreedToPublishPortfolio(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCommon>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAgreedToPublishPortfolio(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * パスワード再設定 仕様は冒頭説明箇所を参照
         * @summary ログイン画面からのパスワード再設定
         * @param {RequestPassword} [requestPassword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiV2ApiUserPasswordResetPassword(requestPassword?: RequestPassword, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiV2ApiUserPasswordResetPassword(requestPassword, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * トークンチェック
         * @summary ログイン画面からのパスワード再設定 トークンチェック
         * @param {RequestTokenCheck} [requestTokenCheck] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiV2ApiUserPasswordResetValidateToken(requestTokenCheck?: RequestTokenCheck, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiV2ApiUserPasswordResetValidateToken(requestTokenCheck, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * パスワード設定 仕様は冒頭説明箇所を参照
         * @summary パスワード設定
         * @param {RequestPassword} [requestPassword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiV2UserRegistrationPassword(requestPassword?: RequestPassword, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiV2UserRegistrationPassword(requestPassword, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 登録時にユーザーに発行されるトークンのチェック
         * @summary トークンチェック
         * @param {RequestTokenCheck} [requestTokenCheck] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postApiV2UserRegistrationValidateToken(requestTokenCheck?: RequestTokenCheck, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postApiV2UserRegistrationValidateToken(requestTokenCheck, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * * ファイルサイズはマイナビクリエイター本体の制限とあわせて2ファイル合計で3MBまでとする * 履歴書・職務経歴書の書類をアップロードする * すでにアップロードされたものがある場合は、参照する際に最新の日付のものが使われる * 制限ファイル拡張子は仕様確認中
         * @summary 書類のアップロード
         * @param {any} files 
         * @param {string} type ドキュメント対応
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDocuments(files: any, type: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object & ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDocuments(files, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 入力代行サービスの申し込みを行う
         * @summary 入力代行申し込み
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postInputAgency(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postInputAgency(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 同意
         * @summary v2の規約への同意
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postUserAgreement(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postUserAgreement(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ブロックする企業検索
         * @summary ブロックする企業検索
         * @param {BlockCompanyPostParam} [blockCompanyPostParam] &#x60;sort_by&#x60;は&#x60;kana&#x60;を送る想定
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postUserBlockCompanies(blockCompanyPostParam?: BlockCompanyPostParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Status & object & PaginationOffset>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postUserBlockCompanies(blockCompanyPostParam, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * マイページ メールアドレスの変更  https://www.figma.com/file/tDn9C162xYWTXkvFMaipAn/Final-Design-and-Design-system?node-id=2249%3A423
         * @summary メールアドレス変更
         * @param {UserEmailChange} [userEmailChange] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postUserEmailChange(userEmailChange?: UserEmailChange, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postUserEmailChange(userEmailChange, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * マイページ メールアドレスの変更時のトークンチェック トークンが正しければそのまま変更完了処理までする  https://www.figma.com/file/tDn9C162xYWTXkvFMaipAn/Final-Design-and-Design-system?node-id=2249%3A423
         * @summary メールアドレス変更 トークンチェック & 変更完了
         * @param {UserEmailChangeToken} [userEmailChangeToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postUserEmailChangeValidateToken(userEmailChangeToken?: UserEmailChangeToken, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postUserEmailChangeValidateToken(userEmailChangeToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * パスワードを変更します 仕様は冒頭説明箇所を参照
         * @summary パスワード変更
         * @param {PasswordChangeParam} [passwordChangeParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postUserPasswordChange(passwordChangeParam?: PasswordChangeParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postUserPasswordChange(passwordChangeParam, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * パスワードをリセットします  ---  * v2ではPOST成功時に登録メールアドレスに登録メールを送信してパスワードを別途設定する。
         * @summary パスワードリセット
         * @param {PasswordResetParam} [passwordResetParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postUserPasswordReset(passwordResetParam?: PasswordResetParam, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postUserPasswordReset(passwordResetParam, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * * 新規ユーザー登録をします * ADMINユーザー登録は別 * ファイル送信は、base64したものを送信する。 * 拡張子、zip、excel（xlsx、xls）、word（docx、doc）、jpeg（jpg）、 * pdfのみを受け付ける。判断はフロント。拡張子偽装は考慮しない * マイナビクリエイター側、マッチボックス側で使用するので、 * どちらかには必要のない項目もある。詳しいまとめは送信項目のまとめを参照。 * 流入経路がmynavicreatorの場合は、ユーザー情報の中にあるmc_connectedがtrueになります * v2ではPOST成功時に登録メールアドレスに登録メールを送信してパスワードを別途設定する。 ---  企業アカウント発行時に `email` `user_type` のみでアカウント発行することは可能か確認。
         * @summary 登録
         * @param {number} [mcPreferredChangeDate] 転職希望時期選択式（マスタから選択）
         * @param {string} [userEntryId] 広告効果測定用エントリーID（フロントで生成する。GAに渡さなくてはいけない。）
         * @param {boolean} [useDirect] Direct利用状況
         * @param {boolean} [useMatchbox] matchbox を使うかどうか
         * @param {string} [userType] ユーザーのタイプ
         * @param {string} [email] Eメールアドレス
         * @param {string} [tel] 電話番号  バリデーション - 半角数字 - ハイフンなしの 10 - 11 桁までの数値 - 表示時もハイフンなしで表示する  仕様 - 文字列の方がフロント側で扱いやすいので文字列相当の数値として扱う
         * @param {string} [name] 求職者 ユーザー名
         * @param {string} [furigana] 求職者 ふりがな  バリデーション - 平仮名 + 空白スペース
         * @param {number} [birthYear] 誕生年  バリデーション - 半角数字 - 1900 - 2021（または現在年） まで
         * @param {number} [birthMonth] 誕生月  バリデーション - 半角数字 - 1 - 12 まで
         * @param {number} [birthDay] 誕生日  バリデーション - 半角数字 - 1 - 31 まで
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postUserRegistration(mcPreferredChangeDate?: number, userEntryId?: string, useDirect?: boolean, useMatchbox?: boolean, userType?: string, email?: string, tel?: string, name?: string, furigana?: string, birthYear?: number, birthMonth?: number, birthDay?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSuccess>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postUserRegistration(mcPreferredChangeDate, userEntryId, useDirect, useMatchbox, userType, email, tel, name, furigana, birthYear, birthMonth, birthDay, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * MATCHBOX Directへの登録
         * @summary MATCHBOX Directへの登録
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postUserRegistrationDirect(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Status>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postUserRegistrationDirect(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * * 履歴書・職務経歴書の書類を削除
         * @summary 書類削除
         * @param {string} fileId アップロード時に返却されるファイルID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocuments(fileId: string, options?: any): AxiosPromise<Status> {
            return localVarFp.deleteDocuments(fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * * こんな簡単に削除できてしまっていい・・？
         * @summary ユーザー情報削除
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deleteUser(options?: any): AxiosPromise<Status> {
            return localVarFp.deleteUser(options).then((request) => request(axios, basePath));
        },
        /**
         * ポートフォリオ公開に承認しているかのチェック
         * @summary ポートフォリオ公開承認チェック
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgreedToPublishPortfolio(options?: any): AxiosPromise<ResponseCommon & Agreed> {
            return localVarFp.getAgreedToPublishPortfolio(options).then((request) => request(axios, basePath));
        },
        /**
         * 入力代行サービスの登録状況を取得する
         * @summary 入力代行情報取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInputAgency(options?: any): AxiosPromise<InputAgencyResponse> {
            return localVarFp.getInputAgency(options).then((request) => request(axios, basePath));
        },
        /**
         * マイページ表示に必要な情報の一括取得
         * @summary ログイン後マイページ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMypage(options?: any): AxiosPromise<Mypage & Status> {
            return localVarFp.getMypage(options).then((request) => request(axios, basePath));
        },
        /**
         * * 個人アカウント：自分宛てのもののみ表示
         * @summary オファー一覧
         * @param {string} limit 
         * @param {string} offset 
         * @param {string} sortBy 
         * @param {string} sortOrder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOffers(limit: string, offset: string, sortBy: string, sortOrder: string, options?: any): AxiosPromise<OffersResponse> {
            return localVarFp.getOffers(limit, offset, sortBy, sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * ユーザー情報取得
         * @summary ユーザー情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser(options?: any): AxiosPromise<MatchboxUserResponse> {
            return localVarFp.getUser(options).then((request) => request(axios, basePath));
        },
        /**
         * ログイン状態の履歴を見る
         * @summary アクセス履歴の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAccessHistory(options?: any): AxiosPromise<object & Status> {
            return localVarFp.getUserAccessHistory(options).then((request) => request(axios, basePath));
        },
        /**
         * ブロックした企業一覧取得
         * @summary ブロックした企業一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserBlockCompanies(options?: any): AxiosPromise<BlockCompaniesResponse> {
            return localVarFp.getUserBlockCompanies(options).then((request) => request(axios, basePath));
        },
        /**
         * ログイン状態を見る 必要な情報は精査
         * @summary ログイン状態／ユーザー情報の取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserIsLogin(options?: any): AxiosPromise<UserIsLogin> {
            return localVarFp.getUserIsLogin(options).then((request) => request(axios, basePath));
        },
        /**
         * 入力代行サービスの登録状況を更新する
         * @summary 入力代行情報更新
         * @param {InlineObject20} [inlineObject20] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchInputAgency(inlineObject20?: InlineObject20, options?: any): AxiosPromise<Status> {
            return localVarFp.patchInputAgency(inlineObject20, options).then((request) => request(axios, basePath));
        },
        /**
         * 承認・非承認、既読
         * @summary オファーの承認・非承認
         * @param {OfferPatchParam} [offerPatchParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchOffer(offerPatchParam?: OfferPatchParam, options?: any): AxiosPromise<OfferResponse> {
            return localVarFp.patchOffer(offerPatchParam, options).then((request) => request(axios, basePath));
        },
        /**
         * * 変更があったものだけを送信するようにしたい * PUTしたら、GETした時と同じ情報が返ってくる
         * @summary ユーザー情報変更
         * @param {UserPatchRequest} [userPatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUser(userPatchRequest?: UserPatchRequest, options?: any): AxiosPromise<MatchboxUserResponse> {
            return localVarFp.patchUser(userPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ブロックした企業 変更
         * @summary ブロックする企業一覧を更新
         * @param {BlockCompaniesPatchParam} [blockCompaniesPatchParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUserBlockCompanies(blockCompaniesPatchParam?: BlockCompaniesPatchParam, options?: any): AxiosPromise<BlockCompaniesResponse> {
            return localVarFp.patchUserBlockCompanies(blockCompaniesPatchParam, options).then((request) => request(axios, basePath));
        },
        /**
         * ポートフォリオ公開承認  不可逆なのでパラメーターなしで叩かれたら承認させる
         * @summary ポートフォリオ公開承認
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAgreedToPublishPortfolio(options?: any): AxiosPromise<ResponseCommon> {
            return localVarFp.postAgreedToPublishPortfolio(options).then((request) => request(axios, basePath));
        },
        /**
         * パスワード再設定 仕様は冒頭説明箇所を参照
         * @summary ログイン画面からのパスワード再設定
         * @param {RequestPassword} [requestPassword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiV2ApiUserPasswordResetPassword(requestPassword?: RequestPassword, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.postApiV2ApiUserPasswordResetPassword(requestPassword, options).then((request) => request(axios, basePath));
        },
        /**
         * トークンチェック
         * @summary ログイン画面からのパスワード再設定 トークンチェック
         * @param {RequestTokenCheck} [requestTokenCheck] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiV2ApiUserPasswordResetValidateToken(requestTokenCheck?: RequestTokenCheck, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.postApiV2ApiUserPasswordResetValidateToken(requestTokenCheck, options).then((request) => request(axios, basePath));
        },
        /**
         * パスワード設定 仕様は冒頭説明箇所を参照
         * @summary パスワード設定
         * @param {RequestPassword} [requestPassword] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiV2UserRegistrationPassword(requestPassword?: RequestPassword, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.postApiV2UserRegistrationPassword(requestPassword, options).then((request) => request(axios, basePath));
        },
        /**
         * 登録時にユーザーに発行されるトークンのチェック
         * @summary トークンチェック
         * @param {RequestTokenCheck} [requestTokenCheck] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postApiV2UserRegistrationValidateToken(requestTokenCheck?: RequestTokenCheck, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.postApiV2UserRegistrationValidateToken(requestTokenCheck, options).then((request) => request(axios, basePath));
        },
        /**
         * * ファイルサイズはマイナビクリエイター本体の制限とあわせて2ファイル合計で3MBまでとする * 履歴書・職務経歴書の書類をアップロードする * すでにアップロードされたものがある場合は、参照する際に最新の日付のものが使われる * 制限ファイル拡張子は仕様確認中
         * @summary 書類のアップロード
         * @param {any} files 
         * @param {string} type ドキュメント対応
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDocuments(files: any, type: string, options?: any): AxiosPromise<object & ResponseSuccess> {
            return localVarFp.postDocuments(files, type, options).then((request) => request(axios, basePath));
        },
        /**
         * 入力代行サービスの申し込みを行う
         * @summary 入力代行申し込み
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postInputAgency(options?: any): AxiosPromise<Status> {
            return localVarFp.postInputAgency(options).then((request) => request(axios, basePath));
        },
        /**
         * 同意
         * @summary v2の規約への同意
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserAgreement(options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.postUserAgreement(options).then((request) => request(axios, basePath));
        },
        /**
         * ブロックする企業検索
         * @summary ブロックする企業検索
         * @param {BlockCompanyPostParam} [blockCompanyPostParam] &#x60;sort_by&#x60;は&#x60;kana&#x60;を送る想定
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserBlockCompanies(blockCompanyPostParam?: BlockCompanyPostParam, options?: any): AxiosPromise<Status & object & PaginationOffset> {
            return localVarFp.postUserBlockCompanies(blockCompanyPostParam, options).then((request) => request(axios, basePath));
        },
        /**
         * マイページ メールアドレスの変更  https://www.figma.com/file/tDn9C162xYWTXkvFMaipAn/Final-Design-and-Design-system?node-id=2249%3A423
         * @summary メールアドレス変更
         * @param {UserEmailChange} [userEmailChange] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserEmailChange(userEmailChange?: UserEmailChange, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.postUserEmailChange(userEmailChange, options).then((request) => request(axios, basePath));
        },
        /**
         * マイページ メールアドレスの変更時のトークンチェック トークンが正しければそのまま変更完了処理までする  https://www.figma.com/file/tDn9C162xYWTXkvFMaipAn/Final-Design-and-Design-system?node-id=2249%3A423
         * @summary メールアドレス変更 トークンチェック & 変更完了
         * @param {UserEmailChangeToken} [userEmailChangeToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserEmailChangeValidateToken(userEmailChangeToken?: UserEmailChangeToken, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.postUserEmailChangeValidateToken(userEmailChangeToken, options).then((request) => request(axios, basePath));
        },
        /**
         * パスワードを変更します 仕様は冒頭説明箇所を参照
         * @summary パスワード変更
         * @param {PasswordChangeParam} [passwordChangeParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserPasswordChange(passwordChangeParam?: PasswordChangeParam, options?: any): AxiosPromise<Status> {
            return localVarFp.postUserPasswordChange(passwordChangeParam, options).then((request) => request(axios, basePath));
        },
        /**
         * パスワードをリセットします  ---  * v2ではPOST成功時に登録メールアドレスに登録メールを送信してパスワードを別途設定する。
         * @summary パスワードリセット
         * @param {PasswordResetParam} [passwordResetParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserPasswordReset(passwordResetParam?: PasswordResetParam, options?: any): AxiosPromise<Status> {
            return localVarFp.postUserPasswordReset(passwordResetParam, options).then((request) => request(axios, basePath));
        },
        /**
         * * 新規ユーザー登録をします * ADMINユーザー登録は別 * ファイル送信は、base64したものを送信する。 * 拡張子、zip、excel（xlsx、xls）、word（docx、doc）、jpeg（jpg）、 * pdfのみを受け付ける。判断はフロント。拡張子偽装は考慮しない * マイナビクリエイター側、マッチボックス側で使用するので、 * どちらかには必要のない項目もある。詳しいまとめは送信項目のまとめを参照。 * 流入経路がmynavicreatorの場合は、ユーザー情報の中にあるmc_connectedがtrueになります * v2ではPOST成功時に登録メールアドレスに登録メールを送信してパスワードを別途設定する。 ---  企業アカウント発行時に `email` `user_type` のみでアカウント発行することは可能か確認。
         * @summary 登録
         * @param {number} [mcPreferredChangeDate] 転職希望時期選択式（マスタから選択）
         * @param {string} [userEntryId] 広告効果測定用エントリーID（フロントで生成する。GAに渡さなくてはいけない。）
         * @param {boolean} [useDirect] Direct利用状況
         * @param {boolean} [useMatchbox] matchbox を使うかどうか
         * @param {string} [userType] ユーザーのタイプ
         * @param {string} [email] Eメールアドレス
         * @param {string} [tel] 電話番号  バリデーション - 半角数字 - ハイフンなしの 10 - 11 桁までの数値 - 表示時もハイフンなしで表示する  仕様 - 文字列の方がフロント側で扱いやすいので文字列相当の数値として扱う
         * @param {string} [name] 求職者 ユーザー名
         * @param {string} [furigana] 求職者 ふりがな  バリデーション - 平仮名 + 空白スペース
         * @param {number} [birthYear] 誕生年  バリデーション - 半角数字 - 1900 - 2021（または現在年） まで
         * @param {number} [birthMonth] 誕生月  バリデーション - 半角数字 - 1 - 12 まで
         * @param {number} [birthDay] 誕生日  バリデーション - 半角数字 - 1 - 31 まで
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserRegistration(mcPreferredChangeDate?: number, userEntryId?: string, useDirect?: boolean, useMatchbox?: boolean, userType?: string, email?: string, tel?: string, name?: string, furigana?: string, birthYear?: number, birthMonth?: number, birthDay?: number, options?: any): AxiosPromise<ResponseSuccess> {
            return localVarFp.postUserRegistration(mcPreferredChangeDate, userEntryId, useDirect, useMatchbox, userType, email, tel, name, furigana, birthYear, birthMonth, birthDay, options).then((request) => request(axios, basePath));
        },
        /**
         * MATCHBOX Directへの登録
         * @summary MATCHBOX Directへの登録
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUserRegistrationDirect(options?: any): AxiosPromise<Status> {
            return localVarFp.postUserRegistrationDirect(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * * 履歴書・職務経歴書の書類を削除
     * @summary 書類削除
     * @param {string} fileId アップロード時に返却されるファイルID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public deleteDocuments(fileId: string, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).deleteDocuments(fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * * こんな簡単に削除できてしまっていい・・？
     * @summary ユーザー情報削除
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public deleteUser(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).deleteUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ポートフォリオ公開に承認しているかのチェック
     * @summary ポートフォリオ公開承認チェック
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getAgreedToPublishPortfolio(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).getAgreedToPublishPortfolio(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 入力代行サービスの登録状況を取得する
     * @summary 入力代行情報取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getInputAgency(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).getInputAgency(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * マイページ表示に必要な情報の一括取得
     * @summary ログイン後マイページ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getMypage(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).getMypage(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * * 個人アカウント：自分宛てのもののみ表示
     * @summary オファー一覧
     * @param {string} limit 
     * @param {string} offset 
     * @param {string} sortBy 
     * @param {string} sortOrder 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getOffers(limit: string, offset: string, sortBy: string, sortOrder: string, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).getOffers(limit, offset, sortBy, sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ユーザー情報取得
     * @summary ユーザー情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getUser(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).getUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ログイン状態の履歴を見る
     * @summary アクセス履歴の取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getUserAccessHistory(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).getUserAccessHistory(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ブロックした企業一覧取得
     * @summary ブロックした企業一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getUserBlockCompanies(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).getUserBlockCompanies(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ログイン状態を見る 必要な情報は精査
     * @summary ログイン状態／ユーザー情報の取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getUserIsLogin(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).getUserIsLogin(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 入力代行サービスの登録状況を更新する
     * @summary 入力代行情報更新
     * @param {InlineObject20} [inlineObject20] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public patchInputAgency(inlineObject20?: InlineObject20, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).patchInputAgency(inlineObject20, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 承認・非承認、既読
     * @summary オファーの承認・非承認
     * @param {OfferPatchParam} [offerPatchParam] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public patchOffer(offerPatchParam?: OfferPatchParam, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).patchOffer(offerPatchParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * * 変更があったものだけを送信するようにしたい * PUTしたら、GETした時と同じ情報が返ってくる
     * @summary ユーザー情報変更
     * @param {UserPatchRequest} [userPatchRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public patchUser(userPatchRequest?: UserPatchRequest, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).patchUser(userPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ブロックした企業 変更
     * @summary ブロックする企業一覧を更新
     * @param {BlockCompaniesPatchParam} [blockCompaniesPatchParam] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public patchUserBlockCompanies(blockCompaniesPatchParam?: BlockCompaniesPatchParam, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).patchUserBlockCompanies(blockCompaniesPatchParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ポートフォリオ公開承認  不可逆なのでパラメーターなしで叩かれたら承認させる
     * @summary ポートフォリオ公開承認
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public postAgreedToPublishPortfolio(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).postAgreedToPublishPortfolio(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * パスワード再設定 仕様は冒頭説明箇所を参照
     * @summary ログイン画面からのパスワード再設定
     * @param {RequestPassword} [requestPassword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public postApiV2ApiUserPasswordResetPassword(requestPassword?: RequestPassword, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).postApiV2ApiUserPasswordResetPassword(requestPassword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * トークンチェック
     * @summary ログイン画面からのパスワード再設定 トークンチェック
     * @param {RequestTokenCheck} [requestTokenCheck] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public postApiV2ApiUserPasswordResetValidateToken(requestTokenCheck?: RequestTokenCheck, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).postApiV2ApiUserPasswordResetValidateToken(requestTokenCheck, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * パスワード設定 仕様は冒頭説明箇所を参照
     * @summary パスワード設定
     * @param {RequestPassword} [requestPassword] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public postApiV2UserRegistrationPassword(requestPassword?: RequestPassword, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).postApiV2UserRegistrationPassword(requestPassword, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 登録時にユーザーに発行されるトークンのチェック
     * @summary トークンチェック
     * @param {RequestTokenCheck} [requestTokenCheck] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public postApiV2UserRegistrationValidateToken(requestTokenCheck?: RequestTokenCheck, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).postApiV2UserRegistrationValidateToken(requestTokenCheck, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * * ファイルサイズはマイナビクリエイター本体の制限とあわせて2ファイル合計で3MBまでとする * 履歴書・職務経歴書の書類をアップロードする * すでにアップロードされたものがある場合は、参照する際に最新の日付のものが使われる * 制限ファイル拡張子は仕様確認中
     * @summary 書類のアップロード
     * @param {any} files 
     * @param {string} type ドキュメント対応
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public postDocuments(files: any, type: string, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).postDocuments(files, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 入力代行サービスの申し込みを行う
     * @summary 入力代行申し込み
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public postInputAgency(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).postInputAgency(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 同意
     * @summary v2の規約への同意
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public postUserAgreement(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).postUserAgreement(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ブロックする企業検索
     * @summary ブロックする企業検索
     * @param {BlockCompanyPostParam} [blockCompanyPostParam] &#x60;sort_by&#x60;は&#x60;kana&#x60;を送る想定
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public postUserBlockCompanies(blockCompanyPostParam?: BlockCompanyPostParam, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).postUserBlockCompanies(blockCompanyPostParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * マイページ メールアドレスの変更  https://www.figma.com/file/tDn9C162xYWTXkvFMaipAn/Final-Design-and-Design-system?node-id=2249%3A423
     * @summary メールアドレス変更
     * @param {UserEmailChange} [userEmailChange] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public postUserEmailChange(userEmailChange?: UserEmailChange, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).postUserEmailChange(userEmailChange, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * マイページ メールアドレスの変更時のトークンチェック トークンが正しければそのまま変更完了処理までする  https://www.figma.com/file/tDn9C162xYWTXkvFMaipAn/Final-Design-and-Design-system?node-id=2249%3A423
     * @summary メールアドレス変更 トークンチェック & 変更完了
     * @param {UserEmailChangeToken} [userEmailChangeToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public postUserEmailChangeValidateToken(userEmailChangeToken?: UserEmailChangeToken, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).postUserEmailChangeValidateToken(userEmailChangeToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * パスワードを変更します 仕様は冒頭説明箇所を参照
     * @summary パスワード変更
     * @param {PasswordChangeParam} [passwordChangeParam] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public postUserPasswordChange(passwordChangeParam?: PasswordChangeParam, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).postUserPasswordChange(passwordChangeParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * パスワードをリセットします  ---  * v2ではPOST成功時に登録メールアドレスに登録メールを送信してパスワードを別途設定する。
     * @summary パスワードリセット
     * @param {PasswordResetParam} [passwordResetParam] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public postUserPasswordReset(passwordResetParam?: PasswordResetParam, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).postUserPasswordReset(passwordResetParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * * 新規ユーザー登録をします * ADMINユーザー登録は別 * ファイル送信は、base64したものを送信する。 * 拡張子、zip、excel（xlsx、xls）、word（docx、doc）、jpeg（jpg）、 * pdfのみを受け付ける。判断はフロント。拡張子偽装は考慮しない * マイナビクリエイター側、マッチボックス側で使用するので、 * どちらかには必要のない項目もある。詳しいまとめは送信項目のまとめを参照。 * 流入経路がmynavicreatorの場合は、ユーザー情報の中にあるmc_connectedがtrueになります * v2ではPOST成功時に登録メールアドレスに登録メールを送信してパスワードを別途設定する。 ---  企業アカウント発行時に `email` `user_type` のみでアカウント発行することは可能か確認。
     * @summary 登録
     * @param {number} [mcPreferredChangeDate] 転職希望時期選択式（マスタから選択）
     * @param {string} [userEntryId] 広告効果測定用エントリーID（フロントで生成する。GAに渡さなくてはいけない。）
     * @param {boolean} [useDirect] Direct利用状況
     * @param {boolean} [useMatchbox] matchbox を使うかどうか
     * @param {string} [userType] ユーザーのタイプ
     * @param {string} [email] Eメールアドレス
     * @param {string} [tel] 電話番号  バリデーション - 半角数字 - ハイフンなしの 10 - 11 桁までの数値 - 表示時もハイフンなしで表示する  仕様 - 文字列の方がフロント側で扱いやすいので文字列相当の数値として扱う
     * @param {string} [name] 求職者 ユーザー名
     * @param {string} [furigana] 求職者 ふりがな  バリデーション - 平仮名 + 空白スペース
     * @param {number} [birthYear] 誕生年  バリデーション - 半角数字 - 1900 - 2021（または現在年） まで
     * @param {number} [birthMonth] 誕生月  バリデーション - 半角数字 - 1 - 12 まで
     * @param {number} [birthDay] 誕生日  バリデーション - 半角数字 - 1 - 31 まで
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public postUserRegistration(mcPreferredChangeDate?: number, userEntryId?: string, useDirect?: boolean, useMatchbox?: boolean, userType?: string, email?: string, tel?: string, name?: string, furigana?: string, birthYear?: number, birthMonth?: number, birthDay?: number, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).postUserRegistration(mcPreferredChangeDate, userEntryId, useDirect, useMatchbox, userType, email, tel, name, furigana, birthYear, birthMonth, birthDay, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * MATCHBOX Directへの登録
     * @summary MATCHBOX Directへの登録
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public postUserRegistrationDirect(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).postUserRegistrationDirect(options).then((request) => request(this.axios, this.basePath));
    }
}


